export const DialectLanguagesList =
[
  {
     label:"Ghotuo",
     value:"aaa"
  },
  {
     label:"Alumu-Tesu",
     value:"aab"
  },
  {
     label:"Ari",
     value:"aac"
  },
  {
     label:"Amal",
     value:"aad"
  },
  {
     label:"Arb\u00ebresh\u00eb Albanian",
     value:"aae"
  },
  {
     label:"Aranadan",
     value:"aaf"
  },
  {
     label:"Ambrak",
     value:"aag"
  },
  {
     label:"Abu' Arapesh",
     value:"aah"
  },
  {
     label:"Arifama-Miniafia",
     value:"aai"
  },
  {
     label:"Ankave",
     value:"aak"
  },
  {
     label:"Afade",
     value:"aal"
  },
  {
     label:"Anamb\u00e9",
     value:"aan"
  },
  {
     label:"Algerian Saharan Arabic",
     value:"aao"
  },
  {
     label:"Par\u00e1 Ar\u00e1ra",
     value:"aap"
  },
  {
     label:"Afar",
     value:"aar",
     "iso6392B":"aar",
     "iso6392T":"aar",
     "iso6391":"aa"
  },
  {
     label:"Aas\u00e1x",
     value:"aas"
  },
  {
     label:"Arvanitika Albanian",
     value:"aat"
  },
  {
     label:"Abau",
     value:"aau"
  },
  {
     label:"Solong",
     value:"aaw"
  },
  {
     label:"Mandobo Atas",
     value:"aax"
  },
  {
     label:"Amarasi",
     value:"aaz"
  },
  {
     label:"Ab\u00e9",
     value:"aba"
  },
  {
     label:"Bankon",
     value:"abb"
  },
  {
     label:"Ambala Ayta",
     value:"abc"
  },
  {
     label:"Manide",
     value:"abd"
  },
  {
     label:"Western Abnaki",
     value:"abe"
  },
  {
     label:"Abai Sungai",
     value:"abf"
  },
  {
     label:"Abaga",
     value:"abg"
  },
  {
     label:"Tajiki Arabic",
     value:"abh"
  },
  {
     label:"Abidji",
     value:"abi"
  },
  {
     label:"Abkhazian",
     value:"abk",
     "iso6392B":"abk",
     "iso6392T":"abk",
     "iso6391":"ab"
  },
  {
     label:"Lampung Nyo",
     value:"abl"
  },
  {
     label:"Abanyom",
     value:"abm"
  },
  {
     label:"Abua",
     value:"abn"
  },
  {
     label:"Abon",
     value:"abo"
  },
  {
     label:"Abellen Ayta",
     value:"abp"
  },
  {
     label:"Abaza",
     value:"abq"
  },
  {
     label:"Abron",
     value:"abr"
  },
  {
     label:"Ambonese Malay",
     value:"abs"
  },
  {
     label:"Ambulas",
     value:"abt"
  },
  {
     label:"Abure",
     value:"abu"
  },
  {
     label:"Baharna Arabic",
     value:"abv"
  },
  {
     label:"Pal",
     value:"abw"
  },
  {
     label:"Inabaknon",
     value:"abx"
  },
  {
     label:"Aneme Wake",
     value:"aby"
  },
  {
     label:"Abui",
     value:"abz"
  },
  {
     label:"Achagua",
     value:"aca"
  },
  {
     label:"\u00c1nc\u00e1",
     value:"acb"
  },
  {
     label:"Gikyode",
     value:"acd"
  },
  {
     label:"Achinese",
     value:"ace",
     "iso6392B":"ace",
     "iso6392T":"ace"
  },
  {
     label:"Saint Lucian Creole French",
     value:"acf"
  },
  {
     label:"Acoli",
     value:"ach",
     "iso6392B":"ach",
     "iso6392T":"ach"
  },
  {
     label:"Mesopotamian Arabic",
     value:"acm"
  },
  {
     label:"Achang",
     value:"acn"
  },
  {
     label:"Eastern Acipa",
     value:"acp"
  },
  {
     label:"Ta'izzi-Adeni Arabic",
     value:"acq"
  },
  {
     label:"Achi",
     value:"acr"
  },
  {
     label:"Achterhoeks",
     value:"act"
  },
  {
     label:"Achuar-Shiwiar",
     value:"acu"
  },
  {
     label:"Achumawi",
     value:"acv"
  },
  {
     label:"Hijazi Arabic",
     value:"acw"
  },
  {
     label:"Omani Arabic",
     value:"acx"
  },
  {
     label:"Cypriot Arabic",
     value:"acy"
  },
  {
     label:"Acheron",
     value:"acz"
  },
  {
     label:"Adangme",
     value:"ada",
     "iso6392B":"ada",
     "iso6392T":"ada"
  },
  {
     label:"Atauran",
     value:"adb"
  },
  {
     label:"Lidzonka",
     value:"add"
  },
  {
     label:"Adele",
     value:"ade"
  },
  {
     label:"Dhofari Arabic",
     value:"adf"
  },
  {
     label:"Andegerebinha",
     value:"adg"
  },
  {
     label:"Adhola",
     value:"adh"
  },
  {
     label:"Adi",
     value:"adi"
  },
  {
     label:"Adioukrou",
     value:"adj"
  },
  {
     label:"Galo",
     value:"adl"
  },
  {
     label:"Adang",
     value:"adn"
  },
  {
     label:"Abu",
     value:"ado"
  },
  {
     label:"Adangbe",
     value:"adq"
  },
  {
     label:"Adonara",
     value:"adr"
  },
  {
     label:"Adnyamathanha",
     value:"adt"
  },
  {
     label:"Aduge",
     value:"adu"
  },
  {
     label:"Amundava",
     value:"adw"
  },
  {
     label:"Amdo Tibetan",
     value:"adx"
  },
  {
     label:"Adyghe",
     value:"ady",
     "iso6392B":"ady",
     "iso6392T":"ady"
  },
  {
     label:"Adzera",
     value:"adz"
  },
  {
     label:"Tunisian Arabic",
     value:"aeb"
  },
  {
     label:"Saidi Arabic",
     value:"aec"
  },
  {
     label:"Northeast Pashai",
     value:"aee"
  },
  {
     label:"Haeke",
     value:"aek"
  },
  {
     label:"Ambele",
     value:"ael"
  },
  {
     label:"Arem",
     value:"aem"
  },
  {
     label:"Aer",
     value:"aeq"
  },
  {
     label:"Eastern Arrernte",
     value:"aer"
  },
  {
     label:"Akeu",
     value:"aeu"
  },
  {
     label:"Ambakich",
     value:"aew"
  },
  {
     label:"Amele",
     value:"aey"
  },
  {
     label:"Aeka",
     value:"aez"
  },
  {
     label:"Gulf Arabic",
     value:"afb"
  },
  {
     label:"Andai",
     value:"afd"
  },
  {
     label:"Putukwam",
     value:"afe"
  },
  {
     label:"Afrihili",
     value:"afh",
     "iso6392B":"afh",
     "iso6392T":"afh"
  },
  {
     label:"Akrukay",
     value:"afi"
  },
  {
     label:"Nanubae",
     value:"afk"
  },
  {
     label:"Defaka",
     value:"afn"
  },
  {
     label:"Eloyi",
     value:"afo"
  },
  {
     label:"Tapei",
     value:"afp"
  },
  {
     label:"Afrikaans",
     value:"afr",
     "iso6392B":"afr",
     "iso6392T":"afr",
     "iso6391":"af"
  },
  {
     label:"Afro-Seminole Creole",
     value:"afs"
  },
  {
     label:"Afitti",
     value:"aft"
  },
  {
     label:"Awutu",
     value:"afu"
  },
  {
     label:"Obokuitai",
     value:"afz"
  },
  {
     label:"Legbo",
     value:"agb"
  },
  {
     label:"Agatu",
     value:"agc"
  },
  {
     label:"Agarabi",
     value:"agd"
  },
  {
     label:"Angal",
     value:"age"
  },
  {
     label:"Arguni",
     value:"agf"
  },
  {
     label:"Angor",
     value:"agg"
  },
  {
     label:"Ngelima",
     value:"agh"
  },
  {
     label:"Agariya",
     value:"agi"
  },
  {
     label:"Argobba",
     value:"agj"
  },
  {
     label:"Isarog Agta",
     value:"agk"
  },
  {
     label:"Fembe",
     value:"agl"
  },
  {
     label:"Angaataha",
     value:"agm"
  },
  {
     label:"Agutaynen",
     value:"agn"
  },
  {
     label:"Tainae",
     value:"ago"
  },
  {
     label:"Aghem",
     value:"agq"
  },
  {
     label:"Aguaruna",
     value:"agr"
  },
  {
     label:"Esimbi",
     value:"ags"
  },
  {
     label:"Central Cagayan Agta",
     value:"agt"
  },
  {
     label:"Aguacateco",
     value:"agu"
  },
  {
     label:"Remontado Dumagat",
     value:"agv"
  },
  {
     label:"Kahua",
     value:"agw"
  },
  {
     label:"Aghul",
     value:"agx"
  },
  {
     label:"Southern Alta",
     value:"agy"
  },
  {
     label:"Mt. Iriga Agta",
     value:"agz"
  },
  {
     label:"Ahanta",
     value:"aha"
  },
  {
     label:"Axamb",
     value:"ahb"
  },
  {
     label:"Qimant",
     value:"ahg"
  },
  {
     label:"Aghu",
     value:"ahh"
  },
  {
     label:"Tiagbamrin Aizi",
     value:"ahi"
  },
  {
     label:"Akha",
     value:"ahk"
  },
  {
     label:"Igo",
     value:"ahl"
  },
  {
     label:"Mobumrin Aizi",
     value:"ahm"
  },
  {
     label:"\u00c0h\u00e0n",
     value:"ahn"
  },
  {
     label:"Aproumu Aizi",
     value:"ahp"
  },
  {
     label:"Ahirani",
     value:"ahr"
  },
  {
     label:"Ashe",
     value:"ahs"
  },
  {
     label:"Ahtena",
     value:"aht"
  },
  {
     label:"Arosi",
     value:"aia"
  },
  {
     label:"Ainu (China)",
     value:"aib"
  },
  {
     label:"Ainbai",
     value:"aic"
  },
  {
     label:"Amara",
     value:"aie"
  },
  {
     label:"Agi",
     value:"aif"
  },
  {
     label:"Antigua and Barbuda Creole English",
     value:"aig"
  },
  {
     label:"Ai-Cham",
     value:"aih"
  },
  {
     label:"Assyrian Neo-Aramaic",
     value:"aii"
  },
  {
     label:"Lishanid Noshan",
     value:"aij"
  },
  {
     label:"Ake",
     value:"aik"
  },
  {
     label:"Aimele",
     value:"ail"
  },
  {
     label:"Aimol",
     value:"aim"
  },
  {
     label:"Ainu (Japan)",
     value:"ain",
     "iso6392B":"ain",
     "iso6392T":"ain"
  },
  {
     label:"Aiton",
     value:"aio"
  },
  {
     label:"Burumakok",
     value:"aip"
  },
  {
     label:"Aimaq",
     value:"aiq"
  },
  {
     label:"Airoran",
     value:"air"
  },
  {
     label:"Aari",
     value:"aiw"
  },
  {
     label:"Aighon",
     value:"aix"
  },
  {
     label:"Ali",
     value:"aiy"
  },
  {
     label:"Aja (South Sudan)",
     value:"aja"
  },
  {
     label:"Aja (Benin)",
     value:"ajg"
  },
  {
     label:"Aji\u00eb",
     value:"aji"
  },
  {
     label:"Andajin",
     value:"ajn"
  },
  {
     label:"South Levantine Arabic",
     value:"ajp"
  },
  {
     label:"Judeo-Tunisian Arabic",
     value:"ajt"
  },
  {
     label:"Judeo-Moroccan Arabic",
     value:"aju"
  },
  {
     label:"Amri Karbi",
     value:"ajz"
  },
  {
     label:"Akan",
     value:"aka",
     "iso6392B":"aka",
     "iso6392T":"aka",
     "iso6391":"ak"
  },
  {
     label:"Batak Angkola",
     value:"akb"
  },
  {
     label:"Mpur",
     value:"akc"
  },
  {
     label:"Ukpet-Ehom",
     value:"akd"
  },
  {
     label:"Akawaio",
     value:"ake"
  },
  {
     label:"Akpa",
     value:"akf"
  },
  {
     label:"Anakalangu",
     value:"akg"
  },
  {
     label:"Angal Heneng",
     value:"akh"
  },
  {
     label:"Aiome",
     value:"aki"
  },
  {
     label:"Aklanon",
     value:"akl"
  },
  {
     label:"Akurio",
     value:"ako"
  },
  {
     label:"Siwu",
     value:"akp"
  },
  {
     label:"Ak",
     value:"akq"
  },
  {
     label:"Araki",
     value:"akr"
  },
  {
     label:"Akaselem",
     value:"aks"
  },
  {
     label:"Akolet",
     value:"akt"
  },
  {
     label:"Akum",
     value:"aku"
  },
  {
     label:"Akhvakh",
     value:"akv"
  },
  {
     label:"Akwa",
     value:"akw"
  },
  {
     label:"Alabama",
     value:"akz"
  },
  {
     label:"Alago",
     value:"ala"
  },
  {
     label:"Qawasqar",
     value:"alc"
  },
  {
     label:"Alladian",
     value:"ald"
  },
  {
     label:"Aleut",
     value:"ale",
     "iso6392B":"ale",
     "iso6392T":"ale"
  },
  {
     label:"Alege",
     value:"alf"
  },
  {
     label:"Alawa",
     value:"alh"
  },
  {
     label:"Amaimon",
     value:"ali"
  },
  {
     label:"Alangan",
     value:"alj"
  },
  {
     label:"Alak",
     value:"alk"
  },
  {
     label:"Allar",
     value:"all"
  },
  {
     label:"Amblong",
     value:"alm"
  },
  {
     label:"Gheg Albanian",
     value:"aln"
  },
  {
     label:"Larike-Wakasihu",
     value:"alo"
  },
  {
     label:"Alune",
     value:"alp"
  },
  {
     label:"Algonquin",
     value:"alq"
  },
  {
     label:"Alutor",
     value:"alr"
  },
  {
     label:"Tosk Albanian",
     value:"als"
  },
  {
     label:"Southern Altai",
     value:"alt",
     "iso6392B":"alt",
     "iso6392T":"alt"
  },
  {
     label:"'Are'are",
     value:"alu"
  },
  {
     label:"Alaba-K\u2019abeena",
     value:"alw"
  },
  {
     label:"Amol",
     value:"alx"
  },
  {
     label:"Alyawarr",
     value:"aly"
  },
  {
     label:"Alur",
     value:"alz"
  },
  {
     label:"Ambo",
     value:"amb"
  },
  {
     label:"Amahuaca",
     value:"amc"
  },
  {
     label:"Yanesha'",
     value:"ame"
  },
  {
     label:"Hamer-Banna",
     value:"amf"
  },
  {
     label:"Amurdak",
     value:"amg"
  },
  {
     label:"Amharic",
     value:"amh",
     "iso6392B":"amh",
     "iso6392T":"amh",
     "iso6391":"am"
  },
  {
     label:"Amis",
     value:"ami"
  },
  {
     label:"Amdang",
     value:"amj"
  },
  {
     label:"Ambai",
     value:"amk"
  },
  {
     label:"War-Jaintia",
     value:"aml"
  },
  {
     label:"Ama (Papua New Guinea)",
     value:"amm"
  },
  {
     label:"Amanab",
     value:"amn"
  },
  {
     label:"Amo",
     value:"amo"
  },
  {
     label:"Alamblak",
     value:"amp"
  },
  {
     label:"Amahai",
     value:"amq"
  },
  {
     label:"Amarakaeri",
     value:"amr"
  },
  {
     label:"Southern Amami-Oshima",
     value:"ams"
  },
  {
     label:"Amto",
     value:"amt"
  },
  {
     label:"Guerrero Amuzgo",
     value:"amu"
  },
  {
     label:"Ambelau",
     value:"amv"
  },
  {
     label:"Western Neo-Aramaic",
     value:"amw"
  },
  {
     label:"Anmatyerre",
     value:"amx"
  },
  {
     label:"Ami",
     value:"amy"
  },
  {
     label:"Ngas",
     value:"anc"
  },
  {
     label:"Ansus",
     value:"and"
  },
  {
     label:"X\u00e2r\u00e2c\u00f9\u00f9",
     value:"ane"
  },
  {
     label:"Animere",
     value:"anf"
  },
  {
     label:"Nend",
     value:"anh"
  },
  {
     label:"Andi",
     value:"ani"
  },
  {
     label:"Anor",
     value:"anj"
  },
  {
     label:"Goemai",
     value:"ank"
  },
  {
     label:"Anu-Hkongso Chin",
     value:"anl"
  },
  {
     label:"Anal",
     value:"anm"
  },
  {
     label:"Obolo",
     value:"ann"
  },
  {
     label:"Andoque",
     value:"ano"
  },
  {
     label:"Angika",
     value:"anp",
     "iso6392B":"anp",
     "iso6392T":"anp"
  },
  {
     label:"Jarawa (India)",
     value:"anq"
  },
  {
     label:"Andh",
     value:"anr"
  },
  {
     label:"Antakarinya",
     value:"ant"
  },
  {
     label:"Anuak",
     value:"anu"
  },
  {
     label:"Denya",
     value:"anv"
  },
  {
     label:"Anaang",
     value:"anw"
  },
  {
     label:"Andra-Hus",
     value:"anx"
  },
  {
     label:"Anyin",
     value:"any"
  },
  {
     label:"Anem",
     value:"anz"
  },
  {
     label:"Angolar",
     value:"aoa"
  },
  {
     label:"Abom",
     value:"aob"
  },
  {
     label:"Pemon",
     value:"aoc"
  },
  {
     label:"Andarum",
     value:"aod"
  },
  {
     label:"Angal Enen",
     value:"aoe"
  },
  {
     label:"Bragat",
     value:"aof"
  },
  {
     label:"Angoram",
     value:"aog"
  },
  {
     label:"Anindilyakwa",
     value:"aoi"
  },
  {
     label:"Mufian",
     value:"aoj"
  },
  {
     label:"Arh\u00f6",
     value:"aok"
  },
  {
     label:"Alor",
     value:"aol"
  },
  {
     label:"\u00d6mie",
     value:"aom"
  },
  {
     label:"Bumbita Arapesh",
     value:"aon"
  },
  {
     label:"Taikat",
     value:"aos"
  },
  {
     label:"Atong (India)",
     value:"aot"
  },
  {
     label:"A'ou",
     value:"aou"
  },
  {
     label:"Atorada",
     value:"aox"
  },
  {
     label:"Uab Meto",
     value:"aoz"
  },
  {
     label:"Sa'a",
     value:"apb"
  },
  {
     label:"North Levantine Arabic",
     value:"apc"
  },
  {
     label:"Sudanese Arabic",
     value:"apd"
  },
  {
     label:"Bukiyip",
     value:"ape"
  },
  {
     label:"Pahanan Agta",
     value:"apf"
  },
  {
     label:"Ampanang",
     value:"apg"
  },
  {
     label:"Athpariya",
     value:"aph"
  },
  {
     label:"Apiak\u00e1",
     value:"api"
  },
  {
     label:"Jicarilla Apache",
     value:"apj"
  },
  {
     label:"Kiowa Apache",
     value:"apk"
  },
  {
     label:"Lipan Apache",
     value:"apl"
  },
  {
     label:"Mescalero-Chiricahua Apache",
     value:"apm"
  },
  {
     label:"Apinay\u00e9",
     value:"apn"
  },
  {
     label:"Ambul",
     value:"apo"
  },
  {
     label:"Apma",
     value:"app"
  },
  {
     label:"A-Pucikwar",
     value:"apq"
  },
  {
     label:"Arop-Lokep",
     value:"apr"
  },
  {
     label:"Arop-Sissano",
     value:"aps"
  },
  {
     label:"Apatani",
     value:"apt"
  },
  {
     label:"Apurin\u00e3",
     value:"apu"
  },
  {
     label:"Western Apache",
     value:"apw"
  },
  {
     label:"Aputai",
     value:"apx"
  },
  {
     label:"Apala\u00ed",
     value:"apy"
  },
  {
     label:"Safeyoka",
     value:"apz"
  },
  {
     label:"Archi",
     value:"aqc"
  },
  {
     label:"Ampari Dogon",
     value:"aqd"
  },
  {
     label:"Arigidi",
     value:"aqg"
  },
  {
     label:"Atohwaim",
     value:"aqm"
  },
  {
     label:"Northern Alta",
     value:"aqn"
  },
  {
     label:"Arh\u00e2",
     value:"aqr"
  },
  {
     label:"Angait\u00e9",
     value:"aqt"
  },
  {
     label:"Akuntsu",
     value:"aqz"
  },
  {
     label:"Arabic",
     value:"ara",
     "iso6392B":"ara",
     "iso6392T":"ara",
     "iso6391":"ar"
  },
  {
     label:"Standard Arabic",
     value:"arb"
  },
  {
     label:"Western Arrarnta",
     value:"are"
  },
  {
     label:"Aragonese",
     value:"arg",
     "iso6392B":"arg",
     "iso6392T":"arg",
     "iso6391":"an"
  },
  {
     label:"Arhuaco",
     value:"arh"
  },
  {
     label:"Arikara",
     value:"ari"
  },
  {
     label:"Arikap\u00fa",
     value:"ark"
  },
  {
     label:"Arabela",
     value:"arl"
  },
  {
     label:"Mapudungun",
     value:"arn",
     "iso6392B":"arn",
     "iso6392T":"arn"
  },
  {
     label:"Araona",
     value:"aro"
  },
  {
     label:"Arapaho",
     value:"arp",
     "iso6392B":"arp",
     "iso6392T":"arp"
  },
  {
     label:"Algerian Arabic",
     value:"arq"
  },
  {
     label:"Karo (Brazil)",
     value:"arr"
  },
  {
     label:"Najdi Arabic",
     value:"ars"
  },
  {
     label:"Arbore",
     value:"arv"
  },
  {
     label:"Arawak",
     value:"arw",
     "iso6392B":"arw",
     "iso6392T":"arw"
  },
  {
     label:"Aru\u00e1 (Rodonia State)",
     value:"arx"
  },
  {
     label:"Moroccan Arabic",
     value:"ary"
  },
  {
     label:"Egyptian Arabic",
     value:"arz"
  },
  {
     label:"Asu (Tanzania)",
     value:"asa"
  },
  {
     label:"Assiniboine",
     value:"asb"
  },
  {
     label:"Casuarina Coast Asmat",
     value:"asc"
  },
  {
     label:"Auslan",
     value:"asf"
  },
  {
     label:"Cishingini",
     value:"asg"
  },
  {
     label:"Buruwai",
     value:"asi"
  },
  {
     label:"Sari",
     value:"asj"
  },
  {
     label:"Ashkun",
     value:"ask"
  },
  {
     label:"Asilulu",
     value:"asl"
  },
  {
     label:"Assamese",
     value:"asm",
     "iso6392B":"asm",
     "iso6392T":"asm",
     "iso6391":"as"
  },
  {
     label:"Xing\u00fa Asurin\u00ed",
     value:"asn"
  },
  {
     label:"Dano",
     value:"aso"
  },
  {
     label:"Asuri",
     value:"asr"
  },
  {
     label:"Ipulo",
     value:"ass"
  },
  {
     label:"Asturian",
     value:"ast",
     "iso6392B":"ast",
     "iso6392T":"ast"
  },
  {
     label:"Tocantins Asurini",
     value:"asu"
  },
  {
     label:"Asoa",
     value:"asv"
  },
  {
     label:"Muratayak",
     value:"asx"
  },
  {
     label:"Yaosakor Asmat",
     value:"asy"
  },
  {
     label:"As",
     value:"asz"
  },
  {
     label:"Pele-Ata",
     value:"ata"
  },
  {
     label:"Zaiwa",
     value:"atb"
  },
  {
     label:"Ata Manobo",
     value:"atd"
  },
  {
     label:"Atemble",
     value:"ate"
  },
  {
     label:"Ivbie North-Okpela-Arhe",
     value:"atg"
  },
  {
     label:"Atti\u00e9",
     value:"ati"
  },
  {
     label:"Atikamekw",
     value:"atj"
  },
  {
     label:"Ati",
     value:"atk"
  },
  {
     label:"Mt. Iraya Agta",
     value:"atl"
  },
  {
     label:"Ata",
     value:"atm"
  },
  {
     label:"Ashtiani",
     value:"atn"
  },
  {
     label:"Atong (Cameroon)",
     value:"ato"
  },
  {
     label:"Pudtol Atta",
     value:"atp"
  },
  {
     label:"Aralle-Tabulahan",
     value:"atq"
  },
  {
     label:"Waimiri-Atroari",
     value:"atr"
  },
  {
     label:"Gros Ventre",
     value:"ats"
  },
  {
     label:"Pamplona Atta",
     value:"att"
  },
  {
     label:"Reel",
     value:"atu"
  },
  {
     label:"Northern Altai",
     value:"atv"
  },
  {
     label:"Atsugewi",
     value:"atw"
  },
  {
     label:"Arutani",
     value:"atx"
  },
  {
     label:"Aneityum",
     value:"aty"
  },
  {
     label:"Arta",
     value:"atz"
  },
  {
     label:"Asumboa",
     value:"aua"
  },
  {
     label:"Alugu",
     value:"aub"
  },
  {
     label:"Waorani",
     value:"auc"
  },
  {
     label:"Anuta",
     value:"aud"
  },
  {
     label:"Aguna",
     value:"aug"
  },
  {
     label:"Aushi",
     value:"auh"
  },
  {
     label:"Anuki",
     value:"aui"
  },
  {
     label:"Awjilah",
     value:"auj"
  },
  {
     label:"Heyo",
     value:"auk"
  },
  {
     label:"Aulua",
     value:"aul"
  },
  {
     label:"Asu (Nigeria)",
     value:"aum"
  },
  {
     label:"Molmo One",
     value:"aun"
  },
  {
     label:"Makayam",
     value:"aup"
  },
  {
     label:"Anus",
     value:"auq"
  },
  {
     label:"Aruek",
     value:"aur"
  },
  {
     label:"Austral",
     value:"aut"
  },
  {
     label:"Auye",
     value:"auu"
  },
  {
     label:"Awyi",
     value:"auw"
  },
  {
     label:"Awiyaana",
     value:"auy"
  },
  {
     label:"Uzbeki Arabic",
     value:"auz"
  },
  {
     label:"Avaric",
     value:"ava",
     "iso6392B":"ava",
     "iso6392T":"ava",
     "iso6391":"av"
  },
  {
     label:"Avau",
     value:"avb"
  },
  {
     label:"Alviri-Vidari",
     value:"avd"
  },
  {
     label:"Avikam",
     value:"avi"
  },
  {
     label:"Kotava",
     value:"avk"
  },
  {
     label:"Eastern Egyptian Bedawi Arabic",
     value:"avl"
  },
  {
     label:"Avatime",
     value:"avn"
  },
  {
     label:"Au",
     value:"avt"
  },
  {
     label:"Avokaya",
     value:"avu"
  },
  {
     label:"Av\u00e1-Canoeiro",
     value:"avv"
  },
  {
     label:"Awadhi",
     value:"awa",
     "iso6392B":"awa",
     "iso6392T":"awa"
  },
  {
     label:"Awa (Papua New Guinea)",
     value:"awb"
  },
  {
     label:"Cicipu",
     value:"awc"
  },
  {
     label:"Awet\u00ed",
     value:"awe"
  },
  {
     label:"Awbono",
     value:"awh"
  },
  {
     label:"Aekyom",
     value:"awi"
  },
  {
     label:"Arawum",
     value:"awm"
  },
  {
     label:"Awngi",
     value:"awn"
  },
  {
     label:"Awak",
     value:"awo"
  },
  {
     label:"Awera",
     value:"awr"
  },
  {
     label:"South Awyu",
     value:"aws"
  },
  {
     label:"Arawet\u00e9",
     value:"awt"
  },
  {
     label:"Central Awyu",
     value:"awu"
  },
  {
     label:"Jair Awyu",
     value:"awv"
  },
  {
     label:"Awun",
     value:"aww"
  },
  {
     label:"Awara",
     value:"awx"
  },
  {
     label:"Edera Awyu",
     value:"awy"
  },
  {
     label:"Yaka (Central African Republic)",
     value:"axk"
  },
  {
     label:"X\u00e2r\u00e2gur\u00e8",
     value:"axx"
  },
  {
     label:"Awar",
     value:"aya"
  },
  {
     label:"Ayizo Gbe",
     value:"ayb"
  },
  {
     label:"Southern Aymara",
     value:"ayc"
  },
  {
     label:"Ayere",
     value:"aye"
  },
  {
     label:"Ginyanga",
     value:"ayg"
  },
  {
     label:"Hadrami Arabic",
     value:"ayh"
  },
  {
     label:"Leyigha",
     value:"ayi"
  },
  {
     label:"Akuku",
     value:"ayk"
  },
  {
     label:"Libyan Arabic",
     value:"ayl"
  },
  {
     label:"Aymara",
     value:"aym",
     "iso6392B":"aym",
     "iso6392T":"aym",
     "iso6391":"ay"
  },
  {
     label:"Sanaani Arabic",
     value:"ayn"
  },
  {
     label:"Ayoreo",
     value:"ayo"
  },
  {
     label:"North Mesopotamian Arabic",
     value:"ayp"
  },
  {
     label:"Ayi (Papua New Guinea)",
     value:"ayq"
  },
  {
     label:"Central Aymara",
     value:"ayr"
  },
  {
     label:"Sorsogon Ayta",
     value:"ays"
  },
  {
     label:"Magbukun Ayta",
     value:"ayt"
  },
  {
     label:"Ayu",
     value:"ayu"
  },
  {
     label:"Mai Brat",
     value:"ayz"
  },
  {
     label:"Azha",
     value:"aza"
  },
  {
     label:"South Azerbaijani",
     value:"azb"
  },
  {
     label:"Eastern Durango Nahuatl",
     value:"azd"
  },
  {
     label:"Azerbaijani",
     value:"aze",
     "iso6392B":"aze",
     "iso6392T":"aze",
     "iso6391":"az"
  },
  {
     label:"San Pedro Amuzgos Amuzgo",
     value:"azg"
  },
  {
     label:"North Azerbaijani",
     value:"azj"
  },
  {
     label:"Ipalapa Amuzgo",
     value:"azm"
  },
  {
     label:"Western Durango Nahuatl",
     value:"azn"
  },
  {
     label:"Awing",
     value:"azo"
  },
  {
     label:"Faire Atta",
     value:"azt"
  },
  {
     label:"Highland Puebla Nahuatl",
     value:"azz"
  },
  {
     label:"Babatana",
     value:"baa"
  },
  {
     label:"Bainouk-Gunyu\u00f1o",
     value:"bab"
  },
  {
     label:"Badui",
     value:"bac"
  },
  {
     label:"Nubaca",
     value:"baf"
  },
  {
     label:"Tuki",
     value:"bag"
  },
  {
     label:"Bahamas Creole English",
     value:"bah"
  },
  {
     label:"Barakai",
     value:"baj"
  },
  {
     label:"Bashkir",
     value:"bak",
     "iso6392B":"bak",
     "iso6392T":"bak",
     "iso6391":"ba"
  },
  {
     label:"Baluchi",
     value:"bal",
     "iso6392B":"bal",
     "iso6392T":"bal"
  },
  {
     label:"Bambara",
     value:"bam",
     "iso6392B":"bam",
     "iso6392T":"bam",
     "iso6391":"bm"
  },
  {
     label:"Balinese",
     value:"ban",
     "iso6392B":"ban",
     "iso6392T":"ban"
  },
  {
     label:"Waimaha",
     value:"bao"
  },
  {
     label:"Bantawa",
     value:"bap"
  },
  {
     label:"Bavarian",
     value:"bar"
  },
  {
     label:"Basa (Cameroon)",
     value:"bas",
     "iso6392B":"bas",
     "iso6392T":"bas"
  },
  {
     label:"Bada (Nigeria)",
     value:"bau"
  },
  {
     label:"Vengo",
     value:"bav"
  },
  {
     label:"Bambili-Bambui",
     value:"baw"
  },
  {
     label:"Bamun",
     value:"bax"
  },
  {
     label:"Batuley",
     value:"bay"
  },
  {
     label:"Baatonum",
     value:"bba"
  },
  {
     label:"Barai",
     value:"bbb"
  },
  {
     label:"Batak Toba",
     value:"bbc"
  },
  {
     label:"Bau",
     value:"bbd"
  },
  {
     label:"Bangba",
     value:"bbe"
  },
  {
     label:"Baibai",
     value:"bbf"
  },
  {
     label:"Barama",
     value:"bbg"
  },
  {
     label:"Bugan",
     value:"bbh"
  },
  {
     label:"Barombi",
     value:"bbi"
  },
  {
     label:"Ghom\u00e1l\u00e1'",
     value:"bbj"
  },
  {
     label:"Babanki",
     value:"bbk"
  },
  {
     label:"Bats",
     value:"bbl"
  },
  {
     label:"Babango",
     value:"bbm"
  },
  {
     label:"Uneapa",
     value:"bbn"
  },
  {
     label:"Northern Bobo Madar\u00e9",
     value:"bbo"
  },
  {
     label:"West Central Banda",
     value:"bbp"
  },
  {
     label:"Bamali",
     value:"bbq"
  },
  {
     label:"Girawa",
     value:"bbr"
  },
  {
     label:"Bakpinka",
     value:"bbs"
  },
  {
     label:"Mburku",
     value:"bbt"
  },
  {
     label:"Kulung (Nigeria)",
     value:"bbu"
  },
  {
     label:"Karnai",
     value:"bbv"
  },
  {
     label:"Baba",
     value:"bbw"
  },
  {
     label:"Bubia",
     value:"bbx"
  },
  {
     label:"Befang",
     value:"bby"
  },
  {
     label:"Central Bai",
     value:"bca"
  },
  {
     label:"Bainouk-Samik",
     value:"bcb"
  },
  {
     label:"Southern Balochi",
     value:"bcc"
  },
  {
     label:"North Babar",
     value:"bcd"
  },
  {
     label:"Bamenyam",
     value:"bce"
  },
  {
     label:"Bamu",
     value:"bcf"
  },
  {
     label:"Baga Pokur",
     value:"bcg"
  },
  {
     label:"Bariai",
     value:"bch"
  },
  {
     label:"Baoul\u00e9",
     value:"bci"
  },
  {
     label:"Bardi",
     value:"bcj"
  },
  {
     label:"Bunuba",
     value:"bck"
  },
  {
     label:"Central Bikol",
     value:"bcl"
  },
  {
     label:"Bannoni",
     value:"bcm"
  },
  {
     label:"Bali (Nigeria)",
     value:"bcn"
  },
  {
     label:"Kaluli",
     value:"bco"
  },
  {
     label:"Bali (Democratic Republic of Congo)",
     value:"bcp"
  },
  {
     label:"Bench",
     value:"bcq"
  },
  {
     label:"Babine",
     value:"bcr"
  },
  {
     label:"Kohumono",
     value:"bcs"
  },
  {
     label:"Bendi",
     value:"bct"
  },
  {
     label:"Awad Bing",
     value:"bcu"
  },
  {
     label:"Shoo-Minda-Nye",
     value:"bcv"
  },
  {
     label:"Bana",
     value:"bcw"
  },
  {
     label:"Bacama",
     value:"bcy"
  },
  {
     label:"Bainouk-Gunyaamolo",
     value:"bcz"
  },
  {
     label:"Bayot",
     value:"bda"
  },
  {
     label:"Basap",
     value:"bdb"
  },
  {
     label:"Ember\u00e1-Baud\u00f3",
     value:"bdc"
  },
  {
     label:"Bunama",
     value:"bdd"
  },
  {
     label:"Bade",
     value:"bde"
  },
  {
     label:"Biage",
     value:"bdf"
  },
  {
     label:"Bonggi",
     value:"bdg"
  },
  {
     label:"Baka (South Sudan)",
     value:"bdh"
  },
  {
     label:"Burun",
     value:"bdi"
  },
  {
     label:"Bai (South Sudan)",
     value:"bdj"
  },
  {
     label:"Budukh",
     value:"bdk"
  },
  {
     label:"Indonesian Bajau",
     value:"bdl"
  },
  {
     label:"Buduma",
     value:"bdm"
  },
  {
     label:"Baldemu",
     value:"bdn"
  },
  {
     label:"Morom",
     value:"bdo"
  },
  {
     label:"Bende",
     value:"bdp"
  },
  {
     label:"Bahnar",
     value:"bdq"
  },
  {
     label:"West Coast Bajau",
     value:"bdr"
  },
  {
     label:"Burunge",
     value:"bds"
  },
  {
     label:"Bokoto",
     value:"bdt"
  },
  {
     label:"Oroko",
     value:"bdu"
  },
  {
     label:"Bodo Parja",
     value:"bdv"
  },
  {
     label:"Baham",
     value:"bdw"
  },
  {
     label:"Budong-Budong",
     value:"bdx"
  },
  {
     label:"Bandjalang",
     value:"bdy"
  },
  {
     label:"Badeshi",
     value:"bdz"
  },
  {
     label:"Beaver",
     value:"bea"
  },
  {
     label:"Bebele",
     value:"beb"
  },
  {
     label:"Iceve-Maci",
     value:"bec"
  },
  {
     label:"Bedoanas",
     value:"bed"
  },
  {
     label:"Byangsi",
     value:"bee"
  },
  {
     label:"Benabena",
     value:"bef"
  },
  {
     label:"Belait",
     value:"beg"
  },
  {
     label:"Biali",
     value:"beh"
  },
  {
     label:"Bekati'",
     value:"bei"
  },
  {
     label:"Beja",
     value:"bej",
     "iso6392B":"bej",
     "iso6392T":"bej"
  },
  {
     label:"Bebeli",
     value:"bek"
  },
  {
     label:"Belarusian",
     value:"bel",
     "iso6392B":"bel",
     "iso6392T":"bel",
     "iso6391":"be"
  },
  {
     label:"Bemba (Zambia)",
     value:"bem",
     "iso6392B":"bem",
     "iso6392T":"bem"
  },
  {
     label:"Bengali",
     value:"ben",
     "iso6392B":"ben",
     "iso6392T":"ben",
     "iso6391":"bn"
  },
  {
     label:"Beami",
     value:"beo"
  },
  {
     label:"Besoa",
     value:"bep"
  },
  {
     label:"Beembe",
     value:"beq"
  },
  {
     label:"Besme",
     value:"bes"
  },
  {
     label:"Guiberoua B\u00e9te",
     value:"bet"
  },
  {
     label:"Blagar",
     value:"beu"
  },
  {
     label:"Daloa B\u00e9t\u00e9",
     value:"bev"
  },
  {
     label:"Betawi",
     value:"bew"
  },
  {
     label:"Jur Modo",
     value:"bex"
  },
  {
     label:"Beli (Papua New Guinea)",
     value:"bey"
  },
  {
     label:"Bena (Tanzania)",
     value:"bez"
  },
  {
     label:"Bari",
     value:"bfa"
  },
  {
     label:"Pauri Bareli",
     value:"bfb"
  },
  {
     label:"Panyi Bai",
     value:"bfc"
  },
  {
     label:"Bafut",
     value:"bfd"
  },
  {
     label:"Betaf",
     value:"bfe"
  },
  {
     label:"Bofi",
     value:"bff"
  },
  {
     label:"Busang Kayan",
     value:"bfg"
  },
  {
     label:"Blafe",
     value:"bfh"
  },
  {
     label:"Bafanji",
     value:"bfj"
  },
  {
     label:"Banda-Nd\u00e9l\u00e9",
     value:"bfl"
  },
  {
     label:"Mmen",
     value:"bfm"
  },
  {
     label:"Bunak",
     value:"bfn"
  },
  {
     label:"Malba Birifor",
     value:"bfo"
  },
  {
     label:"Beba",
     value:"bfp"
  },
  {
     label:"Badaga",
     value:"bfq"
  },
  {
     label:"Bazigar",
     value:"bfr"
  },
  {
     label:"Southern Bai",
     value:"bfs"
  },
  {
     label:"Balti",
     value:"bft"
  },
  {
     label:"Gahri",
     value:"bfu"
  },
  {
     label:"Bondo",
     value:"bfw"
  },
  {
     label:"Bantayanon",
     value:"bfx"
  },
  {
     label:"Bagheli",
     value:"bfy"
  },
  {
     label:"Mahasu Pahari",
     value:"bfz"
  },
  {
     label:"Gwamhi-Wuri",
     value:"bga"
  },
  {
     label:"Bobongko",
     value:"bgb"
  },
  {
     label:"Haryanvi",
     value:"bgc"
  },
  {
     label:"Rathwi Bareli",
     value:"bgd"
  },
  {
     label:"Bauria",
     value:"bge"
  },
  {
     label:"Bangandu",
     value:"bgf"
  },
  {
     label:"Bugun",
     value:"bgg"
  },
  {
     label:"Giangan",
     value:"bgi"
  },
  {
     label:"Bangolan",
     value:"bgj"
  },
  {
     label:"Bit",
     value:"bgk"
  },
  {
     label:"Bo (Laos)",
     value:"bgl"
  },
  {
     label:"Western Balochi",
     value:"bgn"
  },
  {
     label:"Baga Koga",
     value:"bgo"
  },
  {
     label:"Eastern Balochi",
     value:"bgp"
  },
  {
     label:"Bagri",
     value:"bgq"
  },
  {
     label:"Bawm Chin",
     value:"bgr"
  },
  {
     label:"Tagabawa",
     value:"bgs"
  },
  {
     label:"Bughotu",
     value:"bgt"
  },
  {
     label:"Mbongno",
     value:"bgu"
  },
  {
     label:"Warkay-Bipim",
     value:"bgv"
  },
  {
     label:"Bhatri",
     value:"bgw"
  },
  {
     label:"Balkan Gagauz Turkish",
     value:"bgx"
  },
  {
     label:"Benggoi",
     value:"bgy"
  },
  {
     label:"Banggai",
     value:"bgz"
  },
  {
     label:"Bharia",
     value:"bha"
  },
  {
     label:"Bhili",
     value:"bhb"
  },
  {
     label:"Biga",
     value:"bhc"
  },
  {
     label:"Bhadrawahi",
     value:"bhd"
  },
  {
     label:"Bhaya",
     value:"bhe"
  },
  {
     label:"Odiai",
     value:"bhf"
  },
  {
     label:"Binandere",
     value:"bhg"
  },
  {
     label:"Bukharic",
     value:"bhh"
  },
  {
     label:"Bhilali",
     value:"bhi"
  },
  {
     label:"Bahing",
     value:"bhj"
  },
  {
     label:"Bimin",
     value:"bhl"
  },
  {
     label:"Bathari",
     value:"bhm"
  },
  {
     label:"Bohtan Neo-Aramaic",
     value:"bhn"
  },
  {
     label:"Bhojpuri",
     value:"bho",
     "iso6392B":"bho",
     "iso6392T":"bho"
  },
  {
     label:"Bima",
     value:"bhp"
  },
  {
     label:"Tukang Besi South",
     value:"bhq"
  },
  {
     label:"Bara Malagasy",
     value:"bhr"
  },
  {
     label:"Buwal",
     value:"bhs"
  },
  {
     label:"Bhattiyali",
     value:"bht"
  },
  {
     label:"Bhunjia",
     value:"bhu"
  },
  {
     label:"Bahau",
     value:"bhv"
  },
  {
     label:"Biak",
     value:"bhw"
  },
  {
     label:"Bhalay",
     value:"bhx"
  },
  {
     label:"Bhele",
     value:"bhy"
  },
  {
     label:"Bada (Indonesia)",
     value:"bhz"
  },
  {
     label:"Badimaya",
     value:"bia"
  },
  {
     label:"Bissa",
     value:"bib"
  },
  {
     label:"Bikaru",
     value:"bic"
  },
  {
     label:"Bidiyo",
     value:"bid"
  },
  {
     label:"Bepour",
     value:"bie"
  },
  {
     label:"Biafada",
     value:"bif"
  },
  {
     label:"Biangai",
     value:"big"
  },
  {
     label:"Vaghat-Ya-Bijim-Legeri",
     value:"bij"
  },
  {
     label:"Bikol",
     value:"bik",
     "iso6392B":"bik",
     "iso6392T":"bik"
  },
  {
     label:"Bile",
     value:"bil"
  },
  {
     label:"Bimoba",
     value:"bim"
  },
  {
     label:"Bini",
     value:"bin",
     "iso6392B":"bin",
     "iso6392T":"bin"
  },
  {
     label:"Nai",
     value:"bio"
  },
  {
     label:"Bila",
     value:"bip"
  },
  {
     label:"Bipi",
     value:"biq"
  },
  {
     label:"Bisorio",
     value:"bir"
  },
  {
     label:"Bislama",
     value:"bis",
     "iso6392B":"bis",
     "iso6392T":"bis",
     "iso6391":"bi"
  },
  {
     label:"Berinomo",
     value:"bit"
  },
  {
     label:"Biete",
     value:"biu"
  },
  {
     label:"Southern Birifor",
     value:"biv"
  },
  {
     label:"Kol (Cameroon)",
     value:"biw"
  },
  {
     label:"Bijori",
     value:"bix"
  },
  {
     label:"Birhor",
     value:"biy"
  },
  {
     label:"Baloi",
     value:"biz"
  },
  {
     label:"Budza",
     value:"bja"
  },
  {
     label:"Bariji",
     value:"bjc"
  },
  {
     label:"Biao-Jiao Mien",
     value:"bje"
  },
  {
     label:"Barzani Jewish Neo-Aramaic",
     value:"bjf"
  },
  {
     label:"Bidyogo",
     value:"bjg"
  },
  {
     label:"Bahinemo",
     value:"bjh"
  },
  {
     label:"Burji",
     value:"bji"
  },
  {
     label:"Kanauji",
     value:"bjj"
  },
  {
     label:"Barok",
     value:"bjk"
  },
  {
     label:"Bulu (Papua New Guinea)",
     value:"bjl"
  },
  {
     label:"Bajelani",
     value:"bjm"
  },
  {
     label:"Banjar",
     value:"bjn"
  },
  {
     label:"Mid-Southern Banda",
     value:"bjo"
  },
  {
     label:"Fanamaket",
     value:"bjp"
  },
  {
     label:"Binumarien",
     value:"bjr"
  },
  {
     label:"Bajan",
     value:"bjs"
  },
  {
     label:"Balanta-Ganja",
     value:"bjt"
  },
  {
     label:"Busuu",
     value:"bju"
  },
  {
     label:"Bedjond",
     value:"bjv"
  },
  {
     label:"Bakw\u00e9",
     value:"bjw"
  },
  {
     label:"Banao Itneg",
     value:"bjx"
  },
  {
     label:"Baruga",
     value:"bjz"
  },
  {
     label:"Kyak",
     value:"bka"
  },
  {
     label:"Baka (Cameroon)",
     value:"bkc"
  },
  {
     label:"Binukid",
     value:"bkd"
  },
  {
     label:"Beeke",
     value:"bkf"
  },
  {
     label:"Buraka",
     value:"bkg"
  },
  {
     label:"Bakoko",
     value:"bkh"
  },
  {
     label:"Baki",
     value:"bki"
  },
  {
     label:"Pande",
     value:"bkj"
  },
  {
     label:"Brokskat",
     value:"bkk"
  },
  {
     label:"Berik",
     value:"bkl"
  },
  {
     label:"Kom (Cameroon)",
     value:"bkm"
  },
  {
     label:"Bukitan",
     value:"bkn"
  },
  {
     label:"Kwa'",
     value:"bko"
  },
  {
     label:"Boko (Democratic Republic of Congo)",
     value:"bkp"
  },
  {
     label:"Bakair\u00ed",
     value:"bkq"
  },
  {
     label:"Bakumpai",
     value:"bkr"
  },
  {
     label:"Northern Sorsoganon",
     value:"bks"
  },
  {
     label:"Boloki",
     value:"bkt"
  },
  {
     label:"Buhid",
     value:"bku"
  },
  {
     label:"Bekwarra",
     value:"bkv"
  },
  {
     label:"Bekwel",
     value:"bkw"
  },
  {
     label:"Baikeno",
     value:"bkx"
  },
  {
     label:"Bokyi",
     value:"bky"
  },
  {
     label:"Bungku",
     value:"bkz"
  },
  {
     label:"Siksika",
     value:"bla",
     "iso6392B":"bla",
     "iso6392T":"bla"
  },
  {
     label:"Bilua",
     value:"blb"
  },
  {
     label:"Bella Coola",
     value:"blc"
  },
  {
     label:"Bolango",
     value:"bld"
  },
  {
     label:"Balanta-Kentohe",
     value:"ble"
  },
  {
     label:"Buol",
     value:"blf"
  },
  {
     label:"Balau",
     value:"blg"
  },
  {
     label:"Kuwaa",
     value:"blh"
  },
  {
     label:"Bolia",
     value:"bli"
  },
  {
     label:"Bolongan",
     value:"blj"
  },
  {
     label:"Pa'o Karen",
     value:"blk"
  },
  {
     label:"Beli (South Sudan)",
     value:"blm"
  },
  {
     label:"Southern Catanduanes Bikol",
     value:"bln"
  },
  {
     label:"Anii",
     value:"blo"
  },
  {
     label:"Blablanga",
     value:"blp"
  },
  {
     label:"Baluan-Pam",
     value:"blq"
  },
  {
     label:"Blang",
     value:"blr"
  },
  {
     label:"Balaesang",
     value:"bls"
  },
  {
     label:"Tai Dam",
     value:"blt"
  },
  {
     label:"Kibala",
     value:"blv"
  },
  {
     label:"Balangao",
     value:"blw"
  },
  {
     label:"Mag-Indi Ayta",
     value:"blx"
  },
  {
     label:"Notre",
     value:"bly"
  },
  {
     label:"Balantak",
     value:"blz"
  },
  {
     label:"Lame",
     value:"bma"
  },
  {
     label:"Bembe",
     value:"bmb"
  },
  {
     label:"Biem",
     value:"bmc"
  },
  {
     label:"Baga Manduri",
     value:"bmd"
  },
  {
     label:"Limassa",
     value:"bme"
  },
  {
     label:"Bom-Kim",
     value:"bmf"
  },
  {
     label:"Bamwe",
     value:"bmg"
  },
  {
     label:"Kein",
     value:"bmh"
  },
  {
     label:"Bagirmi",
     value:"bmi"
  },
  {
     label:"Bote-Majhi",
     value:"bmj"
  },
  {
     label:"Ghayavi",
     value:"bmk"
  },
  {
     label:"Bomboli",
     value:"bml"
  },
  {
     label:"Northern Betsimisaraka Malagasy",
     value:"bmm"
  },
  {
     label:"Bambalang",
     value:"bmo"
  },
  {
     label:"Bulgebi",
     value:"bmp"
  },
  {
     label:"Bomu",
     value:"bmq"
  },
  {
     label:"Muinane",
     value:"bmr"
  },
  {
     label:"Bilma Kanuri",
     value:"bms"
  },
  {
     label:"Biao Mon",
     value:"bmt"
  },
  {
     label:"Somba-Siawari",
     value:"bmu"
  },
  {
     label:"Bum",
     value:"bmv"
  },
  {
     label:"Bomwali",
     value:"bmw"
  },
  {
     label:"Baimak",
     value:"bmx"
  },
  {
     label:"Baramu",
     value:"bmz"
  },
  {
     label:"Bonerate",
     value:"bna"
  },
  {
     label:"Bookan",
     value:"bnb"
  },
  {
     label:"Bontok",
     value:"bnc"
  },
  {
     label:"Banda (Indonesia)",
     value:"bnd"
  },
  {
     label:"Bintauna",
     value:"bne"
  },
  {
     label:"Masiwang",
     value:"bnf"
  },
  {
     label:"Benga",
     value:"bng"
  },
  {
     label:"Bangi",
     value:"bni"
  },
  {
     label:"Eastern Tawbuid",
     value:"bnj"
  },
  {
     label:"Bierebo",
     value:"bnk"
  },
  {
     label:"Boon",
     value:"bnl"
  },
  {
     label:"Batanga",
     value:"bnm"
  },
  {
     label:"Bunun",
     value:"bnn"
  },
  {
     label:"Bantoanon",
     value:"bno"
  },
  {
     label:"Bola",
     value:"bnp"
  },
  {
     label:"Bantik",
     value:"bnq"
  },
  {
     label:"Butmas-Tur",
     value:"bnr"
  },
  {
     label:"Bundeli",
     value:"bns"
  },
  {
     label:"Bentong",
     value:"bnu"
  },
  {
     label:"Bonerif",
     value:"bnv"
  },
  {
     label:"Bisis",
     value:"bnw"
  },
  {
     label:"Bangubangu",
     value:"bnx"
  },
  {
     label:"Bintulu",
     value:"bny"
  },
  {
     label:"Beezen",
     value:"bnz"
  },
  {
     label:"Bora",
     value:"boa"
  },
  {
     label:"Aweer",
     value:"bob"
  },
  {
     label:"Tibetan",
     value:"bod",
     "iso6392B":"tib",
     "iso6392T":"bod",
     "iso6391":"bo"
  },
  {
     label:"Mundabli",
     value:"boe"
  },
  {
     label:"Bolon",
     value:"bof"
  },
  {
     label:"Boma",
     value:"boh"
  },
  {
     label:"Anjam",
     value:"boj"
  },
  {
     label:"Bonjo",
     value:"bok"
  },
  {
     label:"Bole",
     value:"bol"
  },
  {
     label:"Berom",
     value:"bom"
  },
  {
     label:"Bine",
     value:"bon"
  },
  {
     label:"Tiemac\u00e8w\u00e8 Bozo",
     value:"boo"
  },
  {
     label:"Bonkiman",
     value:"bop"
  },
  {
     label:"Bogaya",
     value:"boq"
  },
  {
     label:"Bor\u00f4ro",
     value:"bor"
  },
  {
     label:"Bosnian",
     value:"bos",
     "iso6392B":"bos",
     "iso6392T":"bos",
     "iso6391":"bs"
  },
  {
     label:"Bongo",
     value:"bot"
  },
  {
     label:"Bondei",
     value:"bou"
  },
  {
     label:"Tuwuli",
     value:"bov"
  },
  {
     label:"Buamu",
     value:"box"
  },
  {
     label:"Bodo (Central African Republic)",
     value:"boy"
  },
  {
     label:"Ti\u00e9yaxo Bozo",
     value:"boz"
  },
  {
     label:"Daakaka",
     value:"bpa"
  },
  {
     label:"Banda-Banda",
     value:"bpd"
  },
  {
     label:"Bonggo",
     value:"bpg"
  },
  {
     label:"Botlikh",
     value:"bph"
  },
  {
     label:"Bagupi",
     value:"bpi"
  },
  {
     label:"Binji",
     value:"bpj"
  },
  {
     label:"Orowe",
     value:"bpk"
  },
  {
     label:"Broome Pearling Lugger Pidgin",
     value:"bpl"
  },
  {
     label:"Biyom",
     value:"bpm"
  },
  {
     label:"Dzao Min",
     value:"bpn"
  },
  {
     label:"Anasi",
     value:"bpo"
  },
  {
     label:"Kaure",
     value:"bpp"
  },
  {
     label:"Banda Malay",
     value:"bpq"
  },
  {
     label:"Koronadal Blaan",
     value:"bpr"
  },
  {
     label:"Sarangani Blaan",
     value:"bps"
  },
  {
     label:"Bongu",
     value:"bpu"
  },
  {
     label:"Bian Marind",
     value:"bpv"
  },
  {
     label:"Bo (Papua New Guinea)",
     value:"bpw"
  },
  {
     label:"Palya Bareli",
     value:"bpx"
  },
  {
     label:"Bishnupriya",
     value:"bpy"
  },
  {
     label:"Bilba",
     value:"bpz"
  },
  {
     label:"Tchumbuli",
     value:"bqa"
  },
  {
     label:"Bagusa",
     value:"bqb"
  },
  {
     label:"Boko (Benin)",
     value:"bqc"
  },
  {
     label:"Bung",
     value:"bqd"
  },
  {
     label:"Bago-Kusuntu",
     value:"bqg"
  },
  {
     label:"Baima",
     value:"bqh"
  },
  {
     label:"Bakhtiari",
     value:"bqi"
  },
  {
     label:"Bandial",
     value:"bqj"
  },
  {
     label:"Banda-Mbr\u00e8s",
     value:"bqk"
  },
  {
     label:"Bilakura",
     value:"bql"
  },
  {
     label:"Wumboko",
     value:"bqm"
  },
  {
     label:"Balo",
     value:"bqo"
  },
  {
     label:"Busa",
     value:"bqp"
  },
  {
     label:"Biritai",
     value:"bqq"
  },
  {
     label:"Burusu",
     value:"bqr"
  },
  {
     label:"Bosngun",
     value:"bqs"
  },
  {
     label:"Bamukumbit",
     value:"bqt"
  },
  {
     label:"Boguru",
     value:"bqu"
  },
  {
     label:"Koro Wachi",
     value:"bqv"
  },
  {
     label:"Buru (Nigeria)",
     value:"bqw"
  },
  {
     label:"Baangi",
     value:"bqx"
  },
  {
     label:"Bakaka",
     value:"bqz"
  },
  {
     label:"Braj",
     value:"bra",
     "iso6392B":"bra",
     "iso6392T":"bra"
  },
  {
     label:"Lave",
     value:"brb"
  },
  {
     label:"Baraamu",
     value:"brd"
  },
  {
     label:"Breton",
     value:"bre",
     "iso6392B":"bre",
     "iso6392T":"bre",
     "iso6391":"br"
  },
  {
     label:"Bira",
     value:"brf"
  },
  {
     label:"Baure",
     value:"brg"
  },
  {
     label:"Brahui",
     value:"brh"
  },
  {
     label:"Mokpwe",
     value:"bri"
  },
  {
     label:"Bieria",
     value:"brj"
  },
  {
     label:"Birwa",
     value:"brl"
  },
  {
     label:"Barambu",
     value:"brm"
  },
  {
     label:"Boruca",
     value:"brn"
  },
  {
     label:"Brokkat",
     value:"bro"
  },
  {
     label:"Barapasi",
     value:"brp"
  },
  {
     label:"Breri",
     value:"brq"
  },
  {
     label:"Birao",
     value:"brr"
  },
  {
     label:"Baras",
     value:"brs"
  },
  {
     label:"Bitare",
     value:"brt"
  },
  {
     label:"Eastern Bru",
     value:"bru"
  },
  {
     label:"Western Bru",
     value:"brv"
  },
  {
     label:"Bellari",
     value:"brw"
  },
  {
     label:"Bodo (India)",
     value:"brx"
  },
  {
     label:"Burui",
     value:"bry"
  },
  {
     label:"Bilbil",
     value:"brz"
  },
  {
     label:"Abinomn",
     value:"bsa"
  },
  {
     label:"Brunei Bisaya",
     value:"bsb"
  },
  {
     label:"Bassari",
     value:"bsc"
  },
  {
     label:"Wushi",
     value:"bse"
  },
  {
     label:"Bauchi",
     value:"bsf"
  },
  {
     label:"Bashkardi",
     value:"bsg"
  },
  {
     label:"Kati",
     value:"bsh"
  },
  {
     label:"Bassossi",
     value:"bsi"
  },
  {
     label:"Bangwinji",
     value:"bsj"
  },
  {
     label:"Burushaski",
     value:"bsk"
  },
  {
     label:"Busami",
     value:"bsm"
  },
  {
     label:"Barasana-Eduria",
     value:"bsn"
  },
  {
     label:"Buso",
     value:"bso"
  },
  {
     label:"Baga Sitemu",
     value:"bsp"
  },
  {
     label:"Bassa",
     value:"bsq"
  },
  {
     label:"Bassa-Kontagora",
     value:"bsr"
  },
  {
     label:"Akoose",
     value:"bss"
  },
  {
     label:"Basketo",
     value:"bst"
  },
  {
     label:"Bahonsuai",
     value:"bsu"
  },
  {
     label:"Baiso",
     value:"bsw"
  },
  {
     label:"Yangkam",
     value:"bsx"
  },
  {
     label:"Sabah Bisaya",
     value:"bsy"
  },
  {
     label:"Bata",
     value:"bta"
  },
  {
     label:"Bati (Cameroon)",
     value:"btc"
  },
  {
     label:"Batak Dairi",
     value:"btd"
  },
  {
     label:"Birgit",
     value:"btf"
  },
  {
     label:"Gagnoa B\u00e9t\u00e9",
     value:"btg"
  },
  {
     label:"Biatah Bidayuh",
     value:"bth"
  },
  {
     label:"Burate",
     value:"bti"
  },
  {
     label:"Bacanese Malay",
     value:"btj"
  },
  {
     label:"Batak Mandailing",
     value:"btm"
  },
  {
     label:"Ratagnon",
     value:"btn"
  },
  {
     label:"Rinconada Bikol",
     value:"bto"
  },
  {
     label:"Budibud",
     value:"btp"
  },
  {
     label:"Batek",
     value:"btq"
  },
  {
     label:"Baetora",
     value:"btr"
  },
  {
     label:"Batak Simalungun",
     value:"bts"
  },
  {
     label:"Bete-Bendi",
     value:"btt"
  },
  {
     label:"Batu",
     value:"btu"
  },
  {
     label:"Bateri",
     value:"btv"
  },
  {
     label:"Butuanon",
     value:"btw"
  },
  {
     label:"Batak Karo",
     value:"btx"
  },
  {
     label:"Bobot",
     value:"bty"
  },
  {
     label:"Batak Alas-Kluet",
     value:"btz"
  },
  {
     label:"Buriat",
     value:"bua",
     "iso6392B":"bua",
     "iso6392T":"bua"
  },
  {
     label:"Bua",
     value:"bub"
  },
  {
     label:"Bushi",
     value:"buc"
  },
  {
     label:"Ntcham",
     value:"bud"
  },
  {
     label:"Bushoong",
     value:"buf"
  },
  {
     label:"Buginese",
     value:"bug",
     "iso6392B":"bug",
     "iso6392T":"bug"
  },
  {
     label:"Younuo Bunu",
     value:"buh"
  },
  {
     label:"Bongili",
     value:"bui"
  },
  {
     label:"Basa-Gurmana",
     value:"buj"
  },
  {
     label:"Bugawac",
     value:"buk"
  },
  {
     label:"Bulgarian",
     value:"bul",
     "iso6392B":"bul",
     "iso6392T":"bul",
     "iso6391":"bg"
  },
  {
     label:"Bulu (Cameroon)",
     value:"bum"
  },
  {
     label:"Sherbro",
     value:"bun"
  },
  {
     label:"Terei",
     value:"buo"
  },
  {
     label:"Busoa",
     value:"bup"
  },
  {
     label:"Brem",
     value:"buq"
  },
  {
     label:"Bokobaru",
     value:"bus"
  },
  {
     label:"Bungain",
     value:"but"
  },
  {
     label:"Budu",
     value:"buu"
  },
  {
     label:"Bun",
     value:"buv"
  },
  {
     label:"Bubi",
     value:"buw"
  },
  {
     label:"Boghom",
     value:"bux"
  },
  {
     label:"Bullom So",
     value:"buy"
  },
  {
     label:"Bukwen",
     value:"buz"
  },
  {
     label:"Barein",
     value:"bva"
  },
  {
     label:"Bube",
     value:"bvb"
  },
  {
     label:"Baelelea",
     value:"bvc"
  },
  {
     label:"Baeggu",
     value:"bvd"
  },
  {
     label:"Berau Malay",
     value:"bve"
  },
  {
     label:"Boor",
     value:"bvf"
  },
  {
     label:"Bonkeng",
     value:"bvg"
  },
  {
     label:"Bure",
     value:"bvh"
  },
  {
     label:"Belanda Viri",
     value:"bvi"
  },
  {
     label:"Baan",
     value:"bvj"
  },
  {
     label:"Bukat",
     value:"bvk"
  },
  {
     label:"Bamunka",
     value:"bvm"
  },
  {
     label:"Buna",
     value:"bvn"
  },
  {
     label:"Bolgo",
     value:"bvo"
  },
  {
     label:"Bumang",
     value:"bvp"
  },
  {
     label:"Birri",
     value:"bvq"
  },
  {
     label:"Burarra",
     value:"bvr"
  },
  {
     label:"Bati (Indonesia)",
     value:"bvt"
  },
  {
     label:"Bukit Malay",
     value:"bvu"
  },
  {
     label:"Boga",
     value:"bvw"
  },
  {
     label:"Dibole",
     value:"bvx"
  },
  {
     label:"Baybayanon",
     value:"bvy"
  },
  {
     label:"Bauzi",
     value:"bvz"
  },
  {
     label:"Bwatoo",
     value:"bwa"
  },
  {
     label:"Namosi-Naitasiri-Serua",
     value:"bwb"
  },
  {
     label:"Bwile",
     value:"bwc"
  },
  {
     label:"Bwaidoka",
     value:"bwd"
  },
  {
     label:"Bwe Karen",
     value:"bwe"
  },
  {
     label:"Boselewa",
     value:"bwf"
  },
  {
     label:"Barwe",
     value:"bwg"
  },
  {
     label:"Bishuo",
     value:"bwh"
  },
  {
     label:"Baniwa",
     value:"bwi"
  },
  {
     label:"L\u00e1\u00e1 L\u00e1\u00e1 Bwamu",
     value:"bwj"
  },
  {
     label:"Bauwaki",
     value:"bwk"
  },
  {
     label:"Bwela",
     value:"bwl"
  },
  {
     label:"Biwat",
     value:"bwm"
  },
  {
     label:"Wunai Bunu",
     value:"bwn"
  },
  {
     label:"Boro (Ethiopia)",
     value:"bwo"
  },
  {
     label:"Mandobo Bawah",
     value:"bwp"
  },
  {
     label:"Southern Bobo Madar\u00e9",
     value:"bwq"
  },
  {
     label:"Bura-Pabir",
     value:"bwr"
  },
  {
     label:"Bomboma",
     value:"bws"
  },
  {
     label:"Bafaw-Balong",
     value:"bwt"
  },
  {
     label:"Buli (Ghana)",
     value:"bwu"
  },
  {
     label:"Bwa",
     value:"bww"
  },
  {
     label:"Bu-Nao Bunu",
     value:"bwx"
  },
  {
     label:"Cwi Bwamu",
     value:"bwy"
  },
  {
     label:"Bwisi",
     value:"bwz"
  },
  {
     label:"Tairaha",
     value:"bxa"
  },
  {
     label:"Belanda Bor",
     value:"bxb"
  },
  {
     label:"Molengue",
     value:"bxc"
  },
  {
     label:"Pela",
     value:"bxd"
  },
  {
     label:"Birale",
     value:"bxe"
  },
  {
     label:"Bilur",
     value:"bxf"
  },
  {
     label:"Bangala",
     value:"bxg"
  },
  {
     label:"Buhutu",
     value:"bxh"
  },
  {
     label:"Bayungu",
     value:"bxj"
  },
  {
     label:"Bukusu",
     value:"bxk"
  },
  {
     label:"Jalkunan",
     value:"bxl"
  },
  {
     label:"Mongolia Buriat",
     value:"bxm"
  },
  {
     label:"Burduna",
     value:"bxn"
  },
  {
     label:"Barikanchi",
     value:"bxo"
  },
  {
     label:"Bebil",
     value:"bxp"
  },
  {
     label:"Beele",
     value:"bxq"
  },
  {
     label:"Russia Buriat",
     value:"bxr"
  },
  {
     label:"Busam",
     value:"bxs"
  },
  {
     label:"China Buriat",
     value:"bxu"
  },
  {
     label:"Berakou",
     value:"bxv"
  },
  {
     label:"Bankagooma",
     value:"bxw"
  },
  {
     label:"Binahari",
     value:"bxz"
  },
  {
     label:"Batak",
     value:"bya"
  },
  {
     label:"Bikya",
     value:"byb"
  },
  {
     label:"Ubaghara",
     value:"byc"
  },
  {
     label:"Benyadu'",
     value:"byd"
  },
  {
     label:"Pouye",
     value:"bye"
  },
  {
     label:"Bete",
     value:"byf"
  },
  {
     label:"Bhujel",
     value:"byh"
  },
  {
     label:"Buyu",
     value:"byi"
  },
  {
     label:"Bina (Nigeria)",
     value:"byj"
  },
  {
     label:"Biao",
     value:"byk"
  },
  {
     label:"Bayono",
     value:"byl"
  },
  {
     label:"Bidjara",
     value:"bym"
  },
  {
     label:"Bilin",
     value:"byn",
     "iso6392B":"byn",
     "iso6392T":"byn"
  },
  {
     label:"Biyo",
     value:"byo"
  },
  {
     label:"Bumaji",
     value:"byp"
  },
  {
     label:"Baruya",
     value:"byr"
  },
  {
     label:"Burak",
     value:"bys"
  },
  {
     label:"Medumba",
     value:"byv"
  },
  {
     label:"Belhariya",
     value:"byw"
  },
  {
     label:"Qaqet",
     value:"byx"
  },
  {
     label:"Banaro",
     value:"byz"
  },
  {
     label:"Bandi",
     value:"bza"
  },
  {
     label:"Andio",
     value:"bzb"
  },
  {
     label:"Southern Betsimisaraka Malagasy",
     value:"bzc"
  },
  {
     label:"Bribri",
     value:"bzd"
  },
  {
     label:"Jenaama Bozo",
     value:"bze"
  },
  {
     label:"Boikin",
     value:"bzf"
  },
  {
     label:"Babuza",
     value:"bzg"
  },
  {
     label:"Mapos Buang",
     value:"bzh"
  },
  {
     label:"Bisu",
     value:"bzi"
  },
  {
     label:"Belize Kriol English",
     value:"bzj"
  },
  {
     label:"Nicaragua Creole English",
     value:"bzk"
  },
  {
     label:"Boano (Sulawesi)",
     value:"bzl"
  },
  {
     label:"Bolondo",
     value:"bzm"
  },
  {
     label:"Boano (Maluku)",
     value:"bzn"
  },
  {
     label:"Bozaba",
     value:"bzo"
  },
  {
     label:"Kemberano",
     value:"bzp"
  },
  {
     label:"Buli (Indonesia)",
     value:"bzq"
  },
  {
     label:"Brithenig",
     value:"bzt"
  },
  {
     label:"Burmeso",
     value:"bzu"
  },
  {
     label:"Naami",
     value:"bzv"
  },
  {
     label:"Basa (Nigeria)",
     value:"bzw"
  },
  {
     label:"K\u025bl\u025bngaxo Bozo",
     value:"bzx"
  },
  {
     label:"Obanliku",
     value:"bzy"
  },
  {
     label:"Evant",
     value:"bzz"
  },
  {
     label:"Chort\u00ed",
     value:"caa"
  },
  {
     label:"Garifuna",
     value:"cab"
  },
  {
     label:"Chuj",
     value:"cac"
  },
  {
     label:"Caddo",
     value:"cad",
     "iso6392B":"cad",
     "iso6392T":"cad"
  },
  {
     label:"Lehar",
     value:"cae"
  },
  {
     label:"Southern Carrier",
     value:"caf"
  },
  {
     label:"Nivacl\u00e9",
     value:"cag"
  },
  {
     label:"Cahuarano",
     value:"cah"
  },
  {
     label:"Kaqchikel",
     value:"cak"
  },
  {
     label:"Carolinian",
     value:"cal"
  },
  {
     label:"Cemuh\u00ee",
     value:"cam"
  },
  {
     label:"Chambri",
     value:"can"
  },
  {
     label:"Ch\u00e1cobo",
     value:"cao"
  },
  {
     label:"Chipaya",
     value:"cap"
  },
  {
     label:"Car Nicobarese",
     value:"caq"
  },
  {
     label:"Galibi Carib",
     value:"car",
     "iso6392B":"car",
     "iso6392T":"car"
  },
  {
     label:"Tsiman\u00e9",
     value:"cas"
  },
  {
     label:"Catalan",
     value:"cat",
     "iso6392B":"cat",
     "iso6392T":"cat",
     "iso6391":"ca"
  },
  {
     label:"Cavine\u00f1a",
     value:"cav"
  },
  {
     label:"Callawalla",
     value:"caw"
  },
  {
     label:"Chiquitano",
     value:"cax"
  },
  {
     label:"Cayuga",
     value:"cay"
  },
  {
     label:"Cabiyar\u00ed",
     value:"cbb"
  },
  {
     label:"Carapana",
     value:"cbc"
  },
  {
     label:"Carijona",
     value:"cbd"
  },
  {
     label:"Chimila",
     value:"cbg"
  },
  {
     label:"Chachi",
     value:"cbi"
  },
  {
     label:"Ede Cabe",
     value:"cbj"
  },
  {
     label:"Chavacano",
     value:"cbk"
  },
  {
     label:"Bualkhaw Chin",
     value:"cbl"
  },
  {
     label:"Nyahkur",
     value:"cbn"
  },
  {
     label:"Izora",
     value:"cbo"
  },
  {
     label:"Tsucuba",
     value:"cbq"
  },
  {
     label:"Cashibo-Cacataibo",
     value:"cbr"
  },
  {
     label:"Cashinahua",
     value:"cbs"
  },
  {
     label:"Chayahuita",
     value:"cbt"
  },
  {
     label:"Candoshi-Shapra",
     value:"cbu"
  },
  {
     label:"Cacua",
     value:"cbv"
  },
  {
     label:"Kinabalian",
     value:"cbw"
  },
  {
     label:"Carabayo",
     value:"cby"
  },
  {
     label:"Chamicuro",
     value:"ccc"
  },
  {
     label:"Cafundo Creole",
     value:"ccd"
  },
  {
     label:"Chopi",
     value:"cce"
  },
  {
     label:"Samba Daka",
     value:"ccg"
  },
  {
     label:"Atsam",
     value:"cch"
  },
  {
     label:"Kasanga",
     value:"ccj"
  },
  {
     label:"Cutchi-Swahili",
     value:"ccl"
  },
  {
     label:"Malaccan Creole Malay",
     value:"ccm"
  },
  {
     label:"Comaltepec Chinantec",
     value:"cco"
  },
  {
     label:"Chakma",
     value:"ccp"
  },
  {
     label:"Choni",
     value:"cda"
  },
  {
     label:"Chenchu",
     value:"cde"
  },
  {
     label:"Chiru",
     value:"cdf"
  },
  {
     label:"Chambeali",
     value:"cdh"
  },
  {
     label:"Chodri",
     value:"cdi"
  },
  {
     label:"Churahi",
     value:"cdj"
  },
  {
     label:"Chepang",
     value:"cdm"
  },
  {
     label:"Chaudangsi",
     value:"cdn"
  },
  {
     label:"Min Dong Chinese",
     value:"cdo"
  },
  {
     label:"Cinda-Regi-Tiyal",
     value:"cdr"
  },
  {
     label:"Chadong",
     value:"cdy"
  },
  {
     label:"Koda",
     value:"cdz"
  },
  {
     label:"Cebuano",
     value:"ceb",
     "iso6392B":"ceb",
     "iso6392T":"ceb"
  },
  {
     label:"Chamacoco",
     value:"ceg"
  },
  {
     label:"Eastern Khumi Chin",
     value:"cek"
  },
  {
     label:"Cen",
     value:"cen"
  },
  {
     label:"Czech",
     value:"ces",
     "iso6392B":"cze",
     "iso6392T":"ces",
     "iso6391":"cs"
  },
  {
     label:"Cent\u00fa\u00fam",
     value:"cet"
  },
  {
     label:"Ekai Chin",
     value:"cey"
  },
  {
     label:"Dijim-Bwilim",
     value:"cfa"
  },
  {
     label:"Cara",
     value:"cfd"
  },
  {
     label:"Como Karim",
     value:"cfg"
  },
  {
     label:"Falam Chin",
     value:"cfm"
  },
  {
     label:"Changriwa",
     value:"cga"
  },
  {
     label:"Kagayanen",
     value:"cgc"
  },
  {
     label:"Chiga",
     value:"cgg"
  },
  {
     label:"Chocangacakha",
     value:"cgk"
  },
  {
     label:"Chamorro",
     value:"cha",
     "iso6392B":"cha",
     "iso6392T":"cha",
     "iso6391":"ch"
  },
  {
     label:"Highland Oaxaca Chontal",
     value:"chd"
  },
  {
     label:"Chechen",
     value:"che",
     "iso6392B":"che",
     "iso6392T":"che",
     "iso6391":"ce"
  },
  {
     label:"Tabasco Chontal",
     value:"chf"
  },
  {
     label:"Ojitl\u00e1n Chinantec",
     value:"chj"
  },
  {
     label:"Chuukese",
     value:"chk",
     "iso6392B":"chk",
     "iso6392T":"chk"
  },
  {
     label:"Cahuilla",
     value:"chl"
  },
  {
     label:"Mari (Russia)",
     value:"chm",
     "iso6392B":"chm",
     "iso6392T":"chm"
  },
  {
     label:"Chinook jargon",
     value:"chn",
     "iso6392B":"chn",
     "iso6392T":"chn"
  },
  {
     label:"Choctaw",
     value:"cho",
     "iso6392B":"cho",
     "iso6392T":"cho"
  },
  {
     label:"Chipewyan",
     value:"chp",
     "iso6392B":"chp",
     "iso6392T":"chp"
  },
  {
     label:"Quiotepec Chinantec",
     value:"chq"
  },
  {
     label:"Cherokee",
     value:"chr",
     "iso6392B":"chr",
     "iso6392T":"chr"
  },
  {
     label:"Chuvash",
     value:"chv",
     "iso6392B":"chv",
     "iso6392T":"chv",
     "iso6391":"cv"
  },
  {
     label:"Chuwabu",
     value:"chw"
  },
  {
     label:"Chantyal",
     value:"chx"
  },
  {
     label:"Cheyenne",
     value:"chy",
     "iso6392B":"chy",
     "iso6392T":"chy"
  },
  {
     label:"Ozumac\u00edn Chinantec",
     value:"chz"
  },
  {
     label:"Cia-Cia",
     value:"cia"
  },
  {
     label:"Ci Gbe",
     value:"cib"
  },
  {
     label:"Chickasaw",
     value:"cic"
  },
  {
     label:"Cineni",
     value:"cie"
  },
  {
     label:"Chinali",
     value:"cih"
  },
  {
     label:"Chitkuli Kinnauri",
     value:"cik"
  },
  {
     label:"Cimbrian",
     value:"cim"
  },
  {
     label:"Cinta Larga",
     value:"cin"
  },
  {
     label:"Chiapanec",
     value:"cip"
  },
  {
     label:"Tiri",
     value:"cir"
  },
  {
     label:"Chippewa",
     value:"ciw"
  },
  {
     label:"Chaima",
     value:"ciy"
  },
  {
     label:"Western Cham",
     value:"cja"
  },
  {
     label:"Chru",
     value:"cje"
  },
  {
     label:"Chamalal",
     value:"cji"
  },
  {
     label:"Chokwe",
     value:"cjk"
  },
  {
     label:"Eastern Cham",
     value:"cjm"
  },
  {
     label:"Chenapian",
     value:"cjn"
  },
  {
     label:"Ash\u00e9ninka Pajonal",
     value:"cjo"
  },
  {
     label:"Cab\u00e9car",
     value:"cjp"
  },
  {
     label:"Shor",
     value:"cjs"
  },
  {
     label:"Chuave",
     value:"cjv"
  },
  {
     label:"Jinyu Chinese",
     value:"cjy"
  },
  {
     label:"Central Kurdish",
     value:"ckb"
  },
  {
     label:"Chak",
     value:"ckh"
  },
  {
     label:"Cibak",
     value:"ckl"
  },
  {
     label:"Chakavian",
     value:"ckm"
  },
  {
     label:"Kaang Chin",
     value:"ckn"
  },
  {
     label:"Anufo",
     value:"cko"
  },
  {
     label:"Kajakse",
     value:"ckq"
  },
  {
     label:"Kairak",
     value:"ckr"
  },
  {
     label:"Tayo",
     value:"cks"
  },
  {
     label:"Chukot",
     value:"ckt"
  },
  {
     label:"Koasati",
     value:"cku"
  },
  {
     label:"Kavalan",
     value:"ckv"
  },
  {
     label:"Caka",
     value:"ckx"
  },
  {
     label:"Cakfem-Mushere",
     value:"cky"
  },
  {
     label:"Cakchiquel-Quich\u00e9 Mixed Language",
     value:"ckz"
  },
  {
     label:"Ron",
     value:"cla"
  },
  {
     label:"Chilcotin",
     value:"clc"
  },
  {
     label:"Chaldean Neo-Aramaic",
     value:"cld"
  },
  {
     label:"Lealao Chinantec",
     value:"cle"
  },
  {
     label:"Chilisso",
     value:"clh"
  },
  {
     label:"Chakali",
     value:"cli"
  },
  {
     label:"Laitu Chin",
     value:"clj"
  },
  {
     label:"Idu-Mishmi",
     value:"clk"
  },
  {
     label:"Chala",
     value:"cll"
  },
  {
     label:"Clallam",
     value:"clm"
  },
  {
     label:"Lowland Oaxaca Chontal",
     value:"clo"
  },
  {
     label:"Lautu Chin",
     value:"clt"
  },
  {
     label:"Caluyanun",
     value:"clu"
  },
  {
     label:"Chulym",
     value:"clw"
  },
  {
     label:"Eastern Highland Chatino",
     value:"cly"
  },
  {
     label:"Maa",
     value:"cma"
  },
  {
     label:"Cerma",
     value:"cme"
  },
  {
     label:"Ember\u00e1-Cham\u00ed",
     value:"cmi"
  },
  {
     label:"Campalagian",
     value:"cml"
  },
  {
     label:"Mandarin Chinese",
     value:"cmn"
  },
  {
     label:"Central Mnong",
     value:"cmo"
  },
  {
     label:"Mro-Khimi Chin",
     value:"cmr"
  },
  {
     label:"Camtho",
     value:"cmt"
  },
  {
     label:"Changthang",
     value:"cna"
  },
  {
     label:"Chinbon Chin",
     value:"cnb"
  },
  {
     label:"C\u00f4\u00f4ng",
     value:"cnc"
  },
  {
     label:"Northern Qiang",
     value:"cng"
  },
  {
     label:"Hakha Chin",
     value:"cnh"
  },
  {
     label:"Ash\u00e1ninka",
     value:"cni"
  },
  {
     label:"Khumi Chin",
     value:"cnk"
  },
  {
     label:"Lalana Chinantec",
     value:"cnl"
  },
  {
     label:"Con",
     value:"cno"
  },
  {
     label:"Northern Ping Chinese",
     value:"cnp"
  },
  {
     label:"Montenegrin",
     value:"cnr",
     "iso6392B":"cnr",
     "iso6392T":"cnr"
  },
  {
     label:"Central Asmat",
     value:"cns"
  },
  {
     label:"Tepetotutla Chinantec",
     value:"cnt"
  },
  {
     label:"Chenoua",
     value:"cnu"
  },
  {
     label:"Ngawn Chin",
     value:"cnw"
  },
  {
     label:"Cocos Islands Malay",
     value:"coa"
  },
  {
     label:"Cocopa",
     value:"coc"
  },
  {
     label:"Cocama-Cocamilla",
     value:"cod"
  },
  {
     label:"Koreguaje",
     value:"coe"
  },
  {
     label:"Colorado",
     value:"cof"
  },
  {
     label:"Chong",
     value:"cog"
  },
  {
     label:"Chonyi-Dzihana-Kauma",
     value:"coh"
  },
  {
     label:"Santa Teresa Cora",
     value:"cok"
  },
  {
     label:"Columbia-Wenatchi",
     value:"col"
  },
  {
     label:"Comanche",
     value:"com"
  },
  {
     label:"Cof\u00e1n",
     value:"con"
  },
  {
     label:"Comox",
     value:"coo"
  },
  {
     label:"Cornish",
     value:"cor",
     "iso6392B":"cor",
     "iso6392T":"cor",
     "iso6391":"kw"
  },
  {
     label:"Corsican",
     value:"cos",
     "iso6392B":"cos",
     "iso6392T":"cos",
     "iso6391":"co"
  },
  {
     label:"Caquinte",
     value:"cot"
  },
  {
     label:"Wamey",
     value:"cou"
  },
  {
     label:"Cao Miao",
     value:"cov"
  },
  {
     label:"Nanti",
     value:"cox"
  },
  {
     label:"Chochotec",
     value:"coz"
  },
  {
     label:"Palantla Chinantec",
     value:"cpa"
  },
  {
     label:"Ucayali-Yur\u00faa Ash\u00e9ninka",
     value:"cpb"
  },
  {
     label:"Ajy\u00edninka Apurucayali",
     value:"cpc"
  },
  {
     label:"Chinese Pidgin English",
     value:"cpi"
  },
  {
     label:"Cherepon",
     value:"cpn"
  },
  {
     label:"Kpeego",
     value:"cpo"
  },
  {
     label:"Capiznon",
     value:"cps"
  },
  {
     label:"Pichis Ash\u00e9ninka",
     value:"cpu"
  },
  {
     label:"Pu-Xian Chinese",
     value:"cpx"
  },
  {
     label:"South Ucayali Ash\u00e9ninka",
     value:"cpy"
  },
  {
     label:"Chuanqiandian Cluster Miao",
     value:"cqd"
  },
  {
     label:"Chara",
     value:"cra"
  },
  {
     label:"Lonwolwol",
     value:"crc"
  },
  {
     label:"Coeur d'Alene",
     value:"crd"
  },
  {
     label:"Cree",
     value:"cre",
     "iso6392B":"cre",
     "iso6392T":"cre",
     "iso6391":"cr"
  },
  {
     label:"Michif",
     value:"crg"
  },
  {
     label:"Crimean Tatar",
     value:"crh",
     "iso6392B":"crh",
     "iso6392T":"crh"
  },
  {
     label:"S\u00e3otomense",
     value:"cri"
  },
  {
     label:"Southern East Cree",
     value:"crj"
  },
  {
     label:"Plains Cree",
     value:"crk"
  },
  {
     label:"Northern East Cree",
     value:"crl"
  },
  {
     label:"Moose Cree",
     value:"crm"
  },
  {
     label:"El Nayar Cora",
     value:"crn"
  },
  {
     label:"Crow",
     value:"cro"
  },
  {
     label:"Iyo'wujwa Chorote",
     value:"crq"
  },
  {
     label:"Seselwa Creole French",
     value:"crs"
  },
  {
     label:"Iyojwa'ja Chorote",
     value:"crt"
  },
  {
     label:"Chaura",
     value:"crv"
  },
  {
     label:"Chrau",
     value:"crw"
  },
  {
     label:"Carrier",
     value:"crx"
  },
  {
     label:"Cori",
     value:"cry"
  },
  {
     label:"Chiltepec Chinantec",
     value:"csa"
  },
  {
     label:"Kashubian",
     value:"csb",
     "iso6392B":"csb",
     "iso6392T":"csb"
  },
  {
     label:"Asho Chin",
     value:"csh"
  },
  {
     label:"Songlai Chin",
     value:"csj"
  },
  {
     label:"Jola-Kasa",
     value:"csk"
  },
  {
     label:"Central Sierra Miwok",
     value:"csm"
  },
  {
     label:"Sochiapam Chinantec",
     value:"cso"
  },
  {
     label:"Southern Ping Chinese",
     value:"csp"
  },
  {
     label:"Northern Ohlone",
     value:"cst"
  },
  {
     label:"Sumtu Chin",
     value:"csv"
  },
  {
     label:"Swampy Cree",
     value:"csw"
  },
  {
     label:"Siyin Chin",
     value:"csy"
  },
  {
     label:"Coos",
     value:"csz"
  },
  {
     label:"Tataltepec Chatino",
     value:"cta"
  },
  {
     label:"Tedim Chin",
     value:"ctd"
  },
  {
     label:"Tepinapa Chinantec",
     value:"cte"
  },
  {
     label:"Chittagonian",
     value:"ctg"
  },
  {
     label:"Thaiphum Chin",
     value:"cth"
  },
  {
     label:"Tlacoatzintepec Chinantec",
     value:"ctl"
  },
  {
     label:"Chhintange",
     value:"ctn"
  },
  {
     label:"Ember\u00e1-Cat\u00edo",
     value:"cto"
  },
  {
     label:"Western Highland Chatino",
     value:"ctp"
  },
  {
     label:"Northern Catanduanes Bikol",
     value:"cts"
  },
  {
     label:"Wayanad Chetti",
     value:"ctt"
  },
  {
     label:"Chol",
     value:"ctu"
  },
  {
     label:"Zacatepec Chatino",
     value:"ctz"
  },
  {
     label:"Cua",
     value:"cua"
  },
  {
     label:"Cubeo",
     value:"cub"
  },
  {
     label:"Usila Chinantec",
     value:"cuc"
  },
  {
     label:"Chungmboko",
     value:"cug"
  },
  {
     label:"Chuka",
     value:"cuh"
  },
  {
     label:"Cuiba",
     value:"cui"
  },
  {
     label:"Mashco Piro",
     value:"cuj"
  },
  {
     label:"San Blas Kuna",
     value:"cuk"
  },
  {
     label:"Culina",
     value:"cul"
  },
  {
     label:"Cun",
     value:"cuq"
  },
  {
     label:"Chhulung",
     value:"cur"
  },
  {
     label:"Teutila Cuicatec",
     value:"cut"
  },
  {
     label:"Tai Ya",
     value:"cuu"
  },
  {
     label:"Cuvok",
     value:"cuv"
  },
  {
     label:"Chukwa",
     value:"cuw"
  },
  {
     label:"Tepeuxila Cuicatec",
     value:"cux"
  },
  {
     label:"Cuitlatec",
     value:"cuy"
  },
  {
     label:"Chug",
     value:"cvg"
  },
  {
     label:"Valle Nacional Chinantec",
     value:"cvn"
  },
  {
     label:"Kabwa",
     value:"cwa"
  },
  {
     label:"Maindo",
     value:"cwb"
  },
  {
     label:"Woods Cree",
     value:"cwd"
  },
  {
     label:"Kwere",
     value:"cwe"
  },
  {
     label:"Chewong",
     value:"cwg"
  },
  {
     label:"Kuwaataay",
     value:"cwt"
  },
  {
     label:"Nopala Chatino",
     value:"cya"
  },
  {
     label:"Welsh",
     value:"cym",
     "iso6392B":"wel",
     "iso6392T":"cym",
     "iso6391":"cy"
  },
  {
     label:"Cuyonon",
     value:"cyo"
  },
  {
     label:"Huizhou Chinese",
     value:"czh"
  },
  {
     label:"Zenzontepec Chatino",
     value:"czn"
  },
  {
     label:"Min Zhong Chinese",
     value:"czo"
  },
  {
     label:"Zotung Chin",
     value:"czt"
  },
  {
     label:"Dangal\u00e9at",
     value:"daa"
  },
  {
     label:"Dambi",
     value:"dac"
  },
  {
     label:"Marik",
     value:"dad"
  },
  {
     label:"Duupa",
     value:"dae"
  },
  {
     label:"Dagbani",
     value:"dag"
  },
  {
     label:"Gwahatike",
     value:"dah"
  },
  {
     label:"Day",
     value:"dai"
  },
  {
     label:"Dar Fur Daju",
     value:"daj"
  },
  {
     label:"Dakota",
     value:"dak",
     "iso6392B":"dak",
     "iso6392T":"dak"
  },
  {
     label:"Dahalo",
     value:"dal"
  },
  {
     label:"Damakawa",
     value:"dam"
  },
  {
     label:"Danish",
     value:"dan",
     "iso6392B":"dan",
     "iso6392T":"dan",
     "iso6391":"da"
  },
  {
     label:"Daai Chin",
     value:"dao"
  },
  {
     label:"Dandami Maria",
     value:"daq"
  },
  {
     label:"Dargwa",
     value:"dar",
     "iso6392B":"dar",
     "iso6392T":"dar"
  },
  {
     label:"Daho-Doo",
     value:"das"
  },
  {
     label:"Dar Sila Daju",
     value:"dau"
  },
  {
     label:"Taita",
     value:"dav"
  },
  {
     label:"Davawenyo",
     value:"daw"
  },
  {
     label:"Dayi",
     value:"dax"
  },
  {
     label:"Dao",
     value:"daz"
  },
  {
     label:"Bangime",
     value:"dba"
  },
  {
     label:"Deno",
     value:"dbb"
  },
  {
     label:"Dadiya",
     value:"dbd"
  },
  {
     label:"Dabe",
     value:"dbe"
  },
  {
     label:"Edopi",
     value:"dbf"
  },
  {
     label:"Dogul Dom Dogon",
     value:"dbg"
  },
  {
     label:"Doka",
     value:"dbi"
  },
  {
     label:"Ida'an",
     value:"dbj"
  },
  {
     label:"Dyirbal",
     value:"dbl"
  },
  {
     label:"Duguri",
     value:"dbm"
  },
  {
     label:"Duriankere",
     value:"dbn"
  },
  {
     label:"Dulbu",
     value:"dbo"
  },
  {
     label:"Duwai",
     value:"dbp"
  },
  {
     label:"Daba",
     value:"dbq"
  },
  {
     label:"Dabarre",
     value:"dbr"
  },
  {
     label:"Ben Tey Dogon",
     value:"dbt"
  },
  {
     label:"Bondum Dom Dogon",
     value:"dbu"
  },
  {
     label:"Dungu",
     value:"dbv"
  },
  {
     label:"Bankan Tey Dogon",
     value:"dbw"
  },
  {
     label:"Dibiyaso",
     value:"dby"
  },
  {
     label:"Deccan",
     value:"dcc"
  },
  {
     label:"Dongotono",
     value:"ddd"
  },
  {
     label:"Doondo",
     value:"dde"
  },
  {
     label:"Fataluku",
     value:"ddg"
  },
  {
     label:"West Goodenough",
     value:"ddi"
  },
  {
     label:"Jaru",
     value:"ddj"
  },
  {
     label:"Dendi (Benin)",
     value:"ddn"
  },
  {
     label:"Dido",
     value:"ddo"
  },
  {
     label:"Donno So Dogon",
     value:"dds"
  },
  {
     label:"Dawera-Daweloor",
     value:"ddw"
  },
  {
     label:"Dagik",
     value:"dec"
  },
  {
     label:"Dedua",
     value:"ded"
  },
  {
     label:"Dewoin",
     value:"dee"
  },
  {
     label:"Dezfuli",
     value:"def"
  },
  {
     label:"Degema",
     value:"deg"
  },
  {
     label:"Dehwari",
     value:"deh"
  },
  {
     label:"Demisa",
     value:"dei"
  },
  {
     label:"Dek",
     value:"dek"
  },
  {
     label:"Delaware",
     value:"del",
     "iso6392B":"del",
     "iso6392T":"del"
  },
  {
     label:"Dem",
     value:"dem"
  },
  {
     label:"Slave (Athapascan)",
     value:"den",
     "iso6392B":"den",
     "iso6392T":"den"
  },
  {
     label:"Dendi (Central African Republic)",
     value:"deq"
  },
  {
     label:"Deori",
     value:"der"
  },
  {
     label:"Desano",
     value:"des"
  },
  {
     label:"German",
     value:"deu",
     "iso6392B":"ger",
     "iso6392T":"deu",
     "iso6391":"de"
  },
  {
     label:"Domung",
     value:"dev"
  },
  {
     label:"Dengese",
     value:"dez"
  },
  {
     label:"Southern Dagaare",
     value:"dga"
  },
  {
     label:"Bunoge Dogon",
     value:"dgb"
  },
  {
     label:"Casiguran Dumagat Agta",
     value:"dgc"
  },
  {
     label:"Dagaari Dioula",
     value:"dgd"
  },
  {
     label:"Degenan",
     value:"dge"
  },
  {
     label:"Doga",
     value:"dgg"
  },
  {
     label:"Dghwede",
     value:"dgh"
  },
  {
     label:"Northern Dagara",
     value:"dgi"
  },
  {
     label:"Dagba",
     value:"dgk"
  },
  {
     label:"Andaandi",
     value:"dgl"
  },
  {
     label:"Dogri (individual language)",
     value:"dgo"
  },
  {
     label:"Dogrib",
     value:"dgr",
     "iso6392B":"dgr",
     "iso6392T":"dgr"
  },
  {
     label:"Dogoso",
     value:"dgs"
  },
  {
     label:"Doghoro",
     value:"dgx"
  },
  {
     label:"Daga",
     value:"dgz"
  },
  {
     label:"Dhundari",
     value:"dhd"
  },
  {
     label:"Dhangu-Djangu",
     value:"dhg"
  },
  {
     label:"Dhimal",
     value:"dhi"
  },
  {
     label:"Dhalandji",
     value:"dhl"
  },
  {
     label:"Zemba",
     value:"dhm"
  },
  {
     label:"Dhanki",
     value:"dhn"
  },
  {
     label:"Dhodia",
     value:"dho"
  },
  {
     label:"Dhargari",
     value:"dhr"
  },
  {
     label:"Dhaiso",
     value:"dhs"
  },
  {
     label:"Dehu",
     value:"dhv"
  },
  {
     label:"Dhanwar (Nepal)",
     value:"dhw"
  },
  {
     label:"Dhungaloo",
     value:"dhx"
  },
  {
     label:"Dia",
     value:"dia"
  },
  {
     label:"South Central Dinka",
     value:"dib"
  },
  {
     label:"Lakota Dida",
     value:"dic"
  },
  {
     label:"Didinga",
     value:"did"
  },
  {
     label:"Digo",
     value:"dig"
  },
  {
     label:"Kumiai",
     value:"dih"
  },
  {
     label:"Dimbong",
     value:"dii"
  },
  {
     label:"Dai",
     value:"dij"
  },
  {
     label:"Southwestern Dinka",
     value:"dik"
  },
  {
     label:"Dilling",
     value:"dil"
  },
  {
     label:"Dime",
     value:"dim"
  },
  {
     label:"Dinka",
     value:"din",
     "iso6392B":"din",
     "iso6392T":"din"
  },
  {
     label:"Dibo",
     value:"dio"
  },
  {
     label:"Northeastern Dinka",
     value:"dip"
  },
  {
     label:"Dimli (individual language)",
     value:"diq"
  },
  {
     label:"Dirim",
     value:"dir"
  },
  {
     label:"Dimasa",
     value:"dis"
  },
  {
     label:"Diriku",
     value:"diu"
  },
  {
     label:"Dhivehi",
     value:"div",
     "iso6392B":"div",
     "iso6392T":"div",
     "iso6391":"dv"
  },
  {
     label:"Northwestern Dinka",
     value:"diw"
  },
  {
     label:"Dixon Reef",
     value:"dix"
  },
  {
     label:"Diuwe",
     value:"diy"
  },
  {
     label:"Ding",
     value:"diz"
  },
  {
     label:"Djinba",
     value:"djb"
  },
  {
     label:"Dar Daju Daju",
     value:"djc"
  },
  {
     label:"Djamindjung",
     value:"djd"
  },
  {
     label:"Zarma",
     value:"dje"
  },
  {
     label:"Djinang",
     value:"dji"
  },
  {
     label:"Djeebbana",
     value:"djj"
  },
  {
     label:"Eastern Maroon Creole",
     value:"djk"
  },
  {
     label:"Jamsay Dogon",
     value:"djm"
  },
  {
     label:"Jawoyn",
     value:"djn"
  },
  {
     label:"Jangkang",
     value:"djo"
  },
  {
     label:"Djambarrpuyngu",
     value:"djr"
  },
  {
     label:"Kapriman",
     value:"dju"
  },
  {
     label:"Dakpakha",
     value:"dka"
  },
  {
     label:"Dakka",
     value:"dkk"
  },
  {
     label:"Kuijau",
     value:"dkr"
  },
  {
     label:"Southeastern Dinka",
     value:"dks"
  },
  {
     label:"Mazagway",
     value:"dkx"
  },
  {
     label:"Dolgan",
     value:"dlg"
  },
  {
     label:"Dahalik",
     value:"dlk"
  },
  {
     label:"Darlong",
     value:"dln"
  },
  {
     label:"Duma",
     value:"dma"
  },
  {
     label:"Mombo Dogon",
     value:"dmb"
  },
  {
     label:"Gavak",
     value:"dmc"
  },
  {
     label:"Dugwor",
     value:"dme"
  },
  {
     label:"Upper Kinabatangan",
     value:"dmg"
  },
  {
     label:"Domaaki",
     value:"dmk"
  },
  {
     label:"Dameli",
     value:"dml"
  },
  {
     label:"Dama",
     value:"dmm"
  },
  {
     label:"Kemedzung",
     value:"dmo"
  },
  {
     label:"East Damar",
     value:"dmr"
  },
  {
     label:"Dampelas",
     value:"dms"
  },
  {
     label:"Dubu",
     value:"dmu"
  },
  {
     label:"Dumpas",
     value:"dmv"
  },
  {
     label:"Mudburra",
     value:"dmw"
  },
  {
     label:"Dema",
     value:"dmx"
  },
  {
     label:"Demta",
     value:"dmy"
  },
  {
     label:"Upper Grand Valley Dani",
     value:"dna"
  },
  {
     label:"Daonda",
     value:"dnd"
  },
  {
     label:"Ndendeule",
     value:"dne"
  },
  {
     label:"Dungan",
     value:"dng"
  },
  {
     label:"Lower Grand Valley Dani",
     value:"dni"
  },
  {
     label:"Dan",
     value:"dnj"
  },
  {
     label:"Dengka",
     value:"dnk"
  },
  {
     label:"Dz\u00f9\u00f9ngoo",
     value:"dnn"
  },
  {
     label:"Ndrulo",
     value:"dno"
  },
  {
     label:"Danaru",
     value:"dnr"
  },
  {
     label:"Mid Grand Valley Dani",
     value:"dnt"
  },
  {
     label:"Danau",
     value:"dnu"
  },
  {
     label:"Danu",
     value:"dnv"
  },
  {
     label:"Western Dani",
     value:"dnw"
  },
  {
     label:"Den\u00ed",
     value:"dny"
  },
  {
     label:"Dom",
     value:"doa"
  },
  {
     label:"Dobu",
     value:"dob"
  },
  {
     label:"Northern Dong",
     value:"doc"
  },
  {
     label:"Doe",
     value:"doe"
  },
  {
     label:"Domu",
     value:"dof"
  },
  {
     label:"Dong",
     value:"doh"
  },
  {
     label:"Dogri (macrolanguage)",
     value:"doi",
     "iso6392B":"doi",
     "iso6392T":"doi"
  },
  {
     label:"Dondo",
     value:"dok"
  },
  {
     label:"Doso",
     value:"dol"
  },
  {
     label:"Toura (Papua New Guinea)",
     value:"don"
  },
  {
     label:"Dongo",
     value:"doo"
  },
  {
     label:"Lukpa",
     value:"dop"
  },
  {
     label:"Dori'o",
     value:"dor"
  },
  {
     label:"Dogos\u00e9",
     value:"dos"
  },
  {
     label:"Dass",
     value:"dot"
  },
  {
     label:"Dombe",
     value:"dov"
  },
  {
     label:"Doyayo",
     value:"dow"
  },
  {
     label:"Bussa",
     value:"dox"
  },
  {
     label:"Dompo",
     value:"doy"
  },
  {
     label:"Dorze",
     value:"doz"
  },
  {
     label:"Papar",
     value:"dpp"
  },
  {
     label:"Dair",
     value:"drb"
  },
  {
     label:"Minderico",
     value:"drc"
  },
  {
     label:"Darmiya",
     value:"drd"
  },
  {
     label:"Dolpo",
     value:"dre"
  },
  {
     label:"Rungus",
     value:"drg"
  },
  {
     label:"C'Lela",
     value:"dri"
  },
  {
     label:"Paakantyi",
     value:"drl"
  },
  {
     label:"West Damar",
     value:"drn"
  },
  {
     label:"Daro-Matu Melanau",
     value:"dro"
  },
  {
     label:"Gedeo",
     value:"drs"
  },
  {
     label:"Drents",
     value:"drt"
  },
  {
     label:"Rukai",
     value:"dru"
  },
  {
     label:"Darai",
     value:"dry"
  },
  {
     label:"Lower Sorbian",
     value:"dsb",
     "iso6392B":"dsb",
     "iso6392T":"dsb"
  },
  {
     label:"Daasanach",
     value:"dsh"
  },
  {
     label:"Disa",
     value:"dsi"
  },
  {
     label:"Desiya",
     value:"dso"
  },
  {
     label:"Tadaksahak",
     value:"dsq"
  },
  {
     label:"Daur",
     value:"dta"
  },
  {
     label:"Labuk-Kinabatangan Kadazan",
     value:"dtb"
  },
  {
     label:"Ditidaht",
     value:"dtd"
  },
  {
     label:"Ana Tinga Dogon",
     value:"dti"
  },
  {
     label:"Tene Kan Dogon",
     value:"dtk"
  },
  {
     label:"Tomo Kan Dogon",
     value:"dtm"
  },
  {
     label:"Daats\u02bci\u0301in",
     value:"dtn"
  },
  {
     label:"Tommo So Dogon",
     value:"dto"
  },
  {
     label:"Kadazan Dusun",
     value:"dtp"
  },
  {
     label:"Lotud",
     value:"dtr"
  },
  {
     label:"Toro So Dogon",
     value:"dts"
  },
  {
     label:"Toro Tegu Dogon",
     value:"dtt"
  },
  {
     label:"Tebul Ure Dogon",
     value:"dtu"
  },
  {
     label:"Dotyali",
     value:"dty"
  },
  {
     label:"Duala",
     value:"dua",
     "iso6392B":"dua",
     "iso6392T":"dua"
  },
  {
     label:"Dubli",
     value:"dub"
  },
  {
     label:"Duna",
     value:"duc"
  },
  {
     label:"Umiray Dumaget Agta",
     value:"due"
  },
  {
     label:"Dumbea",
     value:"duf"
  },
  {
     label:"Duruma",
     value:"dug"
  },
  {
     label:"Dungra Bhil",
     value:"duh"
  },
  {
     label:"Dumun",
     value:"dui"
  },
  {
     label:"Uyajitaya",
     value:"duk"
  },
  {
     label:"Alabat Island Agta",
     value:"dul"
  },
  {
     label:"Dusun Deyah",
     value:"dun"
  },
  {
     label:"Dupaninan Agta",
     value:"duo"
  },
  {
     label:"Duano",
     value:"dup"
  },
  {
     label:"Dusun Malang",
     value:"duq"
  },
  {
     label:"Dii",
     value:"dur"
  },
  {
     label:"Dumi",
     value:"dus"
  },
  {
     label:"Drung",
     value:"duu"
  },
  {
     label:"Duvle",
     value:"duv"
  },
  {
     label:"Dusun Witu",
     value:"duw"
  },
  {
     label:"Duungooma",
     value:"dux"
  },
  {
     label:"Duau",
     value:"dva"
  },
  {
     label:"Diri",
     value:"dwa"
  },
  {
     label:"Dawik Kui",
     value:"dwk"
  },
  {
     label:"Dawro",
     value:"dwr"
  },
  {
     label:"Dutton World Speedwords",
     value:"dws"
  },
  {
     label:"Dhuwal",
     value:"dwu"
  },
  {
     label:"Dawawa",
     value:"dww"
  },
  {
     label:"Dhuwaya",
     value:"dwy"
  },
  {
     label:"Dewas Rai",
     value:"dwz"
  },
  {
     label:"Dyan",
     value:"dya"
  },
  {
     label:"Djimini Senoufo",
     value:"dyi"
  },
  {
     label:"Yanda Dom Dogon",
     value:"dym"
  },
  {
     label:"Dyangadi",
     value:"dyn"
  },
  {
     label:"Jola-Fonyi",
     value:"dyo"
  },
  {
     label:"Dyula",
     value:"dyu",
     "iso6392B":"dyu",
     "iso6392T":"dyu"
  },
  {
     label:"Djabugay",
     value:"dyy"
  },
  {
     label:"Tunzu",
     value:"dza"
  },
  {
     label:"Dazaga",
     value:"dzg"
  },
  {
     label:"Dzalakha",
     value:"dzl"
  },
  {
     label:"Dzando",
     value:"dzn"
  },
  {
     label:"Dzongkha",
     value:"dzo",
     "iso6392B":"dzo",
     "iso6392T":"dzo",
     "iso6391":"dz"
  },
  {
     label:"Beginci",
     value:"ebc"
  },
  {
     label:"Ebughu",
     value:"ebg"
  },
  {
     label:"Eastern Bontok",
     value:"ebk"
  },
  {
     label:"Teke-Ebo",
     value:"ebo"
  },
  {
     label:"Ebri\u00e9",
     value:"ebr"
  },
  {
     label:"Embu",
     value:"ebu"
  },
  {
     label:"E",
     value:"eee"
  },
  {
     label:"Efai",
     value:"efa"
  },
  {
     label:"Efe",
     value:"efe"
  },
  {
     label:"Efik",
     value:"efi",
     "iso6392B":"efi",
     "iso6392T":"efi"
  },
  {
     label:"Ega",
     value:"ega"
  },
  {
     label:"Emilian",
     value:"egl"
  },
  {
     label:"Eggon",
     value:"ego"
  },
  {
     label:"Ehueun",
     value:"ehu"
  },
  {
     label:"Eipomek",
     value:"eip"
  },
  {
     label:"Eitiep",
     value:"eit"
  },
  {
     label:"Askopan",
     value:"eiv"
  },
  {
     label:"Ejamat",
     value:"eja"
  },
  {
     label:"Ekajuk",
     value:"eka",
     "iso6392B":"eka",
     "iso6392T":"eka"
  },
  {
     label:"Ekit",
     value:"eke"
  },
  {
     label:"Ekari",
     value:"ekg"
  },
  {
     label:"Eki",
     value:"eki"
  },
  {
     label:"Standard Estonian",
     value:"ekk"
  },
  {
     label:"Kol (Bangladesh)",
     value:"ekl"
  },
  {
     label:"Elip",
     value:"ekm"
  },
  {
     label:"Koti",
     value:"eko"
  },
  {
     label:"Ekpeye",
     value:"ekp"
  },
  {
     label:"Yace",
     value:"ekr"
  },
  {
     label:"Eastern Kayah",
     value:"eky"
  },
  {
     label:"Elepi",
     value:"ele"
  },
  {
     label:"El Hugeirat",
     value:"elh"
  },
  {
     label:"Elkei",
     value:"elk"
  },
  {
     label:"Modern Greek (1453-)",
     value:"ell",
     "iso6392B":"gre",
     "iso6392T":"ell",
     "iso6391":"el"
  },
  {
     label:"Eleme",
     value:"elm"
  },
  {
     label:"El Molo",
     value:"elo"
  },
  {
     label:"Elu",
     value:"elu"
  },
  {
     label:"Emai-Iuleha-Ora",
     value:"ema"
  },
  {
     label:"Embaloh",
     value:"emb"
  },
  {
     label:"Emerillon",
     value:"eme"
  },
  {
     label:"Eastern Meohang",
     value:"emg"
  },
  {
     label:"Mussau-Emira",
     value:"emi"
  },
  {
     label:"Eastern Maninkakan",
     value:"emk"
  },
  {
     label:"Eman",
     value:"emn"
  },
  {
     label:"Northern Ember\u00e1",
     value:"emp"
  },
  {
     label:"Pacific Gulf Yupik",
     value:"ems"
  },
  {
     label:"Eastern Muria",
     value:"emu"
  },
  {
     label:"Emplawas",
     value:"emw"
  },
  {
     label:"Erromintxela",
     value:"emx"
  },
  {
     label:"Apali",
     value:"ena"
  },
  {
     label:"Markweeta",
     value:"enb"
  },
  {
     label:"En",
     value:"enc"
  },
  {
     label:"Ende",
     value:"end"
  },
  {
     label:"Forest Enets",
     value:"enf"
  },
  {
     label:"English",
     value:"eng",
     "iso6392B":"eng",
     "iso6392T":"eng",
     "iso6391":"en"
  },
  {
     label:"Tundra Enets",
     value:"enh"
  },
  {
     label:"Enlhet",
     value:"enl"
  },
  {
     label:"Engenni",
     value:"enn"
  },
  {
     label:"Enggano",
     value:"eno"
  },
  {
     label:"Enga",
     value:"enq"
  },
  {
     label:"Emumu",
     value:"enr"
  },
  {
     label:"Enu",
     value:"enu"
  },
  {
     label:"Enwan (Edu State)",
     value:"env"
  },
  {
     label:"Enwan (Akwa Ibom State)",
     value:"enw"
  },
  {
     label:"Enxet",
     value:"enx"
  },
  {
     label:"Beti (C\u00f4te d'Ivoire)",
     value:"eot"
  },
  {
     label:"Epie",
     value:"epi"
  },
  {
     label:"Esperanto",
     value:"epo",
     "iso6392B":"epo",
     "iso6392T":"epo",
     "iso6391":"eo"
  },
  {
     label:"Eravallan",
     value:"era"
  },
  {
     label:"Sie",
     value:"erg"
  },
  {
     label:"Eruwa",
     value:"erh"
  },
  {
     label:"Ogea",
     value:"eri"
  },
  {
     label:"South Efate",
     value:"erk"
  },
  {
     label:"Horpa",
     value:"ero"
  },
  {
     label:"Ersu",
     value:"ers"
  },
  {
     label:"Eritai",
     value:"ert"
  },
  {
     label:"Erokwanas",
     value:"erw"
  },
  {
     label:"Ese Ejja",
     value:"ese"
  },
  {
     label:"Aheri Gondi",
     value:"esg"
  },
  {
     label:"Eshtehardi",
     value:"esh"
  },
  {
     label:"North Alaskan Inupiatun",
     value:"esi"
  },
  {
     label:"Northwest Alaska Inupiatun",
     value:"esk"
  },
  {
     label:"Central Siberian Yupik",
     value:"ess"
  },
  {
     label:"Estonian",
     value:"est",
     "iso6392B":"est",
     "iso6392T":"est",
     "iso6391":"et"
  },
  {
     label:"Central Yupik",
     value:"esu"
  },
  {
     label:"Eskayan",
     value:"esy"
  },
  {
     label:"Etebi",
     value:"etb"
  },
  {
     label:"Eton (Vanuatu)",
     value:"etn"
  },
  {
     label:"Eton (Cameroon)",
     value:"eto"
  },
  {
     label:"Edolo",
     value:"etr"
  },
  {
     label:"Yekhee",
     value:"ets"
  },
  {
     label:"Ejagham",
     value:"etu"
  },
  {
     label:"Eten",
     value:"etx"
  },
  {
     label:"Semimi",
     value:"etz"
  },
  {
     label:"Basque",
     value:"eus",
     "iso6392B":"baq",
     "iso6392T":"eus",
     "iso6391":"eu"
  },
  {
     label:"Even",
     value:"eve"
  },
  {
     label:"Uvbie",
     value:"evh"
  },
  {
     label:"Evenki",
     value:"evn"
  },
  {
     label:"Ewe",
     value:"ewe",
     "iso6392B":"ewe",
     "iso6392T":"ewe",
     "iso6391":"ee"
  },
  {
     label:"Ewondo",
     value:"ewo",
     "iso6392B":"ewo",
     "iso6392T":"ewo"
  },
  {
     label:"Extremaduran",
     value:"ext"
  },
  {
     label:"Keiyo",
     value:"eyo"
  },
  {
     label:"Ezaa",
     value:"eza"
  },
  {
     label:"Uzekwe",
     value:"eze"
  },
  {
     label:"Fasu",
     value:"faa"
  },
  {
     label:"Fa d'Ambu",
     value:"fab"
  },
  {
     label:"Wagi",
     value:"fad"
  },
  {
     label:"Fagani",
     value:"faf"
  },
  {
     label:"Finongan",
     value:"fag"
  },
  {
     label:"Baissa Fali",
     value:"fah"
  },
  {
     label:"Faiwol",
     value:"fai"
  },
  {
     label:"Faita",
     value:"faj"
  },
  {
     label:"Fang (Cameroon)",
     value:"fak"
  },
  {
     label:"South Fali",
     value:"fal"
  },
  {
     label:"Fam",
     value:"fam"
  },
  {
     label:"Fang (Equatorial Guinea)",
     value:"fan",
     "iso6392B":"fan",
     "iso6392T":"fan"
  },
  {
     label:"Faroese",
     value:"fao",
     "iso6392B":"fao",
     "iso6392T":"fao",
     "iso6391":"fo"
  },
  {
     label:"Paloor",
     value:"fap"
  },
  {
     label:"Fataleka",
     value:"far"
  },
  {
     label:"Persian",
     value:"fas",
     "iso6392B":"per",
     "iso6392T":"fas",
     "iso6391":"fa"
  },
  {
     label:"Fanti",
     value:"fat",
     "iso6392B":"fat",
     "iso6392T":"fat"
  },
  {
     label:"Fayu",
     value:"fau"
  },
  {
     label:"Fala",
     value:"fax"
  },
  {
     label:"Southwestern Fars",
     value:"fay"
  },
  {
     label:"Northwestern Fars",
     value:"faz"
  },
  {
     label:"West Albay Bikol",
     value:"fbl"
  },
  {
     label:"Feroge",
     value:"fer"
  },
  {
     label:"Foia Foia",
     value:"ffi"
  },
  {
     label:"Maasina Fulfulde",
     value:"ffm"
  },
  {
     label:"Fongoro",
     value:"fgr"
  },
  {
     label:"Nobiin",
     value:"fia"
  },
  {
     label:"Fyer",
     value:"fie"
  },
  {
     label:"Faifi",
     value:"fif"
  },
  {
     label:"Fijian",
     value:"fij",
     "iso6392B":"fij",
     "iso6392T":"fij",
     "iso6391":"fj"
  },
  {
     label:"Filipino",
     value:"fil",
     "iso6392B":"fil",
     "iso6392T":"fil"
  },
  {
     label:"Finnish",
     value:"fin",
     "iso6392B":"fin",
     "iso6392T":"fin",
     "iso6391":"fi"
  },
  {
     label:"Fipa",
     value:"fip"
  },
  {
     label:"Firan",
     value:"fir"
  },
  {
     label:"Tornedalen Finnish",
     value:"fit"
  },
  {
     label:"Fiwaga",
     value:"fiw"
  },
  {
     label:"Kirya-Konz\u0259l",
     value:"fkk"
  },
  {
     label:"Kven Finnish",
     value:"fkv"
  },
  {
     label:"Kalispel-Pend d'Oreille",
     value:"fla"
  },
  {
     label:"Foau",
     value:"flh"
  },
  {
     label:"Fali",
     value:"fli"
  },
  {
     label:"North Fali",
     value:"fll"
  },
  {
     label:"Fuliiru",
     value:"flr"
  },
  {
     label:"Flaaitaal",
     value:"fly"
  },
  {
     label:"Fe'fe'",
     value:"fmp"
  },
  {
     label:"Far Western Muria",
     value:"fmu"
  },
  {
     label:"Fanbak",
     value:"fnb"
  },
  {
     label:"Fanagalo",
     value:"fng"
  },
  {
     label:"Fania",
     value:"fni"
  },
  {
     label:"Foodo",
     value:"fod"
  },
  {
     label:"Foi",
     value:"foi"
  },
  {
     label:"Foma",
     value:"fom"
  },
  {
     label:"Fon",
     value:"fon",
     "iso6392B":"fon",
     "iso6392T":"fon"
  },
  {
     label:"Fore",
     value:"for"
  },
  {
     label:"Fernando Po Creole English",
     value:"fpe"
  },
  {
     label:"Fas",
     value:"fqs"
  },
  {
     label:"French",
     value:"fra",
     "iso6392B":"fre",
     "iso6392T":"fra",
     "iso6391":"fr"
  },
  {
     label:"Cajun French",
     value:"frc"
  },
  {
     label:"Fordata",
     value:"frd"
  },
  {
     label:"Arpitan",
     value:"frp"
  },
  {
     label:"Forak",
     value:"frq"
  },
  {
     label:"Northern Frisian",
     value:"frr",
     "iso6392B":"frr",
     "iso6392T":"frr"
  },
  {
     label:"Eastern Frisian",
     value:"frs",
     "iso6392B":"frs",
     "iso6392T":"frs"
  },
  {
     label:"Fortsenal",
     value:"frt"
  },
  {
     label:"Western Frisian",
     value:"fry",
     "iso6392B":"fry",
     "iso6392T":"fry",
     "iso6391":"fy"
  },
  {
     label:"Adamawa Fulfulde",
     value:"fub"
  },
  {
     label:"Pulaar",
     value:"fuc"
  },
  {
     label:"East Futuna",
     value:"fud"
  },
  {
     label:"Borgu Fulfulde",
     value:"fue"
  },
  {
     label:"Pular",
     value:"fuf"
  },
  {
     label:"Western Niger Fulfulde",
     value:"fuh"
  },
  {
     label:"Bagirmi Fulfulde",
     value:"fui"
  },
  {
     label:"Ko",
     value:"fuj"
  },
  {
     label:"Fulah",
     value:"ful",
     "iso6392B":"ful",
     "iso6392T":"ful",
     "iso6391":"ff"
  },
  {
     label:"Fum",
     value:"fum"
  },
  {
     label:"Fulni\u00f4",
     value:"fun"
  },
  {
     label:"Central-Eastern Niger Fulfulde",
     value:"fuq"
  },
  {
     label:"Friulian",
     value:"fur",
     "iso6392B":"fur",
     "iso6392T":"fur"
  },
  {
     label:"Futuna-Aniwa",
     value:"fut"
  },
  {
     label:"Furu",
     value:"fuu"
  },
  {
     label:"Nigerian Fulfulde",
     value:"fuv"
  },
  {
     label:"Fuyug",
     value:"fuy"
  },
  {
     label:"Fur",
     value:"fvr"
  },
  {
     label:"Fw\u00e2i",
     value:"fwa"
  },
  {
     label:"Fwe",
     value:"fwe"
  },
  {
     label:"Ga",
     value:"gaa",
     "iso6392B":"gaa",
     "iso6392T":"gaa"
  },
  {
     label:"Gabri",
     value:"gab"
  },
  {
     label:"Mixed Great Andamanese",
     value:"gac"
  },
  {
     label:"Gaddang",
     value:"gad"
  },
  {
     label:"Guarequena",
     value:"gae"
  },
  {
     label:"Gende",
     value:"gaf"
  },
  {
     label:"Gagauz",
     value:"gag"
  },
  {
     label:"Alekano",
     value:"gah"
  },
  {
     label:"Borei",
     value:"gai"
  },
  {
     label:"Gadsup",
     value:"gaj"
  },
  {
     label:"Gamkonora",
     value:"gak"
  },
  {
     label:"Galolen",
     value:"gal"
  },
  {
     label:"Kandawo",
     value:"gam"
  },
  {
     label:"Gan Chinese",
     value:"gan"
  },
  {
     label:"Gants",
     value:"gao"
  },
  {
     label:"Gal",
     value:"gap"
  },
  {
     label:"Gata'",
     value:"gaq"
  },
  {
     label:"Galeya",
     value:"gar"
  },
  {
     label:"Adiwasi Garasia",
     value:"gas"
  },
  {
     label:"Kenati",
     value:"gat"
  },
  {
     label:"Mudhili Gadaba",
     value:"gau"
  },
  {
     label:"Nobonob",
     value:"gaw"
  },
  {
     label:"Borana-Arsi-Guji Oromo",
     value:"gax"
  },
  {
     label:"Gayo",
     value:"gay",
     "iso6392B":"gay",
     "iso6392T":"gay"
  },
  {
     label:"West Central Oromo",
     value:"gaz"
  },
  {
     label:"Gbaya (Central African Republic)",
     value:"gba",
     "iso6392B":"gba",
     "iso6392T":"gba"
  },
  {
     label:"Kaytetye",
     value:"gbb"
  },
  {
     label:"Karajarri",
     value:"gbd"
  },
  {
     label:"Niksek",
     value:"gbe"
  },
  {
     label:"Gaikundi",
     value:"gbf"
  },
  {
     label:"Gbanziri",
     value:"gbg"
  },
  {
     label:"Defi Gbe",
     value:"gbh"
  },
  {
     label:"Galela",
     value:"gbi"
  },
  {
     label:"Bodo Gadaba",
     value:"gbj"
  },
  {
     label:"Gaddi",
     value:"gbk"
  },
  {
     label:"Gamit",
     value:"gbl"
  },
  {
     label:"Garhwali",
     value:"gbm"
  },
  {
     label:"Mo'da",
     value:"gbn"
  },
  {
     label:"Northern Grebo",
     value:"gbo"
  },
  {
     label:"Gbaya-Bossangoa",
     value:"gbp"
  },
  {
     label:"Gbaya-Bozoum",
     value:"gbq"
  },
  {
     label:"Gbagyi",
     value:"gbr"
  },
  {
     label:"Gbesi Gbe",
     value:"gbs"
  },
  {
     label:"Gagadu",
     value:"gbu"
  },
  {
     label:"Gbanu",
     value:"gbv"
  },
  {
     label:"Gabi-Gabi",
     value:"gbw"
  },
  {
     label:"Eastern Xwla Gbe",
     value:"gbx"
  },
  {
     label:"Gbari",
     value:"gby"
  },
  {
     label:"Zoroastrian Dari",
     value:"gbz"
  },
  {
     label:"Mali",
     value:"gcc"
  },
  {
     label:"Guadeloupean Creole French",
     value:"gcf"
  },
  {
     label:"Grenadian Creole English",
     value:"gcl"
  },
  {
     label:"Gaina",
     value:"gcn"
  },
  {
     label:"Guianese Creole French",
     value:"gcr"
  },
  {
     label:"Colonia Tovar German",
     value:"gct"
  },
  {
     label:"Gade Lohar",
     value:"gda"
  },
  {
     label:"Pottangi Ollar Gadaba",
     value:"gdb"
  },
  {
     label:"Gedaged",
     value:"gdd"
  },
  {
     label:"Gude",
     value:"gde"
  },
  {
     label:"Guduf-Gava",
     value:"gdf"
  },
  {
     label:"Ga'dang",
     value:"gdg"
  },
  {
     label:"Gadjerawang",
     value:"gdh"
  },
  {
     label:"Gundi",
     value:"gdi"
  },
  {
     label:"Gurdjar",
     value:"gdj"
  },
  {
     label:"Gadang",
     value:"gdk"
  },
  {
     label:"Dirasha",
     value:"gdl"
  },
  {
     label:"Laal",
     value:"gdm"
  },
  {
     label:"Umanakaina",
     value:"gdn"
  },
  {
     label:"Ghodoberi",
     value:"gdo"
  },
  {
     label:"Mehri",
     value:"gdq"
  },
  {
     label:"Wipi",
     value:"gdr"
  },
  {
     label:"Gudu",
     value:"gdu"
  },
  {
     label:"Godwari",
     value:"gdx"
  },
  {
     label:"Geruma",
     value:"gea"
  },
  {
     label:"Kire",
     value:"geb"
  },
  {
     label:"Gboloo Grebo",
     value:"gec"
  },
  {
     label:"Gade",
     value:"ged"
  },
  {
     label:"Gerai",
     value:"gef"
  },
  {
     label:"Gengle",
     value:"geg"
  },
  {
     label:"Hutterite German",
     value:"geh"
  },
  {
     label:"Gebe",
     value:"gei"
  },
  {
     label:"Gen",
     value:"gej"
  },
  {
     label:"Ywom",
     value:"gek"
  },
  {
     label:"ut-Ma'in",
     value:"gel"
  },
  {
     label:"Geme",
     value:"geq"
  },
  {
     label:"Geser-Gorom",
     value:"ges"
  },
  {
     label:"Eviya",
     value:"gev"
  },
  {
     label:"Gera",
     value:"gew"
  },
  {
     label:"Garre",
     value:"gex"
  },
  {
     label:"Enya",
     value:"gey"
  },
  {
     label:"Patpatar",
     value:"gfk"
  },
  {
     label:"Gao",
     value:"gga"
  },
  {
     label:"Gbii",
     value:"ggb"
  },
  {
     label:"Gurr-goni",
     value:"gge"
  },
  {
     label:"Gurgula",
     value:"ggg"
  },
  {
     label:"Ganglau",
     value:"ggl"
  },
  {
     label:"Gitua",
     value:"ggt"
  },
  {
     label:"Gagu",
     value:"ggu"
  },
  {
     label:"Gogodala",
     value:"ggw"
  },
  {
     label:"Ghadam\u00e8s",
     value:"gha"
  },
  {
     label:"Southern Ghale",
     value:"ghe"
  },
  {
     label:"Northern Ghale",
     value:"ghh"
  },
  {
     label:"Geko Karen",
     value:"ghk"
  },
  {
     label:"Ghulfan",
     value:"ghl"
  },
  {
     label:"Ghanongga",
     value:"ghn"
  },
  {
     label:"Ghera",
     value:"ghr"
  },
  {
     label:"Guhu-Samane",
     value:"ghs"
  },
  {
     label:"Kuke",
     value:"ght"
  },
  {
     label:"Kija",
     value:"gia"
  },
  {
     label:"Gibanawa",
     value:"gib"
  },
  {
     label:"Gail",
     value:"gic"
  },
  {
     label:"Gidar",
     value:"gid"
  },
  {
     label:"Ga\u0253ogbo",
     value:"gie"
  },
  {
     label:"Goaria",
     value:"gig"
  },
  {
     label:"Githabul",
     value:"gih"
  },
  {
     label:"Gilbertese",
     value:"gil",
     "iso6392B":"gil",
     "iso6392T":"gil"
  },
  {
     label:"Gimi (Eastern Highlands)",
     value:"gim"
  },
  {
     label:"Hinukh",
     value:"gin"
  },
  {
     label:"Gimi (West New Britain)",
     value:"gip"
  },
  {
     label:"Green Gelao",
     value:"giq"
  },
  {
     label:"Red Gelao",
     value:"gir"
  },
  {
     label:"North Giziga",
     value:"gis"
  },
  {
     label:"Gitxsan",
     value:"git"
  },
  {
     label:"Mulao",
     value:"giu"
  },
  {
     label:"White Gelao",
     value:"giw"
  },
  {
     label:"Gilima",
     value:"gix"
  },
  {
     label:"Giyug",
     value:"giy"
  },
  {
     label:"South Giziga",
     value:"giz"
  },
  {
     label:"Geji",
     value:"gji"
  },
  {
     label:"Kachi Koli",
     value:"gjk"
  },
  {
     label:"Gonja",
     value:"gjn"
  },
  {
     label:"Gurindji Kriol",
     value:"gjr"
  },
  {
     label:"Gujari",
     value:"gju"
  },
  {
     label:"Guya",
     value:"gka"
  },
  {
     label:"Mag\u0268 (Madang Province)",
     value:"gkd"
  },
  {
     label:"Ndai",
     value:"gke"
  },
  {
     label:"Gokana",
     value:"gkn"
  },
  {
     label:"Guinea Kpelle",
     value:"gkp"
  },
  {
     label:"Scottish Gaelic",
     value:"gla",
     "iso6392B":"gla",
     "iso6392T":"gla",
     "iso6391":"gd"
  },
  {
     label:"Bon Gula",
     value:"glc"
  },
  {
     label:"Nanai",
     value:"gld"
  },
  {
     label:"Irish",
     value:"gle",
     "iso6392B":"gle",
     "iso6392T":"gle",
     "iso6391":"ga"
  },
  {
     label:"Galician",
     value:"glg",
     "iso6392B":"glg",
     "iso6392T":"glg",
     "iso6391":"gl"
  },
  {
     label:"Northwest Pashai",
     value:"glh"
  },
  {
     label:"Gula Iro",
     value:"glj"
  },
  {
     label:"Gilaki",
     value:"glk"
  },
  {
     label:"Galambu",
     value:"glo"
  },
  {
     label:"Glaro-Twabo",
     value:"glr"
  },
  {
     label:"Gula (Chad)",
     value:"glu"
  },
  {
     label:"Manx",
     value:"glv",
     "iso6392B":"glv",
     "iso6392T":"glv",
     "iso6391":"gv"
  },
  {
     label:"Glavda",
     value:"glw"
  },
  {
     label:"Gula'alaa",
     value:"gmb"
  },
  {
     label:"M\u00e1ghd\u00ec",
     value:"gmd"
  },
  {
     label:"Mag\u0268yi",
     value:"gmg"
  },
  {
     label:"Gbaya-Mbodomo",
     value:"gmm"
  },
  {
     label:"Gimnime",
     value:"gmn"
  },
  {
     label:"Mirning",
     value:"gmr"
  },
  {
     label:"Gumalu",
     value:"gmu"
  },
  {
     label:"Gamo",
     value:"gmv"
  },
  {
     label:"Magoma",
     value:"gmx"
  },
  {
     label:"Mgbolizhia",
     value:"gmz"
  },
  {
     label:"Kaansa",
     value:"gna"
  },
  {
     label:"Gangte",
     value:"gnb"
  },
  {
     label:"Zulgo-Gemzek",
     value:"gnd"
  },
  {
     label:"Ganang",
     value:"gne"
  },
  {
     label:"Ngangam",
     value:"gng"
  },
  {
     label:"Lere",
     value:"gnh"
  },
  {
     label:"Gooniyandi",
     value:"gni"
  },
  {
     label:"Ngen",
     value:"gnj"
  },
  {
     label:"\u01c1Gana",
     value:"gnk"
  },
  {
     label:"Ginuman",
     value:"gnm"
  },
  {
     label:"Gumatj",
     value:"gnn"
  },
  {
     label:"Northern Gondi",
     value:"gno"
  },
  {
     label:"Gana",
     value:"gnq"
  },
  {
     label:"Guntai",
     value:"gnt"
  },
  {
     label:"Gnau",
     value:"gnu"
  },
  {
     label:"Western Bolivian Guaran\u00ed",
     value:"gnw"
  },
  {
     label:"Ganzi",
     value:"gnz"
  },
  {
     label:"Guro",
     value:"goa"
  },
  {
     label:"Playero",
     value:"gob"
  },
  {
     label:"Gorakor",
     value:"goc"
  },
  {
     label:"Godi\u00e9",
     value:"god"
  },
  {
     label:"Gongduk",
     value:"goe"
  },
  {
     label:"Gofa",
     value:"gof"
  },
  {
     label:"Gogo",
     value:"gog"
  },
  {
     label:"Gobasi",
     value:"goi"
  },
  {
     label:"Gowlan",
     value:"goj"
  },
  {
     label:"Gowli",
     value:"gok"
  },
  {
     label:"Gola",
     value:"gol"
  },
  {
     label:"Goan Konkani",
     value:"gom"
  },
  {
     label:"Gondi",
     value:"gon",
     "iso6392B":"gon",
     "iso6392T":"gon"
  },
  {
     label:"Gone Dau",
     value:"goo"
  },
  {
     label:"Yeretuar",
     value:"gop"
  },
  {
     label:"Gorap",
     value:"goq"
  },
  {
     label:"Gorontalo",
     value:"gor",
     "iso6392B":"gor",
     "iso6392T":"gor"
  },
  {
     label:"Gronings",
     value:"gos"
  },
  {
     label:"Gavar",
     value:"gou"
  },
  {
     label:"Gorowa",
     value:"gow"
  },
  {
     label:"Gobu",
     value:"gox"
  },
  {
     label:"Goundo",
     value:"goy"
  },
  {
     label:"Gozarkhani",
     value:"goz"
  },
  {
     label:"Gupa-Abawa",
     value:"gpa"
  },
  {
     label:"Ghanaian Pidgin English",
     value:"gpe"
  },
  {
     label:"Taiap",
     value:"gpn"
  },
  {
     label:"Ga'anda",
     value:"gqa"
  },
  {
     label:"Guiqiong",
     value:"gqi"
  },
  {
     label:"Gor",
     value:"gqr"
  },
  {
     label:"Qau",
     value:"gqu"
  },
  {
     label:"Rajput Garasia",
     value:"gra"
  },
  {
     label:"Grebo",
     value:"grb",
     "iso6392B":"grb",
     "iso6392T":"grb"
  },
  {
     label:"Guruntum-Mbaaru",
     value:"grd"
  },
  {
     label:"Madi",
     value:"grg"
  },
  {
     label:"Gbiri-Niragu",
     value:"grh"
  },
  {
     label:"Ghari",
     value:"gri"
  },
  {
     label:"Southern Grebo",
     value:"grj"
  },
  {
     label:"Kota Marudu Talantang",
     value:"grm"
  },
  {
     label:"Guarani",
     value:"grn",
     "iso6392B":"grn",
     "iso6392T":"grn",
     "iso6391":"gn"
  },
  {
     label:"Groma",
     value:"gro"
  },
  {
     label:"Gorovu",
     value:"grq"
  },
  {
     label:"Taznatit",
     value:"grr"
  },
  {
     label:"Gresi",
     value:"grs"
  },
  {
     label:"Garo",
     value:"grt"
  },
  {
     label:"Kistane",
     value:"gru"
  },
  {
     label:"Central Grebo",
     value:"grv"
  },
  {
     label:"Gweda",
     value:"grw"
  },
  {
     label:"Guriaso",
     value:"grx"
  },
  {
     label:"Barclayville Grebo",
     value:"gry"
  },
  {
     label:"Guramalum",
     value:"grz"
  },
  {
     label:"Gusilay",
     value:"gsl"
  },
  {
     label:"Nema",
     value:"gsn"
  },
  {
     label:"Southwest Gbaya",
     value:"gso"
  },
  {
     label:"Wasembo",
     value:"gsp"
  },
  {
     label:"Swiss German",
     value:"gsw",
     "iso6392B":"gsw",
     "iso6392T":"gsw"
  },
  {
     label:"Guat\u00f3",
     value:"gta"
  },
  {
     label:"Shiki",
     value:"gua"
  },
  {
     label:"Guajaj\u00e1ra",
     value:"gub"
  },
  {
     label:"Wayuu",
     value:"guc"
  },
  {
     label:"Yocobou\u00e9 Dida",
     value:"gud"
  },
  {
     label:"Gurindji",
     value:"gue"
  },
  {
     label:"Gupapuyngu",
     value:"guf"
  },
  {
     label:"Paraguayan Guaran\u00ed",
     value:"gug"
  },
  {
     label:"Guahibo",
     value:"guh"
  },
  {
     label:"Eastern Bolivian Guaran\u00ed",
     value:"gui"
  },
  {
     label:"Gujarati",
     value:"guj",
     "iso6392B":"guj",
     "iso6392T":"guj",
     "iso6391":"gu"
  },
  {
     label:"Gumuz",
     value:"guk"
  },
  {
     label:"Sea Island Creole English",
     value:"gul"
  },
  {
     label:"Guambiano",
     value:"gum"
  },
  {
     label:"Mby\u00e1 Guaran\u00ed",
     value:"gun"
  },
  {
     label:"Guayabero",
     value:"guo"
  },
  {
     label:"Gunwinggu",
     value:"gup"
  },
  {
     label:"Ach\u00e9",
     value:"guq"
  },
  {
     label:"Farefare",
     value:"gur"
  },
  {
     label:"Mal\u00e9ku Ja\u00edka",
     value:"gut"
  },
  {
     label:"Yanomam\u00f6",
     value:"guu"
  },
  {
     label:"Gun",
     value:"guw"
  },
  {
     label:"Gourmanch\u00e9ma",
     value:"gux"
  },
  {
     label:"Gusii",
     value:"guz"
  },
  {
     label:"Guana (Paraguay)",
     value:"gva"
  },
  {
     label:"Guanano",
     value:"gvc"
  },
  {
     label:"Duwet",
     value:"gve"
  },
  {
     label:"Golin",
     value:"gvf"
  },
  {
     label:"Guaj\u00e1",
     value:"gvj"
  },
  {
     label:"Gulay",
     value:"gvl"
  },
  {
     label:"Gurmana",
     value:"gvm"
  },
  {
     label:"Kuku-Yalanji",
     value:"gvn"
  },
  {
     label:"Gavi\u00e3o Do Jiparan\u00e1",
     value:"gvo"
  },
  {
     label:"Par\u00e1 Gavi\u00e3o",
     value:"gvp"
  },
  {
     label:"Gurung",
     value:"gvr"
  },
  {
     label:"Gumawana",
     value:"gvs"
  },
  {
     label:"Mbato",
     value:"gwa"
  },
  {
     label:"Gwa",
     value:"gwb"
  },
  {
     label:"Gawri",
     value:"gwc"
  },
  {
     label:"Gawwada",
     value:"gwd"
  },
  {
     label:"Gweno",
     value:"gwe"
  },
  {
     label:"Gowro",
     value:"gwf"
  },
  {
     label:"Moo",
     value:"gwg"
  },
  {
     label:"Gwich\u02bcin",
     value:"gwi",
     "iso6392B":"gwi",
     "iso6392T":"gwi"
  },
  {
     label:"\u01c0Gwi",
     value:"gwj"
  },
  {
     label:"Gwandara",
     value:"gwn"
  },
  {
     label:"Gwere",
     value:"gwr"
  },
  {
     label:"Gawar-Bati",
     value:"gwt"
  },
  {
     label:"Kwini",
     value:"gww"
  },
  {
     label:"Gua",
     value:"gwx"
  },
  {
     label:"W\u00e8 Southern",
     value:"gxx"
  },
  {
     label:"Northwest Gbaya",
     value:"gya"
  },
  {
     label:"Garus",
     value:"gyb"
  },
  {
     label:"Kayardild",
     value:"gyd"
  },
  {
     label:"Gyem",
     value:"gye"
  },
  {
     label:"Gbayi",
     value:"gyg"
  },
  {
     label:"Gyele",
     value:"gyi"
  },
  {
     label:"Gayil",
     value:"gyl"
  },
  {
     label:"Ng\u00e4bere",
     value:"gym"
  },
  {
     label:"Guyanese Creole English",
     value:"gyn"
  },
  {
     label:"Gyalsumdo",
     value:"gyo"
  },
  {
     label:"Guarayu",
     value:"gyr"
  },
  {
     label:"Ganza",
     value:"gza"
  },
  {
     label:"Gazi",
     value:"gzi"
  },
  {
     label:"Gane",
     value:"gzn"
  },
  {
     label:"Han",
     value:"haa"
  },
  {
     label:"Gurani",
     value:"hac"
  },
  {
     label:"Hatam",
     value:"had"
  },
  {
     label:"Eastern Oromo",
     value:"hae"
  },
  {
     label:"Hanga",
     value:"hag"
  },
  {
     label:"Hahon",
     value:"hah"
  },
  {
     label:"Haida",
     value:"hai",
     "iso6392B":"hai",
     "iso6392T":"hai"
  },
  {
     label:"Hajong",
     value:"haj"
  },
  {
     label:"Hakka Chinese",
     value:"hak"
  },
  {
     label:"Halang",
     value:"hal"
  },
  {
     label:"Hewa",
     value:"ham"
  },
  {
     label:"Hangaza",
     value:"han"
  },
  {
     label:"Hak\u00f6",
     value:"hao"
  },
  {
     label:"Hupla",
     value:"hap"
  },
  {
     label:"Ha",
     value:"haq"
  },
  {
     label:"Harari",
     value:"har"
  },
  {
     label:"Haisla",
     value:"has"
  },
  {
     label:"Haitian",
     value:"hat",
     "iso6392B":"hat",
     "iso6392T":"hat",
     "iso6391":"ht"
  },
  {
     label:"Hausa",
     value:"hau",
     "iso6392B":"hau",
     "iso6392T":"hau",
     "iso6391":"ha"
  },
  {
     label:"Havu",
     value:"hav"
  },
  {
     label:"Hawaiian",
     value:"haw",
     "iso6392B":"haw",
     "iso6392T":"haw"
  },
  {
     label:"Southern Haida",
     value:"hax"
  },
  {
     label:"Haya",
     value:"hay"
  },
  {
     label:"Hazaragi",
     value:"haz"
  },
  {
     label:"Hamba",
     value:"hba"
  },
  {
     label:"Huba",
     value:"hbb"
  },
  {
     label:"Heiban",
     value:"hbn"
  },
  {
     label:"Serbo-Croatian",
     value:"hbs",
     "iso6391":"sh"
  },
  {
     label:"Habu",
     value:"hbu"
  },
  {
     label:"Andaman Creole Hindi",
     value:"hca"
  },
  {
     label:"Huichol",
     value:"hch"
  },
  {
     label:"Northern Haida",
     value:"hdn"
  },
  {
     label:"Hadiyya",
     value:"hdy"
  },
  {
     label:"Northern Qiandong Miao",
     value:"hea"
  },
  {
     label:"Hebrew",
     value:"heb",
     "iso6392B":"heb",
     "iso6392T":"heb",
     "iso6391":"he"
  },
  {
     label:"Herd\u00e9",
     value:"hed"
  },
  {
     label:"Helong",
     value:"heg"
  },
  {
     label:"Hehe",
     value:"heh"
  },
  {
     label:"Heiltsuk",
     value:"hei"
  },
  {
     label:"Hemba",
     value:"hem"
  },
  {
     label:"Herero",
     value:"her",
     "iso6392B":"her",
     "iso6392T":"her",
     "iso6391":"hz"
  },
  {
     label:"Hai\u01c1om",
     value:"hgm"
  },
  {
     label:"Haigwai",
     value:"hgw"
  },
  {
     label:"Hoia Hoia",
     value:"hhi"
  },
  {
     label:"Kerak",
     value:"hhr"
  },
  {
     label:"Hoyahoya",
     value:"hhy"
  },
  {
     label:"Lamang",
     value:"hia"
  },
  {
     label:"Hidatsa",
     value:"hid"
  },
  {
     label:"Fiji Hindi",
     value:"hif"
  },
  {
     label:"Kamwe",
     value:"hig"
  },
  {
     label:"Pamosu",
     value:"hih"
  },
  {
     label:"Hinduri",
     value:"hii"
  },
  {
     label:"Hijuk",
     value:"hij"
  },
  {
     label:"Seit-Kaitetu",
     value:"hik"
  },
  {
     label:"Hiligaynon",
     value:"hil",
     "iso6392B":"hil",
     "iso6392T":"hil"
  },
  {
     label:"Hindi",
     value:"hin",
     "iso6392B":"hin",
     "iso6392T":"hin",
     "iso6391":"hi"
  },
  {
     label:"Tsoa",
     value:"hio"
  },
  {
     label:"Himarim\u00e3",
     value:"hir"
  },
  {
     label:"Hiw",
     value:"hiw"
  },
  {
     label:"Hixkary\u00e1na",
     value:"hix"
  },
  {
     label:"Haji",
     value:"hji"
  },
  {
     label:"Kahe",
     value:"hka"
  },
  {
     label:"Hunde",
     value:"hke"
  },
  {
     label:"Hunjara-Kaina Ke",
     value:"hkk"
  },
  {
     label:"Mel-Khaonh",
     value:"hkn"
  },
  {
     label:"Halia",
     value:"hla"
  },
  {
     label:"Halbi",
     value:"hlb"
  },
  {
     label:"Halang Doan",
     value:"hld"
  },
  {
     label:"Hlersu",
     value:"hle"
  },
  {
     label:"Matu Chin",
     value:"hlt"
  },
  {
     label:"Southern Mashan Hmong",
     value:"hma"
  },
  {
     label:"Humburi Senni Songhay",
     value:"hmb"
  },
  {
     label:"Central Huishui Hmong",
     value:"hmc"
  },
  {
     label:"Large Flowery Miao",
     value:"hmd"
  },
  {
     label:"Eastern Huishui Hmong",
     value:"hme"
  },
  {
     label:"Hmong Don",
     value:"hmf"
  },
  {
     label:"Southwestern Guiyang Hmong",
     value:"hmg"
  },
  {
     label:"Southwestern Huishui Hmong",
     value:"hmh"
  },
  {
     label:"Northern Huishui Hmong",
     value:"hmi"
  },
  {
     label:"Ge",
     value:"hmj"
  },
  {
     label:"Luopohe Hmong",
     value:"hml"
  },
  {
     label:"Central Mashan Hmong",
     value:"hmm"
  },
  {
     label:"Hmong",
     value:"hmn",
     "iso6392B":"hmn",
     "iso6392T":"hmn"
  },
  {
     label:"Hiri Motu",
     value:"hmo",
     "iso6392B":"hmo",
     "iso6392T":"hmo",
     "iso6391":"ho"
  },
  {
     label:"Northern Mashan Hmong",
     value:"hmp"
  },
  {
     label:"Eastern Qiandong Miao",
     value:"hmq"
  },
  {
     label:"Hmar",
     value:"hmr"
  },
  {
     label:"Southern Qiandong Miao",
     value:"hms"
  },
  {
     label:"Hamtai",
     value:"hmt"
  },
  {
     label:"Hamap",
     value:"hmu"
  },
  {
     label:"Hmong D\u00f4",
     value:"hmv"
  },
  {
     label:"Western Mashan Hmong",
     value:"hmw"
  },
  {
     label:"Southern Guiyang Hmong",
     value:"hmy"
  },
  {
     label:"Hmong Shua",
     value:"hmz"
  },
  {
     label:"Mina (Cameroon)",
     value:"hna"
  },
  {
     label:"Southern Hindko",
     value:"hnd"
  },
  {
     label:"Chhattisgarhi",
     value:"hne"
  },
  {
     label:"Hungu",
     value:"hng"
  },
  {
     label:"\u01c1Ani",
     value:"hnh"
  },
  {
     label:"Hani",
     value:"hni"
  },
  {
     label:"Hmong Njua",
     value:"hnj"
  },
  {
     label:"Hanunoo",
     value:"hnn"
  },
  {
     label:"Northern Hindko",
     value:"hno"
  },
  {
     label:"Caribbean Hindustani",
     value:"hns"
  },
  {
     label:"Hung",
     value:"hnu"
  },
  {
     label:"Hoava",
     value:"hoa"
  },
  {
     label:"Mari (Madang Province)",
     value:"hob"
  },
  {
     label:"Ho",
     value:"hoc"
  },
  {
     label:"Horom",
     value:"hoe"
  },
  {
     label:"Hoby\u00f3t",
     value:"hoh"
  },
  {
     label:"Holikachuk",
     value:"hoi"
  },
  {
     label:"Hadothi",
     value:"hoj"
  },
  {
     label:"Holu",
     value:"hol"
  },
  {
     label:"Holoholo",
     value:"hoo"
  },
  {
     label:"Hopi",
     value:"hop"
  },
  {
     label:"Hote",
     value:"hot"
  },
  {
     label:"Hovongan",
     value:"hov"
  },
  {
     label:"Honi",
     value:"how"
  },
  {
     label:"Holiya",
     value:"hoy"
  },
  {
     label:"Hozo",
     value:"hoz"
  },
  {
     label:"Hrangkhol",
     value:"hra"
  },
  {
     label:"Niwer Mil",
     value:"hrc"
  },
  {
     label:"Hre",
     value:"hre"
  },
  {
     label:"Haruku",
     value:"hrk"
  },
  {
     label:"Horned Miao",
     value:"hrm"
  },
  {
     label:"Haroi",
     value:"hro"
  },
  {
     label:"H\u00e9rtevin",
     value:"hrt"
  },
  {
     label:"Hruso",
     value:"hru"
  },
  {
     label:"Croatian",
     value:"hrv",
     "iso6392B":"hrv",
     "iso6392T":"hrv",
     "iso6391":"hr"
  },
  {
     label:"Warwar Feni",
     value:"hrw"
  },
  {
     label:"Hunsrik",
     value:"hrx"
  },
  {
     label:"Harzani",
     value:"hrz"
  },
  {
     label:"Upper Sorbian",
     value:"hsb",
     "iso6392B":"hsb",
     "iso6392T":"hsb"
  },
  {
     label:"Xiang Chinese",
     value:"hsn"
  },
  {
     label:"Harsusi",
     value:"hss"
  },
  {
     label:"Minica Huitoto",
     value:"hto"
  },
  {
     label:"Hadza",
     value:"hts"
  },
  {
     label:"Hitu",
     value:"htu"
  },
  {
     label:"Huambisa",
     value:"hub"
  },
  {
     label:"\u01c2Hua",
     value:"huc"
  },
  {
     label:"Huaulu",
     value:"hud"
  },
  {
     label:"San Francisco Del Mar Huave",
     value:"hue"
  },
  {
     label:"Humene",
     value:"huf"
  },
  {
     label:"Huachipaeri",
     value:"hug"
  },
  {
     label:"Huilliche",
     value:"huh"
  },
  {
     label:"Huli",
     value:"hui"
  },
  {
     label:"Northern Guiyang Hmong",
     value:"huj"
  },
  {
     label:"Hula",
     value:"hul"
  },
  {
     label:"Hungana",
     value:"hum"
  },
  {
     label:"Hungarian",
     value:"hun",
     "iso6392B":"hun",
     "iso6392T":"hun",
     "iso6391":"hu"
  },
  {
     label:"Hu",
     value:"huo"
  },
  {
     label:"Hupa",
     value:"hup",
     "iso6392B":"hup",
     "iso6392T":"hup"
  },
  {
     label:"Tsat",
     value:"huq"
  },
  {
     label:"Halkomelem",
     value:"hur"
  },
  {
     label:"Huastec",
     value:"hus"
  },
  {
     label:"Humla",
     value:"hut"
  },
  {
     label:"Murui Huitoto",
     value:"huu"
  },
  {
     label:"San Mateo Del Mar Huave",
     value:"huv"
  },
  {
     label:"N\u00fcpode Huitoto",
     value:"hux"
  },
  {
     label:"Hulaul\u00e1",
     value:"huy"
  },
  {
     label:"Hunzib",
     value:"huz"
  },
  {
     label:"Haitian Vodoun Culture Language",
     value:"hvc"
  },
  {
     label:"San Dionisio Del Mar Huave",
     value:"hve"
  },
  {
     label:"Haveke",
     value:"hvk"
  },
  {
     label:"Sabu",
     value:"hvn"
  },
  {
     label:"Santa Mar\u00eda Del Mar Huave",
     value:"hvv"
  },
  {
     label:"Wan\u00e9",
     value:"hwa"
  },
  {
     label:"Hawai'i Creole English",
     value:"hwc"
  },
  {
     label:"Hwana",
     value:"hwo"
  },
  {
     label:"Hya",
     value:"hya"
  },
  {
     label:"Armenian",
     value:"hye",
     "iso6392B":"arm",
     "iso6392T":"hye",
     "iso6391":"hy"
  },
  {
     label:"Western Armenian",
     value:"hyw"
  },
  {
     label:"Iaai",
     value:"iai"
  },
  {
     label:"Iatmul",
     value:"ian"
  },
  {
     label:"Purari",
     value:"iar"
  },
  {
     label:"Iban",
     value:"iba",
     "iso6392B":"iba",
     "iso6392T":"iba"
  },
  {
     label:"Ibibio",
     value:"ibb"
  },
  {
     label:"Iwaidja",
     value:"ibd"
  },
  {
     label:"Akpes",
     value:"ibe"
  },
  {
     label:"Ibanag",
     value:"ibg"
  },
  {
     label:"Bih",
     value:"ibh"
  },
  {
     label:"Ibaloi",
     value:"ibl"
  },
  {
     label:"Agoi",
     value:"ibm"
  },
  {
     label:"Ibino",
     value:"ibn"
  },
  {
     label:"Igbo",
     value:"ibo",
     "iso6392B":"ibo",
     "iso6392T":"ibo",
     "iso6391":"ig"
  },
  {
     label:"Ibuoro",
     value:"ibr"
  },
  {
     label:"Ibu",
     value:"ibu"
  },
  {
     label:"Ibani",
     value:"iby"
  },
  {
     label:"Ede Ica",
     value:"ica"
  },
  {
     label:"Etkywan",
     value:"ich"
  },
  {
     label:"Islander Creole English",
     value:"icr"
  },
  {
     label:"Idakho-Isukha-Tiriki",
     value:"ida"
  },
  {
     label:"Indo-Portuguese",
     value:"idb"
  },
  {
     label:"Idon",
     value:"idc"
  },
  {
     label:"Ede Idaca",
     value:"idd"
  },
  {
     label:"Idere",
     value:"ide"
  },
  {
     label:"Idi",
     value:"idi"
  },
  {
     label:"Ido",
     value:"ido",
     "iso6392B":"ido",
     "iso6392T":"ido",
     "iso6391":"io"
  },
  {
     label:"Indri",
     value:"idr"
  },
  {
     label:"Idesa",
     value:"ids"
  },
  {
     label:"Idat\u00e9",
     value:"idt"
  },
  {
     label:"Idoma",
     value:"idu"
  },
  {
     label:"Amganad Ifugao",
     value:"ifa"
  },
  {
     label:"Batad Ifugao",
     value:"ifb"
  },
  {
     label:"If\u00e8",
     value:"ife"
  },
  {
     label:"Tuwali Ifugao",
     value:"ifk"
  },
  {
     label:"Teke-Fuumu",
     value:"ifm"
  },
  {
     label:"Mayoyao Ifugao",
     value:"ifu"
  },
  {
     label:"Keley-I Kallahan",
     value:"ify"
  },
  {
     label:"Ebira",
     value:"igb"
  },
  {
     label:"Igede",
     value:"ige"
  },
  {
     label:"Igana",
     value:"igg"
  },
  {
     label:"Igala",
     value:"igl"
  },
  {
     label:"Kanggape",
     value:"igm"
  },
  {
     label:"Ignaciano",
     value:"ign"
  },
  {
     label:"Isebe",
     value:"igo"
  },
  {
     label:"Interglossa",
     value:"igs"
  },
  {
     label:"Igwe",
     value:"igw"
  },
  {
     label:"Iha Based Pidgin",
     value:"ihb"
  },
  {
     label:"Ihievbe",
     value:"ihi"
  },
  {
     label:"Iha",
     value:"ihp"
  },
  {
     label:"Sichuan Yi",
     value:"iii",
     "iso6392B":"iii",
     "iso6392T":"iii",
     "iso6391":"ii"
  },
  {
     label:"Izon",
     value:"ijc"
  },
  {
     label:"Biseni",
     value:"ije"
  },
  {
     label:"Ede Ije",
     value:"ijj"
  },
  {
     label:"Kalabari",
     value:"ijn"
  },
  {
     label:"Southeast Ijo",
     value:"ijs"
  },
  {
     label:"Eastern Canadian Inuktitut",
     value:"ike"
  },
  {
     label:"Iko",
     value:"iki"
  },
  {
     label:"Ika",
     value:"ikk"
  },
  {
     label:"Ikulu",
     value:"ikl"
  },
  {
     label:"Olulumo-Ikom",
     value:"iko"
  },
  {
     label:"Ikpeshi",
     value:"ikp"
  },
  {
     label:"Inuinnaqtun",
     value:"ikt"
  },
  {
     label:"Inuktitut",
     value:"iku",
     "iso6392B":"iku",
     "iso6392T":"iku",
     "iso6391":"iu"
  },
  {
     label:"Iku-Gora-Ankwa",
     value:"ikv"
  },
  {
     label:"Ikwere",
     value:"ikw"
  },
  {
     label:"Ik",
     value:"ikx"
  },
  {
     label:"Ikizu",
     value:"ikz"
  },
  {
     label:"Ile Ape",
     value:"ila"
  },
  {
     label:"Ila",
     value:"ilb"
  },
  {
     label:"Interlingue",
     value:"ile",
     "iso6392B":"ile",
     "iso6392T":"ile",
     "iso6391":"ie"
  },
  {
     label:"Ili Turki",
     value:"ili"
  },
  {
     label:"Ilongot",
     value:"ilk"
  },
  {
     label:"Iranun (Malaysia)",
     value:"ilm"
  },
  {
     label:"Iloko",
     value:"ilo",
     "iso6392B":"ilo",
     "iso6392T":"ilo"
  },
  {
     label:"Iranun (Philippines)",
     value:"ilp"
  },
  {
     label:"International Sign",
     value:"ils"
  },
  {
     label:"Ili'uun",
     value:"ilu"
  },
  {
     label:"Ilue",
     value:"ilv"
  },
  {
     label:"Mala Malasar",
     value:"ima"
  },
  {
     label:"Anamgura",
     value:"imi"
  },
  {
     label:"Imonda",
     value:"imn"
  },
  {
     label:"Imbongu",
     value:"imo"
  },
  {
     label:"Imroing",
     value:"imr"
  },
  {
     label:"Interlingua (International Auxiliary Language Association)",
     value:"ina",
     "iso6392B":"ina",
     "iso6392T":"ina",
     "iso6391":"ia"
  },
  {
     label:"Inga",
     value:"inb"
  },
  {
     label:"Indonesian",
     value:"ind",
     "iso6392B":"ind",
     "iso6392T":"ind",
     "iso6391":"id"
  },
  {
     label:"Degexit'an",
     value:"ing"
  },
  {
     label:"Ingush",
     value:"inh",
     "iso6392B":"inh",
     "iso6392T":"inh"
  },
  {
     label:"Jungle Inga",
     value:"inj"
  },
  {
     label:"Isinai",
     value:"inn"
  },
  {
     label:"Inoke-Yate",
     value:"ino"
  },
  {
     label:"I\u00f1apari",
     value:"inp"
  },
  {
     label:"Intha",
     value:"int"
  },
  {
     label:"Inor",
     value:"ior"
  },
  {
     label:"Tuma-Irumu",
     value:"iou"
  },
  {
     label:"Ipili",
     value:"ipi"
  },
  {
     label:"Inupiaq",
     value:"ipk",
     "iso6392B":"ipk",
     "iso6392T":"ipk",
     "iso6391":"ik"
  },
  {
     label:"Ipiko",
     value:"ipo"
  },
  {
     label:"Iquito",
     value:"iqu"
  },
  {
     label:"Ikwo",
     value:"iqw"
  },
  {
     label:"Iresim",
     value:"ire"
  },
  {
     label:"Irarutu",
     value:"irh"
  },
  {
     label:"Rigwe",
     value:"iri"
  },
  {
     label:"Iraqw",
     value:"irk"
  },
  {
     label:"Ir\u00e1ntxe",
     value:"irn"
  },
  {
     label:"Ir",
     value:"irr"
  },
  {
     label:"Irula",
     value:"iru"
  },
  {
     label:"Kamberau",
     value:"irx"
  },
  {
     label:"Iraya",
     value:"iry"
  },
  {
     label:"Isabi",
     value:"isa"
  },
  {
     label:"Isconahua",
     value:"isc"
  },
  {
     label:"Isnag",
     value:"isd"
  },
  {
     label:"Esan",
     value:"ish"
  },
  {
     label:"Nkem-Nkum",
     value:"isi"
  },
  {
     label:"Ishkashimi",
     value:"isk"
  },
  {
     label:"Icelandic",
     value:"isl",
     "iso6392B":"ice",
     "iso6392T":"isl",
     "iso6391":"is"
  },
  {
     label:"Masimasi",
     value:"ism"
  },
  {
     label:"Isanzu",
     value:"isn"
  },
  {
     label:"Isoko",
     value:"iso"
  },
  {
     label:"Istriot",
     value:"ist"
  },
  {
     label:"Isu (Menchum Division)",
     value:"isu"
  },
  {
     label:"Italian",
     value:"ita",
     "iso6392B":"ita",
     "iso6392T":"ita",
     "iso6391":"it"
  },
  {
     label:"Binongan Itneg",
     value:"itb"
  },
  {
     label:"Southern Tidung",
     value:"itd"
  },
  {
     label:"Inlaod Itneg",
     value:"iti"
  },
  {
     label:"Judeo-Italian",
     value:"itk"
  },
  {
     label:"Itelmen",
     value:"itl"
  },
  {
     label:"Itu Mbon Uzo",
     value:"itm"
  },
  {
     label:"Itonama",
     value:"ito"
  },
  {
     label:"Iteri",
     value:"itr"
  },
  {
     label:"Isekiri",
     value:"its"
  },
  {
     label:"Maeng Itneg",
     value:"itt"
  },
  {
     label:"Itawit",
     value:"itv"
  },
  {
     label:"Ito",
     value:"itw"
  },
  {
     label:"Itik",
     value:"itx"
  },
  {
     label:"Moyadan Itneg",
     value:"ity"
  },
  {
     label:"Itz\u00e1",
     value:"itz"
  },
  {
     label:"Iu Mien",
     value:"ium"
  },
  {
     label:"Ibatan",
     value:"ivb"
  },
  {
     label:"Ivatan",
     value:"ivv"
  },
  {
     label:"I-Wak",
     value:"iwk"
  },
  {
     label:"Iwam",
     value:"iwm"
  },
  {
     label:"Iwur",
     value:"iwo"
  },
  {
     label:"Sepik Iwam",
     value:"iws"
  },
  {
     label:"Ixcatec",
     value:"ixc"
  },
  {
     label:"Ixil",
     value:"ixl"
  },
  {
     label:"Iyayu",
     value:"iya"
  },
  {
     label:"Mesaka",
     value:"iyo"
  },
  {
     label:"Yaka (Congo)",
     value:"iyx"
  },
  {
     label:"Ingrian",
     value:"izh"
  },
  {
     label:"Izere",
     value:"izr"
  },
  {
     label:"Izii",
     value:"izz"
  },
  {
     label:"Jamamad\u00ed",
     value:"jaa"
  },
  {
     label:"Hyam",
     value:"jab"
  },
  {
     label:"Popti'",
     value:"jac"
  },
  {
     label:"Jahanka",
     value:"jad"
  },
  {
     label:"Yabem",
     value:"jae"
  },
  {
     label:"Jara",
     value:"jaf"
  },
  {
     label:"Jah Hut",
     value:"jah"
  },
  {
     label:"Zazao",
     value:"jaj"
  },
  {
     label:"Jakun",
     value:"jak"
  },
  {
     label:"Yalahatan",
     value:"jal"
  },
  {
     label:"Jamaican Creole English",
     value:"jam"
  },
  {
     label:"Yanyuwa",
     value:"jao"
  },
  {
     label:"Yaqay",
     value:"jaq"
  },
  {
     label:"New Caledonian Javanese",
     value:"jas"
  },
  {
     label:"Jakati",
     value:"jat"
  },
  {
     label:"Yaur",
     value:"jau"
  },
  {
     label:"Javanese",
     value:"jav",
     "iso6392B":"jav",
     "iso6392T":"jav",
     "iso6391":"jv"
  },
  {
     label:"Jambi Malay",
     value:"jax"
  },
  {
     label:"Yan-nhangu",
     value:"jay"
  },
  {
     label:"Jawe",
     value:"jaz"
  },
  {
     label:"Judeo-Berber",
     value:"jbe"
  },
  {
     label:"Arandai",
     value:"jbj"
  },
  {
     label:"Barikewa",
     value:"jbk"
  },
  {
     label:"Nafusi",
     value:"jbn"
  },
  {
     label:"Lojban",
     value:"jbo",
     "iso6392B":"jbo",
     "iso6392T":"jbo"
  },
  {
     label:"Jofotek-Bromnya",
     value:"jbr"
  },
  {
     label:"Jabut\u00ed",
     value:"jbt"
  },
  {
     label:"Jukun Takum",
     value:"jbu"
  },
  {
     label:"Krymchak",
     value:"jct"
  },
  {
     label:"Jad",
     value:"jda"
  },
  {
     label:"Jadgali",
     value:"jdg"
  },
  {
     label:"Judeo-Tat",
     value:"jdt"
  },
  {
     label:"Jebero",
     value:"jeb"
  },
  {
     label:"Jerung",
     value:"jee"
  },
  {
     label:"Jeh",
     value:"jeh"
  },
  {
     label:"Yei",
     value:"jei"
  },
  {
     label:"Jeri Kuo",
     value:"jek"
  },
  {
     label:"Yelmek",
     value:"jel"
  },
  {
     label:"Dza",
     value:"jen"
  },
  {
     label:"Jere",
     value:"jer"
  },
  {
     label:"Manem",
     value:"jet"
  },
  {
     label:"Jonkor Bourmataguil",
     value:"jeu"
  },
  {
     label:"Judeo-Georgian",
     value:"jge"
  },
  {
     label:"Gwak",
     value:"jgk"
  },
  {
     label:"Ngomba",
     value:"jgo"
  },
  {
     label:"Jehai",
     value:"jhi"
  },
  {
     label:"Jina",
     value:"jia"
  },
  {
     label:"Jibu",
     value:"jib"
  },
  {
     label:"Tol",
     value:"jic"
  },
  {
     label:"Bu",
     value:"jid"
  },
  {
     label:"Jilbe",
     value:"jie"
  },
  {
     label:"Jingulu",
     value:"jig"
  },
  {
     label:"sTodsde",
     value:"jih"
  },
  {
     label:"Jiiddu",
     value:"jii"
  },
  {
     label:"Jilim",
     value:"jil"
  },
  {
     label:"Jimi (Cameroon)",
     value:"jim"
  },
  {
     label:"Jiamao",
     value:"jio"
  },
  {
     label:"Guanyinqiao",
     value:"jiq"
  },
  {
     label:"Jita",
     value:"jit"
  },
  {
     label:"Youle Jinuo",
     value:"jiu"
  },
  {
     label:"Shuar",
     value:"jiv"
  },
  {
     label:"Buyuan Jinuo",
     value:"jiy"
  },
  {
     label:"Jejueo",
     value:"jje"
  },
  {
     label:"Bankal",
     value:"jjr"
  },
  {
     label:"Kaera",
     value:"jka"
  },
  {
     label:"Mobwa Karen",
     value:"jkm"
  },
  {
     label:"Kubo",
     value:"jko"
  },
  {
     label:"Paku Karen",
     value:"jkp"
  },
  {
     label:"Koro (India)",
     value:"jkr"
  },
  {
     label:"Labir",
     value:"jku"
  },
  {
     label:"Ngile",
     value:"jle"
  },
  {
     label:"Dima",
     value:"jma"
  },
  {
     label:"Zumbun",
     value:"jmb"
  },
  {
     label:"Machame",
     value:"jmc"
  },
  {
     label:"Yamdena",
     value:"jmd"
  },
  {
     label:"Jimi (Nigeria)",
     value:"jmi"
  },
  {
     label:"Jumli",
     value:"jml"
  },
  {
     label:"Makuri Naga",
     value:"jmn"
  },
  {
     label:"Kamara",
     value:"jmr"
  },
  {
     label:"Mashi (Nigeria)",
     value:"jms"
  },
  {
     label:"Mouwase",
     value:"jmw"
  },
  {
     label:"Western Juxtlahuaca Mixtec",
     value:"jmx"
  },
  {
     label:"Jangshung",
     value:"jna"
  },
  {
     label:"Jandavra",
     value:"jnd"
  },
  {
     label:"Janji",
     value:"jni"
  },
  {
     label:"Yemsa",
     value:"jnj"
  },
  {
     label:"Rawat",
     value:"jnl"
  },
  {
     label:"Jaunsari",
     value:"jns"
  },
  {
     label:"Joba",
     value:"job"
  },
  {
     label:"Wojenaka",
     value:"jod"
  },
  {
     label:"Jogi",
     value:"jog"
  },
  {
     label:"Jowulu",
     value:"jow"
  },
  {
     label:"Japanese",
     value:"jpn",
     "iso6392B":"jpn",
     "iso6392T":"jpn",
     "iso6391":"ja"
  },
  {
     label:"Judeo-Persian",
     value:"jpr",
     "iso6392B":"jpr",
     "iso6392T":"jpr"
  },
  {
     label:"Jaqaru",
     value:"jqr"
  },
  {
     label:"Jarai",
     value:"jra"
  },
  {
     label:"Judeo-Arabic",
     value:"jrb",
     "iso6392B":"jrb",
     "iso6392T":"jrb"
  },
  {
     label:"Jiru",
     value:"jrr"
  },
  {
     label:"Jorto",
     value:"jrt"
  },
  {
     label:"Japrer\u00eda",
     value:"jru"
  },
  {
     label:"J\u00fama",
     value:"jua"
  },
  {
     label:"Wannu",
     value:"jub"
  },
  {
     label:"Worodougou",
     value:"jud"
  },
  {
     label:"H\u00f5ne",
     value:"juh"
  },
  {
     label:"Wapan",
     value:"juk"
  },
  {
     label:"Jirel",
     value:"jul"
  },
  {
     label:"Jumjum",
     value:"jum"
  },
  {
     label:"Juang",
     value:"jun"
  },
  {
     label:"Jiba",
     value:"juo"
  },
  {
     label:"Hupd\u00eb",
     value:"jup"
  },
  {
     label:"Jur\u00fana",
     value:"jur"
  },
  {
     label:"Ju",
     value:"juu"
  },
  {
     label:"W\u00e3pha",
     value:"juw"
  },
  {
     label:"Juray",
     value:"juy"
  },
  {
     label:"Javindo",
     value:"jvd"
  },
  {
     label:"Caribbean Javanese",
     value:"jvn"
  },
  {
     label:"Jwira-Pepesa",
     value:"jwi"
  },
  {
     label:"Jiarong",
     value:"jya"
  },
  {
     label:"Judeo-Yemeni Arabic",
     value:"jye"
  },
  {
     label:"Jaya",
     value:"jyy"
  },
  {
     label:"Kara-Kalpak",
     value:"kaa",
     "iso6392B":"kaa",
     "iso6392T":"kaa"
  },
  {
     label:"Kabyle",
     value:"kab",
     "iso6392B":"kab",
     "iso6392T":"kab"
  },
  {
     label:"Kachin",
     value:"kac",
     "iso6392B":"kac",
     "iso6392T":"kac"
  },
  {
     label:"Adara",
     value:"kad"
  },
  {
     label:"Katso",
     value:"kaf"
  },
  {
     label:"Kajaman",
     value:"kag"
  },
  {
     label:"Kara (Central African Republic)",
     value:"kah"
  },
  {
     label:"Karekare",
     value:"kai"
  },
  {
     label:"Jju",
     value:"kaj"
  },
  {
     label:"Kalanguya",
     value:"kak"
  },
  {
     label:"Kalaallisut",
     value:"kal",
     "iso6392B":"kal",
     "iso6392T":"kal",
     "iso6391":"kl"
  },
  {
     label:"Kamba (Kenya)",
     value:"kam",
     "iso6392B":"kam",
     "iso6392T":"kam"
  },
  {
     label:"Kannada",
     value:"kan",
     "iso6392B":"kan",
     "iso6392T":"kan",
     "iso6391":"kn"
  },
  {
     label:"Xaasongaxango",
     value:"kao"
  },
  {
     label:"Bezhta",
     value:"kap"
  },
  {
     label:"Capanahua",
     value:"kaq"
  },
  {
     label:"Kashmiri",
     value:"kas",
     "iso6392B":"kas",
     "iso6392T":"kas",
     "iso6391":"ks"
  },
  {
     label:"Georgian",
     value:"kat",
     "iso6392B":"geo",
     "iso6392T":"kat",
     "iso6391":"ka"
  },
  {
     label:"Kanuri",
     value:"kau",
     "iso6392B":"kau",
     "iso6392T":"kau",
     "iso6391":"kr"
  },
  {
     label:"Katuk\u00edna",
     value:"kav"
  },
  {
     label:"Kao",
     value:"kax"
  },
  {
     label:"Kamayur\u00e1",
     value:"kay"
  },
  {
     label:"Kazakh",
     value:"kaz",
     "iso6392B":"kaz",
     "iso6392T":"kaz",
     "iso6391":"kk"
  },
  {
     label:"Kadiw\u00e9u",
     value:"kbc"
  },
  {
     label:"Kabardian",
     value:"kbd",
     "iso6392B":"kbd",
     "iso6392T":"kbd"
  },
  {
     label:"Kanju",
     value:"kbe"
  },
  {
     label:"Khamba",
     value:"kbg"
  },
  {
     label:"Cams\u00e1",
     value:"kbh"
  },
  {
     label:"Kaptiau",
     value:"kbi"
  },
  {
     label:"Kari",
     value:"kbj"
  },
  {
     label:"Grass Koiari",
     value:"kbk"
  },
  {
     label:"Kanembu",
     value:"kbl"
  },
  {
     label:"Iwal",
     value:"kbm"
  },
  {
     label:"Kare (Central African Republic)",
     value:"kbn"
  },
  {
     label:"Keliko",
     value:"kbo"
  },
  {
     label:"Kabiy\u00e8",
     value:"kbp"
  },
  {
     label:"Kamano",
     value:"kbq"
  },
  {
     label:"Kafa",
     value:"kbr"
  },
  {
     label:"Kande",
     value:"kbs"
  },
  {
     label:"Abadi",
     value:"kbt"
  },
  {
     label:"Kabutra",
     value:"kbu"
  },
  {
     label:"Dera (Indonesia)",
     value:"kbv"
  },
  {
     label:"Kaiep",
     value:"kbw"
  },
  {
     label:"Ap Ma",
     value:"kbx"
  },
  {
     label:"Manga Kanuri",
     value:"kby"
  },
  {
     label:"Duhwa",
     value:"kbz"
  },
  {
     label:"Khanty",
     value:"kca"
  },
  {
     label:"Kawacha",
     value:"kcb"
  },
  {
     label:"Lubila",
     value:"kcc"
  },
  {
     label:"Ngk\u00e2lmpw Kanum",
     value:"kcd"
  },
  {
     label:"Kaivi",
     value:"kce"
  },
  {
     label:"Ukaan",
     value:"kcf"
  },
  {
     label:"Tyap",
     value:"kcg"
  },
  {
     label:"Vono",
     value:"kch"
  },
  {
     label:"Kamantan",
     value:"kci"
  },
  {
     label:"Kobiana",
     value:"kcj"
  },
  {
     label:"Kalanga",
     value:"kck"
  },
  {
     label:"Kela (Papua New Guinea)",
     value:"kcl"
  },
  {
     label:"Gula (Central African Republic)",
     value:"kcm"
  },
  {
     label:"Nubi",
     value:"kcn"
  },
  {
     label:"Kinalakna",
     value:"kco"
  },
  {
     label:"Kanga",
     value:"kcp"
  },
  {
     label:"Kamo",
     value:"kcq"
  },
  {
     label:"Katla",
     value:"kcr"
  },
  {
     label:"Koenoem",
     value:"kcs"
  },
  {
     label:"Kaian",
     value:"kct"
  },
  {
     label:"Kami (Tanzania)",
     value:"kcu"
  },
  {
     label:"Kete",
     value:"kcv"
  },
  {
     label:"Kabwari",
     value:"kcw"
  },
  {
     label:"Kachama-Ganjule",
     value:"kcx"
  },
  {
     label:"Korandje",
     value:"kcy"
  },
  {
     label:"Konongo",
     value:"kcz"
  },
  {
     label:"Kutu",
     value:"kdc"
  },
  {
     label:"Yankunytjatjara",
     value:"kdd"
  },
  {
     label:"Makonde",
     value:"kde"
  },
  {
     label:"Mamusi",
     value:"kdf"
  },
  {
     label:"Seba",
     value:"kdg"
  },
  {
     label:"Tem",
     value:"kdh"
  },
  {
     label:"Kumam",
     value:"kdi"
  },
  {
     label:"Karamojong",
     value:"kdj"
  },
  {
     label:"Num\u00e8\u00e8",
     value:"kdk"
  },
  {
     label:"Tsikimba",
     value:"kdl"
  },
  {
     label:"Kagoma",
     value:"kdm"
  },
  {
     label:"Kunda",
     value:"kdn"
  },
  {
     label:"Kaningdon-Nindem",
     value:"kdp"
  },
  {
     label:"Koch",
     value:"kdq"
  },
  {
     label:"Karaim",
     value:"kdr"
  },
  {
     label:"Kuy",
     value:"kdt"
  },
  {
     label:"Kadaru",
     value:"kdu"
  },
  {
     label:"Koneraw",
     value:"kdw"
  },
  {
     label:"Kam",
     value:"kdx"
  },
  {
     label:"Keder",
     value:"kdy"
  },
  {
     label:"Kwaja",
     value:"kdz"
  },
  {
     label:"Kabuverdianu",
     value:"kea"
  },
  {
     label:"K\u00e9l\u00e9",
     value:"keb"
  },
  {
     label:"Keiga",
     value:"kec"
  },
  {
     label:"Kerewe",
     value:"ked"
  },
  {
     label:"Eastern Keres",
     value:"kee"
  },
  {
     label:"Kpessi",
     value:"kef"
  },
  {
     label:"Tese",
     value:"keg"
  },
  {
     label:"Keak",
     value:"keh"
  },
  {
     label:"Kei",
     value:"kei"
  },
  {
     label:"Kadar",
     value:"kej"
  },
  {
     label:"Kekch\u00ed",
     value:"kek"
  },
  {
     label:"Kela (Democratic Republic of Congo)",
     value:"kel"
  },
  {
     label:"Kemak",
     value:"kem"
  },
  {
     label:"Kenyang",
     value:"ken"
  },
  {
     label:"Kakwa",
     value:"keo"
  },
  {
     label:"Kaikadi",
     value:"kep"
  },
  {
     label:"Kamar",
     value:"keq"
  },
  {
     label:"Kera",
     value:"ker"
  },
  {
     label:"Kugbo",
     value:"kes"
  },
  {
     label:"Ket",
     value:"ket"
  },
  {
     label:"Akebu",
     value:"keu"
  },
  {
     label:"Kanikkaran",
     value:"kev"
  },
  {
     label:"West Kewa",
     value:"kew"
  },
  {
     label:"Kukna",
     value:"kex"
  },
  {
     label:"Kupia",
     value:"key"
  },
  {
     label:"Kukele",
     value:"kez"
  },
  {
     label:"Kodava",
     value:"kfa"
  },
  {
     label:"Northwestern Kolami",
     value:"kfb"
  },
  {
     label:"Konda-Dora",
     value:"kfc"
  },
  {
     label:"Korra Koraga",
     value:"kfd"
  },
  {
     label:"Kota (India)",
     value:"kfe"
  },
  {
     label:"Koya",
     value:"kff"
  },
  {
     label:"Kudiya",
     value:"kfg"
  },
  {
     label:"Kurichiya",
     value:"kfh"
  },
  {
     label:"Kannada Kurumba",
     value:"kfi"
  },
  {
     label:"Kemiehua",
     value:"kfj"
  },
  {
     label:"Kinnauri",
     value:"kfk"
  },
  {
     label:"Kung",
     value:"kfl"
  },
  {
     label:"Khunsari",
     value:"kfm"
  },
  {
     label:"Kuk",
     value:"kfn"
  },
  {
     label:"Koro (C\u00f4te d'Ivoire)",
     value:"kfo"
  },
  {
     label:"Korwa",
     value:"kfp"
  },
  {
     label:"Korku",
     value:"kfq"
  },
  {
     label:"Kachhi",
     value:"kfr"
  },
  {
     label:"Bilaspuri",
     value:"kfs"
  },
  {
     label:"Kanjari",
     value:"kft"
  },
  {
     label:"Katkari",
     value:"kfu"
  },
  {
     label:"Kurmukar",
     value:"kfv"
  },
  {
     label:"Kharam Naga",
     value:"kfw"
  },
  {
     label:"Kullu Pahari",
     value:"kfx"
  },
  {
     label:"Kumaoni",
     value:"kfy"
  },
  {
     label:"Koromf\u00e9",
     value:"kfz"
  },
  {
     label:"Koyaga",
     value:"kga"
  },
  {
     label:"Kawe",
     value:"kgb"
  },
  {
     label:"Komering",
     value:"kge"
  },
  {
     label:"Kube",
     value:"kgf"
  },
  {
     label:"Kusunda",
     value:"kgg"
  },
  {
     label:"Gamale Kham",
     value:"kgj"
  },
  {
     label:"Kaiw\u00e1",
     value:"kgk"
  },
  {
     label:"Karingani",
     value:"kgn"
  },
  {
     label:"Krongo",
     value:"kgo"
  },
  {
     label:"Kaingang",
     value:"kgp"
  },
  {
     label:"Kamoro",
     value:"kgq"
  },
  {
     label:"Abun",
     value:"kgr"
  },
  {
     label:"Kumbainggar",
     value:"kgs"
  },
  {
     label:"Somyev",
     value:"kgt"
  },
  {
     label:"Kobol",
     value:"kgu"
  },
  {
     label:"Karas",
     value:"kgv"
  },
  {
     label:"Karon Dori",
     value:"kgw"
  },
  {
     label:"Kamaru",
     value:"kgx"
  },
  {
     label:"Kyerung",
     value:"kgy"
  },
  {
     label:"Khasi",
     value:"kha",
     "iso6392B":"kha",
     "iso6392T":"kha"
  },
  {
     label:"L\u00fc",
     value:"khb"
  },
  {
     label:"Tukang Besi North",
     value:"khc"
  },
  {
     label:"B\u00e4di Kanum",
     value:"khd"
  },
  {
     label:"Korowai",
     value:"khe"
  },
  {
     label:"Khuen",
     value:"khf"
  },
  {
     label:"Khams Tibetan",
     value:"khg"
  },
  {
     label:"Kehu",
     value:"khh"
  },
  {
     label:"Kuturmi",
     value:"khj"
  },
  {
     label:"Halh Mongolian",
     value:"khk"
  },
  {
     label:"Lusi",
     value:"khl"
  },
  {
     label:"Khmer",
     value:"khm",
     "iso6392B":"khm",
     "iso6392T":"khm",
     "iso6391":"km"
  },
  {
     label:"Khandesi",
     value:"khn"
  },
  {
     label:"Kapori",
     value:"khp"
  },
  {
     label:"Koyra Chiini Songhay",
     value:"khq"
  },
  {
     label:"Kharia",
     value:"khr"
  },
  {
     label:"Kasua",
     value:"khs"
  },
  {
     label:"Khamti",
     value:"kht"
  },
  {
     label:"Nkhumbi",
     value:"khu"
  },
  {
     label:"Khvarshi",
     value:"khv"
  },
  {
     label:"Khowar",
     value:"khw"
  },
  {
     label:"Kanu",
     value:"khx"
  },
  {
     label:"Kele (Democratic Republic of Congo)",
     value:"khy"
  },
  {
     label:"Keapara",
     value:"khz"
  },
  {
     label:"Kim",
     value:"kia"
  },
  {
     label:"Koalib",
     value:"kib"
  },
  {
     label:"Kickapoo",
     value:"kic"
  },
  {
     label:"Koshin",
     value:"kid"
  },
  {
     label:"Kibet",
     value:"kie"
  },
  {
     label:"Eastern Parbate Kham",
     value:"kif"
  },
  {
     label:"Kimaama",
     value:"kig"
  },
  {
     label:"Kilmeri",
     value:"kih"
  },
  {
     label:"Kilivila",
     value:"kij"
  },
  {
     label:"Kikuyu",
     value:"kik",
     "iso6392B":"kik",
     "iso6392T":"kik",
     "iso6391":"ki"
  },
  {
     label:"Kariya",
     value:"kil"
  },
  {
     label:"Karagas",
     value:"kim"
  },
  {
     label:"Kinyarwanda",
     value:"kin",
     "iso6392B":"kin",
     "iso6392T":"kin",
     "iso6391":"rw"
  },
  {
     label:"Kiowa",
     value:"kio"
  },
  {
     label:"Sheshi Kham",
     value:"kip"
  },
  {
     label:"Kosadle",
     value:"kiq"
  },
  {
     label:"Kirghiz",
     value:"kir",
     "iso6392B":"kir",
     "iso6392T":"kir",
     "iso6391":"ky"
  },
  {
     label:"Kis",
     value:"kis"
  },
  {
     label:"Agob",
     value:"kit"
  },
  {
     label:"Kirmanjki (individual language)",
     value:"kiu"
  },
  {
     label:"Kimbu",
     value:"kiv"
  },
  {
     label:"Northeast Kiwai",
     value:"kiw"
  },
  {
     label:"Khiamniungan Naga",
     value:"kix"
  },
  {
     label:"Kirikiri",
     value:"kiy"
  },
  {
     label:"Kisi",
     value:"kiz"
  },
  {
     label:"Mlap",
     value:"kja"
  },
  {
     label:"Q'anjob'al",
     value:"kjb"
  },
  {
     label:"Coastal Konjo",
     value:"kjc"
  },
  {
     label:"Southern Kiwai",
     value:"kjd"
  },
  {
     label:"Kisar",
     value:"kje"
  },
  {
     label:"Khmu",
     value:"kjg"
  },
  {
     label:"Khakas",
     value:"kjh"
  },
  {
     label:"Zabana",
     value:"kji"
  },
  {
     label:"Khinalugh",
     value:"kjj"
  },
  {
     label:"Highland Konjo",
     value:"kjk"
  },
  {
     label:"Western Parbate Kham",
     value:"kjl"
  },
  {
     label:"Kh\u00e1ng",
     value:"kjm"
  },
  {
     label:"Kunjen",
     value:"kjn"
  },
  {
     label:"Harijan Kinnauri",
     value:"kjo"
  },
  {
     label:"Pwo Eastern Karen",
     value:"kjp"
  },
  {
     label:"Western Keres",
     value:"kjq"
  },
  {
     label:"Kurudu",
     value:"kjr"
  },
  {
     label:"East Kewa",
     value:"kjs"
  },
  {
     label:"Phrae Pwo Karen",
     value:"kjt"
  },
  {
     label:"Kashaya",
     value:"kju"
  },
  {
     label:"Ramopa",
     value:"kjx"
  },
  {
     label:"Erave",
     value:"kjy"
  },
  {
     label:"Bumthangkha",
     value:"kjz"
  },
  {
     label:"Kakanda",
     value:"kka"
  },
  {
     label:"Kwerisa",
     value:"kkb"
  },
  {
     label:"Odoodee",
     value:"kkc"
  },
  {
     label:"Kinuku",
     value:"kkd"
  },
  {
     label:"Kakabe",
     value:"kke"
  },
  {
     label:"Kalaktang Monpa",
     value:"kkf"
  },
  {
     label:"Mabaka Valley Kalinga",
     value:"kkg"
  },
  {
     label:"Kh\u00fcn",
     value:"kkh"
  },
  {
     label:"Kagulu",
     value:"kki"
  },
  {
     label:"Kako",
     value:"kkj"
  },
  {
     label:"Kokota",
     value:"kkk"
  },
  {
     label:"Kosarek Yale",
     value:"kkl"
  },
  {
     label:"Kiong",
     value:"kkm"
  },
  {
     label:"Kon Keu",
     value:"kkn"
  },
  {
     label:"Karko",
     value:"kko"
  },
  {
     label:"Gugubera",
     value:"kkp"
  },
  {
     label:"Kaeku",
     value:"kkq"
  },
  {
     label:"Kir-Balar",
     value:"kkr"
  },
  {
     label:"Giiwo",
     value:"kks"
  },
  {
     label:"Koi",
     value:"kkt"
  },
  {
     label:"Tumi",
     value:"kku"
  },
  {
     label:"Kangean",
     value:"kkv"
  },
  {
     label:"Teke-Kukuya",
     value:"kkw"
  },
  {
     label:"Kohin",
     value:"kkx"
  },
  {
     label:"Guugu Yimidhirr",
     value:"kky"
  },
  {
     label:"Kaska",
     value:"kkz"
  },
  {
     label:"Kiliwa",
     value:"klb"
  },
  {
     label:"Kolbila",
     value:"klc"
  },
  {
     label:"Gamilaraay",
     value:"kld"
  },
  {
     label:"Kulung (Nepal)",
     value:"kle"
  },
  {
     label:"Kendeje",
     value:"klf"
  },
  {
     label:"Tagakaulo",
     value:"klg"
  },
  {
     label:"Weliki",
     value:"klh"
  },
  {
     label:"Kalumpang",
     value:"kli"
  },
  {
     label:"Khalaj",
     value:"klj"
  },
  {
     label:"Kono (Nigeria)",
     value:"klk"
  },
  {
     label:"Kagan Kalagan",
     value:"kll"
  },
  {
     label:"Migum",
     value:"klm"
  },
  {
     label:"Kalenjin",
     value:"kln"
  },
  {
     label:"Kapya",
     value:"klo"
  },
  {
     label:"Kamasa",
     value:"klp"
  },
  {
     label:"Rumu",
     value:"klq"
  },
  {
     label:"Khaling",
     value:"klr"
  },
  {
     label:"Kalasha",
     value:"kls"
  },
  {
     label:"Nukna",
     value:"klt"
  },
  {
     label:"Klao",
     value:"klu"
  },
  {
     label:"Maskelynes",
     value:"klv"
  },
  {
     label:"Tado",
     value:"klw"
  },
  {
     label:"Koluwawa",
     value:"klx"
  },
  {
     label:"Kalao",
     value:"kly"
  },
  {
     label:"Kabola",
     value:"klz"
  },
  {
     label:"Konni",
     value:"kma"
  },
  {
     label:"Kimbundu",
     value:"kmb",
     "iso6392B":"kmb",
     "iso6392T":"kmb"
  },
  {
     label:"Southern Dong",
     value:"kmc"
  },
  {
     label:"Majukayang Kalinga",
     value:"kmd"
  },
  {
     label:"Bakole",
     value:"kme"
  },
  {
     label:"Kare (Papua New Guinea)",
     value:"kmf"
  },
  {
     label:"K\u00e2te",
     value:"kmg"
  },
  {
     label:"Kalam",
     value:"kmh"
  },
  {
     label:"Kami (Nigeria)",
     value:"kmi"
  },
  {
     label:"Kumarbhag Paharia",
     value:"kmj"
  },
  {
     label:"Limos Kalinga",
     value:"kmk"
  },
  {
     label:"Tanudan Kalinga",
     value:"kml"
  },
  {
     label:"Kom (India)",
     value:"kmm"
  },
  {
     label:"Awtuw",
     value:"kmn"
  },
  {
     label:"Kwoma",
     value:"kmo"
  },
  {
     label:"Gimme",
     value:"kmp"
  },
  {
     label:"Kwama",
     value:"kmq"
  },
  {
     label:"Northern Kurdish",
     value:"kmr"
  },
  {
     label:"Kamasau",
     value:"kms"
  },
  {
     label:"Kemtuik",
     value:"kmt"
  },
  {
     label:"Kanite",
     value:"kmu"
  },
  {
     label:"Karip\u00fana Creole French",
     value:"kmv"
  },
  {
     label:"Komo (Democratic Republic of Congo)",
     value:"kmw"
  },
  {
     label:"Waboda",
     value:"kmx"
  },
  {
     label:"Koma",
     value:"kmy"
  },
  {
     label:"Khorasani Turkish",
     value:"kmz"
  },
  {
     label:"Dera (Nigeria)",
     value:"kna"
  },
  {
     label:"Lubuagan Kalinga",
     value:"knb"
  },
  {
     label:"Central Kanuri",
     value:"knc"
  },
  {
     label:"Konda",
     value:"knd"
  },
  {
     label:"Kankanaey",
     value:"kne"
  },
  {
     label:"Mankanya",
     value:"knf"
  },
  {
     label:"Koongo",
     value:"kng"
  },
  {
     label:"Kanufi",
     value:"kni"
  },
  {
     label:"Western Kanjobal",
     value:"knj"
  },
  {
     label:"Kuranko",
     value:"knk"
  },
  {
     label:"Keninjal",
     value:"knl"
  },
  {
     label:"Kanamar\u00ed",
     value:"knm"
  },
  {
     label:"Konkani (individual language)",
     value:"knn"
  },
  {
     label:"Kono (Sierra Leone)",
     value:"kno"
  },
  {
     label:"Kwanja",
     value:"knp"
  },
  {
     label:"Kintaq",
     value:"knq"
  },
  {
     label:"Kaningra",
     value:"knr"
  },
  {
     label:"Kensiu",
     value:"kns"
  },
  {
     label:"Panoan Katuk\u00edna",
     value:"knt"
  },
  {
     label:"Kono (Guinea)",
     value:"knu"
  },
  {
     label:"Tabo",
     value:"knv"
  },
  {
     label:"Kung-Ekoka",
     value:"knw"
  },
  {
     label:"Kendayan",
     value:"knx"
  },
  {
     label:"Kanyok",
     value:"kny"
  },
  {
     label:"Kalams\u00e9",
     value:"knz"
  },
  {
     label:"Konomala",
     value:"koa"
  },
  {
     label:"Kodi",
     value:"kod"
  },
  {
     label:"Kacipo-Balesi",
     value:"koe"
  },
  {
     label:"Cogui",
     value:"kog"
  },
  {
     label:"Koyo",
     value:"koh"
  },
  {
     label:"Komi-Permyak",
     value:"koi"
  },
  {
     label:"Konkani (macrolanguage)",
     value:"kok",
     "iso6392B":"kok",
     "iso6392T":"kok"
  },
  {
     label:"Kol (Papua New Guinea)",
     value:"kol"
  },
  {
     label:"Komi",
     value:"kom",
     "iso6392B":"kom",
     "iso6392T":"kom",
     "iso6391":"kv"
  },
  {
     label:"Kongo",
     value:"kon",
     "iso6392B":"kon",
     "iso6392T":"kon",
     "iso6391":"kg"
  },
  {
     label:"Konzo",
     value:"koo"
  },
  {
     label:"Waube",
     value:"kop"
  },
  {
     label:"Kota (Gabon)",
     value:"koq"
  },
  {
     label:"Korean",
     value:"kor",
     "iso6392B":"kor",
     "iso6392T":"kor",
     "iso6391":"ko"
  },
  {
     label:"Kosraean",
     value:"kos",
     "iso6392B":"kos",
     "iso6392T":"kos"
  },
  {
     label:"Lagwan",
     value:"kot"
  },
  {
     label:"Koke",
     value:"kou"
  },
  {
     label:"Kudu-Camo",
     value:"kov"
  },
  {
     label:"Kugama",
     value:"kow"
  },
  {
     label:"Koyukon",
     value:"koy"
  },
  {
     label:"Korak",
     value:"koz"
  },
  {
     label:"Kutto",
     value:"kpa"
  },
  {
     label:"Mullu Kurumba",
     value:"kpb"
  },
  {
     label:"Curripaco",
     value:"kpc"
  },
  {
     label:"Koba",
     value:"kpd"
  },
  {
     label:"Kpelle",
     value:"kpe",
     "iso6392B":"kpe",
     "iso6392T":"kpe"
  },
  {
     label:"Komba",
     value:"kpf"
  },
  {
     label:"Kapingamarangi",
     value:"kpg"
  },
  {
     label:"Kplang",
     value:"kph"
  },
  {
     label:"Kofei",
     value:"kpi"
  },
  {
     label:"Karaj\u00e1",
     value:"kpj"
  },
  {
     label:"Kpan",
     value:"kpk"
  },
  {
     label:"Kpala",
     value:"kpl"
  },
  {
     label:"Koho",
     value:"kpm"
  },
  {
     label:"Ikposo",
     value:"kpo"
  },
  {
     label:"Korupun-Sela",
     value:"kpq"
  },
  {
     label:"Korafe-Yegha",
     value:"kpr"
  },
  {
     label:"Tehit",
     value:"kps"
  },
  {
     label:"Karata",
     value:"kpt"
  },
  {
     label:"Kafoa",
     value:"kpu"
  },
  {
     label:"Komi-Zyrian",
     value:"kpv"
  },
  {
     label:"Kobon",
     value:"kpw"
  },
  {
     label:"Mountain Koiali",
     value:"kpx"
  },
  {
     label:"Koryak",
     value:"kpy"
  },
  {
     label:"Kupsabiny",
     value:"kpz"
  },
  {
     label:"Mum",
     value:"kqa"
  },
  {
     label:"Kovai",
     value:"kqb"
  },
  {
     label:"Doromu-Koki",
     value:"kqc"
  },
  {
     label:"Koy Sanjaq Surat",
     value:"kqd"
  },
  {
     label:"Kalagan",
     value:"kqe"
  },
  {
     label:"Kakabai",
     value:"kqf"
  },
  {
     label:"Khe",
     value:"kqg"
  },
  {
     label:"Kisankasa",
     value:"kqh"
  },
  {
     label:"Koitabu",
     value:"kqi"
  },
  {
     label:"Koromira",
     value:"kqj"
  },
  {
     label:"Kotafon Gbe",
     value:"kqk"
  },
  {
     label:"Kyenele",
     value:"kql"
  },
  {
     label:"Khisa",
     value:"kqm"
  },
  {
     label:"Kaonde",
     value:"kqn"
  },
  {
     label:"Eastern Krahn",
     value:"kqo"
  },
  {
     label:"Kimr\u00e9",
     value:"kqp"
  },
  {
     label:"Krenak",
     value:"kqq"
  },
  {
     label:"Kimaragang",
     value:"kqr"
  },
  {
     label:"Northern Kissi",
     value:"kqs"
  },
  {
     label:"Klias River Kadazan",
     value:"kqt"
  },
  {
     label:"Okolod",
     value:"kqv"
  },
  {
     label:"Kandas",
     value:"kqw"
  },
  {
     label:"Mser",
     value:"kqx"
  },
  {
     label:"Koorete",
     value:"kqy"
  },
  {
     label:"Kumhali",
     value:"kra"
  },
  {
     label:"Karachay-Balkar",
     value:"krc",
     "iso6392B":"krc",
     "iso6392T":"krc"
  },
  {
     label:"Kairui-Midiki",
     value:"krd"
  },
  {
     label:"Panar\u00e1",
     value:"kre"
  },
  {
     label:"Koro (Vanuatu)",
     value:"krf"
  },
  {
     label:"Kurama",
     value:"krh"
  },
  {
     label:"Krio",
     value:"kri"
  },
  {
     label:"Kinaray-A",
     value:"krj"
  },
  {
     label:"Karelian",
     value:"krl",
     "iso6392B":"krl",
     "iso6392T":"krl"
  },
  {
     label:"Sapo",
     value:"krn"
  },
  {
     label:"Korop",
     value:"krp"
  },
  {
     label:"Krung",
     value:"krr"
  },
  {
     label:"Gbaya (Sudan)",
     value:"krs"
  },
  {
     label:"Tumari Kanuri",
     value:"krt"
  },
  {
     label:"Kurukh",
     value:"kru",
     "iso6392B":"kru",
     "iso6392T":"kru"
  },
  {
     label:"Kavet",
     value:"krv"
  },
  {
     label:"Western Krahn",
     value:"krw"
  },
  {
     label:"Karon",
     value:"krx"
  },
  {
     label:"Kryts",
     value:"kry"
  },
  {
     label:"Sota Kanum",
     value:"krz"
  },
  {
     label:"Shuwa-Zamani",
     value:"ksa"
  },
  {
     label:"Shambala",
     value:"ksb"
  },
  {
     label:"Southern Kalinga",
     value:"ksc"
  },
  {
     label:"Kuanua",
     value:"ksd"
  },
  {
     label:"Kuni",
     value:"kse"
  },
  {
     label:"Bafia",
     value:"ksf"
  },
  {
     label:"Kusaghe",
     value:"ksg"
  },
  {
     label:"K\u00f6lsch",
     value:"ksh"
  },
  {
     label:"Krisa",
     value:"ksi"
  },
  {
     label:"Uare",
     value:"ksj"
  },
  {
     label:"Kansa",
     value:"ksk"
  },
  {
     label:"Kumalu",
     value:"ksl"
  },
  {
     label:"Kumba",
     value:"ksm"
  },
  {
     label:"Kasiguranin",
     value:"ksn"
  },
  {
     label:"Kofa",
     value:"kso"
  },
  {
     label:"Kaba",
     value:"ksp"
  },
  {
     label:"Kwaami",
     value:"ksq"
  },
  {
     label:"Borong",
     value:"ksr"
  },
  {
     label:"Southern Kisi",
     value:"kss"
  },
  {
     label:"Winy\u00e9",
     value:"kst"
  },
  {
     label:"Khamyang",
     value:"ksu"
  },
  {
     label:"Kusu",
     value:"ksv"
  },
  {
     label:"S'gaw Karen",
     value:"ksw"
  },
  {
     label:"Kedang",
     value:"ksx"
  },
  {
     label:"Kharia Thar",
     value:"ksy"
  },
  {
     label:"Kodaku",
     value:"ksz"
  },
  {
     label:"Katua",
     value:"kta"
  },
  {
     label:"Kambaata",
     value:"ktb"
  },
  {
     label:"Kholok",
     value:"ktc"
  },
  {
     label:"Kokata",
     value:"ktd"
  },
  {
     label:"Nubri",
     value:"kte"
  },
  {
     label:"Kwami",
     value:"ktf"
  },
  {
     label:"Karanga",
     value:"kth"
  },
  {
     label:"North Muyu",
     value:"kti"
  },
  {
     label:"Plapo Krumen",
     value:"ktj"
  },
  {
     label:"Koroshi",
     value:"ktl"
  },
  {
     label:"Kurti",
     value:"ktm"
  },
  {
     label:"Kariti\u00e2na",
     value:"ktn"
  },
  {
     label:"Kuot",
     value:"kto"
  },
  {
     label:"Kaduo",
     value:"ktp"
  },
  {
     label:"South Muyu",
     value:"kts"
  },
  {
     label:"Ketum",
     value:"ktt"
  },
  {
     label:"Kituba (Democratic Republic of Congo)",
     value:"ktu"
  },
  {
     label:"Eastern Katu",
     value:"ktv"
  },
  {
     label:"Kaxarar\u00ed",
     value:"ktx"
  },
  {
     label:"Kango (Bas-U\u00e9l\u00e9 District)",
     value:"kty"
  },
  {
     label:"Ju\u01c0\u02bchoan",
     value:"ktz"
  },
  {
     label:"Kuanyama",
     value:"kua",
     "iso6392B":"kua",
     "iso6392T":"kua",
     "iso6391":"kj"
  },
  {
     label:"Kutep",
     value:"kub"
  },
  {
     label:"Kwinsu",
     value:"kuc"
  },
  {
     label:"'Auhelawa",
     value:"kud"
  },
  {
     label:"Kuman (Papua New Guinea)",
     value:"kue"
  },
  {
     label:"Western Katu",
     value:"kuf"
  },
  {
     label:"Kupa",
     value:"kug"
  },
  {
     label:"Kushi",
     value:"kuh"
  },
  {
     label:"Kuik\u00faro-Kalap\u00e1lo",
     value:"kui"
  },
  {
     label:"Kuria",
     value:"kuj"
  },
  {
     label:"Kepo'",
     value:"kuk"
  },
  {
     label:"Kulere",
     value:"kul"
  },
  {
     label:"Kumyk",
     value:"kum",
     "iso6392B":"kum",
     "iso6392T":"kum"
  },
  {
     label:"Kunama",
     value:"kun"
  },
  {
     label:"Kumukio",
     value:"kuo"
  },
  {
     label:"Kunimaipa",
     value:"kup"
  },
  {
     label:"Karipuna",
     value:"kuq"
  },
  {
     label:"Kurdish",
     value:"kur",
     "iso6392B":"kur",
     "iso6392T":"kur",
     "iso6391":"ku"
  },
  {
     label:"Kusaal",
     value:"kus"
  },
  {
     label:"Kutenai",
     value:"kut",
     "iso6392B":"kut",
     "iso6392T":"kut"
  },
  {
     label:"Upper Kuskokwim",
     value:"kuu"
  },
  {
     label:"Kur",
     value:"kuv"
  },
  {
     label:"Kpagua",
     value:"kuw"
  },
  {
     label:"Kukatja",
     value:"kux"
  },
  {
     label:"Kuuku-Ya'u",
     value:"kuy"
  },
  {
     label:"Bagvalal",
     value:"kva"
  },
  {
     label:"Kubu",
     value:"kvb"
  },
  {
     label:"Kove",
     value:"kvc"
  },
  {
     label:"Kui (Indonesia)",
     value:"kvd"
  },
  {
     label:"Kalabakan",
     value:"kve"
  },
  {
     label:"Kabalai",
     value:"kvf"
  },
  {
     label:"Kuni-Boazi",
     value:"kvg"
  },
  {
     label:"Komodo",
     value:"kvh"
  },
  {
     label:"Kwang",
     value:"kvi"
  },
  {
     label:"Psikye",
     value:"kvj"
  },
  {
     label:"Kayaw",
     value:"kvl"
  },
  {
     label:"Kendem",
     value:"kvm"
  },
  {
     label:"Border Kuna",
     value:"kvn"
  },
  {
     label:"Dobel",
     value:"kvo"
  },
  {
     label:"Kompane",
     value:"kvp"
  },
  {
     label:"Geba Karen",
     value:"kvq"
  },
  {
     label:"Kerinci",
     value:"kvr"
  },
  {
     label:"Lahta Karen",
     value:"kvt"
  },
  {
     label:"Yinbaw Karen",
     value:"kvu"
  },
  {
     label:"Kola",
     value:"kvv"
  },
  {
     label:"Wersing",
     value:"kvw"
  },
  {
     label:"Parkari Koli",
     value:"kvx"
  },
  {
     label:"Yintale Karen",
     value:"kvy"
  },
  {
     label:"Tsakwambo",
     value:"kvz"
  },
  {
     label:"D\u00e2w",
     value:"kwa"
  },
  {
     label:"Kwa",
     value:"kwb"
  },
  {
     label:"Likwala",
     value:"kwc"
  },
  {
     label:"Kwaio",
     value:"kwd"
  },
  {
     label:"Kwerba",
     value:"kwe"
  },
  {
     label:"Kwara'ae",
     value:"kwf"
  },
  {
     label:"Sara Kaba Deme",
     value:"kwg"
  },
  {
     label:"Kowiai",
     value:"kwh"
  },
  {
     label:"Awa-Cuaiquer",
     value:"kwi"
  },
  {
     label:"Kwanga",
     value:"kwj"
  },
  {
     label:"Kwakiutl",
     value:"kwk"
  },
  {
     label:"Kofyar",
     value:"kwl"
  },
  {
     label:"Kwambi",
     value:"kwm"
  },
  {
     label:"Kwangali",
     value:"kwn"
  },
  {
     label:"Kwomtari",
     value:"kwo"
  },
  {
     label:"Kodia",
     value:"kwp"
  },
  {
     label:"Kwer",
     value:"kwr"
  },
  {
     label:"Kwese",
     value:"kws"
  },
  {
     label:"Kwesten",
     value:"kwt"
  },
  {
     label:"Kwakum",
     value:"kwu"
  },
  {
     label:"Sara Kaba N\u00e1\u00e0",
     value:"kwv"
  },
  {
     label:"Kwinti",
     value:"kww"
  },
  {
     label:"Khirwar",
     value:"kwx"
  },
  {
     label:"San Salvador Kongo",
     value:"kwy"
  },
  {
     label:"Kairiru",
     value:"kxa"
  },
  {
     label:"Krobu",
     value:"kxb"
  },
  {
     label:"Konso",
     value:"kxc"
  },
  {
     label:"Brunei",
     value:"kxd"
  },
  {
     label:"Manumanaw Karen",
     value:"kxf"
  },
  {
     label:"Karo (Ethiopia)",
     value:"kxh"
  },
  {
     label:"Keningau Murut",
     value:"kxi"
  },
  {
     label:"Kulfa",
     value:"kxj"
  },
  {
     label:"Zayein Karen",
     value:"kxk"
  },
  {
     label:"Northern Khmer",
     value:"kxm"
  },
  {
     label:"Kanowit-Tanjong Melanau",
     value:"kxn"
  },
  {
     label:"Wadiyara Koli",
     value:"kxp"
  },
  {
     label:"Sm\u00e4rky Kanum",
     value:"kxq"
  },
  {
     label:"Koro (Papua New Guinea)",
     value:"kxr"
  },
  {
     label:"Kangjia",
     value:"kxs"
  },
  {
     label:"Koiwat",
     value:"kxt"
  },
  {
     label:"Kuvi",
     value:"kxv"
  },
  {
     label:"Konai",
     value:"kxw"
  },
  {
     label:"Likuba",
     value:"kxx"
  },
  {
     label:"Kayong",
     value:"kxy"
  },
  {
     label:"Kerewo",
     value:"kxz"
  },
  {
     label:"Kwaya",
     value:"kya"
  },
  {
     label:"Butbut Kalinga",
     value:"kyb"
  },
  {
     label:"Kyaka",
     value:"kyc"
  },
  {
     label:"Karey",
     value:"kyd"
  },
  {
     label:"Krache",
     value:"kye"
  },
  {
     label:"Kouya",
     value:"kyf"
  },
  {
     label:"Keyagana",
     value:"kyg"
  },
  {
     label:"Karok",
     value:"kyh"
  },
  {
     label:"Kiput",
     value:"kyi"
  },
  {
     label:"Karao",
     value:"kyj"
  },
  {
     label:"Kamayo",
     value:"kyk"
  },
  {
     label:"Kalapuya",
     value:"kyl"
  },
  {
     label:"Kpatili",
     value:"kym"
  },
  {
     label:"Northern Binukidnon",
     value:"kyn"
  },
  {
     label:"Kelon",
     value:"kyo"
  },
  {
     label:"Kang",
     value:"kyp"
  },
  {
     label:"Kenga",
     value:"kyq"
  },
  {
     label:"Kuru\u00e1ya",
     value:"kyr"
  },
  {
     label:"Baram Kayan",
     value:"kys"
  },
  {
     label:"Kayagar",
     value:"kyt"
  },
  {
     label:"Western Kayah",
     value:"kyu"
  },
  {
     label:"Kayort",
     value:"kyv"
  },
  {
     label:"Kudmali",
     value:"kyw"
  },
  {
     label:"Rapoisi",
     value:"kyx"
  },
  {
     label:"Kambaira",
     value:"kyy"
  },
  {
     label:"Kayab\u00ed",
     value:"kyz"
  },
  {
     label:"Western Karaboro",
     value:"kza"
  },
  {
     label:"Kaibobo",
     value:"kzb"
  },
  {
     label:"Bondoukou Kulango",
     value:"kzc"
  },
  {
     label:"Kadai",
     value:"kzd"
  },
  {
     label:"Kosena",
     value:"kze"
  },
  {
     label:"Da'a Kaili",
     value:"kzf"
  },
  {
     label:"Kikai",
     value:"kzg"
  },
  {
     label:"Kelabit",
     value:"kzi"
  },
  {
     label:"Kayeli",
     value:"kzl"
  },
  {
     label:"Kais",
     value:"kzm"
  },
  {
     label:"Kokola",
     value:"kzn"
  },
  {
     label:"Kaningi",
     value:"kzo"
  },
  {
     label:"Kaidipang",
     value:"kzp"
  },
  {
     label:"Kaike",
     value:"kzq"
  },
  {
     label:"Karang",
     value:"kzr"
  },
  {
     label:"Sugut Dusun",
     value:"kzs"
  },
  {
     label:"Kayupulau",
     value:"kzu"
  },
  {
     label:"Komyandaret",
     value:"kzv"
  },
  {
     label:"Kango (Tshopo District)",
     value:"kzy"
  },
  {
     label:"Kalabra",
     value:"kzz"
  },
  {
     label:"Southern Subanen",
     value:"laa"
  },
  {
     label:"Lacandon",
     value:"lac"
  },
  {
     label:"Ladino",
     value:"lad",
     "iso6392B":"lad",
     "iso6392T":"lad"
  },
  {
     label:"Pattani",
     value:"lae"
  },
  {
     label:"Lafofa",
     value:"laf"
  },
  {
     label:"Langi",
     value:"lag"
  },
  {
     label:"Lahnda",
     value:"lah",
     "iso6392B":"lah",
     "iso6392T":"lah"
  },
  {
     label:"Lambya",
     value:"lai"
  },
  {
     label:"Lango (Uganda)",
     value:"laj"
  },
  {
     label:"Laka (Nigeria)",
     value:"lak"
  },
  {
     label:"Lalia",
     value:"lal"
  },
  {
     label:"Lamba",
     value:"lam",
     "iso6392B":"lam",
     "iso6392T":"lam"
  },
  {
     label:"Laru",
     value:"lan"
  },
  {
     label:"Lao",
     value:"lao",
     "iso6392B":"lao",
     "iso6392T":"lao",
     "iso6391":"lo"
  },
  {
     label:"Laka (Chad)",
     value:"lap"
  },
  {
     label:"Qabiao",
     value:"laq"
  },
  {
     label:"Larteh",
     value:"lar"
  },
  {
     label:"Lama (Togo)",
     value:"las"
  },
  {
     label:"Laba",
     value:"lau"
  },
  {
     label:"Latvian",
     value:"lav",
     "iso6392B":"lav",
     "iso6392T":"lav",
     "iso6391":"lv"
  },
  {
     label:"Lauje",
     value:"law"
  },
  {
     label:"Tiwa",
     value:"lax"
  },
  {
     label:"Lama Bai",
     value:"lay"
  },
  {
     label:"Label",
     value:"lbb"
  },
  {
     label:"Lakkia",
     value:"lbc"
  },
  {
     label:"Lak",
     value:"lbe"
  },
  {
     label:"Tinani",
     value:"lbf"
  },
  {
     label:"Laopang",
     value:"lbg"
  },
  {
     label:"La'bi",
     value:"lbi"
  },
  {
     label:"Ladakhi",
     value:"lbj"
  },
  {
     label:"Central Bontok",
     value:"lbk"
  },
  {
     label:"Libon Bikol",
     value:"lbl"
  },
  {
     label:"Lodhi",
     value:"lbm"
  },
  {
     label:"Rmeet",
     value:"lbn"
  },
  {
     label:"Laven",
     value:"lbo"
  },
  {
     label:"Wampar",
     value:"lbq"
  },
  {
     label:"Lohorung",
     value:"lbr"
  },
  {
     label:"Lachi",
     value:"lbt"
  },
  {
     label:"Labu",
     value:"lbu"
  },
  {
     label:"Lavatbura-Lamusong",
     value:"lbv"
  },
  {
     label:"Tolaki",
     value:"lbw"
  },
  {
     label:"Lawangan",
     value:"lbx"
  },
  {
     label:"Lardil",
     value:"lbz"
  },
  {
     label:"Legenyem",
     value:"lcc"
  },
  {
     label:"Lola",
     value:"lcd"
  },
  {
     label:"Loncong",
     value:"lce"
  },
  {
     label:"Lubu",
     value:"lcf"
  },
  {
     label:"Luchazi",
     value:"lch"
  },
  {
     label:"Lisela",
     value:"lcl"
  },
  {
     label:"Tungag",
     value:"lcm"
  },
  {
     label:"Western Lawa",
     value:"lcp"
  },
  {
     label:"Luhu",
     value:"lcq"
  },
  {
     label:"Lisabata-Nuniali",
     value:"lcs"
  },
  {
     label:"Kla-Dan",
     value:"lda"
  },
  {
     label:"Du\u0303ya",
     value:"ldb"
  },
  {
     label:"Luri",
     value:"ldd"
  },
  {
     label:"Lenyima",
     value:"ldg"
  },
  {
     label:"Lamja-Dengsa-Tola",
     value:"ldh"
  },
  {
     label:"Laari",
     value:"ldi"
  },
  {
     label:"Lemoro",
     value:"ldj"
  },
  {
     label:"Leelau",
     value:"ldk"
  },
  {
     label:"Kaan",
     value:"ldl"
  },
  {
     label:"Landoma",
     value:"ldm"
  },
  {
     label:"L\u00e1adan",
     value:"ldn"
  },
  {
     label:"Loo",
     value:"ldo"
  },
  {
     label:"Tso",
     value:"ldp"
  },
  {
     label:"Lufu",
     value:"ldq"
  },
  {
     label:"Lega-Shabunda",
     value:"lea"
  },
  {
     label:"Lala-Bisa",
     value:"leb"
  },
  {
     label:"Leco",
     value:"lec"
  },
  {
     label:"Lendu",
     value:"led"
  },
  {
     label:"Ly\u00e9l\u00e9",
     value:"lee"
  },
  {
     label:"Lelemi",
     value:"lef"
  },
  {
     label:"Lenje",
     value:"leh"
  },
  {
     label:"Lemio",
     value:"lei"
  },
  {
     label:"Lengola",
     value:"lej"
  },
  {
     label:"Leipon",
     value:"lek"
  },
  {
     label:"Lele (Democratic Republic of Congo)",
     value:"lel"
  },
  {
     label:"Nomaande",
     value:"lem"
  },
  {
     label:"Leti (Cameroon)",
     value:"leo"
  },
  {
     label:"Lepcha",
     value:"lep"
  },
  {
     label:"Lembena",
     value:"leq"
  },
  {
     label:"Lenkau",
     value:"ler"
  },
  {
     label:"Lese",
     value:"les"
  },
  {
     label:"Lesing-Gelimi",
     value:"let"
  },
  {
     label:"Kara (Papua New Guinea)",
     value:"leu"
  },
  {
     label:"Lamma",
     value:"lev"
  },
  {
     label:"Ledo Kaili",
     value:"lew"
  },
  {
     label:"Luang",
     value:"lex"
  },
  {
     label:"Lemolang",
     value:"ley"
  },
  {
     label:"Lezghian",
     value:"lez",
     "iso6392B":"lez",
     "iso6392T":"lez"
  },
  {
     label:"Lefa",
     value:"lfa"
  },
  {
     label:"Lingua Franca Nova",
     value:"lfn"
  },
  {
     label:"Lungga",
     value:"lga"
  },
  {
     label:"Laghu",
     value:"lgb"
  },
  {
     label:"Lugbara",
     value:"lgg"
  },
  {
     label:"Laghuu",
     value:"lgh"
  },
  {
     label:"Lengilu",
     value:"lgi"
  },
  {
     label:"Lingarak",
     value:"lgk"
  },
  {
     label:"Wala",
     value:"lgl"
  },
  {
     label:"Lega-Mwenga",
     value:"lgm"
  },
  {
     label:"T'apo",
     value:"lgn"
  },
  {
     label:"Logba",
     value:"lgq"
  },
  {
     label:"Lengo",
     value:"lgr"
  },
  {
     label:"Pahi",
     value:"lgt"
  },
  {
     label:"Longgu",
     value:"lgu"
  },
  {
     label:"Ligenza",
     value:"lgz"
  },
  {
     label:"Laha (Viet Nam)",
     value:"lha"
  },
  {
     label:"Laha (Indonesia)",
     value:"lhh"
  },
  {
     label:"Lahu Shi",
     value:"lhi"
  },
  {
     label:"Lahul Lohar",
     value:"lhl"
  },
  {
     label:"Lhomi",
     value:"lhm"
  },
  {
     label:"Lahanan",
     value:"lhn"
  },
  {
     label:"Lhokpu",
     value:"lhp"
  },
  {
     label:"Lo-Toga",
     value:"lht"
  },
  {
     label:"Lahu",
     value:"lhu"
  },
  {
     label:"West-Central Limba",
     value:"lia"
  },
  {
     label:"Likum",
     value:"lib"
  },
  {
     label:"Hlai",
     value:"lic"
  },
  {
     label:"Nyindrou",
     value:"lid"
  },
  {
     label:"Likila",
     value:"lie"
  },
  {
     label:"Limbu",
     value:"lif"
  },
  {
     label:"Ligbi",
     value:"lig"
  },
  {
     label:"Lihir",
     value:"lih"
  },
  {
     label:"Ligurian",
     value:"lij"
  },
  {
     label:"Lika",
     value:"lik"
  },
  {
     label:"Lillooet",
     value:"lil"
  },
  {
     label:"Limburgan",
     value:"lim",
     "iso6392B":"lim",
     "iso6392T":"lim",
     "iso6391":"li"
  },
  {
     label:"Lingala",
     value:"lin",
     "iso6392B":"lin",
     "iso6392T":"lin",
     "iso6391":"ln"
  },
  {
     label:"Liki",
     value:"lio"
  },
  {
     label:"Sekpele",
     value:"lip"
  },
  {
     label:"Libido",
     value:"liq"
  },
  {
     label:"Liberian English",
     value:"lir"
  },
  {
     label:"Lisu",
     value:"lis"
  },
  {
     label:"Lithuanian",
     value:"lit",
     "iso6392B":"lit",
     "iso6392T":"lit",
     "iso6391":"lt"
  },
  {
     label:"Logorik",
     value:"liu"
  },
  {
     label:"Liv",
     value:"liv"
  },
  {
     label:"Col",
     value:"liw"
  },
  {
     label:"Liabuku",
     value:"lix"
  },
  {
     label:"Banda-Bambari",
     value:"liy"
  },
  {
     label:"Libinza",
     value:"liz"
  },
  {
     label:"Rampi",
     value:"lje"
  },
  {
     label:"Laiyolo",
     value:"lji"
  },
  {
     label:"Li'o",
     value:"ljl"
  },
  {
     label:"Lampung Api",
     value:"ljp"
  },
  {
     label:"Yirandali",
     value:"ljw"
  },
  {
     label:"Lakalei",
     value:"lka"
  },
  {
     label:"Kabras",
     value:"lkb"
  },
  {
     label:"Kucong",
     value:"lkc"
  },
  {
     label:"Lakond\u00ea",
     value:"lkd"
  },
  {
     label:"Kenyi",
     value:"lke"
  },
  {
     label:"Lakha",
     value:"lkh"
  },
  {
     label:"Laki",
     value:"lki"
  },
  {
     label:"Remun",
     value:"lkj"
  },
  {
     label:"Laeko-Libuat",
     value:"lkl"
  },
  {
     label:"Lakon",
     value:"lkn"
  },
  {
     label:"Khayo",
     value:"lko"
  },
  {
     label:"P\u00e4ri",
     value:"lkr"
  },
  {
     label:"Kisa",
     value:"lks"
  },
  {
     label:"Lakota",
     value:"lkt"
  },
  {
     label:"Lokoya",
     value:"lky"
  },
  {
     label:"Lala-Roba",
     value:"lla"
  },
  {
     label:"Lolo",
     value:"llb"
  },
  {
     label:"Lele (Guinea)",
     value:"llc"
  },
  {
     label:"Ladin",
     value:"lld"
  },
  {
     label:"Lele (Papua New Guinea)",
     value:"lle"
  },
  {
     label:"Lole",
     value:"llg"
  },
  {
     label:"Lamu",
     value:"llh"
  },
  {
     label:"Teke-Laali",
     value:"lli"
  },
  {
     label:"Lilau",
     value:"lll"
  },
  {
     label:"Lasalimu",
     value:"llm"
  },
  {
     label:"Lele (Chad)",
     value:"lln"
  },
  {
     label:"North Efate",
     value:"llp"
  },
  {
     label:"Lolak",
     value:"llq"
  },
  {
     label:"Lau",
     value:"llu"
  },
  {
     label:"Lauan",
     value:"llx"
  },
  {
     label:"East Limba",
     value:"lma"
  },
  {
     label:"Merei",
     value:"lmb"
  },
  {
     label:"Lumun",
     value:"lmd"
  },
  {
     label:"P\u00e9v\u00e9",
     value:"lme"
  },
  {
     label:"South Lembata",
     value:"lmf"
  },
  {
     label:"Lamogai",
     value:"lmg"
  },
  {
     label:"Lambichhong",
     value:"lmh"
  },
  {
     label:"Lombi",
     value:"lmi"
  },
  {
     label:"West Lembata",
     value:"lmj"
  },
  {
     label:"Lamkang",
     value:"lmk"
  },
  {
     label:"Hano",
     value:"lml"
  },
  {
     label:"Lambadi",
     value:"lmn"
  },
  {
     label:"Lombard",
     value:"lmo"
  },
  {
     label:"Limbum",
     value:"lmp"
  },
  {
     label:"Lamatuka",
     value:"lmq"
  },
  {
     label:"Lamalera",
     value:"lmr"
  },
  {
     label:"Lamenu",
     value:"lmu"
  },
  {
     label:"Lomaiviti",
     value:"lmv"
  },
  {
     label:"Lake Miwok",
     value:"lmw"
  },
  {
     label:"Laimbue",
     value:"lmx"
  },
  {
     label:"Lamboya",
     value:"lmy"
  },
  {
     label:"Langbashe",
     value:"lna"
  },
  {
     label:"Mbalanhu",
     value:"lnb"
  },
  {
     label:"Lundayeh",
     value:"lnd"
  },
  {
     label:"Lanoh",
     value:"lnh"
  },
  {
     label:"Daantanai'",
     value:"lni"
  },
  {
     label:"South Central Banda",
     value:"lnl"
  },
  {
     label:"Langam",
     value:"lnm"
  },
  {
     label:"Lorediakarkar",
     value:"lnn"
  },
  {
     label:"Lango (South Sudan)",
     value:"lno"
  },
  {
     label:"Lamnso'",
     value:"lns"
  },
  {
     label:"Longuda",
     value:"lnu"
  },
  {
     label:"Lonzo",
     value:"lnz"
  },
  {
     label:"Loloda",
     value:"loa"
  },
  {
     label:"Lobi",
     value:"lob"
  },
  {
     label:"Inonhan",
     value:"loc"
  },
  {
     label:"Saluan",
     value:"loe"
  },
  {
     label:"Logol",
     value:"lof"
  },
  {
     label:"Logo",
     value:"log"
  },
  {
     label:"Narim",
     value:"loh"
  },
  {
     label:"Loma (C\u00f4te d'Ivoire)",
     value:"loi"
  },
  {
     label:"Lou",
     value:"loj"
  },
  {
     label:"Loko",
     value:"lok"
  },
  {
     label:"Mongo",
     value:"lol",
     "iso6392B":"lol",
     "iso6392T":"lol"
  },
  {
     label:"Loma (Liberia)",
     value:"lom"
  },
  {
     label:"Malawi Lomwe",
     value:"lon"
  },
  {
     label:"Lombo",
     value:"loo"
  },
  {
     label:"Lopa",
     value:"lop"
  },
  {
     label:"Lobala",
     value:"loq"
  },
  {
     label:"T\u00e9\u00e9n",
     value:"lor"
  },
  {
     label:"Loniu",
     value:"los"
  },
  {
     label:"Otuho",
     value:"lot"
  },
  {
     label:"Louisiana Creole",
     value:"lou"
  },
  {
     label:"Lopi",
     value:"lov"
  },
  {
     label:"Tampias Lobu",
     value:"low"
  },
  {
     label:"Loun",
     value:"lox"
  },
  {
     label:"Loke",
     value:"loy"
  },
  {
     label:"Lozi",
     value:"loz",
     "iso6392B":"loz",
     "iso6392T":"loz"
  },
  {
     label:"Lelepa",
     value:"lpa"
  },
  {
     label:"Lepki",
     value:"lpe"
  },
  {
     label:"Long Phuri Naga",
     value:"lpn"
  },
  {
     label:"Lipo",
     value:"lpo"
  },
  {
     label:"Lopit",
     value:"lpx"
  },
  {
     label:"Rara Bakati'",
     value:"lra"
  },
  {
     label:"Northern Luri",
     value:"lrc"
  },
  {
     label:"Marachi",
     value:"lri"
  },
  {
     label:"Loarki",
     value:"lrk"
  },
  {
     label:"Lari",
     value:"lrl"
  },
  {
     label:"Marama",
     value:"lrm"
  },
  {
     label:"Lorang",
     value:"lrn"
  },
  {
     label:"Laro",
     value:"lro"
  },
  {
     label:"Southern Yamphu",
     value:"lrr"
  },
  {
     label:"Larantuka Malay",
     value:"lrt"
  },
  {
     label:"Larevat",
     value:"lrv"
  },
  {
     label:"Lemerig",
     value:"lrz"
  },
  {
     label:"Lasgerdi",
     value:"lsa"
  },
  {
     label:"Lishana Deni",
     value:"lsd"
  },
  {
     label:"Lusengo",
     value:"lse"
  },
  {
     label:"Lish",
     value:"lsh"
  },
  {
     label:"Lashi",
     value:"lsi"
  },
  {
     label:"Saamia",
     value:"lsm"
  },
  {
     label:"Aruop",
     value:"lsr"
  },
  {
     label:"Lasi",
     value:"lss"
  },
  {
     label:"Latgalian",
     value:"ltg"
  },
  {
     label:"Thur",
     value:"lth"
  },
  {
     label:"Leti (Indonesia)",
     value:"lti"
  },
  {
     label:"Latund\u00ea",
     value:"ltn"
  },
  {
     label:"Tsotso",
     value:"lto"
  },
  {
     label:"Tachoni",
     value:"lts"
  },
  {
     label:"Latu",
     value:"ltu"
  },
  {
     label:"Luxembourgish",
     value:"ltz",
     "iso6392B":"ltz",
     "iso6392T":"ltz",
     "iso6391":"lb"
  },
  {
     label:"Luba-Lulua",
     value:"lua",
     "iso6392B":"lua",
     "iso6392T":"lua"
  },
  {
     label:"Luba-Katanga",
     value:"lub",
     "iso6392B":"lub",
     "iso6392T":"lub",
     "iso6391":"lu"
  },
  {
     label:"Aringa",
     value:"luc"
  },
  {
     label:"Ludian",
     value:"lud"
  },
  {
     label:"Luvale",
     value:"lue"
  },
  {
     label:"Laua",
     value:"luf"
  },
  {
     label:"Ganda",
     value:"lug",
     "iso6392B":"lug",
     "iso6392T":"lug",
     "iso6391":"lg"
  },
  {
     label:"Luna",
     value:"luj"
  },
  {
     label:"Lunanakha",
     value:"luk"
  },
  {
     label:"Olu'bo",
     value:"lul"
  },
  {
     label:"Luimbi",
     value:"lum"
  },
  {
     label:"Lunda",
     value:"lun",
     "iso6392B":"lun",
     "iso6392T":"lun"
  },
  {
     label:"Luo (Kenya and Tanzania)",
     value:"luo",
     "iso6392B":"luo",
     "iso6392T":"luo"
  },
  {
     label:"Lumbu",
     value:"lup"
  },
  {
     label:"Lucumi",
     value:"luq"
  },
  {
     label:"Laura",
     value:"lur"
  },
  {
     label:"Lushai",
     value:"lus",
     "iso6392B":"lus",
     "iso6392T":"lus"
  },
  {
     label:"Lushootseed",
     value:"lut"
  },
  {
     label:"Lumba-Yakkha",
     value:"luu"
  },
  {
     label:"Luwati",
     value:"luv"
  },
  {
     label:"Luo (Cameroon)",
     value:"luw"
  },
  {
     label:"Luyia",
     value:"luy"
  },
  {
     label:"Southern Luri",
     value:"luz"
  },
  {
     label:"Maku'a",
     value:"lva"
  },
  {
     label:"Lavi",
     value:"lvi"
  },
  {
     label:"Lavukaleve",
     value:"lvk"
  },
  {
     label:"Standard Latvian",
     value:"lvs"
  },
  {
     label:"Levuka",
     value:"lvu"
  },
  {
     label:"Lwalu",
     value:"lwa"
  },
  {
     label:"Lewo Eleng",
     value:"lwe"
  },
  {
     label:"Wanga",
     value:"lwg"
  },
  {
     label:"White Lachi",
     value:"lwh"
  },
  {
     label:"Eastern Lawa",
     value:"lwl"
  },
  {
     label:"Laomian",
     value:"lwm"
  },
  {
     label:"Luwo",
     value:"lwo"
  },
  {
     label:"Lewotobi",
     value:"lwt"
  },
  {
     label:"Lawu",
     value:"lwu"
  },
  {
     label:"Lewo",
     value:"lww"
  },
  {
     label:"Layakha",
     value:"lya"
  },
  {
     label:"Lyngngam",
     value:"lyg"
  },
  {
     label:"Luyana",
     value:"lyn"
  },
  {
     label:"Litzlitz",
     value:"lzl"
  },
  {
     label:"Leinong Naga",
     value:"lzn"
  },
  {
     label:"Laz",
     value:"lzz"
  },
  {
     label:"San Jer\u00f3nimo Tec\u00f3atl Mazatec",
     value:"maa"
  },
  {
     label:"Yutanduchi Mixtec",
     value:"mab"
  },
  {
     label:"Madurese",
     value:"mad",
     "iso6392B":"mad",
     "iso6392T":"mad"
  },
  {
     label:"Bo-Rukul",
     value:"mae"
  },
  {
     label:"Mafa",
     value:"maf"
  },
  {
     label:"Magahi",
     value:"mag",
     "iso6392B":"mag",
     "iso6392T":"mag"
  },
  {
     label:"Marshallese",
     value:"mah",
     "iso6392B":"mah",
     "iso6392T":"mah",
     "iso6391":"mh"
  },
  {
     label:"Maithili",
     value:"mai",
     "iso6392B":"mai",
     "iso6392T":"mai"
  },
  {
     label:"Jalapa De D\u00edaz Mazatec",
     value:"maj"
  },
  {
     label:"Makasar",
     value:"mak",
     "iso6392B":"mak",
     "iso6392T":"mak"
  },
  {
     label:"Malayalam",
     value:"mal",
     "iso6392B":"mal",
     "iso6392T":"mal",
     "iso6391":"ml"
  },
  {
     label:"Mam",
     value:"mam"
  },
  {
     label:"Mandingo",
     value:"man",
     "iso6392B":"man",
     "iso6392T":"man"
  },
  {
     label:"Chiquihuitl\u00e1n Mazatec",
     value:"maq"
  },
  {
     label:"Marathi",
     value:"mar",
     "iso6392B":"mar",
     "iso6392T":"mar",
     "iso6391":"mr"
  },
  {
     label:"Masai",
     value:"mas",
     "iso6392B":"mas",
     "iso6392T":"mas"
  },
  {
     label:"San Francisco Matlatzinca",
     value:"mat"
  },
  {
     label:"Huautla Mazatec",
     value:"mau"
  },
  {
     label:"Sater\u00e9-Maw\u00e9",
     value:"mav"
  },
  {
     label:"Mampruli",
     value:"maw"
  },
  {
     label:"North Moluccan Malay",
     value:"max"
  },
  {
     label:"Central Mazahua",
     value:"maz"
  },
  {
     label:"Higaonon",
     value:"mba"
  },
  {
     label:"Western Bukidnon Manobo",
     value:"mbb"
  },
  {
     label:"Macushi",
     value:"mbc"
  },
  {
     label:"Dibabawon Manobo",
     value:"mbd"
  },
  {
     label:"Baba Malay",
     value:"mbf"
  },
  {
     label:"Mangseng",
     value:"mbh"
  },
  {
     label:"Ilianen Manobo",
     value:"mbi"
  },
  {
     label:"Nad\u00ebb",
     value:"mbj"
  },
  {
     label:"Malol",
     value:"mbk"
  },
  {
     label:"Maxakal\u00ed",
     value:"mbl"
  },
  {
     label:"Ombamba",
     value:"mbm"
  },
  {
     label:"Macagu\u00e1n",
     value:"mbn"
  },
  {
     label:"Mbo (Cameroon)",
     value:"mbo"
  },
  {
     label:"Malayo",
     value:"mbp"
  },
  {
     label:"Maisin",
     value:"mbq"
  },
  {
     label:"Nukak Mak\u00fa",
     value:"mbr"
  },
  {
     label:"Sarangani Manobo",
     value:"mbs"
  },
  {
     label:"Matigsalug Manobo",
     value:"mbt"
  },
  {
     label:"Mbula-Bwazza",
     value:"mbu"
  },
  {
     label:"Mbulungish",
     value:"mbv"
  },
  {
     label:"Maring",
     value:"mbw"
  },
  {
     label:"Mari (East Sepik Province)",
     value:"mbx"
  },
  {
     label:"Memoni",
     value:"mby"
  },
  {
     label:"Amoltepec Mixtec",
     value:"mbz"
  },
  {
     label:"Maca",
     value:"mca"
  },
  {
     label:"Machiguenga",
     value:"mcb"
  },
  {
     label:"Bitur",
     value:"mcc"
  },
  {
     label:"Sharanahua",
     value:"mcd"
  },
  {
     label:"Itundujia Mixtec",
     value:"mce"
  },
  {
     label:"Mats\u00e9s",
     value:"mcf"
  },
  {
     label:"Mapoyo",
     value:"mcg"
  },
  {
     label:"Maquiritari",
     value:"mch"
  },
  {
     label:"Mese",
     value:"mci"
  },
  {
     label:"Mvanip",
     value:"mcj"
  },
  {
     label:"Mbunda",
     value:"mck"
  },
  {
     label:"Malaccan Creole Portuguese",
     value:"mcm"
  },
  {
     label:"Masana",
     value:"mcn"
  },
  {
     label:"Coatl\u00e1n Mixe",
     value:"mco"
  },
  {
     label:"Makaa",
     value:"mcp"
  },
  {
     label:"Ese",
     value:"mcq"
  },
  {
     label:"Menya",
     value:"mcr"
  },
  {
     label:"Mambai",
     value:"mcs"
  },
  {
     label:"Mengisa",
     value:"mct"
  },
  {
     label:"Cameroon Mambila",
     value:"mcu"
  },
  {
     label:"Minanibai",
     value:"mcv"
  },
  {
     label:"Mawa (Chad)",
     value:"mcw"
  },
  {
     label:"Mpiemo",
     value:"mcx"
  },
  {
     label:"South Watut",
     value:"mcy"
  },
  {
     label:"Mawan",
     value:"mcz"
  },
  {
     label:"Mada (Nigeria)",
     value:"mda"
  },
  {
     label:"Morigi",
     value:"mdb"
  },
  {
     label:"Male (Papua New Guinea)",
     value:"mdc"
  },
  {
     label:"Mbum",
     value:"mdd"
  },
  {
     label:"Maba (Chad)",
     value:"mde"
  },
  {
     label:"Moksha",
     value:"mdf",
     "iso6392B":"mdf",
     "iso6392T":"mdf"
  },
  {
     label:"Massalat",
     value:"mdg"
  },
  {
     label:"Maguindanaon",
     value:"mdh"
  },
  {
     label:"Mamvu",
     value:"mdi"
  },
  {
     label:"Mangbetu",
     value:"mdj"
  },
  {
     label:"Mangbutu",
     value:"mdk"
  },
  {
     label:"Mayogo",
     value:"mdm"
  },
  {
     label:"Mbati",
     value:"mdn"
  },
  {
     label:"Mbala",
     value:"mdp"
  },
  {
     label:"Mbole",
     value:"mdq"
  },
  {
     label:"Mandar",
     value:"mdr",
     "iso6392B":"mdr",
     "iso6392T":"mdr"
  },
  {
     label:"Maria (Papua New Guinea)",
     value:"mds"
  },
  {
     label:"Mbere",
     value:"mdt"
  },
  {
     label:"Mboko",
     value:"mdu"
  },
  {
     label:"Santa Luc\u00eda Monteverde Mixtec",
     value:"mdv"
  },
  {
     label:"Mbosi",
     value:"mdw"
  },
  {
     label:"Dizin",
     value:"mdx"
  },
  {
     label:"Male (Ethiopia)",
     value:"mdy"
  },
  {
     label:"Suru\u00ed Do Par\u00e1",
     value:"mdz"
  },
  {
     label:"Menka",
     value:"mea"
  },
  {
     label:"Ikobi",
     value:"meb"
  },
  {
     label:"Marra",
     value:"mec"
  },
  {
     label:"Melpa",
     value:"med"
  },
  {
     label:"Mengen",
     value:"mee"
  },
  {
     label:"Megam",
     value:"mef"
  },
  {
     label:"Southwestern Tlaxiaco Mixtec",
     value:"meh"
  },
  {
     label:"Midob",
     value:"mei"
  },
  {
     label:"Meyah",
     value:"mej"
  },
  {
     label:"Mekeo",
     value:"mek"
  },
  {
     label:"Central Melanau",
     value:"mel"
  },
  {
     label:"Mende (Sierra Leone)",
     value:"men",
     "iso6392B":"men",
     "iso6392T":"men"
  },
  {
     label:"Kedah Malay",
     value:"meo"
  },
  {
     label:"Miriwoong",
     value:"mep"
  },
  {
     label:"Merey",
     value:"meq"
  },
  {
     label:"Meru",
     value:"mer"
  },
  {
     label:"Masmaje",
     value:"mes"
  },
  {
     label:"Mato",
     value:"met"
  },
  {
     label:"Motu",
     value:"meu"
  },
  {
     label:"Mano",
     value:"mev"
  },
  {
     label:"Maaka",
     value:"mew"
  },
  {
     label:"Hassaniyya",
     value:"mey"
  },
  {
     label:"Menominee",
     value:"mez"
  },
  {
     label:"Pattani Malay",
     value:"mfa"
  },
  {
     label:"Bangka",
     value:"mfb"
  },
  {
     label:"Mba",
     value:"mfc"
  },
  {
     label:"Mendankwe-Nkwen",
     value:"mfd"
  },
  {
     label:"Morisyen",
     value:"mfe"
  },
  {
     label:"Naki",
     value:"mff"
  },
  {
     label:"Mogofin",
     value:"mfg"
  },
  {
     label:"Matal",
     value:"mfh"
  },
  {
     label:"Wandala",
     value:"mfi"
  },
  {
     label:"Mefele",
     value:"mfj"
  },
  {
     label:"North Mofu",
     value:"mfk"
  },
  {
     label:"Putai",
     value:"mfl"
  },
  {
     label:"Marghi South",
     value:"mfm"
  },
  {
     label:"Cross River Mbembe",
     value:"mfn"
  },
  {
     label:"Mbe",
     value:"mfo"
  },
  {
     label:"Makassar Malay",
     value:"mfp"
  },
  {
     label:"Moba",
     value:"mfq"
  },
  {
     label:"Marrithiyel",
     value:"mfr"
  },
  {
     label:"Mokerang",
     value:"mft"
  },
  {
     label:"Mbwela",
     value:"mfu"
  },
  {
     label:"Mandjak",
     value:"mfv"
  },
  {
     label:"Melo",
     value:"mfx"
  },
  {
     label:"Mayo",
     value:"mfy"
  },
  {
     label:"Mabaan",
     value:"mfz"
  },
  {
     label:"Mararit",
     value:"mgb"
  },
  {
     label:"Morokodo",
     value:"mgc"
  },
  {
     label:"Moru",
     value:"mgd"
  },
  {
     label:"Mango",
     value:"mge"
  },
  {
     label:"Maklew",
     value:"mgf"
  },
  {
     label:"Mpumpong",
     value:"mgg"
  },
  {
     label:"Makhuwa-Meetto",
     value:"mgh"
  },
  {
     label:"Lijili",
     value:"mgi"
  },
  {
     label:"Abureni",
     value:"mgj"
  },
  {
     label:"Mawes",
     value:"mgk"
  },
  {
     label:"Maleu-Kilenge",
     value:"mgl"
  },
  {
     label:"Mambae",
     value:"mgm"
  },
  {
     label:"Mbangi",
     value:"mgn"
  },
  {
     label:"Meta'",
     value:"mgo"
  },
  {
     label:"Eastern Magar",
     value:"mgp"
  },
  {
     label:"Malila",
     value:"mgq"
  },
  {
     label:"Mambwe-Lungu",
     value:"mgr"
  },
  {
     label:"Manda (Tanzania)",
     value:"mgs"
  },
  {
     label:"Mongol",
     value:"mgt"
  },
  {
     label:"Mailu",
     value:"mgu"
  },
  {
     label:"Matengo",
     value:"mgv"
  },
  {
     label:"Matumbi",
     value:"mgw"
  },
  {
     label:"Mbunga",
     value:"mgy"
  },
  {
     label:"Mbugwe",
     value:"mgz"
  },
  {
     label:"Manda (India)",
     value:"mha"
  },
  {
     label:"Mahongwe",
     value:"mhb"
  },
  {
     label:"Mocho",
     value:"mhc"
  },
  {
     label:"Mbugu",
     value:"mhd"
  },
  {
     label:"Besisi",
     value:"mhe"
  },
  {
     label:"Mamaa",
     value:"mhf"
  },
  {
     label:"Margu",
     value:"mhg"
  },
  {
     label:"Ma'di",
     value:"mhi"
  },
  {
     label:"Mogholi",
     value:"mhj"
  },
  {
     label:"Mungaka",
     value:"mhk"
  },
  {
     label:"Mauwake",
     value:"mhl"
  },
  {
     label:"Makhuwa-Moniga",
     value:"mhm"
  },
  {
     label:"M\u00f3cheno",
     value:"mhn"
  },
  {
     label:"Mashi (Zambia)",
     value:"mho"
  },
  {
     label:"Balinese Malay",
     value:"mhp"
  },
  {
     label:"Mandan",
     value:"mhq"
  },
  {
     label:"Eastern Mari",
     value:"mhr"
  },
  {
     label:"Buru (Indonesia)",
     value:"mhs"
  },
  {
     label:"Mandahuaca",
     value:"mht"
  },
  {
     label:"Digaro-Mishmi",
     value:"mhu"
  },
  {
     label:"Mbukushu",
     value:"mhw"
  },
  {
     label:"Maru",
     value:"mhx"
  },
  {
     label:"Ma'anyan",
     value:"mhy"
  },
  {
     label:"Mor (Mor Islands)",
     value:"mhz"
  },
  {
     label:"Miami",
     value:"mia"
  },
  {
     label:"Atatl\u00e1huca Mixtec",
     value:"mib"
  },
  {
     label:"Mi'kmaq",
     value:"mic",
     "iso6392B":"mic",
     "iso6392T":"mic"
  },
  {
     label:"Mandaic",
     value:"mid"
  },
  {
     label:"Ocotepec Mixtec",
     value:"mie"
  },
  {
     label:"Mofu-Gudur",
     value:"mif"
  },
  {
     label:"San Miguel El Grande Mixtec",
     value:"mig"
  },
  {
     label:"Chayuco Mixtec",
     value:"mih"
  },
  {
     label:"Chigmecatitl\u00e1n Mixtec",
     value:"mii"
  },
  {
     label:"Abar",
     value:"mij"
  },
  {
     label:"Mikasuki",
     value:"mik"
  },
  {
     label:"Pe\u00f1oles Mixtec",
     value:"mil"
  },
  {
     label:"Alacatlatzala Mixtec",
     value:"mim"
  },
  {
     label:"Minangkabau",
     value:"min",
     "iso6392B":"min",
     "iso6392T":"min"
  },
  {
     label:"Pinotepa Nacional Mixtec",
     value:"mio"
  },
  {
     label:"Apasco-Apoala Mixtec",
     value:"mip"
  },
  {
     label:"M\u00edskito",
     value:"miq"
  },
  {
     label:"Isthmus Mixe",
     value:"mir"
  },
  {
     label:"Uncoded languages",
     value:"mis",
     "iso6392B":"mis",
     "iso6392T":"mis"
  },
  {
     label:"Southern Puebla Mixtec",
     value:"mit"
  },
  {
     label:"Cacaloxtepec Mixtec",
     value:"miu"
  },
  {
     label:"Akoye",
     value:"miw"
  },
  {
     label:"Mixtepec Mixtec",
     value:"mix"
  },
  {
     label:"Ayutla Mixtec",
     value:"miy"
  },
  {
     label:"Coatzospan Mixtec",
     value:"miz"
  },
  {
     label:"Makalero",
     value:"mjb"
  },
  {
     label:"San Juan Colorado Mixtec",
     value:"mjc"
  },
  {
     label:"Northwest Maidu",
     value:"mjd"
  },
  {
     label:"Tu",
     value:"mjg"
  },
  {
     label:"Mwera (Nyasa)",
     value:"mjh"
  },
  {
     label:"Kim Mun",
     value:"mji"
  },
  {
     label:"Mawak",
     value:"mjj"
  },
  {
     label:"Matukar",
     value:"mjk"
  },
  {
     label:"Mandeali",
     value:"mjl"
  },
  {
     label:"Medebur",
     value:"mjm"
  },
  {
     label:"Ma (Papua New Guinea)",
     value:"mjn"
  },
  {
     label:"Malankuravan",
     value:"mjo"
  },
  {
     label:"Malapandaram",
     value:"mjp"
  },
  {
     label:"Malavedan",
     value:"mjr"
  },
  {
     label:"Miship",
     value:"mjs"
  },
  {
     label:"Sauria Paharia",
     value:"mjt"
  },
  {
     label:"Manna-Dora",
     value:"mju"
  },
  {
     label:"Mannan",
     value:"mjv"
  },
  {
     label:"Karbi",
     value:"mjw"
  },
  {
     label:"Mahali",
     value:"mjx"
  },
  {
     label:"Majhi",
     value:"mjz"
  },
  {
     label:"Mbre",
     value:"mka"
  },
  {
     label:"Mal Paharia",
     value:"mkb"
  },
  {
     label:"Siliput",
     value:"mkc"
  },
  {
     label:"Macedonian",
     value:"mkd",
     "iso6392B":"mac",
     "iso6392T":"mkd",
     "iso6391":"mk"
  },
  {
     label:"Mawchi",
     value:"mke"
  },
  {
     label:"Miya",
     value:"mkf"
  },
  {
     label:"Mak (China)",
     value:"mkg"
  },
  {
     label:"Dhatki",
     value:"mki"
  },
  {
     label:"Mokilese",
     value:"mkj"
  },
  {
     label:"Byep",
     value:"mkk"
  },
  {
     label:"Mokole",
     value:"mkl"
  },
  {
     label:"Moklen",
     value:"mkm"
  },
  {
     label:"Kupang Malay",
     value:"mkn"
  },
  {
     label:"Mingang Doso",
     value:"mko"
  },
  {
     label:"Moikodi",
     value:"mkp"
  },
  {
     label:"Malas",
     value:"mkr"
  },
  {
     label:"Silacayoapan Mixtec",
     value:"mks"
  },
  {
     label:"Vamale",
     value:"mkt"
  },
  {
     label:"Konyanka Maninka",
     value:"mku"
  },
  {
     label:"Mafea",
     value:"mkv"
  },
  {
     label:"Kituba (Congo)",
     value:"mkw"
  },
  {
     label:"Kinamiging Manobo",
     value:"mkx"
  },
  {
     label:"East Makian",
     value:"mky"
  },
  {
     label:"Makasae",
     value:"mkz"
  },
  {
     label:"Malo",
     value:"mla"
  },
  {
     label:"Mbule",
     value:"mlb"
  },
  {
     label:"Cao Lan",
     value:"mlc"
  },
  {
     label:"Manambu",
     value:"mle"
  },
  {
     label:"Mal",
     value:"mlf"
  },
  {
     label:"Malagasy",
     value:"mlg",
     "iso6392B":"mlg",
     "iso6392T":"mlg",
     "iso6391":"mg"
  },
  {
     label:"Mape",
     value:"mlh"
  },
  {
     label:"Malimpung",
     value:"mli"
  },
  {
     label:"Miltu",
     value:"mlj"
  },
  {
     label:"Ilwana",
     value:"mlk"
  },
  {
     label:"Malua Bay",
     value:"mll"
  },
  {
     label:"Mulam",
     value:"mlm"
  },
  {
     label:"Malango",
     value:"mln"
  },
  {
     label:"Mlomp",
     value:"mlo"
  },
  {
     label:"Bargam",
     value:"mlp"
  },
  {
     label:"Western Maninkakan",
     value:"mlq"
  },
  {
     label:"Vame",
     value:"mlr"
  },
  {
     label:"Masalit",
     value:"mls"
  },
  {
     label:"Maltese",
     value:"mlt",
     "iso6392B":"mlt",
     "iso6392T":"mlt",
     "iso6391":"mt"
  },
  {
     label:"To'abaita",
     value:"mlu"
  },
  {
     label:"Motlav",
     value:"mlv"
  },
  {
     label:"Moloko",
     value:"mlw"
  },
  {
     label:"Malfaxal",
     value:"mlx"
  },
  {
     label:"Malaynon",
     value:"mlz"
  },
  {
     label:"Mama",
     value:"mma"
  },
  {
     label:"Momina",
     value:"mmb"
  },
  {
     label:"Michoac\u00e1n Mazahua",
     value:"mmc"
  },
  {
     label:"Maonan",
     value:"mmd"
  },
  {
     label:"Mae",
     value:"mme"
  },
  {
     label:"Mundat",
     value:"mmf"
  },
  {
     label:"North Ambrym",
     value:"mmg"
  },
  {
     label:"Mehin\u00e1ku",
     value:"mmh"
  },
  {
     label:"Musar",
     value:"mmi"
  },
  {
     label:"Majhwar",
     value:"mmj"
  },
  {
     label:"Mukha-Dora",
     value:"mmk"
  },
  {
     label:"Man Met",
     value:"mml"
  },
  {
     label:"Maii",
     value:"mmm"
  },
  {
     label:"Mamanwa",
     value:"mmn"
  },
  {
     label:"Mangga Buang",
     value:"mmo"
  },
  {
     label:"Siawi",
     value:"mmp"
  },
  {
     label:"Musak",
     value:"mmq"
  },
  {
     label:"Western Xiangxi Miao",
     value:"mmr"
  },
  {
     label:"Malalamai",
     value:"mmt"
  },
  {
     label:"Mmaala",
     value:"mmu"
  },
  {
     label:"Emae",
     value:"mmw"
  },
  {
     label:"Madak",
     value:"mmx"
  },
  {
     label:"Migaama",
     value:"mmy"
  },
  {
     label:"Mabaale",
     value:"mmz"
  },
  {
     label:"Mbula",
     value:"mna"
  },
  {
     label:"Muna",
     value:"mnb"
  },
  {
     label:"Manchu",
     value:"mnc",
     "iso6392B":"mnc",
     "iso6392T":"mnc"
  },
  {
     label:"Mond\u00e9",
     value:"mnd"
  },
  {
     label:"Naba",
     value:"mne"
  },
  {
     label:"Mundani",
     value:"mnf"
  },
  {
     label:"Eastern Mnong",
     value:"mng"
  },
  {
     label:"Mono (Democratic Republic of Congo)",
     value:"mnh"
  },
  {
     label:"Manipuri",
     value:"mni",
     "iso6392B":"mni",
     "iso6392T":"mni"
  },
  {
     label:"Munji",
     value:"mnj"
  },
  {
     label:"Mandinka",
     value:"mnk"
  },
  {
     label:"Tiale",
     value:"mnl"
  },
  {
     label:"Mapena",
     value:"mnm"
  },
  {
     label:"Southern Mnong",
     value:"mnn"
  },
  {
     label:"Min Bei Chinese",
     value:"mnp"
  },
  {
     label:"Minriq",
     value:"mnq"
  },
  {
     label:"Mono (USA)",
     value:"mnr"
  },
  {
     label:"Mansi",
     value:"mns"
  },
  {
     label:"Mer",
     value:"mnu"
  },
  {
     label:"Rennell-Bellona",
     value:"mnv"
  },
  {
     label:"Mon",
     value:"mnw"
  },
  {
     label:"Manikion",
     value:"mnx"
  },
  {
     label:"Manyawa",
     value:"mny"
  },
  {
     label:"Moni",
     value:"mnz"
  },
  {
     label:"Mwan",
     value:"moa"
  },
  {
     label:"Mocov\u00ed",
     value:"moc"
  },
  {
     label:"Innu",
     value:"moe"
  },
  {
     label:"Mongondow",
     value:"mog"
  },
  {
     label:"Mohawk",
     value:"moh",
     "iso6392B":"moh",
     "iso6392T":"moh"
  },
  {
     label:"Mboi",
     value:"moi"
  },
  {
     label:"Monzombo",
     value:"moj"
  },
  {
     label:"Morori",
     value:"mok"
  },
  {
     label:"Mongolian",
     value:"mon",
     "iso6392B":"mon",
     "iso6392T":"mon",
     "iso6391":"mn"
  },
  {
     label:"Monom",
     value:"moo"
  },
  {
     label:"Mop\u00e1n Maya",
     value:"mop"
  },
  {
     label:"Mor (Bomberai Peninsula)",
     value:"moq"
  },
  {
     label:"Moro",
     value:"mor"
  },
  {
     label:"Mossi",
     value:"mos",
     "iso6392B":"mos",
     "iso6392T":"mos"
  },
  {
     label:"Bar\u00ed",
     value:"mot"
  },
  {
     label:"Mogum",
     value:"mou"
  },
  {
     label:"Mohave",
     value:"mov"
  },
  {
     label:"Moi (Congo)",
     value:"mow"
  },
  {
     label:"Molima",
     value:"mox"
  },
  {
     label:"Shekkacho",
     value:"moy"
  },
  {
     label:"Mukulu",
     value:"moz"
  },
  {
     label:"Mpoto",
     value:"mpa"
  },
  {
     label:"Malak Malak",
     value:"mpb"
  },
  {
     label:"Mangarrayi",
     value:"mpc"
  },
  {
     label:"Machinere",
     value:"mpd"
  },
  {
     label:"Majang",
     value:"mpe"
  },
  {
     label:"Marba",
     value:"mpg"
  },
  {
     label:"Maung",
     value:"mph"
  },
  {
     label:"Mpade",
     value:"mpi"
  },
  {
     label:"Martu Wangka",
     value:"mpj"
  },
  {
     label:"Mbara (Chad)",
     value:"mpk"
  },
  {
     label:"Middle Watut",
     value:"mpl"
  },
  {
     label:"Yosond\u00faa Mixtec",
     value:"mpm"
  },
  {
     label:"Mindiri",
     value:"mpn"
  },
  {
     label:"Miu",
     value:"mpo"
  },
  {
     label:"Migabac",
     value:"mpp"
  },
  {
     label:"Mat\u00eds",
     value:"mpq"
  },
  {
     label:"Vangunu",
     value:"mpr"
  },
  {
     label:"Dadibi",
     value:"mps"
  },
  {
     label:"Mian",
     value:"mpt"
  },
  {
     label:"Makur\u00e1p",
     value:"mpu"
  },
  {
     label:"Mungkip",
     value:"mpv"
  },
  {
     label:"Mapidian",
     value:"mpw"
  },
  {
     label:"Misima-Panaeati",
     value:"mpx"
  },
  {
     label:"Mapia",
     value:"mpy"
  },
  {
     label:"Mpi",
     value:"mpz"
  },
  {
     label:"Maba (Indonesia)",
     value:"mqa"
  },
  {
     label:"Mbuko",
     value:"mqb"
  },
  {
     label:"Mangole",
     value:"mqc"
  },
  {
     label:"Matepi",
     value:"mqe"
  },
  {
     label:"Momuna",
     value:"mqf"
  },
  {
     label:"Kota Bangun Kutai Malay",
     value:"mqg"
  },
  {
     label:"Tlazoyaltepec Mixtec",
     value:"mqh"
  },
  {
     label:"Mariri",
     value:"mqi"
  },
  {
     label:"Mamasa",
     value:"mqj"
  },
  {
     label:"Rajah Kabunsuwan Manobo",
     value:"mqk"
  },
  {
     label:"Mbelime",
     value:"mql"
  },
  {
     label:"South Marquesan",
     value:"mqm"
  },
  {
     label:"Moronene",
     value:"mqn"
  },
  {
     label:"Modole",
     value:"mqo"
  },
  {
     label:"Manipa",
     value:"mqp"
  },
  {
     label:"Minokok",
     value:"mqq"
  },
  {
     label:"Mander",
     value:"mqr"
  },
  {
     label:"West Makian",
     value:"mqs"
  },
  {
     label:"Mok",
     value:"mqt"
  },
  {
     label:"Mandari",
     value:"mqu"
  },
  {
     label:"Mosimo",
     value:"mqv"
  },
  {
     label:"Murupi",
     value:"mqw"
  },
  {
     label:"Mamuju",
     value:"mqx"
  },
  {
     label:"Manggarai",
     value:"mqy"
  },
  {
     label:"Pano",
     value:"mqz"
  },
  {
     label:"Mlabri",
     value:"mra"
  },
  {
     label:"Marino",
     value:"mrb"
  },
  {
     label:"Maricopa",
     value:"mrc"
  },
  {
     label:"Western Magar",
     value:"mrd"
  },
  {
     label:"Elseng",
     value:"mrf"
  },
  {
     label:"Mising",
     value:"mrg"
  },
  {
     label:"Mara Chin",
     value:"mrh"
  },
  {
     label:"Maori",
     value:"mri",
     "iso6392B":"mao",
     "iso6392T":"mri",
     "iso6391":"mi"
  },
  {
     label:"Western Mari",
     value:"mrj"
  },
  {
     label:"Hmwaveke",
     value:"mrk"
  },
  {
     label:"Mortlockese",
     value:"mrl"
  },
  {
     label:"Merlav",
     value:"mrm"
  },
  {
     label:"Cheke Holo",
     value:"mrn"
  },
  {
     label:"Mru",
     value:"mro"
  },
  {
     label:"Morouas",
     value:"mrp"
  },
  {
     label:"North Marquesan",
     value:"mrq"
  },
  {
     label:"Maria (India)",
     value:"mrr"
  },
  {
     label:"Maragus",
     value:"mrs"
  },
  {
     label:"Marghi Central",
     value:"mrt"
  },
  {
     label:"Mono (Cameroon)",
     value:"mru"
  },
  {
     label:"Mangareva",
     value:"mrv"
  },
  {
     label:"Maranao",
     value:"mrw"
  },
  {
     label:"Maremgi",
     value:"mrx"
  },
  {
     label:"Mandaya",
     value:"mry"
  },
  {
     label:"Marind",
     value:"mrz"
  },
  {
     label:"Malay (macrolanguage)",
     value:"msa",
     "iso6392B":"may",
     "iso6392T":"msa",
     "iso6391":"ms"
  },
  {
     label:"Masbatenyo",
     value:"msb"
  },
  {
     label:"Sankaran Maninka",
     value:"msc"
  },
  {
     label:"Musey",
     value:"mse"
  },
  {
     label:"Mekwei",
     value:"msf"
  },
  {
     label:"Moraid",
     value:"msg"
  },
  {
     label:"Masikoro Malagasy",
     value:"msh"
  },
  {
     label:"Sabah Malay",
     value:"msi"
  },
  {
     label:"Ma (Democratic Republic of Congo)",
     value:"msj"
  },
  {
     label:"Mansaka",
     value:"msk"
  },
  {
     label:"Molof",
     value:"msl"
  },
  {
     label:"Agusan Manobo",
     value:"msm"
  },
  {
     label:"Vur\u00ebs",
     value:"msn"
  },
  {
     label:"Mombum",
     value:"mso"
  },
  {
     label:"Caac",
     value:"msq"
  },
  {
     label:"West Masela",
     value:"mss"
  },
  {
     label:"Musom",
     value:"msu"
  },
  {
     label:"Maslam",
     value:"msv"
  },
  {
     label:"Mansoanka",
     value:"msw"
  },
  {
     label:"Moresada",
     value:"msx"
  },
  {
     label:"Aruamu",
     value:"msy"
  },
  {
     label:"Momare",
     value:"msz"
  },
  {
     label:"Cotabato Manobo",
     value:"mta"
  },
  {
     label:"Anyin Morofo",
     value:"mtb"
  },
  {
     label:"Munit",
     value:"mtc"
  },
  {
     label:"Mualang",
     value:"mtd"
  },
  {
     label:"Mono (Solomon Islands)",
     value:"mte"
  },
  {
     label:"Murik (Papua New Guinea)",
     value:"mtf"
  },
  {
     label:"Una",
     value:"mtg"
  },
  {
     label:"Munggui",
     value:"mth"
  },
  {
     label:"Maiwa (Papua New Guinea)",
     value:"mti"
  },
  {
     label:"Moskona",
     value:"mtj"
  },
  {
     label:"Mbe'",
     value:"mtk"
  },
  {
     label:"Montol",
     value:"mtl"
  },
  {
     label:"Totontepec Mixe",
     value:"mto"
  },
  {
     label:"Wich\u00ed Lhamt\u00e9s Nocten",
     value:"mtp"
  },
  {
     label:"Muong",
     value:"mtq"
  },
  {
     label:"Mewari",
     value:"mtr"
  },
  {
     label:"Yora",
     value:"mts"
  },
  {
     label:"Mota",
     value:"mtt"
  },
  {
     label:"Tututepec Mixtec",
     value:"mtu"
  },
  {
     label:"Asaro'o",
     value:"mtv"
  },
  {
     label:"Southern Binukidnon",
     value:"mtw"
  },
  {
     label:"Tida\u00e1 Mixtec",
     value:"mtx"
  },
  {
     label:"Nabi",
     value:"mty"
  },
  {
     label:"Mundang",
     value:"mua"
  },
  {
     label:"Mubi",
     value:"mub"
  },
  {
     label:"Ajumbu",
     value:"muc"
  },
  {
     label:"Mednyj Aleut",
     value:"mud"
  },
  {
     label:"Media Lengua",
     value:"mue"
  },
  {
     label:"Musgu",
     value:"mug"
  },
  {
     label:"M\u00fcnd\u00fc",
     value:"muh"
  },
  {
     label:"Musi",
     value:"mui"
  },
  {
     label:"Mabire",
     value:"muj"
  },
  {
     label:"Mugom",
     value:"muk"
  },
  {
     label:"Multiple languages",
     value:"mul",
     "iso6392B":"mul",
     "iso6392T":"mul"
  },
  {
     label:"Maiwala",
     value:"mum"
  },
  {
     label:"Nyong",
     value:"muo"
  },
  {
     label:"Malvi",
     value:"mup"
  },
  {
     label:"Eastern Xiangxi Miao",
     value:"muq"
  },
  {
     label:"Murle",
     value:"mur"
  },
  {
     label:"Creek",
     value:"mus",
     "iso6392B":"mus",
     "iso6392T":"mus"
  },
  {
     label:"Western Muria",
     value:"mut"
  },
  {
     label:"Yaaku",
     value:"muu"
  },
  {
     label:"Muthuvan",
     value:"muv"
  },
  {
     label:"Bo-Ung",
     value:"mux"
  },
  {
     label:"Muyang",
     value:"muy"
  },
  {
     label:"Mursi",
     value:"muz"
  },
  {
     label:"Manam",
     value:"mva"
  },
  {
     label:"Mamboru",
     value:"mvd"
  },
  {
     label:"Marwari (Pakistan)",
     value:"mve"
  },
  {
     label:"Peripheral Mongolian",
     value:"mvf"
  },
  {
     label:"Yucua\u00f1e Mixtec",
     value:"mvg"
  },
  {
     label:"Mulgi",
     value:"mvh"
  },
  {
     label:"Miyako",
     value:"mvi"
  },
  {
     label:"Mekmek",
     value:"mvk"
  },
  {
     label:"Muya",
     value:"mvm"
  },
  {
     label:"Minaveha",
     value:"mvn"
  },
  {
     label:"Marovo",
     value:"mvo"
  },
  {
     label:"Duri",
     value:"mvp"
  },
  {
     label:"Moere",
     value:"mvq"
  },
  {
     label:"Marau",
     value:"mvr"
  },
  {
     label:"Massep",
     value:"mvs"
  },
  {
     label:"Mpotovoro",
     value:"mvt"
  },
  {
     label:"Marfa",
     value:"mvu"
  },
  {
     label:"Tagal Murut",
     value:"mvv"
  },
  {
     label:"Machinga",
     value:"mvw"
  },
  {
     label:"Meoswar",
     value:"mvx"
  },
  {
     label:"Indus Kohistani",
     value:"mvy"
  },
  {
     label:"Mesqan",
     value:"mvz"
  },
  {
     label:"Mwatebu",
     value:"mwa"
  },
  {
     label:"Juwal",
     value:"mwb"
  },
  {
     label:"Are",
     value:"mwc"
  },
  {
     label:"Mwera (Chimwera)",
     value:"mwe"
  },
  {
     label:"Murrinh-Patha",
     value:"mwf"
  },
  {
     label:"Aiklep",
     value:"mwg"
  },
  {
     label:"Mouk-Aria",
     value:"mwh"
  },
  {
     label:"Labo",
     value:"mwi"
  },
  {
     label:"Kita Maninkakan",
     value:"mwk"
  },
  {
     label:"Mirandese",
     value:"mwl",
     "iso6392B":"mwl",
     "iso6392T":"mwl"
  },
  {
     label:"Sar",
     value:"mwm"
  },
  {
     label:"Nyamwanga",
     value:"mwn"
  },
  {
     label:"Central Maewo",
     value:"mwo"
  },
  {
     label:"Kala Lagaw Ya",
     value:"mwp"
  },
  {
     label:"M\u00fcn Chin",
     value:"mwq"
  },
  {
     label:"Marwari",
     value:"mwr",
     "iso6392B":"mwr",
     "iso6392T":"mwr"
  },
  {
     label:"Mwimbi-Muthambi",
     value:"mws"
  },
  {
     label:"Moken",
     value:"mwt"
  },
  {
     label:"Mentawai",
     value:"mwv"
  },
  {
     label:"Hmong Daw",
     value:"mww"
  },
  {
     label:"Moingi",
     value:"mwz"
  },
  {
     label:"Northwest Oaxaca Mixtec",
     value:"mxa"
  },
  {
     label:"Tezoatl\u00e1n Mixtec",
     value:"mxb"
  },
  {
     label:"Manyika",
     value:"mxc"
  },
  {
     label:"Modang",
     value:"mxd"
  },
  {
     label:"Mele-Fila",
     value:"mxe"
  },
  {
     label:"Malgbe",
     value:"mxf"
  },
  {
     label:"Mbangala",
     value:"mxg"
  },
  {
     label:"Mvuba",
     value:"mxh"
  },
  {
     label:"Miju-Mishmi",
     value:"mxj"
  },
  {
     label:"Monumbo",
     value:"mxk"
  },
  {
     label:"Maxi Gbe",
     value:"mxl"
  },
  {
     label:"Meramera",
     value:"mxm"
  },
  {
     label:"Moi (Indonesia)",
     value:"mxn"
  },
  {
     label:"Mbowe",
     value:"mxo"
  },
  {
     label:"Tlahuitoltepec Mixe",
     value:"mxp"
  },
  {
     label:"Juquila Mixe",
     value:"mxq"
  },
  {
     label:"Murik (Malaysia)",
     value:"mxr"
  },
  {
     label:"Huitepec Mixtec",
     value:"mxs"
  },
  {
     label:"Jamiltepec Mixtec",
     value:"mxt"
  },
  {
     label:"Mada (Cameroon)",
     value:"mxu"
  },
  {
     label:"Metlat\u00f3noc Mixtec",
     value:"mxv"
  },
  {
     label:"Namo",
     value:"mxw"
  },
  {
     label:"Mahou",
     value:"mxx"
  },
  {
     label:"Southeastern Nochixtl\u00e1n Mixtec",
     value:"mxy"
  },
  {
     label:"Central Masela",
     value:"mxz"
  },
  {
     label:"Burmese",
     value:"mya",
     "iso6392B":"bur",
     "iso6392T":"mya",
     "iso6391":"my"
  },
  {
     label:"Mbay",
     value:"myb"
  },
  {
     label:"Mayeka",
     value:"myc"
  },
  {
     label:"Myene",
     value:"mye"
  },
  {
     label:"Bambassi",
     value:"myf"
  },
  {
     label:"Manta",
     value:"myg"
  },
  {
     label:"Makah",
     value:"myh"
  },
  {
     label:"Mangayat",
     value:"myj"
  },
  {
     label:"Mamara Senoufo",
     value:"myk"
  },
  {
     label:"Moma",
     value:"myl"
  },
  {
     label:"Me'en",
     value:"mym"
  },
  {
     label:"Anfillo",
     value:"myo"
  },
  {
     label:"Pirah\u00e3",
     value:"myp"
  },
  {
     label:"Muniche",
     value:"myr"
  },
  {
     label:"Munduruk\u00fa",
     value:"myu"
  },
  {
     label:"Erzya",
     value:"myv",
     "iso6392B":"myv",
     "iso6392T":"myv"
  },
  {
     label:"Muyuw",
     value:"myw"
  },
  {
     label:"Masaaba",
     value:"myx"
  },
  {
     label:"Macuna",
     value:"myy"
  },
  {
     label:"Santa Mar\u00eda Zacatepec Mixtec",
     value:"mza"
  },
  {
     label:"Tumzabt",
     value:"mzb"
  },
  {
     label:"Malimba",
     value:"mzd"
  },
  {
     label:"Morawa",
     value:"mze"
  },
  {
     label:"Wich\u00ed Lhamt\u00e9s G\u00fcisnay",
     value:"mzh"
  },
  {
     label:"Ixcatl\u00e1n Mazatec",
     value:"mzi"
  },
  {
     label:"Manya",
     value:"mzj"
  },
  {
     label:"Nigeria Mambila",
     value:"mzk"
  },
  {
     label:"Mazatl\u00e1n Mixe",
     value:"mzl"
  },
  {
     label:"Mumuye",
     value:"mzm"
  },
  {
     label:"Mazanderani",
     value:"mzn"
  },
  {
     label:"Movima",
     value:"mzp"
  },
  {
     label:"Mori Atas",
     value:"mzq"
  },
  {
     label:"Mar\u00fabo",
     value:"mzr"
  },
  {
     label:"Macanese",
     value:"mzs"
  },
  {
     label:"Mintil",
     value:"mzt"
  },
  {
     label:"Inapang",
     value:"mzu"
  },
  {
     label:"Manza",
     value:"mzv"
  },
  {
     label:"Deg",
     value:"mzw"
  },
  {
     label:"Mawayana",
     value:"mzx"
  },
  {
     label:"Maiadomu",
     value:"mzz"
  },
  {
     label:"Namla",
     value:"naa"
  },
  {
     label:"Southern Nambiku\u00e1ra",
     value:"nab"
  },
  {
     label:"Narak",
     value:"nac"
  },
  {
     label:"Nabak",
     value:"naf"
  },
  {
     label:"Naga Pidgin",
     value:"nag"
  },
  {
     label:"Nalu",
     value:"naj"
  },
  {
     label:"Nakanai",
     value:"nak"
  },
  {
     label:"Nalik",
     value:"nal"
  },
  {
     label:"Ngan'gityemerri",
     value:"nam"
  },
  {
     label:"Min Nan Chinese",
     value:"nan"
  },
  {
     label:"Naaba",
     value:"nao"
  },
  {
     label:"Neapolitan",
     value:"nap",
     "iso6392B":"nap",
     "iso6392T":"nap"
  },
  {
     label:"Khoekhoe",
     value:"naq"
  },
  {
     label:"Iguta",
     value:"nar"
  },
  {
     label:"Naasioi",
     value:"nas"
  },
  {
     label:"Ca\u0331hungwa\u0331rya\u0331",
     value:"nat"
  },
  {
     label:"Nauru",
     value:"nau",
     "iso6392B":"nau",
     "iso6392T":"nau",
     "iso6391":"na"
  },
  {
     label:"Navajo",
     value:"nav",
     "iso6392B":"nav",
     "iso6392T":"nav",
     "iso6391":"nv"
  },
  {
     label:"Nawuri",
     value:"naw"
  },
  {
     label:"Nakwi",
     value:"nax"
  },
  {
     label:"Coatepec Nahuatl",
     value:"naz"
  },
  {
     label:"Nyemba",
     value:"nba"
  },
  {
     label:"Ndoe",
     value:"nbb"
  },
  {
     label:"Chang Naga",
     value:"nbc"
  },
  {
     label:"Ngbinda",
     value:"nbd"
  },
  {
     label:"Konyak Naga",
     value:"nbe"
  },
  {
     label:"Nagarchal",
     value:"nbg"
  },
  {
     label:"Ngamo",
     value:"nbh"
  },
  {
     label:"Mao Naga",
     value:"nbi"
  },
  {
     label:"Ngarinyman",
     value:"nbj"
  },
  {
     label:"Nake",
     value:"nbk"
  },
  {
     label:"South Ndebele",
     value:"nbl",
     "iso6392B":"nbl",
     "iso6392T":"nbl",
     "iso6391":"nr"
  },
  {
     label:"Ngbaka Ma'bo",
     value:"nbm"
  },
  {
     label:"Kuri",
     value:"nbn"
  },
  {
     label:"Nkukoli",
     value:"nbo"
  },
  {
     label:"Nnam",
     value:"nbp"
  },
  {
     label:"Nggem",
     value:"nbq"
  },
  {
     label:"Numana",
     value:"nbr"
  },
  {
     label:"Na",
     value:"nbt"
  },
  {
     label:"Rongmei Naga",
     value:"nbu"
  },
  {
     label:"Ngamambo",
     value:"nbv"
  },
  {
     label:"Southern Ngbandi",
     value:"nbw"
  },
  {
     label:"Ningera",
     value:"nby"
  },
  {
     label:"Iyo",
     value:"nca"
  },
  {
     label:"Central Nicobarese",
     value:"ncb"
  },
  {
     label:"Ponam",
     value:"ncc"
  },
  {
     label:"Nachering",
     value:"ncd"
  },
  {
     label:"Yale",
     value:"nce"
  },
  {
     label:"Notsi",
     value:"ncf"
  },
  {
     label:"Nisga'a",
     value:"ncg"
  },
  {
     label:"Central Huasteca Nahuatl",
     value:"nch"
  },
  {
     label:"Northern Puebla Nahuatl",
     value:"ncj"
  },
  {
     label:"Na-kara",
     value:"nck"
  },
  {
     label:"Michoac\u00e1n Nahuatl",
     value:"ncl"
  },
  {
     label:"Nambo",
     value:"ncm"
  },
  {
     label:"Nauna",
     value:"ncn"
  },
  {
     label:"Sibe",
     value:"nco"
  },
  {
     label:"Northern Katang",
     value:"ncq"
  },
  {
     label:"Ncane",
     value:"ncr"
  },
  {
     label:"Chothe Naga",
     value:"nct"
  },
  {
     label:"Chumburung",
     value:"ncu"
  },
  {
     label:"Central Puebla Nahuatl",
     value:"ncx"
  },
  {
     label:"Ndasa",
     value:"nda"
  },
  {
     label:"Kenswei Nsei",
     value:"ndb"
  },
  {
     label:"Ndau",
     value:"ndc"
  },
  {
     label:"Nde-Nsele-Nta",
     value:"ndd"
  },
  {
     label:"North Ndebele",
     value:"nde",
     "iso6392B":"nde",
     "iso6392T":"nde",
     "iso6391":"nd"
  },
  {
     label:"Ndengereko",
     value:"ndg"
  },
  {
     label:"Ndali",
     value:"ndh"
  },
  {
     label:"Samba Leko",
     value:"ndi"
  },
  {
     label:"Ndamba",
     value:"ndj"
  },
  {
     label:"Ndaka",
     value:"ndk"
  },
  {
     label:"Ndolo",
     value:"ndl"
  },
  {
     label:"Ndam",
     value:"ndm"
  },
  {
     label:"Ngundi",
     value:"ndn"
  },
  {
     label:"Ndonga",
     value:"ndo",
     "iso6392B":"ndo",
     "iso6392T":"ndo",
     "iso6391":"ng"
  },
  {
     label:"Ndo",
     value:"ndp"
  },
  {
     label:"Ndombe",
     value:"ndq"
  },
  {
     label:"Ndoola",
     value:"ndr"
  },
  {
     label:"Low German",
     value:"nds",
     "iso6392B":"nds",
     "iso6392T":"nds"
  },
  {
     label:"Ndunga",
     value:"ndt"
  },
  {
     label:"Dugun",
     value:"ndu"
  },
  {
     label:"Ndut",
     value:"ndv"
  },
  {
     label:"Ndobo",
     value:"ndw"
  },
  {
     label:"Nduga",
     value:"ndx"
  },
  {
     label:"Lutos",
     value:"ndy"
  },
  {
     label:"Ndogo",
     value:"ndz"
  },
  {
     label:"Eastern Ngad'a",
     value:"nea"
  },
  {
     label:"Toura (C\u00f4te d'Ivoire)",
     value:"neb"
  },
  {
     label:"Nedebang",
     value:"nec"
  },
  {
     label:"Nde-Gbite",
     value:"ned"
  },
  {
     label:"N\u00eal\u00eamwa-Nixumwak",
     value:"nee"
  },
  {
     label:"Nefamese",
     value:"nef"
  },
  {
     label:"Negidal",
     value:"neg"
  },
  {
     label:"Nyenkha",
     value:"neh"
  },
  {
     label:"Neko",
     value:"nej"
  },
  {
     label:"Neku",
     value:"nek"
  },
  {
     label:"Nemi",
     value:"nem"
  },
  {
     label:"Nengone",
     value:"nen"
  },
  {
     label:"N\u00e1-Meo",
     value:"neo"
  },
  {
     label:"Nepali (macrolanguage)",
     value:"nep",
     "iso6392B":"nep",
     "iso6392T":"nep",
     "iso6391":"ne"
  },
  {
     label:"North Central Mixe",
     value:"neq"
  },
  {
     label:"Yahadian",
     value:"ner"
  },
  {
     label:"Bhoti Kinnauri",
     value:"nes"
  },
  {
     label:"Nete",
     value:"net"
  },
  {
     label:"Neo",
     value:"neu"
  },
  {
     label:"Nyaheun",
     value:"nev"
  },
  {
     label:"Newari",
     value:"new",
     "iso6392B":"new",
     "iso6392T":"new"
  },
  {
     label:"Neme",
     value:"nex"
  },
  {
     label:"Neyo",
     value:"ney"
  },
  {
     label:"Nez Perce",
     value:"nez"
  },
  {
     label:"Dhao",
     value:"nfa"
  },
  {
     label:"Ahwai",
     value:"nfd"
  },
  {
     label:"Ayiwo",
     value:"nfl"
  },
  {
     label:"Nafaanra",
     value:"nfr"
  },
  {
     label:"Mfumte",
     value:"nfu"
  },
  {
     label:"Ngbaka",
     value:"nga"
  },
  {
     label:"Northern Ngbandi",
     value:"ngb"
  },
  {
     label:"Ngombe (Democratic Republic of Congo)",
     value:"ngc"
  },
  {
     label:"Ngando (Central African Republic)",
     value:"ngd"
  },
  {
     label:"Ngemba",
     value:"nge"
  },
  {
     label:"Ngbaka Manza",
     value:"ngg"
  },
  {
     label:"N\u01c1ng",
     value:"ngh"
  },
  {
     label:"Ngizim",
     value:"ngi"
  },
  {
     label:"Ngie",
     value:"ngj"
  },
  {
     label:"Dalabon",
     value:"ngk"
  },
  {
     label:"Lomwe",
     value:"ngl"
  },
  {
     label:"Ngatik Men's Creole",
     value:"ngm"
  },
  {
     label:"Ngwo",
     value:"ngn"
  },
  {
     label:"Ngoni",
     value:"ngo"
  },
  {
     label:"Ngulu",
     value:"ngp"
  },
  {
     label:"Ngurimi",
     value:"ngq"
  },
  {
     label:"Engdewu",
     value:"ngr"
  },
  {
     label:"Gvoko",
     value:"ngs"
  },
  {
     label:"Kriang",
     value:"ngt"
  },
  {
     label:"Guerrero Nahuatl",
     value:"ngu"
  },
  {
     label:"Ngwaba",
     value:"ngw"
  },
  {
     label:"Nggwahyi",
     value:"ngx"
  },
  {
     label:"Tibea",
     value:"ngy"
  },
  {
     label:"Ngungwel",
     value:"ngz"
  },
  {
     label:"Nhanda",
     value:"nha"
  },
  {
     label:"Beng",
     value:"nhb"
  },
  {
     label:"Chirip\u00e1",
     value:"nhd"
  },
  {
     label:"Eastern Huasteca Nahuatl",
     value:"nhe"
  },
  {
     label:"Nhuwala",
     value:"nhf"
  },
  {
     label:"Tetelcingo Nahuatl",
     value:"nhg"
  },
  {
     label:"Nahari",
     value:"nhh"
  },
  {
     label:"Zacatl\u00e1n-Ahuacatl\u00e1n-Tepetzintla Nahuatl",
     value:"nhi"
  },
  {
     label:"Isthmus-Cosoleacaque Nahuatl",
     value:"nhk"
  },
  {
     label:"Morelos Nahuatl",
     value:"nhm"
  },
  {
     label:"Central Nahuatl",
     value:"nhn"
  },
  {
     label:"Takuu",
     value:"nho"
  },
  {
     label:"Isthmus-Pajapan Nahuatl",
     value:"nhp"
  },
  {
     label:"Huaxcaleca Nahuatl",
     value:"nhq"
  },
  {
     label:"Naro",
     value:"nhr"
  },
  {
     label:"Ometepec Nahuatl",
     value:"nht"
  },
  {
     label:"Noone",
     value:"nhu"
  },
  {
     label:"Temascaltepec Nahuatl",
     value:"nhv"
  },
  {
     label:"Western Huasteca Nahuatl",
     value:"nhw"
  },
  {
     label:"Isthmus-Mecayapan Nahuatl",
     value:"nhx"
  },
  {
     label:"Northern Oaxaca Nahuatl",
     value:"nhy"
  },
  {
     label:"Santa Mar\u00eda La Alta Nahuatl",
     value:"nhz"
  },
  {
     label:"Nias",
     value:"nia",
     "iso6392B":"nia",
     "iso6392T":"nia"
  },
  {
     label:"Nakame",
     value:"nib"
  },
  {
     label:"Niellim",
     value:"nie"
  },
  {
     label:"Nek",
     value:"nif"
  },
  {
     label:"Nyiha (Tanzania)",
     value:"nih"
  },
  {
     label:"Nii",
     value:"nii"
  },
  {
     label:"Ngaju",
     value:"nij"
  },
  {
     label:"Southern Nicobarese",
     value:"nik"
  },
  {
     label:"Nila",
     value:"nil"
  },
  {
     label:"Nilamba",
     value:"nim"
  },
  {
     label:"Ninzo",
     value:"nin"
  },
  {
     label:"Nganasan",
     value:"nio"
  },
  {
     label:"Nandi",
     value:"niq"
  },
  {
     label:"Nimboran",
     value:"nir"
  },
  {
     label:"Nimi",
     value:"nis"
  },
  {
     label:"Southeastern Kolami",
     value:"nit"
  },
  {
     label:"Niuean",
     value:"niu",
     "iso6392B":"niu",
     "iso6392T":"niu"
  },
  {
     label:"Gilyak",
     value:"niv"
  },
  {
     label:"Nimo",
     value:"niw"
  },
  {
     label:"Hema",
     value:"nix"
  },
  {
     label:"Ngiti",
     value:"niy"
  },
  {
     label:"Ningil",
     value:"niz"
  },
  {
     label:"Nzanyi",
     value:"nja"
  },
  {
     label:"Nocte Naga",
     value:"njb"
  },
  {
     label:"Ndonde Hamba",
     value:"njd"
  },
  {
     label:"Lotha Naga",
     value:"njh"
  },
  {
     label:"Gudanji",
     value:"nji"
  },
  {
     label:"Njen",
     value:"njj"
  },
  {
     label:"Njalgulgule",
     value:"njl"
  },
  {
     label:"Angami Naga",
     value:"njm"
  },
  {
     label:"Liangmai Naga",
     value:"njn"
  },
  {
     label:"Ao Naga",
     value:"njo"
  },
  {
     label:"Njerep",
     value:"njr"
  },
  {
     label:"Nisa",
     value:"njs"
  },
  {
     label:"Ndyuka-Trio Pidgin",
     value:"njt"
  },
  {
     label:"Ngadjunmaya",
     value:"nju"
  },
  {
     label:"Kunyi",
     value:"njx"
  },
  {
     label:"Njyem",
     value:"njy"
  },
  {
     label:"Nyishi",
     value:"njz"
  },
  {
     label:"Nkoya",
     value:"nka"
  },
  {
     label:"Khoibu Naga",
     value:"nkb"
  },
  {
     label:"Nkongho",
     value:"nkc"
  },
  {
     label:"Koireng",
     value:"nkd"
  },
  {
     label:"Duke",
     value:"nke"
  },
  {
     label:"Inpui Naga",
     value:"nkf"
  },
  {
     label:"Nekgini",
     value:"nkg"
  },
  {
     label:"Khezha Naga",
     value:"nkh"
  },
  {
     label:"Thangal Naga",
     value:"nki"
  },
  {
     label:"Nakai",
     value:"nkj"
  },
  {
     label:"Nokuku",
     value:"nkk"
  },
  {
     label:"Namat",
     value:"nkm"
  },
  {
     label:"Nkangala",
     value:"nkn"
  },
  {
     label:"Nkonya",
     value:"nko"
  },
  {
     label:"Nkami",
     value:"nkq"
  },
  {
     label:"Nukuoro",
     value:"nkr"
  },
  {
     label:"North Asmat",
     value:"nks"
  },
  {
     label:"Nyika (Tanzania)",
     value:"nkt"
  },
  {
     label:"Bouna Kulango",
     value:"nku"
  },
  {
     label:"Nyika (Malawi and Zambia)",
     value:"nkv"
  },
  {
     label:"Nkutu",
     value:"nkw"
  },
  {
     label:"Nkoroo",
     value:"nkx"
  },
  {
     label:"Nkari",
     value:"nkz"
  },
  {
     label:"Ngombale",
     value:"nla"
  },
  {
     label:"Nalca",
     value:"nlc"
  },
  {
     label:"Dutch",
     value:"nld",
     "iso6392B":"dut",
     "iso6392T":"nld",
     "iso6391":"nl"
  },
  {
     label:"East Nyala",
     value:"nle"
  },
  {
     label:"Gela",
     value:"nlg"
  },
  {
     label:"Grangali",
     value:"nli"
  },
  {
     label:"Nyali",
     value:"nlj"
  },
  {
     label:"Ninia Yali",
     value:"nlk"
  },
  {
     label:"Nihali",
     value:"nll"
  },
  {
     label:"Mankiyali",
     value:"nlm"
  },
  {
     label:"Ngul",
     value:"nlo"
  },
  {
     label:"Lao Naga",
     value:"nlq"
  },
  {
     label:"Nchumbulu",
     value:"nlu"
  },
  {
     label:"Orizaba Nahuatl",
     value:"nlv"
  },
  {
     label:"Nahali",
     value:"nlx"
  },
  {
     label:"Nyamal",
     value:"nly"
  },
  {
     label:"Nal\u00f6go",
     value:"nlz"
  },
  {
     label:"Maram Naga",
     value:"nma"
  },
  {
     label:"Big Nambas",
     value:"nmb"
  },
  {
     label:"Ngam",
     value:"nmc"
  },
  {
     label:"Ndumu",
     value:"nmd"
  },
  {
     label:"Mzieme Naga",
     value:"nme"
  },
  {
     label:"Tangkhul Naga (India)",
     value:"nmf"
  },
  {
     label:"Kwasio",
     value:"nmg"
  },
  {
     label:"Monsang Naga",
     value:"nmh"
  },
  {
     label:"Nyam",
     value:"nmi"
  },
  {
     label:"Ngombe (Central African Republic)",
     value:"nmj"
  },
  {
     label:"Namakura",
     value:"nmk"
  },
  {
     label:"Ndemli",
     value:"nml"
  },
  {
     label:"Manangba",
     value:"nmm"
  },
  {
     label:"\u01c3X\u00f3\u00f5",
     value:"nmn"
  },
  {
     label:"Moyon Naga",
     value:"nmo"
  },
  {
     label:"Nambya",
     value:"nmq"
  },
  {
     label:"Letemboi",
     value:"nms"
  },
  {
     label:"Namonuito",
     value:"nmt"
  },
  {
     label:"Northeast Maidu",
     value:"nmu"
  },
  {
     label:"Nimoa",
     value:"nmw"
  },
  {
     label:"Nama (Papua New Guinea)",
     value:"nmx"
  },
  {
     label:"Namuyi",
     value:"nmy"
  },
  {
     label:"Nawdm",
     value:"nmz"
  },
  {
     label:"Nyangumarta",
     value:"nna"
  },
  {
     label:"Nande",
     value:"nnb"
  },
  {
     label:"Nancere",
     value:"nnc"
  },
  {
     label:"West Ambae",
     value:"nnd"
  },
  {
     label:"Ngandyera",
     value:"nne"
  },
  {
     label:"Ngaing",
     value:"nnf"
  },
  {
     label:"Maring Naga",
     value:"nng"
  },
  {
     label:"Ngiemboon",
     value:"nnh"
  },
  {
     label:"North Nuaulu",
     value:"nni"
  },
  {
     label:"Nyangatom",
     value:"nnj"
  },
  {
     label:"Nankina",
     value:"nnk"
  },
  {
     label:"Northern Rengma Naga",
     value:"nnl"
  },
  {
     label:"Namia",
     value:"nnm"
  },
  {
     label:"Ngete",
     value:"nnn"
  },
  {
     label:"Norwegian Nynorsk",
     value:"nno",
     "iso6392B":"nno",
     "iso6392T":"nno",
     "iso6391":"nn"
  },
  {
     label:"Wancho Naga",
     value:"nnp"
  },
  {
     label:"Ngindo",
     value:"nnq"
  },
  {
     label:"Dwang",
     value:"nnu"
  },
  {
     label:"Southern Nuni",
     value:"nnw"
  },
  {
     label:"Nda'nda'",
     value:"nnz"
  },
  {
     label:"Woun Meu",
     value:"noa"
  },
  {
     label:"Norwegian Bokm\u00e5l",
     value:"nob",
     "iso6392B":"nob",
     "iso6392T":"nob",
     "iso6391":"nb"
  },
  {
     label:"Nuk",
     value:"noc"
  },
  {
     label:"Northern Thai",
     value:"nod"
  },
  {
     label:"Nimadi",
     value:"noe"
  },
  {
     label:"Nomane",
     value:"nof"
  },
  {
     label:"Nogai",
     value:"nog",
     "iso6392B":"nog",
     "iso6392T":"nog"
  },
  {
     label:"Nomu",
     value:"noh"
  },
  {
     label:"Noiri",
     value:"noi"
  },
  {
     label:"Nonuya",
     value:"noj"
  },
  {
     label:"Numanggang",
     value:"nop"
  },
  {
     label:"Ngongo",
     value:"noq"
  },
  {
     label:"Norwegian",
     value:"nor",
     "iso6392B":"nor",
     "iso6392T":"nor",
     "iso6391":"no"
  },
  {
     label:"Eastern Nisu",
     value:"nos"
  },
  {
     label:"Nomatsiguenga",
     value:"not"
  },
  {
     label:"Ewage-Notu",
     value:"nou"
  },
  {
     label:"Novial",
     value:"nov"
  },
  {
     label:"Nyambo",
     value:"now"
  },
  {
     label:"Noy",
     value:"noy"
  },
  {
     label:"Nayi",
     value:"noz"
  },
  {
     label:"Nar Phu",
     value:"npa"
  },
  {
     label:"Nupbikha",
     value:"npb"
  },
  {
     label:"Ponyo-Gongwang Naga",
     value:"npg"
  },
  {
     label:"Phom Naga",
     value:"nph"
  },
  {
     label:"Nepali (individual language)",
     value:"npi"
  },
  {
     label:"Southeastern Puebla Nahuatl",
     value:"npl"
  },
  {
     label:"Mondropolon",
     value:"npn"
  },
  {
     label:"Pochuri Naga",
     value:"npo"
  },
  {
     label:"Nipsan",
     value:"nps"
  },
  {
     label:"Puimei Naga",
     value:"npu"
  },
  {
     label:"Noipx",
     value:"npx"
  },
  {
     label:"Napu",
     value:"npy"
  },
  {
     label:"Southern Nago",
     value:"nqg"
  },
  {
     label:"Kura Ede Nago",
     value:"nqk"
  },
  {
     label:"Ngendelengo",
     value:"nql"
  },
  {
     label:"Ndom",
     value:"nqm"
  },
  {
     label:"Nen",
     value:"nqn"
  },
  {
     label:"N'Ko",
     value:"nqo",
     "iso6392B":"nqo",
     "iso6392T":"nqo"
  },
  {
     label:"Kyan-Karyaw Naga",
     value:"nqq"
  },
  {
     label:"Akyaung Ari Naga",
     value:"nqy"
  },
  {
     label:"Ngom",
     value:"nra"
  },
  {
     label:"Nara",
     value:"nrb"
  },
  {
     label:"Southern Rengma Naga",
     value:"nre"
  },
  {
     label:"J\u00e8rriais",
     value:"nrf"
  },
  {
     label:"Narango",
     value:"nrg"
  },
  {
     label:"Chokri Naga",
     value:"nri"
  },
  {
     label:"Ngarla",
     value:"nrk"
  },
  {
     label:"Ngarluma",
     value:"nrl"
  },
  {
     label:"Narom",
     value:"nrm"
  },
  {
     label:"Narua",
     value:"nru"
  },
  {
     label:"Lala",
     value:"nrz"
  },
  {
     label:"Sangtam Naga",
     value:"nsa"
  },
  {
     label:"Nshi",
     value:"nsc"
  },
  {
     label:"Southern Nisu",
     value:"nsd"
  },
  {
     label:"Nsenga",
     value:"nse"
  },
  {
     label:"Northwestern Nisu",
     value:"nsf"
  },
  {
     label:"Ngasa",
     value:"nsg"
  },
  {
     label:"Ngoshie",
     value:"nsh"
  },
  {
     label:"Naskapi",
     value:"nsk"
  },
  {
     label:"Sumi Naga",
     value:"nsm"
  },
  {
     label:"Nehan",
     value:"nsn"
  },
  {
     label:"Pedi",
     value:"nso",
     "iso6392B":"nso",
     "iso6392T":"nso"
  },
  {
     label:"Northern Sierra Miwok",
     value:"nsq"
  },
  {
     label:"Nali",
     value:"nss"
  },
  {
     label:"Tase Naga",
     value:"nst"
  },
  {
     label:"Sierra Negra Nahuatl",
     value:"nsu"
  },
  {
     label:"Southwestern Nisu",
     value:"nsv"
  },
  {
     label:"Navut",
     value:"nsw"
  },
  {
     label:"Nsongo",
     value:"nsx"
  },
  {
     label:"Nasal",
     value:"nsy"
  },
  {
     label:"Nisenan",
     value:"nsz"
  },
  {
     label:"Northern Tidung",
     value:"ntd"
  },
  {
     label:"Nathembo",
     value:"nte"
  },
  {
     label:"Natioro",
     value:"nti"
  },
  {
     label:"Ngaanyatjarra",
     value:"ntj"
  },
  {
     label:"Ikoma-Nata-Isenye",
     value:"ntk"
  },
  {
     label:"Nateni",
     value:"ntm"
  },
  {
     label:"Ntomba",
     value:"nto"
  },
  {
     label:"Northern Tepehuan",
     value:"ntp"
  },
  {
     label:"Delo",
     value:"ntr"
  },
  {
     label:"Nat\u00fcgu",
     value:"ntu"
  },
  {
     label:"Tangkhul Naga (Myanmar)",
     value:"ntx"
  },
  {
     label:"Mantsi",
     value:"nty"
  },
  {
     label:"Natanzi",
     value:"ntz"
  },
  {
     label:"Yuanga",
     value:"nua"
  },
  {
     label:"Ngala",
     value:"nud"
  },
  {
     label:"Ngundu",
     value:"nue"
  },
  {
     label:"Nusu",
     value:"nuf"
  },
  {
     label:"Ndunda",
     value:"nuh"
  },
  {
     label:"Ngumbi",
     value:"nui"
  },
  {
     label:"Nyole",
     value:"nuj"
  },
  {
     label:"Nuu-chah-nulth",
     value:"nuk"
  },
  {
     label:"Niuafo'ou",
     value:"num"
  },
  {
     label:"Anong",
     value:"nun"
  },
  {
     label:"Ngu\u00f4n",
     value:"nuo"
  },
  {
     label:"Nupe-Nupe-Tako",
     value:"nup"
  },
  {
     label:"Nukumanu",
     value:"nuq"
  },
  {
     label:"Nukuria",
     value:"nur"
  },
  {
     label:"Nuer",
     value:"nus"
  },
  {
     label:"Nung (Viet Nam)",
     value:"nut"
  },
  {
     label:"Ngbundu",
     value:"nuu"
  },
  {
     label:"Northern Nuni",
     value:"nuv"
  },
  {
     label:"Nguluwan",
     value:"nuw"
  },
  {
     label:"Mehek",
     value:"nux"
  },
  {
     label:"Nunggubuyu",
     value:"nuy"
  },
  {
     label:"Tlamacazapa Nahuatl",
     value:"nuz"
  },
  {
     label:"Nasarian",
     value:"nvh"
  },
  {
     label:"Namiae",
     value:"nvm"
  },
  {
     label:"Nyokon",
     value:"nvo"
  },
  {
     label:"Nyabwa",
     value:"nwb"
  },
  {
     label:"Ngwe",
     value:"nwe"
  },
  {
     label:"Southwest Tanna",
     value:"nwi"
  },
  {
     label:"Nyamusa-Molo",
     value:"nwm"
  },
  {
     label:"Nawaru",
     value:"nwr"
  },
  {
     label:"Nauete",
     value:"nxa"
  },
  {
     label:"Ngando (Democratic Republic of Congo)",
     value:"nxd"
  },
  {
     label:"Nage",
     value:"nxe"
  },
  {
     label:"Ngad'a",
     value:"nxg"
  },
  {
     label:"Nindi",
     value:"nxi"
  },
  {
     label:"Koki Naga",
     value:"nxk"
  },
  {
     label:"South Nuaulu",
     value:"nxl"
  },
  {
     label:"Ndambomo",
     value:"nxo"
  },
  {
     label:"Naxi",
     value:"nxq"
  },
  {
     label:"Ninggerum",
     value:"nxr"
  },
  {
     label:"Nafri",
     value:"nxx"
  },
  {
     label:"Nyanja",
     value:"nya",
     "iso6392B":"nya",
     "iso6392T":"nya",
     "iso6391":"ny"
  },
  {
     label:"Nyangbo",
     value:"nyb"
  },
  {
     label:"Nyanga-li",
     value:"nyc"
  },
  {
     label:"Nyore",
     value:"nyd"
  },
  {
     label:"Nyengo",
     value:"nye"
  },
  {
     label:"Giryama",
     value:"nyf"
  },
  {
     label:"Nyindu",
     value:"nyg"
  },
  {
     label:"Nyikina",
     value:"nyh"
  },
  {
     label:"Ama (Sudan)",
     value:"nyi"
  },
  {
     label:"Nyanga",
     value:"nyj"
  },
  {
     label:"Nyaneka",
     value:"nyk"
  },
  {
     label:"Nyeu",
     value:"nyl"
  },
  {
     label:"Nyamwezi",
     value:"nym",
     "iso6392B":"nym",
     "iso6392T":"nym"
  },
  {
     label:"Nyankole",
     value:"nyn",
     "iso6392B":"nyn",
     "iso6392T":"nyn"
  },
  {
     label:"Nyoro",
     value:"nyo",
     "iso6392B":"nyo",
     "iso6392T":"nyo"
  },
  {
     label:"Nayini",
     value:"nyq"
  },
  {
     label:"Nyiha (Malawi)",
     value:"nyr"
  },
  {
     label:"Nyungar",
     value:"nys"
  },
  {
     label:"Nyungwe",
     value:"nyu"
  },
  {
     label:"Nyaw",
     value:"nyw"
  },
  {
     label:"Nyakyusa-Ngonde",
     value:"nyy"
  },
  {
     label:"Tigon Mbembe",
     value:"nza"
  },
  {
     label:"Njebi",
     value:"nzb"
  },
  {
     label:"Nzadi",
     value:"nzd"
  },
  {
     label:"Nzima",
     value:"nzi",
     "iso6392B":"nzi",
     "iso6392T":"nzi"
  },
  {
     label:"Nzakara",
     value:"nzk"
  },
  {
     label:"Zeme Naga",
     value:"nzm"
  },
  {
     label:"Teke-Nzikou",
     value:"nzu"
  },
  {
     label:"Nzakambay",
     value:"nzy"
  },
  {
     label:"Nanga Dama Dogon",
     value:"nzz"
  },
  {
     label:"Orok",
     value:"oaa"
  },
  {
     label:"Oroch",
     value:"oac"
  },
  {
     label:"Southern Bontok",
     value:"obk"
  },
  {
     label:"Oblo",
     value:"obl"
  },
  {
     label:"Obo Manobo",
     value:"obo"
  },
  {
     label:"Obulom",
     value:"obu"
  },
  {
     label:"Ocaina",
     value:"oca"
  },
  {
     label:"Occitan (post 1500)",
     value:"oci",
     "iso6392B":"oci",
     "iso6392T":"oci",
     "iso6391":"oc"
  },
  {
     label:"Atzingo Matlatzinca",
     value:"ocu"
  },
  {
     label:"Odut",
     value:"oda"
  },
  {
     label:"Od",
     value:"odk"
  },
  {
     label:"Odual",
     value:"odu"
  },
  {
     label:"Efutop",
     value:"ofu"
  },
  {
     label:"Ogbia",
     value:"ogb"
  },
  {
     label:"Ogbah",
     value:"ogc"
  },
  {
     label:"Ogbogolo",
     value:"ogg"
  },
  {
     label:"Khana",
     value:"ogo"
  },
  {
     label:"Ogbronuagum",
     value:"ogu"
  },
  {
     label:"Oirata",
     value:"oia"
  },
  {
     label:"Inebu One",
     value:"oin"
  },
  {
     label:"Northwestern Ojibwa",
     value:"ojb"
  },
  {
     label:"Central Ojibwa",
     value:"ojc"
  },
  {
     label:"Eastern Ojibwa",
     value:"ojg"
  },
  {
     label:"Ojibwa",
     value:"oji",
     "iso6392B":"oji",
     "iso6392T":"oji",
     "iso6391":"oj"
  },
  {
     label:"Severn Ojibwa",
     value:"ojs"
  },
  {
     label:"Ontong Java",
     value:"ojv"
  },
  {
     label:"Western Ojibwa",
     value:"ojw"
  },
  {
     label:"Okanagan",
     value:"oka"
  },
  {
     label:"Okobo",
     value:"okb"
  },
  {
     label:"Okodia",
     value:"okd"
  },
  {
     label:"Okpe (Southwestern Edo)",
     value:"oke"
  },
  {
     label:"Koresh-e Rostam",
     value:"okh"
  },
  {
     label:"Okiek",
     value:"oki"
  },
  {
     label:"Kwamtim One",
     value:"okk"
  },
  {
     label:"Oki-No-Erabu",
     value:"okn"
  },
  {
     label:"Kirike",
     value:"okr"
  },
  {
     label:"Oko-Eni-Osayen",
     value:"oks"
  },
  {
     label:"Oku",
     value:"oku"
  },
  {
     label:"Orokaiva",
     value:"okv"
  },
  {
     label:"Okpe (Northwestern Edo)",
     value:"okx"
  },
  {
     label:"Walungge",
     value:"ola"
  },
  {
     label:"Mochi",
     value:"old"
  },
  {
     label:"Olekha",
     value:"ole"
  },
  {
     label:"Oloma",
     value:"olm"
  },
  {
     label:"Livvi",
     value:"olo"
  },
  {
     label:"Olrat",
     value:"olr"
  },
  {
     label:"Kuvale",
     value:"olu"
  },
  {
     label:"Omaha-Ponca",
     value:"oma"
  },
  {
     label:"East Ambae",
     value:"omb"
  },
  {
     label:"Omagua",
     value:"omg"
  },
  {
     label:"Omi",
     value:"omi"
  },
  {
     label:"Ombo",
     value:"oml"
  },
  {
     label:"Utarmbung",
     value:"omo"
  },
  {
     label:"Omotik",
     value:"omt"
  },
  {
     label:"South Tairora",
     value:"omw"
  },
  {
     label:"Ona",
     value:"ona"
  },
  {
     label:"Lingao",
     value:"onb"
  },
  {
     label:"Oneida",
     value:"one"
  },
  {
     label:"Olo",
     value:"ong"
  },
  {
     label:"Onin",
     value:"oni"
  },
  {
     label:"Onjob",
     value:"onj"
  },
  {
     label:"Kabore One",
     value:"onk"
  },
  {
     label:"Onobasulu",
     value:"onn"
  },
  {
     label:"Onondaga",
     value:"ono"
  },
  {
     label:"Sartang",
     value:"onp"
  },
  {
     label:"Northern One",
     value:"onr"
  },
  {
     label:"Ono",
     value:"ons"
  },
  {
     label:"Ontenu",
     value:"ont"
  },
  {
     label:"Unua",
     value:"onu"
  },
  {
     label:"Onin Based Pidgin",
     value:"onx"
  },
  {
     label:"Tohono O'odham",
     value:"ood"
  },
  {
     label:"Ong",
     value:"oog"
  },
  {
     label:"\u00d6nge",
     value:"oon"
  },
  {
     label:"Oorlams",
     value:"oor"
  },
  {
     label:"Okpamheri",
     value:"opa"
  },
  {
     label:"Kopkaka",
     value:"opk"
  },
  {
     label:"Oksapmin",
     value:"opm"
  },
  {
     label:"Opao",
     value:"opo"
  },
  {
     label:"Ofay\u00e9",
     value:"opy"
  },
  {
     label:"Oroha",
     value:"ora"
  },
  {
     label:"Orma",
     value:"orc"
  },
  {
     label:"Orej\u00f3n",
     value:"ore"
  },
  {
     label:"Oring",
     value:"org"
  },
  {
     label:"Oroqen",
     value:"orh"
  },
  {
     label:"Oriya (macrolanguage)",
     value:"ori",
     "iso6392B":"ori",
     "iso6392T":"ori",
     "iso6391":"or"
  },
  {
     label:"Oromo",
     value:"orm",
     "iso6392B":"orm",
     "iso6392T":"orm",
     "iso6391":"om"
  },
  {
     label:"Orang Kanaq",
     value:"orn"
  },
  {
     label:"Orokolo",
     value:"oro"
  },
  {
     label:"Oruma",
     value:"orr"
  },
  {
     label:"Orang Seletar",
     value:"ors"
  },
  {
     label:"Adivasi Oriya",
     value:"ort"
  },
  {
     label:"Ormuri",
     value:"oru"
  },
  {
     label:"Oro Win",
     value:"orw"
  },
  {
     label:"Oro",
     value:"orx"
  },
  {
     label:"Odia",
     value:"ory"
  },
  {
     label:"Ormu",
     value:"orz"
  },
  {
     label:"Osage",
     value:"osa",
     "iso6392B":"osa",
     "iso6392T":"osa"
  },
  {
     label:"Osing",
     value:"osi"
  },
  {
     label:"Ososo",
     value:"oso"
  },
  {
     label:"Ossetian",
     value:"oss",
     "iso6392B":"oss",
     "iso6392T":"oss",
     "iso6391":"os"
  },
  {
     label:"Osatu",
     value:"ost"
  },
  {
     label:"Southern One",
     value:"osu"
  },
  {
     label:"Ot Danum",
     value:"otd"
  },
  {
     label:"Mezquital Otomi",
     value:"ote"
  },
  {
     label:"Tilapa Otomi",
     value:"otl"
  },
  {
     label:"Eastern Highland Otomi",
     value:"otm"
  },
  {
     label:"Tenango Otomi",
     value:"otn"
  },
  {
     label:"Quer\u00e9taro Otomi",
     value:"otq"
  },
  {
     label:"Otoro",
     value:"otr"
  },
  {
     label:"Estado de M\u00e9xico Otomi",
     value:"ots"
  },
  {
     label:"Temoaya Otomi",
     value:"ott"
  },
  {
     label:"Ottawa",
     value:"otw"
  },
  {
     label:"Texcatepec Otomi",
     value:"otx"
  },
  {
     label:"Ixtenco Otomi",
     value:"otz"
  },
  {
     label:"Tagargrent",
     value:"oua"
  },
  {
     label:"Glio-Oubi",
     value:"oub"
  },
  {
     label:"Oune",
     value:"oue"
  },
  {
     label:"Elfdalian",
     value:"ovd"
  },
  {
     label:"Owiniga",
     value:"owi"
  },
  {
     label:"Oy",
     value:"oyb"
  },
  {
     label:"Oyda",
     value:"oyd"
  },
  {
     label:"Wayampi",
     value:"oym"
  },
  {
     label:"Oya'oya",
     value:"oyy"
  },
  {
     label:"Koonzime",
     value:"ozm"
  },
  {
     label:"Parec\u00eds",
     value:"pab"
  },
  {
     label:"Pacoh",
     value:"pac"
  },
  {
     label:"Paumar\u00ed",
     value:"pad"
  },
  {
     label:"Pagibete",
     value:"pae"
  },
  {
     label:"Pangasinan",
     value:"pag",
     "iso6392B":"pag",
     "iso6392T":"pag"
  },
  {
     label:"Tenharim",
     value:"pah"
  },
  {
     label:"Pe",
     value:"pai"
  },
  {
     label:"Parakan\u00e3",
     value:"pak"
  },
  {
     label:"Pampanga",
     value:"pam",
     "iso6392B":"pam",
     "iso6392T":"pam"
  },
  {
     label:"Panjabi",
     value:"pan",
     "iso6392B":"pan",
     "iso6392T":"pan",
     "iso6391":"pa"
  },
  {
     label:"Northern Paiute",
     value:"pao"
  },
  {
     label:"Papiamento",
     value:"pap",
     "iso6392B":"pap",
     "iso6392T":"pap"
  },
  {
     label:"Parya",
     value:"paq"
  },
  {
     label:"Panamint",
     value:"par"
  },
  {
     label:"Papasena",
     value:"pas"
  },
  {
     label:"Papitalai",
     value:"pat"
  },
  {
     label:"Palauan",
     value:"pau",
     "iso6392B":"pau",
     "iso6392T":"pau"
  },
  {
     label:"Paka\u00e1snovos",
     value:"pav"
  },
  {
     label:"Pawnee",
     value:"paw"
  },
  {
     label:"Pech",
     value:"pay"
  },
  {
     label:"P\u00e1ez",
     value:"pbb"
  },
  {
     label:"Patamona",
     value:"pbc"
  },
  {
     label:"Mezontla Popoloca",
     value:"pbe"
  },
  {
     label:"Coyotepec Popoloca",
     value:"pbf"
  },
  {
     label:"E'\u00f1apa Woromaipu",
     value:"pbh"
  },
  {
     label:"Parkwa",
     value:"pbi"
  },
  {
     label:"Mak (Nigeria)",
     value:"pbl"
  },
  {
     label:"Puebla Mazatec",
     value:"pbm"
  },
  {
     label:"Kpasam",
     value:"pbn"
  },
  {
     label:"Papel",
     value:"pbo"
  },
  {
     label:"Badyara",
     value:"pbp"
  },
  {
     label:"Pangwa",
     value:"pbr"
  },
  {
     label:"Central Pame",
     value:"pbs"
  },
  {
     label:"Southern Pashto",
     value:"pbt"
  },
  {
     label:"Northern Pashto",
     value:"pbu"
  },
  {
     label:"Pnar",
     value:"pbv"
  },
  {
     label:"Pyu (Papua New Guinea)",
     value:"pby"
  },
  {
     label:"Santa In\u00e9s Ahuatempan Popoloca",
     value:"pca"
  },
  {
     label:"Pear",
     value:"pcb"
  },
  {
     label:"Bouyei",
     value:"pcc"
  },
  {
     label:"Picard",
     value:"pcd"
  },
  {
     label:"Ruching Palaung",
     value:"pce"
  },
  {
     label:"Paliyan",
     value:"pcf"
  },
  {
     label:"Paniya",
     value:"pcg"
  },
  {
     label:"Pardhan",
     value:"pch"
  },
  {
     label:"Duruwa",
     value:"pci"
  },
  {
     label:"Parenga",
     value:"pcj"
  },
  {
     label:"Paite Chin",
     value:"pck"
  },
  {
     label:"Pardhi",
     value:"pcl"
  },
  {
     label:"Nigerian Pidgin",
     value:"pcm"
  },
  {
     label:"Piti",
     value:"pcn"
  },
  {
     label:"Pacahuara",
     value:"pcp"
  },
  {
     label:"Pyapun",
     value:"pcw"
  },
  {
     label:"Anam",
     value:"pda"
  },
  {
     label:"Pennsylvania German",
     value:"pdc"
  },
  {
     label:"Pa Di",
     value:"pdi"
  },
  {
     label:"Podena",
     value:"pdn"
  },
  {
     label:"Padoe",
     value:"pdo"
  },
  {
     label:"Plautdietsch",
     value:"pdt"
  },
  {
     label:"Kayan",
     value:"pdu"
  },
  {
     label:"Peranakan Indonesian",
     value:"pea"
  },
  {
     label:"Mala (Papua New Guinea)",
     value:"ped"
  },
  {
     label:"Taje",
     value:"pee"
  },
  {
     label:"Pengo",
     value:"peg"
  },
  {
     label:"Bonan",
     value:"peh"
  },
  {
     label:"Chichimeca-Jonaz",
     value:"pei"
  },
  {
     label:"Penchal",
     value:"pek"
  },
  {
     label:"Pekal",
     value:"pel"
  },
  {
     label:"Phende",
     value:"pem"
  },
  {
     label:"Kunja",
     value:"pep"
  },
  {
     label:"Southern Pomo",
     value:"peq"
  },
  {
     label:"Iranian Persian",
     value:"pes"
  },
  {
     label:"P\u00e9mono",
     value:"pev"
  },
  {
     label:"Petats",
     value:"pex"
  },
  {
     label:"Petjo",
     value:"pey"
  },
  {
     label:"Eastern Penan",
     value:"pez"
  },
  {
     label:"P\u00e1\u00e1fang",
     value:"pfa"
  },
  {
     label:"Pere",
     value:"pfe"
  },
  {
     label:"Pfaelzisch",
     value:"pfl"
  },
  {
     label:"Sudanese Creole Arabic",
     value:"pga"
  },
  {
     label:"Pangwali",
     value:"pgg"
  },
  {
     label:"Pagi",
     value:"pgi"
  },
  {
     label:"Rerep",
     value:"pgk"
  },
  {
     label:"Pangseng",
     value:"pgs"
  },
  {
     label:"Pagu",
     value:"pgu"
  },
  {
     label:"Pa-Hng",
     value:"pha"
  },
  {
     label:"Phudagi",
     value:"phd"
  },
  {
     label:"Phuong",
     value:"phg"
  },
  {
     label:"Phukha",
     value:"phh"
  },
  {
     label:"Phake",
     value:"phk"
  },
  {
     label:"Phalura",
     value:"phl"
  },
  {
     label:"Phimbi",
     value:"phm"
  },
  {
     label:"Phunoi",
     value:"pho"
  },
  {
     label:"Phana'",
     value:"phq"
  },
  {
     label:"Pahari-Potwari",
     value:"phr"
  },
  {
     label:"Phu Thai",
     value:"pht"
  },
  {
     label:"Phuan",
     value:"phu"
  },
  {
     label:"Pahlavani",
     value:"phv"
  },
  {
     label:"Phangduwali",
     value:"phw"
  },
  {
     label:"Pima Bajo",
     value:"pia"
  },
  {
     label:"Yine",
     value:"pib"
  },
  {
     label:"Pinji",
     value:"pic"
  },
  {
     label:"Piaroa",
     value:"pid"
  },
  {
     label:"Pingelapese",
     value:"pif"
  },
  {
     label:"Pisabo",
     value:"pig"
  },
  {
     label:"Pitcairn-Norfolk",
     value:"pih"
  },
  {
     label:"Pini",
     value:"pii"
  },
  {
     label:"Yom",
     value:"pil"
  },
  {
     label:"Piame",
     value:"pin"
  },
  {
     label:"Piapoco",
     value:"pio"
  },
  {
     label:"Pero",
     value:"pip"
  },
  {
     label:"Piratapuyo",
     value:"pir"
  },
  {
     label:"Pijin",
     value:"pis"
  },
  {
     label:"Pintupi-Luritja",
     value:"piu"
  },
  {
     label:"Pileni",
     value:"piv"
  },
  {
     label:"Pimbwe",
     value:"piw"
  },
  {
     label:"Piu",
     value:"pix"
  },
  {
     label:"Piya-Kwonci",
     value:"piy"
  },
  {
     label:"Pije",
     value:"piz"
  },
  {
     label:"Pitjantjatjara",
     value:"pjt"
  },
  {
     label:"Pokomo",
     value:"pkb"
  },
  {
     label:"Pak-Tong",
     value:"pkg"
  },
  {
     label:"Pankhu",
     value:"pkh"
  },
  {
     label:"Pakanha",
     value:"pkn"
  },
  {
     label:"P\u00f6koot",
     value:"pko"
  },
  {
     label:"Pukapuka",
     value:"pkp"
  },
  {
     label:"Attapady Kurumba",
     value:"pkr"
  },
  {
     label:"Maleng",
     value:"pkt"
  },
  {
     label:"Paku",
     value:"pku"
  },
  {
     label:"Miani",
     value:"pla"
  },
  {
     label:"Polonombauk",
     value:"plb"
  },
  {
     label:"Central Palawano",
     value:"plc"
  },
  {
     label:"Polari",
     value:"pld"
  },
  {
     label:"Palu'e",
     value:"ple"
  },
  {
     label:"Pilag\u00e1",
     value:"plg"
  },
  {
     label:"Paulohi",
     value:"plh"
  },
  {
     label:"Polci",
     value:"plj"
  },
  {
     label:"Kohistani Shina",
     value:"plk"
  },
  {
     label:"Shwe Palaung",
     value:"pll"
  },
  {
     label:"Palenquero",
     value:"pln"
  },
  {
     label:"Oluta Popoluca",
     value:"plo"
  },
  {
     label:"Palaka Senoufo",
     value:"plr"
  },
  {
     label:"San Marcos Tlacoyalco Popoloca",
     value:"pls"
  },
  {
     label:"Plateau Malagasy",
     value:"plt"
  },
  {
     label:"Palik\u00far",
     value:"plu"
  },
  {
     label:"Southwest Palawano",
     value:"plv"
  },
  {
     label:"Brooke's Point Palawano",
     value:"plw"
  },
  {
     label:"Bolyu",
     value:"ply"
  },
  {
     label:"Paluan",
     value:"plz"
  },
  {
     label:"Paama",
     value:"pma"
  },
  {
     label:"Pambia",
     value:"pmb"
  },
  {
     label:"Pwaamei",
     value:"pme"
  },
  {
     label:"Pamona",
     value:"pmf"
  },
  {
     label:"Northern Pumi",
     value:"pmi"
  },
  {
     label:"Southern Pumi",
     value:"pmj"
  },
  {
     label:"Pomo",
     value:"pmm"
  },
  {
     label:"Pam",
     value:"pmn"
  },
  {
     label:"Pom",
     value:"pmo"
  },
  {
     label:"Northern Pame",
     value:"pmq"
  },
  {
     label:"Paynamar",
     value:"pmr"
  },
  {
     label:"Piemontese",
     value:"pms"
  },
  {
     label:"Tuamotuan",
     value:"pmt"
  },
  {
     label:"Plains Miwok",
     value:"pmw"
  },
  {
     label:"Poumei Naga",
     value:"pmx"
  },
  {
     label:"Papuan Malay",
     value:"pmy"
  },
  {
     label:"Punan Bah-Biau",
     value:"pna"
  },
  {
     label:"Western Panjabi",
     value:"pnb"
  },
  {
     label:"Pannei",
     value:"pnc"
  },
  {
     label:"Mpinda",
     value:"pnd"
  },
  {
     label:"Western Penan",
     value:"pne"
  },
  {
     label:"Pongu",
     value:"png"
  },
  {
     label:"Penrhyn",
     value:"pnh"
  },
  {
     label:"Aoheng",
     value:"pni"
  },
  {
     label:"Paunaka",
     value:"pnk"
  },
  {
     label:"Paleni",
     value:"pnl"
  },
  {
     label:"Punan Batu 1",
     value:"pnm"
  },
  {
     label:"Pinai-Hagahai",
     value:"pnn"
  },
  {
     label:"Pancana",
     value:"pnp"
  },
  {
     label:"Pana (Burkina Faso)",
     value:"pnq"
  },
  {
     label:"Panim",
     value:"pnr"
  },
  {
     label:"Ponosakan",
     value:"pns"
  },
  {
     label:"Pontic",
     value:"pnt"
  },
  {
     label:"Jiongnai Bunu",
     value:"pnu"
  },
  {
     label:"Pinigura",
     value:"pnv"
  },
  {
     label:"Banyjima",
     value:"pnw"
  },
  {
     label:"Phong-Kniang",
     value:"pnx"
  },
  {
     label:"Pinyin",
     value:"pny"
  },
  {
     label:"Pana (Central African Republic)",
     value:"pnz"
  },
  {
     label:"Poqomam",
     value:"poc"
  },
  {
     label:"San Juan Atzingo Popoloca",
     value:"poe"
  },
  {
     label:"Poke",
     value:"pof"
  },
  {
     label:"Poqomchi'",
     value:"poh"
  },
  {
     label:"Highland Popoluca",
     value:"poi"
  },
  {
     label:"Pokang\u00e1",
     value:"pok"
  },
  {
     label:"Polish",
     value:"pol",
     "iso6392B":"pol",
     "iso6392T":"pol",
     "iso6391":"pl"
  },
  {
     label:"Southeastern Pomo",
     value:"pom"
  },
  {
     label:"Pohnpeian",
     value:"pon",
     "iso6392B":"pon",
     "iso6392T":"pon"
  },
  {
     label:"Pwapw\u00e2",
     value:"pop"
  },
  {
     label:"Texistepec Popoluca",
     value:"poq"
  },
  {
     label:"Portuguese",
     value:"por",
     "iso6392B":"por",
     "iso6392T":"por",
     "iso6391":"pt"
  },
  {
     label:"Sayula Popoluca",
     value:"pos"
  },
  {
     label:"Potawatomi",
     value:"pot"
  },
  {
     label:"Upper Guinea Crioulo",
     value:"pov"
  },
  {
     label:"San Felipe Otlaltepec Popoloca",
     value:"pow"
  },
  {
     label:"Pogolo",
     value:"poy"
  },
  {
     label:"Papi",
     value:"ppe"
  },
  {
     label:"Paipai",
     value:"ppi"
  },
  {
     label:"Uma",
     value:"ppk"
  },
  {
     label:"Pipil",
     value:"ppl"
  },
  {
     label:"Papuma",
     value:"ppm"
  },
  {
     label:"Papapana",
     value:"ppn"
  },
  {
     label:"Folopa",
     value:"ppo"
  },
  {
     label:"Pelende",
     value:"ppp"
  },
  {
     label:"Pei",
     value:"ppq"
  },
  {
     label:"San Lu\u00eds Temalacayuca Popoloca",
     value:"pps"
  },
  {
     label:"Pare",
     value:"ppt"
  },
  {
     label:"Pa'a",
     value:"pqa"
  },
  {
     label:"Malecite-Passamaquoddy",
     value:"pqm"
  },
  {
     label:"Parachi",
     value:"prc"
  },
  {
     label:"Parsi-Dari",
     value:"prd"
  },
  {
     label:"Principense",
     value:"pre"
  },
  {
     label:"Paranan",
     value:"prf"
  },
  {
     label:"Prussian",
     value:"prg"
  },
  {
     label:"Porohanon",
     value:"prh"
  },
  {
     label:"Paic\u00ee",
     value:"pri"
  },
  {
     label:"Parauk",
     value:"prk"
  },
  {
     label:"Kibiri",
     value:"prm"
  },
  {
     label:"Prasuni",
     value:"prn"
  },
  {
     label:"Parsi",
     value:"prp"
  },
  {
     label:"Ash\u00e9ninka Peren\u00e9",
     value:"prq"
  },
  {
     label:"Dari",
     value:"prs"
  },
  {
     label:"Phai",
     value:"prt"
  },
  {
     label:"Puragi",
     value:"pru"
  },
  {
     label:"Parawen",
     value:"prw"
  },
  {
     label:"Purik",
     value:"prx"
  },
  {
     label:"Asue Awyu",
     value:"psa"
  },
  {
     label:"Central Malay",
     value:"pse"
  },
  {
     label:"Southwest Pashai",
     value:"psh"
  },
  {
     label:"Southeast Pashai",
     value:"psi"
  },
  {
     label:"Panasuan",
     value:"psn"
  },
  {
     label:"Pasi",
     value:"psq"
  },
  {
     label:"Kaulong",
     value:"pss"
  },
  {
     label:"Central Pashto",
     value:"pst"
  },
  {
     label:"Port Sandwich",
     value:"psw"
  },
  {
     label:"Pai Tavytera",
     value:"pta"
  },
  {
     label:"Pindiini",
     value:"pti"
  },
  {
     label:"Patani",
     value:"ptn"
  },
  {
     label:"Zo'\u00e9",
     value:"pto"
  },
  {
     label:"Patep",
     value:"ptp"
  },
  {
     label:"Pattapu",
     value:"ptq"
  },
  {
     label:"Piamatsina",
     value:"ptr"
  },
  {
     label:"Enrekang",
     value:"ptt"
  },
  {
     label:"Bambam",
     value:"ptu"
  },
  {
     label:"Port Vato",
     value:"ptv"
  },
  {
     label:"Pathiya",
     value:"pty"
  },
  {
     label:"Western Highland Purepecha",
     value:"pua"
  },
  {
     label:"Purum",
     value:"pub"
  },
  {
     label:"Punan Merap",
     value:"puc"
  },
  {
     label:"Punan Aput",
     value:"pud"
  },
  {
     label:"Punan Merah",
     value:"puf"
  },
  {
     label:"Phuie",
     value:"pug"
  },
  {
     label:"Puinave",
     value:"pui"
  },
  {
     label:"Punan Tubu",
     value:"puj"
  },
  {
     label:"Puma",
     value:"pum"
  },
  {
     label:"Puoc",
     value:"puo"
  },
  {
     label:"Pulabu",
     value:"pup"
  },
  {
     label:"Purubor\u00e1",
     value:"pur"
  },
  {
     label:"Pushto",
     value:"pus",
     "iso6392B":"pus",
     "iso6392T":"pus",
     "iso6391":"ps"
  },
  {
     label:"Putoh",
     value:"put"
  },
  {
     label:"Punu",
     value:"puu"
  },
  {
     label:"Puluwatese",
     value:"puw"
  },
  {
     label:"Puare",
     value:"pux"
  },
  {
     label:"Pawaia",
     value:"pwa"
  },
  {
     label:"Panawa",
     value:"pwb"
  },
  {
     label:"Gapapaiwa",
     value:"pwg"
  },
  {
     label:"Molbog",
     value:"pwm"
  },
  {
     label:"Paiwan",
     value:"pwn"
  },
  {
     label:"Pwo Western Karen",
     value:"pwo"
  },
  {
     label:"Powari",
     value:"pwr"
  },
  {
     label:"Pwo Northern Karen",
     value:"pww"
  },
  {
     label:"Quetzaltepec Mixe",
     value:"pxm"
  },
  {
     label:"Pye Krumen",
     value:"pye"
  },
  {
     label:"Fyam",
     value:"pym"
  },
  {
     label:"Poyan\u00e1wa",
     value:"pyn"
  },
  {
     label:"Puyuma",
     value:"pyu"
  },
  {
     label:"Pyen",
     value:"pyy"
  },
  {
     label:"Para Naga",
     value:"pzn"
  },
  {
     label:"Quapaw",
     value:"qua"
  },
  {
     label:"Huallaga Hu\u00e1nuco Quechua",
     value:"qub"
  },
  {
     label:"K'iche'",
     value:"quc"
  },
  {
     label:"Calder\u00f3n Highland Quichua",
     value:"qud"
  },
  {
     label:"Quechua",
     value:"que",
     "iso6392B":"que",
     "iso6392T":"que",
     "iso6391":"qu"
  },
  {
     label:"Lambayeque Quechua",
     value:"quf"
  },
  {
     label:"Chimborazo Highland Quichua",
     value:"qug"
  },
  {
     label:"South Bolivian Quechua",
     value:"quh"
  },
  {
     label:"Quileute",
     value:"qui"
  },
  {
     label:"Chachapoyas Quechua",
     value:"quk"
  },
  {
     label:"North Bolivian Quechua",
     value:"qul"
  },
  {
     label:"Sipacapense",
     value:"qum"
  },
  {
     label:"Southern Pastaza Quechua",
     value:"qup"
  },
  {
     label:"Quinqui",
     value:"quq"
  },
  {
     label:"Yanahuanca Pasco Quechua",
     value:"qur"
  },
  {
     label:"Santiago del Estero Quichua",
     value:"qus"
  },
  {
     label:"Sacapulteco",
     value:"quv"
  },
  {
     label:"Tena Lowland Quichua",
     value:"quw"
  },
  {
     label:"Yauyos Quechua",
     value:"qux"
  },
  {
     label:"Ayacucho Quechua",
     value:"quy"
  },
  {
     label:"Cusco Quechua",
     value:"quz"
  },
  {
     label:"Ambo-Pasco Quechua",
     value:"qva"
  },
  {
     label:"Cajamarca Quechua",
     value:"qvc"
  },
  {
     label:"Eastern Apur\u00edmac Quechua",
     value:"qve"
  },
  {
     label:"Huamal\u00edes-Dos de Mayo Hu\u00e1nuco Quechua",
     value:"qvh"
  },
  {
     label:"Imbabura Highland Quichua",
     value:"qvi"
  },
  {
     label:"Loja Highland Quichua",
     value:"qvj"
  },
  {
     label:"Cajatambo North Lima Quechua",
     value:"qvl"
  },
  {
     label:"Margos-Yarowilca-Lauricocha Quechua",
     value:"qvm"
  },
  {
     label:"North Jun\u00edn Quechua",
     value:"qvn"
  },
  {
     label:"Napo Lowland Quechua",
     value:"qvo"
  },
  {
     label:"Pacaraos Quechua",
     value:"qvp"
  },
  {
     label:"San Mart\u00edn Quechua",
     value:"qvs"
  },
  {
     label:"Huaylla Wanca Quechua",
     value:"qvw"
  },
  {
     label:"Queyu",
     value:"qvy"
  },
  {
     label:"Northern Pastaza Quichua",
     value:"qvz"
  },
  {
     label:"Corongo Ancash Quechua",
     value:"qwa"
  },
  {
     label:"Huaylas Ancash Quechua",
     value:"qwh"
  },
  {
     label:"Sihuas Ancash Quechua",
     value:"qws"
  },
  {
     label:"Chiqui\u00e1n Ancash Quechua",
     value:"qxa"
  },
  {
     label:"Chincha Quechua",
     value:"qxc"
  },
  {
     label:"Panao Hu\u00e1nuco Quechua",
     value:"qxh"
  },
  {
     label:"Salasaca Highland Quichua",
     value:"qxl"
  },
  {
     label:"Northern Conchucos Ancash Quechua",
     value:"qxn"
  },
  {
     label:"Southern Conchucos Ancash Quechua",
     value:"qxo"
  },
  {
     label:"Puno Quechua",
     value:"qxp"
  },
  {
     label:"Qashqa'i",
     value:"qxq"
  },
  {
     label:"Ca\u00f1ar Highland Quichua",
     value:"qxr"
  },
  {
     label:"Southern Qiang",
     value:"qxs"
  },
  {
     label:"Santa Ana de Tusi Pasco Quechua",
     value:"qxt"
  },
  {
     label:"Arequipa-La Uni\u00f3n Quechua",
     value:"qxu"
  },
  {
     label:"Jauja Wanca Quechua",
     value:"qxw"
  },
  {
     label:"Quenya",
     value:"qya"
  },
  {
     label:"Dungmali",
     value:"raa"
  },
  {
     label:"Camling",
     value:"rab"
  },
  {
     label:"Rasawa",
     value:"rac"
  },
  {
     label:"Rade",
     value:"rad"
  },
  {
     label:"Western Meohang",
     value:"raf"
  },
  {
     label:"Logooli",
     value:"rag"
  },
  {
     label:"Rabha",
     value:"rah"
  },
  {
     label:"Ramoaaina",
     value:"rai"
  },
  {
     label:"Rajasthani",
     value:"raj",
     "iso6392B":"raj",
     "iso6392T":"raj"
  },
  {
     label:"Tulu-Bohuai",
     value:"rak"
  },
  {
     label:"Ralte",
     value:"ral"
  },
  {
     label:"Canela",
     value:"ram"
  },
  {
     label:"Riantana",
     value:"ran"
  },
  {
     label:"Rao",
     value:"rao"
  },
  {
     label:"Rapanui",
     value:"rap",
     "iso6392B":"rap",
     "iso6392T":"rap"
  },
  {
     label:"Saam",
     value:"raq"
  },
  {
     label:"Rarotongan",
     value:"rar",
     "iso6392B":"rar",
     "iso6392T":"rar"
  },
  {
     label:"Tegali",
     value:"ras"
  },
  {
     label:"Razajerdi",
     value:"rat"
  },
  {
     label:"Raute",
     value:"rau"
  },
  {
     label:"Sampang",
     value:"rav"
  },
  {
     label:"Rawang",
     value:"raw"
  },
  {
     label:"Rang",
     value:"rax"
  },
  {
     label:"Rapa",
     value:"ray"
  },
  {
     label:"Rahambuu",
     value:"raz"
  },
  {
     label:"Rumai Palaung",
     value:"rbb"
  },
  {
     label:"Northern Bontok",
     value:"rbk"
  },
  {
     label:"Miraya Bikol",
     value:"rbl"
  },
  {
     label:"R\u00e9union Creole French",
     value:"rcf"
  },
  {
     label:"Rudbari",
     value:"rdb"
  },
  {
     label:"Rerau",
     value:"rea"
  },
  {
     label:"Rembong",
     value:"reb"
  },
  {
     label:"Rejang Kayan",
     value:"ree"
  },
  {
     label:"Kara (Tanzania)",
     value:"reg"
  },
  {
     label:"Reli",
     value:"rei"
  },
  {
     label:"Rejang",
     value:"rej"
  },
  {
     label:"Rendille",
     value:"rel"
  },
  {
     label:"Rengao",
     value:"ren"
  },
  {
     label:"Reshe",
     value:"res"
  },
  {
     label:"Retta",
     value:"ret"
  },
  {
     label:"Reyesano",
     value:"rey"
  },
  {
     label:"Roria",
     value:"rga"
  },
  {
     label:"Romano-Greek",
     value:"rge"
  },
  {
     label:"Romagnol",
     value:"rgn"
  },
  {
     label:"Res\u00edgaro",
     value:"rgr"
  },
  {
     label:"Southern Roglai",
     value:"rgs"
  },
  {
     label:"Ringgou",
     value:"rgu"
  },
  {
     label:"Rohingya",
     value:"rhg"
  },
  {
     label:"Yahang",
     value:"rhp"
  },
  {
     label:"Riang (India)",
     value:"ria"
  },
  {
     label:"Tarifit",
     value:"rif"
  },
  {
     label:"Riang Lang",
     value:"ril"
  },
  {
     label:"Nyaturu",
     value:"rim"
  },
  {
     label:"Nungu",
     value:"rin"
  },
  {
     label:"Ribun",
     value:"rir"
  },
  {
     label:"Ritharrngu",
     value:"rit"
  },
  {
     label:"Riung",
     value:"riu"
  },
  {
     label:"Rajong",
     value:"rjg"
  },
  {
     label:"Raji",
     value:"rji"
  },
  {
     label:"Rajbanshi",
     value:"rjs"
  },
  {
     label:"Kraol",
     value:"rka"
  },
  {
     label:"Rikbaktsa",
     value:"rkb"
  },
  {
     label:"Rakahanga-Manihiki",
     value:"rkh"
  },
  {
     label:"Rakhine",
     value:"rki"
  },
  {
     label:"Marka",
     value:"rkm"
  },
  {
     label:"Rangpuri",
     value:"rkt"
  },
  {
     label:"Rama",
     value:"rma"
  },
  {
     label:"Rembarrnga",
     value:"rmb"
  },
  {
     label:"Carpathian Romani",
     value:"rmc"
  },
  {
     label:"Angloromani",
     value:"rme"
  },
  {
     label:"Kalo Finnish Romani",
     value:"rmf"
  },
  {
     label:"Traveller Norwegian",
     value:"rmg"
  },
  {
     label:"Murkim",
     value:"rmh"
  },
  {
     label:"Lomavren",
     value:"rmi"
  },
  {
     label:"Romkun",
     value:"rmk"
  },
  {
     label:"Baltic Romani",
     value:"rml"
  },
  {
     label:"Roma",
     value:"rmm"
  },
  {
     label:"Balkan Romani",
     value:"rmn"
  },
  {
     label:"Sinte Romani",
     value:"rmo"
  },
  {
     label:"Rempi",
     value:"rmp"
  },
  {
     label:"Cal\u00f3",
     value:"rmq"
  },
  {
     label:"Domari",
     value:"rmt"
  },
  {
     label:"Tavringer Romani",
     value:"rmu"
  },
  {
     label:"Romanova",
     value:"rmv"
  },
  {
     label:"Welsh Romani",
     value:"rmw"
  },
  {
     label:"Romam",
     value:"rmx"
  },
  {
     label:"Vlax Romani",
     value:"rmy"
  },
  {
     label:"Marma",
     value:"rmz"
  },
  {
     label:"Ruund",
     value:"rnd"
  },
  {
     label:"Ronga",
     value:"rng"
  },
  {
     label:"Ranglong",
     value:"rnl"
  },
  {
     label:"Roon",
     value:"rnn"
  },
  {
     label:"Rongpo",
     value:"rnp"
  },
  {
     label:"Rungwa",
     value:"rnw"
  },
  {
     label:"Tae'",
     value:"rob"
  },
  {
     label:"Cacgia Roglai",
     value:"roc"
  },
  {
     label:"Rogo",
     value:"rod"
  },
  {
     label:"Ronji",
     value:"roe"
  },
  {
     label:"Rombo",
     value:"rof"
  },
  {
     label:"Northern Roglai",
     value:"rog"
  },
  {
     label:"Romansh",
     value:"roh",
     "iso6392B":"roh",
     "iso6392T":"roh",
     "iso6391":"rm"
  },
  {
     label:"Romblomanon",
     value:"rol"
  },
  {
     label:"Romany",
     value:"rom",
     "iso6392B":"rom",
     "iso6392T":"rom"
  },
  {
     label:"Romanian",
     value:"ron",
     "iso6392B":"rum",
     "iso6392T":"ron",
     "iso6391":"ro"
  },
  {
     label:"Rotokas",
     value:"roo"
  },
  {
     label:"Kriol",
     value:"rop"
  },
  {
     label:"Rongga",
     value:"ror"
  },
  {
     label:"Runga",
     value:"rou"
  },
  {
     label:"Dela-Oenale",
     value:"row"
  },
  {
     label:"Repanbitip",
     value:"rpn"
  },
  {
     label:"Rapting",
     value:"rpt"
  },
  {
     label:"Ririo",
     value:"rri"
  },
  {
     label:"Waima",
     value:"rro"
  },
  {
     label:"Romano-Serbian",
     value:"rsb"
  },
  {
     label:"Rungtu Chin",
     value:"rtc"
  },
  {
     label:"Ratahan",
     value:"rth"
  },
  {
     label:"Rotuman",
     value:"rtm"
  },
  {
     label:"Rathawi",
     value:"rtw"
  },
  {
     label:"Gungu",
     value:"rub"
  },
  {
     label:"Ruuli",
     value:"ruc"
  },
  {
     label:"Rusyn",
     value:"rue"
  },
  {
     label:"Luguru",
     value:"ruf"
  },
  {
     label:"Roviana",
     value:"rug"
  },
  {
     label:"Ruga",
     value:"ruh"
  },
  {
     label:"Rufiji",
     value:"rui"
  },
  {
     label:"Che",
     value:"ruk"
  },
  {
     label:"Rundi",
     value:"run",
     "iso6392B":"run",
     "iso6392T":"run",
     "iso6391":"rn"
  },
  {
     label:"Istro Romanian",
     value:"ruo"
  },
  {
     label:"Macedo-Romanian",
     value:"rup",
     "iso6392B":"rup",
     "iso6392T":"rup"
  },
  {
     label:"Megleno Romanian",
     value:"ruq"
  },
  {
     label:"Russian",
     value:"rus",
     "iso6392B":"rus",
     "iso6392T":"rus",
     "iso6391":"ru"
  },
  {
     label:"Rutul",
     value:"rut"
  },
  {
     label:"Lanas Lobu",
     value:"ruu"
  },
  {
     label:"Mala (Nigeria)",
     value:"ruy"
  },
  {
     label:"Ruma",
     value:"ruz"
  },
  {
     label:"Rawo",
     value:"rwa"
  },
  {
     label:"Rwa",
     value:"rwk"
  },
  {
     label:"Amba (Uganda)",
     value:"rwm"
  },
  {
     label:"Rawa",
     value:"rwo"
  },
  {
     label:"Marwari (India)",
     value:"rwr"
  },
  {
     label:"Ngardi",
     value:"rxd"
  },
  {
     label:"Northern Amami-Oshima",
     value:"ryn"
  },
  {
     label:"Yaeyama",
     value:"rys"
  },
  {
     label:"Central Okinawan",
     value:"ryu"
  },
  {
     label:"R\u0101zi\u1e25\u012b",
     value:"rzh"
  },
  {
     label:"Saba",
     value:"saa"
  },
  {
     label:"Buglere",
     value:"sab"
  },
  {
     label:"Meskwaki",
     value:"sac"
  },
  {
     label:"Sandawe",
     value:"sad",
     "iso6392B":"sad",
     "iso6392T":"sad"
  },
  {
     label:"Saban\u00ea",
     value:"sae"
  },
  {
     label:"Safaliba",
     value:"saf"
  },
  {
     label:"Sango",
     value:"sag",
     "iso6392B":"sag",
     "iso6392T":"sag",
     "iso6391":"sg"
  },
  {
     label:"Yakut",
     value:"sah",
     "iso6392B":"sah",
     "iso6392T":"sah"
  },
  {
     label:"Sahu",
     value:"saj"
  },
  {
     label:"Sake",
     value:"sak"
  },
  {
     label:"Sause",
     value:"sao"
  },
  {
     label:"Samburu",
     value:"saq"
  },
  {
     label:"Sasak",
     value:"sas",
     "iso6392B":"sas",
     "iso6392T":"sas"
  },
  {
     label:"Santali",
     value:"sat",
     "iso6392B":"sat",
     "iso6392T":"sat"
  },
  {
     label:"Saleman",
     value:"sau"
  },
  {
     label:"Saafi-Saafi",
     value:"sav"
  },
  {
     label:"Sawi",
     value:"saw"
  },
  {
     label:"Sa",
     value:"sax"
  },
  {
     label:"Saya",
     value:"say"
  },
  {
     label:"Saurashtra",
     value:"saz"
  },
  {
     label:"Ngambay",
     value:"sba"
  },
  {
     label:"Simbo",
     value:"sbb"
  },
  {
     label:"Kele (Papua New Guinea)",
     value:"sbc"
  },
  {
     label:"Southern Samo",
     value:"sbd"
  },
  {
     label:"Saliba",
     value:"sbe"
  },
  {
     label:"Chabu",
     value:"sbf"
  },
  {
     label:"Seget",
     value:"sbg"
  },
  {
     label:"Sori-Harengan",
     value:"sbh"
  },
  {
     label:"Seti",
     value:"sbi"
  },
  {
     label:"Surbakhal",
     value:"sbj"
  },
  {
     label:"Safwa",
     value:"sbk"
  },
  {
     label:"Botolan Sambal",
     value:"sbl"
  },
  {
     label:"Sagala",
     value:"sbm"
  },
  {
     label:"Sindhi Bhil",
     value:"sbn"
  },
  {
     label:"Sab\u00fcm",
     value:"sbo"
  },
  {
     label:"Sangu (Tanzania)",
     value:"sbp"
  },
  {
     label:"Sileibi",
     value:"sbq"
  },
  {
     label:"Sembakung Murut",
     value:"sbr"
  },
  {
     label:"Subiya",
     value:"sbs"
  },
  {
     label:"Kimki",
     value:"sbt"
  },
  {
     label:"Stod Bhoti",
     value:"sbu"
  },
  {
     label:"Simba",
     value:"sbw"
  },
  {
     label:"Seberuang",
     value:"sbx"
  },
  {
     label:"Soli",
     value:"sby"
  },
  {
     label:"Sara Kaba",
     value:"sbz"
  },
  {
     label:"Chut",
     value:"scb"
  },
  {
     label:"Dongxiang",
     value:"sce"
  },
  {
     label:"San Miguel Creole French",
     value:"scf"
  },
  {
     label:"Sanggau",
     value:"scg"
  },
  {
     label:"Sakachep",
     value:"sch"
  },
  {
     label:"Sri Lankan Creole Malay",
     value:"sci"
  },
  {
     label:"Sadri",
     value:"sck"
  },
  {
     label:"Shina",
     value:"scl"
  },
  {
     label:"Sicilian",
     value:"scn",
     "iso6392B":"scn",
     "iso6392T":"scn"
  },
  {
     label:"Scots",
     value:"sco",
     "iso6392B":"sco",
     "iso6392T":"sco"
  },
  {
     label:"Hyolmo",
     value:"scp"
  },
  {
     label:"Sa'och",
     value:"scq"
  },
  {
     label:"North Slavey",
     value:"scs"
  },
  {
     label:"Southern Katang",
     value:"sct"
  },
  {
     label:"Shumcho",
     value:"scu"
  },
  {
     label:"Sheni",
     value:"scv"
  },
  {
     label:"Sha",
     value:"scw"
  },
  {
     label:"Toraja-Sa'dan",
     value:"sda"
  },
  {
     label:"Shabak",
     value:"sdb"
  },
  {
     label:"Sassarese Sardinian",
     value:"sdc"
  },
  {
     label:"Surubu",
     value:"sde"
  },
  {
     label:"Sarli",
     value:"sdf"
  },
  {
     label:"Savi",
     value:"sdg"
  },
  {
     label:"Southern Kurdish",
     value:"sdh"
  },
  {
     label:"Suundi",
     value:"sdj"
  },
  {
     label:"Sos Kundi",
     value:"sdk"
  },
  {
     label:"Gallurese Sardinian",
     value:"sdn"
  },
  {
     label:"Bukar-Sadung Bidayuh",
     value:"sdo"
  },
  {
     label:"Sherdukpen",
     value:"sdp"
  },
  {
     label:"Semandang",
     value:"sdq"
  },
  {
     label:"Oraon Sadri",
     value:"sdr"
  },
  {
     label:"Sarudu",
     value:"sdu"
  },
  {
     label:"Sibu Melanau",
     value:"sdx"
  },
  {
     label:"Sallands",
     value:"sdz"
  },
  {
     label:"Semai",
     value:"sea"
  },
  {
     label:"Shempire Senoufo",
     value:"seb"
  },
  {
     label:"Sechelt",
     value:"sec"
  },
  {
     label:"Sedang",
     value:"sed"
  },
  {
     label:"Seneca",
     value:"see"
  },
  {
     label:"Cebaara Senoufo",
     value:"sef"
  },
  {
     label:"Segeju",
     value:"seg"
  },
  {
     label:"Sena",
     value:"seh"
  },
  {
     label:"Seri",
     value:"sei"
  },
  {
     label:"Sene",
     value:"sej"
  },
  {
     label:"Sekani",
     value:"sek"
  },
  {
     label:"Selkup",
     value:"sel",
     "iso6392B":"sel",
     "iso6392T":"sel"
  },
  {
     label:"Nanerig\u00e9 S\u00e9noufo",
     value:"sen"
  },
  {
     label:"Suarmin",
     value:"seo"
  },
  {
     label:"S\u00ecc\u00ect\u00e9 S\u00e9noufo",
     value:"sep"
  },
  {
     label:"Senara S\u00e9noufo",
     value:"seq"
  },
  {
     label:"Serrano",
     value:"ser"
  },
  {
     label:"Koyraboro Senni Songhai",
     value:"ses"
  },
  {
     label:"Sentani",
     value:"set"
  },
  {
     label:"Serui-Laut",
     value:"seu"
  },
  {
     label:"Nyarafolo Senoufo",
     value:"sev"
  },
  {
     label:"Sewa Bay",
     value:"sew"
  },
  {
     label:"Secoya",
     value:"sey"
  },
  {
     label:"Senthang Chin",
     value:"sez"
  },
  {
     label:"Langue des signes de Belgique Francophone",
     value:"sfb"
  },
  {
     label:"Eastern Subanen",
     value:"sfe"
  },
  {
     label:"Small Flowery Miao",
     value:"sfm"
  },
  {
     label:"Sehwi",
     value:"sfw"
  },
  {
     label:"Mag-antsi Ayta",
     value:"sgb"
  },
  {
     label:"Kipsigis",
     value:"sgc"
  },
  {
     label:"Surigaonon",
     value:"sgd"
  },
  {
     label:"Segai",
     value:"sge"
  },
  {
     label:"Shughni",
     value:"sgh"
  },
  {
     label:"Suga",
     value:"sgi"
  },
  {
     label:"Surgujia",
     value:"sgj"
  },
  {
     label:"Sangkong",
     value:"sgk"
  },
  {
     label:"Singpho",
     value:"sgp"
  },
  {
     label:"Sangisari",
     value:"sgr"
  },
  {
     label:"Samogitian",
     value:"sgs"
  },
  {
     label:"Brokpake",
     value:"sgt"
  },
  {
     label:"Salas",
     value:"sgu"
  },
  {
     label:"Sebat Bet Gurage",
     value:"sgw"
  },
  {
     label:"Sanglechi",
     value:"sgy"
  },
  {
     label:"Sursurunga",
     value:"sgz"
  },
  {
     label:"Shall-Zwall",
     value:"sha"
  },
  {
     label:"Ninam",
     value:"shb"
  },
  {
     label:"Sonde",
     value:"shc"
  },
  {
     label:"Kundal Shahi",
     value:"shd"
  },
  {
     label:"Sheko",
     value:"she"
  },
  {
     label:"Shua",
     value:"shg"
  },
  {
     label:"Shoshoni",
     value:"shh"
  },
  {
     label:"Tachelhit",
     value:"shi"
  },
  {
     label:"Shatt",
     value:"shj"
  },
  {
     label:"Shilluk",
     value:"shk"
  },
  {
     label:"Shendu",
     value:"shl"
  },
  {
     label:"Shahrudi",
     value:"shm"
  },
  {
     label:"Shan",
     value:"shn",
     "iso6392B":"shn",
     "iso6392T":"shn"
  },
  {
     label:"Shanga",
     value:"sho"
  },
  {
     label:"Shipibo-Conibo",
     value:"shp"
  },
  {
     label:"Sala",
     value:"shq"
  },
  {
     label:"Shi",
     value:"shr"
  },
  {
     label:"Shuswap",
     value:"shs"
  },
  {
     label:"Chadian Arabic",
     value:"shu"
  },
  {
     label:"Shehri",
     value:"shv"
  },
  {
     label:"Shwai",
     value:"shw"
  },
  {
     label:"She",
     value:"shx"
  },
  {
     label:"Tachawit",
     value:"shy"
  },
  {
     label:"Syenara Senoufo",
     value:"shz"
  },
  {
     label:"Sebop",
     value:"sib"
  },
  {
     label:"Sidamo",
     value:"sid",
     "iso6392B":"sid",
     "iso6392T":"sid"
  },
  {
     label:"Simaa",
     value:"sie"
  },
  {
     label:"Siamou",
     value:"sif"
  },
  {
     label:"Paasaal",
     value:"sig"
  },
  {
     label:"Zire",
     value:"sih"
  },
  {
     label:"Shom Peng",
     value:"sii"
  },
  {
     label:"Numbami",
     value:"sij"
  },
  {
     label:"Sikiana",
     value:"sik"
  },
  {
     label:"Tumulung Sisaala",
     value:"sil"
  },
  {
     label:"Mende (Papua New Guinea)",
     value:"sim"
  },
  {
     label:"Sinhala",
     value:"sin",
     "iso6392B":"sin",
     "iso6392T":"sin",
     "iso6391":"si"
  },
  {
     label:"Sikkimese",
     value:"sip"
  },
  {
     label:"Sonia",
     value:"siq"
  },
  {
     label:"Siri",
     value:"sir"
  },
  {
     label:"Sinagen",
     value:"siu"
  },
  {
     label:"Sumariup",
     value:"siv"
  },
  {
     label:"Siwai",
     value:"siw"
  },
  {
     label:"Sumau",
     value:"six"
  },
  {
     label:"Sivandi",
     value:"siy"
  },
  {
     label:"Siwi",
     value:"siz"
  },
  {
     label:"Epena",
     value:"sja"
  },
  {
     label:"Sajau Basap",
     value:"sjb"
  },
  {
     label:"Kildin Sami",
     value:"sjd"
  },
  {
     label:"Pite Sami",
     value:"sje"
  },
  {
     label:"Assangori",
     value:"sjg"
  },
  {
     label:"Sajalong",
     value:"sjl"
  },
  {
     label:"Mapun",
     value:"sjm"
  },
  {
     label:"Sindarin",
     value:"sjn"
  },
  {
     label:"Xibe",
     value:"sjo"
  },
  {
     label:"Surjapuri",
     value:"sjp"
  },
  {
     label:"Siar-Lak",
     value:"sjr"
  },
  {
     label:"Ter Sami",
     value:"sjt"
  },
  {
     label:"Ume Sami",
     value:"sju"
  },
  {
     label:"Shawnee",
     value:"sjw"
  },
  {
     label:"Skagit",
     value:"ska"
  },
  {
     label:"Saek",
     value:"skb"
  },
  {
     label:"Ma Manda",
     value:"skc"
  },
  {
     label:"Southern Sierra Miwok",
     value:"skd"
  },
  {
     label:"Seke (Vanuatu)",
     value:"ske"
  },
  {
     label:"Sakirabi\u00e1",
     value:"skf"
  },
  {
     label:"Sakalava Malagasy",
     value:"skg"
  },
  {
     label:"Sikule",
     value:"skh"
  },
  {
     label:"Sika",
     value:"ski"
  },
  {
     label:"Seke (Nepal)",
     value:"skj"
  },
  {
     label:"Kutong",
     value:"skm"
  },
  {
     label:"Kolibugan Subanon",
     value:"skn"
  },
  {
     label:"Seko Tengah",
     value:"sko"
  },
  {
     label:"Sekapan",
     value:"skp"
  },
  {
     label:"Sininkere",
     value:"skq"
  },
  {
     label:"Saraiki",
     value:"skr"
  },
  {
     label:"Maia",
     value:"sks"
  },
  {
     label:"Sakata",
     value:"skt"
  },
  {
     label:"Sakao",
     value:"sku"
  },
  {
     label:"Skou",
     value:"skv"
  },
  {
     label:"Seko Padang",
     value:"skx"
  },
  {
     label:"Sikaiana",
     value:"sky"
  },
  {
     label:"Sekar",
     value:"skz"
  },
  {
     label:"S\u00e1liba",
     value:"slc"
  },
  {
     label:"Sissala",
     value:"sld"
  },
  {
     label:"Sholaga",
     value:"sle"
  },
  {
     label:"Selungai Murut",
     value:"slg"
  },
  {
     label:"Southern Puget Sound Salish",
     value:"slh"
  },
  {
     label:"Lower Silesian",
     value:"sli"
  },
  {
     label:"Salum\u00e1",
     value:"slj"
  },
  {
     label:"Slovak",
     value:"slk",
     "iso6392B":"slo",
     "iso6392T":"slk",
     "iso6391":"sk"
  },
  {
     label:"Salt-Yui",
     value:"sll"
  },
  {
     label:"Pangutaran Sama",
     value:"slm"
  },
  {
     label:"Lamaholot",
     value:"slp"
  },
  {
     label:"Salar",
     value:"slr"
  },
  {
     label:"Sila",
     value:"slt"
  },
  {
     label:"Selaru",
     value:"slu"
  },
  {
     label:"Slovenian",
     value:"slv",
     "iso6392B":"slv",
     "iso6392T":"slv",
     "iso6391":"sl"
  },
  {
     label:"Sialum",
     value:"slw"
  },
  {
     label:"Salampasu",
     value:"slx"
  },
  {
     label:"Selayar",
     value:"sly"
  },
  {
     label:"Ma'ya",
     value:"slz"
  },
  {
     label:"Southern Sami",
     value:"sma",
     "iso6392B":"sma",
     "iso6392T":"sma"
  },
  {
     label:"Simbari",
     value:"smb"
  },
  {
     label:"Sama",
     value:"smd"
  },
  {
     label:"Northern Sami",
     value:"sme",
     "iso6392B":"sme",
     "iso6392T":"sme",
     "iso6391":"se"
  },
  {
     label:"Auwe",
     value:"smf"
  },
  {
     label:"Simbali",
     value:"smg"
  },
  {
     label:"Samei",
     value:"smh"
  },
  {
     label:"Lule Sami",
     value:"smj",
     "iso6392B":"smj",
     "iso6392T":"smj"
  },
  {
     label:"Bolinao",
     value:"smk"
  },
  {
     label:"Central Sama",
     value:"sml"
  },
  {
     label:"Musasa",
     value:"smm"
  },
  {
     label:"Inari Sami",
     value:"smn",
     "iso6392B":"smn",
     "iso6392T":"smn"
  },
  {
     label:"Samoan",
     value:"smo",
     "iso6392B":"smo",
     "iso6392T":"smo",
     "iso6391":"sm"
  },
  {
     label:"Samo",
     value:"smq"
  },
  {
     label:"Simeulue",
     value:"smr"
  },
  {
     label:"Skolt Sami",
     value:"sms",
     "iso6392B":"sms",
     "iso6392T":"sms"
  },
  {
     label:"Simte",
     value:"smt"
  },
  {
     label:"Samvedi",
     value:"smv"
  },
  {
     label:"Sumbawa",
     value:"smw"
  },
  {
     label:"Samba",
     value:"smx"
  },
  {
     label:"Semnani",
     value:"smy"
  },
  {
     label:"Simeku",
     value:"smz"
  },
  {
     label:"Shona",
     value:"sna",
     "iso6392B":"sna",
     "iso6392T":"sna",
     "iso6391":"sn"
  },
  {
     label:"Sebuyau",
     value:"snb"
  },
  {
     label:"Sinaugoro",
     value:"snc"
  },
  {
     label:"Sindhi",
     value:"snd",
     "iso6392B":"snd",
     "iso6392T":"snd",
     "iso6391":"sd"
  },
  {
     label:"Bau Bidayuh",
     value:"sne"
  },
  {
     label:"Noon",
     value:"snf"
  },
  {
     label:"Sanga (Democratic Republic of Congo)",
     value:"sng"
  },
  {
     label:"Riverain Sango",
     value:"snj"
  },
  {
     label:"Soninke",
     value:"snk",
     "iso6392B":"snk",
     "iso6392T":"snk"
  },
  {
     label:"Sangil",
     value:"snl"
  },
  {
     label:"Southern Ma'di",
     value:"snm"
  },
  {
     label:"Siona",
     value:"snn"
  },
  {
     label:"Snohomish",
     value:"sno"
  },
  {
     label:"Siane",
     value:"snp"
  },
  {
     label:"Sangu (Gabon)",
     value:"snq"
  },
  {
     label:"Sihan",
     value:"snr"
  },
  {
     label:"South West Bay",
     value:"sns"
  },
  {
     label:"Senggi",
     value:"snu"
  },
  {
     label:"Sa'ban",
     value:"snv"
  },
  {
     label:"Selee",
     value:"snw"
  },
  {
     label:"Sam",
     value:"snx"
  },
  {
     label:"Saniyo-Hiyewe",
     value:"sny"
  },
  {
     label:"Kou",
     value:"snz"
  },
  {
     label:"Thai Song",
     value:"soa"
  },
  {
     label:"Sobei",
     value:"sob"
  },
  {
     label:"So (Democratic Republic of Congo)",
     value:"soc"
  },
  {
     label:"Songoora",
     value:"sod"
  },
  {
     label:"Songomeno",
     value:"soe"
  },
  {
     label:"Aka",
     value:"soh"
  },
  {
     label:"Sonha",
     value:"soi"
  },
  {
     label:"Soi",
     value:"soj"
  },
  {
     label:"Sokoro",
     value:"sok"
  },
  {
     label:"Solos",
     value:"sol"
  },
  {
     label:"Somali",
     value:"som",
     "iso6392B":"som",
     "iso6392T":"som",
     "iso6391":"so"
  },
  {
     label:"Songo",
     value:"soo"
  },
  {
     label:"Songe",
     value:"sop"
  },
  {
     label:"Kanasi",
     value:"soq"
  },
  {
     label:"Somrai",
     value:"sor"
  },
  {
     label:"Seeku",
     value:"sos"
  },
  {
     label:"Southern Sotho",
     value:"sot",
     "iso6392B":"sot",
     "iso6392T":"sot",
     "iso6391":"st"
  },
  {
     label:"Southern Thai",
     value:"sou"
  },
  {
     label:"Sonsorol",
     value:"sov"
  },
  {
     label:"Sowanda",
     value:"sow"
  },
  {
     label:"Swo",
     value:"sox"
  },
  {
     label:"Miyobe",
     value:"soy"
  },
  {
     label:"Temi",
     value:"soz"
  },
  {
     label:"Spanish",
     value:"spa",
     "iso6392B":"spa",
     "iso6392T":"spa",
     "iso6391":"es"
  },
  {
     label:"Sepa (Indonesia)",
     value:"spb"
  },
  {
     label:"Sap\u00e9",
     value:"spc"
  },
  {
     label:"Saep",
     value:"spd"
  },
  {
     label:"Sepa (Papua New Guinea)",
     value:"spe"
  },
  {
     label:"Sian",
     value:"spg"
  },
  {
     label:"Saponi",
     value:"spi"
  },
  {
     label:"Sengo",
     value:"spk"
  },
  {
     label:"Selepet",
     value:"spl"
  },
  {
     label:"Akukem",
     value:"spm"
  },
  {
     label:"Sanapan\u00e1",
     value:"spn"
  },
  {
     label:"Spokane",
     value:"spo"
  },
  {
     label:"Supyire Senoufo",
     value:"spp"
  },
  {
     label:"Loreto-Ucayali Spanish",
     value:"spq"
  },
  {
     label:"Saparua",
     value:"spr"
  },
  {
     label:"Saposa",
     value:"sps"
  },
  {
     label:"Spiti Bhoti",
     value:"spt"
  },
  {
     label:"Sapuan",
     value:"spu"
  },
  {
     label:"Sambalpuri",
     value:"spv"
  },
  {
     label:"Sabaot",
     value:"spy"
  },
  {
     label:"Shama-Sambuga",
     value:"sqa"
  },
  {
     label:"Shau",
     value:"sqh"
  },
  {
     label:"Albanian",
     value:"sqi",
     "iso6392B":"alb",
     "iso6392T":"sqi",
     "iso6391":"sq"
  },
  {
     label:"Suma",
     value:"sqm"
  },
  {
     label:"Sorkhei",
     value:"sqo"
  },
  {
     label:"Sou",
     value:"sqq"
  },
  {
     label:"Soqotri",
     value:"sqt"
  },
  {
     label:"Squamish",
     value:"squ"
  },
  {
     label:"Saruga",
     value:"sra"
  },
  {
     label:"Sora",
     value:"srb"
  },
  {
     label:"Logudorese Sardinian",
     value:"src"
  },
  {
     label:"Sardinian",
     value:"srd",
     "iso6392B":"srd",
     "iso6392T":"srd",
     "iso6391":"sc"
  },
  {
     label:"Sara",
     value:"sre"
  },
  {
     label:"Nafi",
     value:"srf"
  },
  {
     label:"Sulod",
     value:"srg"
  },
  {
     label:"Sarikoli",
     value:"srh"
  },
  {
     label:"Siriano",
     value:"sri"
  },
  {
     label:"Serudung Murut",
     value:"srk"
  },
  {
     label:"Isirawa",
     value:"srl"
  },
  {
     label:"Saramaccan",
     value:"srm"
  },
  {
     label:"Sranan Tongo",
     value:"srn",
     "iso6392B":"srn",
     "iso6392T":"srn"
  },
  {
     label:"Campidanese Sardinian",
     value:"sro"
  },
  {
     label:"Serbian",
     value:"srp",
     "iso6392B":"srp",
     "iso6392T":"srp",
     "iso6391":"sr"
  },
  {
     label:"Sirion\u00f3",
     value:"srq"
  },
  {
     label:"Serer",
     value:"srr",
     "iso6392B":"srr",
     "iso6392T":"srr"
  },
  {
     label:"Sarsi",
     value:"srs"
  },
  {
     label:"Sauri",
     value:"srt"
  },
  {
     label:"Suru\u00ed",
     value:"sru"
  },
  {
     label:"Southern Sorsoganon",
     value:"srv"
  },
  {
     label:"Serua",
     value:"srw"
  },
  {
     label:"Sirmauri",
     value:"srx"
  },
  {
     label:"Sera",
     value:"sry"
  },
  {
     label:"Shahmirzadi",
     value:"srz"
  },
  {
     label:"Southern Sama",
     value:"ssb"
  },
  {
     label:"Suba-Simbiti",
     value:"ssc"
  },
  {
     label:"Siroi",
     value:"ssd"
  },
  {
     label:"Balangingi",
     value:"sse"
  },
  {
     label:"Seimat",
     value:"ssg"
  },
  {
     label:"Shihhi Arabic",
     value:"ssh"
  },
  {
     label:"Sansi",
     value:"ssi"
  },
  {
     label:"Sausi",
     value:"ssj"
  },
  {
     label:"Sunam",
     value:"ssk"
  },
  {
     label:"Western Sisaala",
     value:"ssl"
  },
  {
     label:"Semnam",
     value:"ssm"
  },
  {
     label:"Waata",
     value:"ssn"
  },
  {
     label:"Sissano",
     value:"sso"
  },
  {
     label:"So'a",
     value:"ssq"
  },
  {
     label:"S\u00f4",
     value:"sss"
  },
  {
     label:"Sinasina",
     value:"sst"
  },
  {
     label:"Susuami",
     value:"ssu"
  },
  {
     label:"Shark Bay",
     value:"ssv"
  },
  {
     label:"Swati",
     value:"ssw",
     "iso6392B":"ssw",
     "iso6392T":"ssw",
     "iso6391":"ss"
  },
  {
     label:"Samberigi",
     value:"ssx"
  },
  {
     label:"Saho",
     value:"ssy"
  },
  {
     label:"Sengseng",
     value:"ssz"
  },
  {
     label:"Settla",
     value:"sta"
  },
  {
     label:"Northern Subanen",
     value:"stb"
  },
  {
     label:"Sentinel",
     value:"std"
  },
  {
     label:"Liana-Seti",
     value:"ste"
  },
  {
     label:"Seta",
     value:"stf"
  },
  {
     label:"Trieng",
     value:"stg"
  },
  {
     label:"Shelta",
     value:"sth"
  },
  {
     label:"Bulo Stieng",
     value:"sti"
  },
  {
     label:"Matya Samo",
     value:"stj"
  },
  {
     label:"Arammba",
     value:"stk"
  },
  {
     label:"Stellingwerfs",
     value:"stl"
  },
  {
     label:"Setaman",
     value:"stm"
  },
  {
     label:"Owa",
     value:"stn"
  },
  {
     label:"Stoney",
     value:"sto"
  },
  {
     label:"Southeastern Tepehuan",
     value:"stp"
  },
  {
     label:"Saterfriesisch",
     value:"stq"
  },
  {
     label:"Straits Salish",
     value:"str"
  },
  {
     label:"Shumashti",
     value:"sts"
  },
  {
     label:"Budeh Stieng",
     value:"stt"
  },
  {
     label:"Samtao",
     value:"stu"
  },
  {
     label:"Silt'e",
     value:"stv"
  },
  {
     label:"Satawalese",
     value:"stw"
  },
  {
     label:"Siberian Tatar",
     value:"sty"
  },
  {
     label:"Sulka",
     value:"sua"
  },
  {
     label:"Suku",
     value:"sub"
  },
  {
     label:"Western Subanon",
     value:"suc"
  },
  {
     label:"Suena",
     value:"sue"
  },
  {
     label:"Suganga",
     value:"sug"
  },
  {
     label:"Suki",
     value:"sui"
  },
  {
     label:"Shubi",
     value:"suj"
  },
  {
     label:"Sukuma",
     value:"suk",
     "iso6392B":"suk",
     "iso6392T":"suk"
  },
  {
     label:"Sundanese",
     value:"sun",
     "iso6392B":"sun",
     "iso6392T":"sun",
     "iso6391":"su"
  },
  {
     label:"Suri",
     value:"suq"
  },
  {
     label:"Mwaghavul",
     value:"sur"
  },
  {
     label:"Susu",
     value:"sus",
     "iso6392B":"sus",
     "iso6392T":"sus"
  },
  {
     label:"Puroik",
     value:"suv"
  },
  {
     label:"Sumbwa",
     value:"suw"
  },
  {
     label:"Suy\u00e1",
     value:"suy"
  },
  {
     label:"Sunwar",
     value:"suz"
  },
  {
     label:"Svan",
     value:"sva"
  },
  {
     label:"Ulau-Suain",
     value:"svb"
  },
  {
     label:"Vincentian Creole English",
     value:"svc"
  },
  {
     label:"Serili",
     value:"sve"
  },
  {
     label:"Slavomolisano",
     value:"svm"
  },
  {
     label:"Savosavo",
     value:"svs"
  },
  {
     label:"Swahili (macrolanguage)",
     value:"swa",
     "iso6392B":"swa",
     "iso6392T":"swa",
     "iso6391":"sw"
  },
  {
     label:"Maore Comorian",
     value:"swb"
  },
  {
     label:"Congo Swahili",
     value:"swc"
  },
  {
     label:"Swedish",
     value:"swe",
     "iso6392B":"swe",
     "iso6392T":"swe",
     "iso6391":"sv"
  },
  {
     label:"Sere",
     value:"swf"
  },
  {
     label:"Swabian",
     value:"swg"
  },
  {
     label:"Swahili (individual language)",
     value:"swh"
  },
  {
     label:"Sui",
     value:"swi"
  },
  {
     label:"Sira",
     value:"swj"
  },
  {
     label:"Malawi Sena",
     value:"swk"
  },
  {
     label:"Samosa",
     value:"swm"
  },
  {
     label:"Sawknah",
     value:"swn"
  },
  {
     label:"Shanenawa",
     value:"swo"
  },
  {
     label:"Suau",
     value:"swp"
  },
  {
     label:"Sharwa",
     value:"swq"
  },
  {
     label:"Saweru",
     value:"swr"
  },
  {
     label:"Seluwasan",
     value:"sws"
  },
  {
     label:"Sawila",
     value:"swt"
  },
  {
     label:"Suwawa",
     value:"swu"
  },
  {
     label:"Shekhawati",
     value:"swv"
  },
  {
     label:"Suruah\u00e1",
     value:"swx"
  },
  {
     label:"Sarua",
     value:"swy"
  },
  {
     label:"Suba",
     value:"sxb"
  },
  {
     label:"Sighu",
     value:"sxe"
  },
  {
     label:"Shuhi",
     value:"sxg"
  },
  {
     label:"Samre",
     value:"sxm"
  },
  {
     label:"Sangir",
     value:"sxn"
  },
  {
     label:"Saaroa",
     value:"sxr"
  },
  {
     label:"Sasaru",
     value:"sxs"
  },
  {
     label:"Upper Saxon",
     value:"sxu"
  },
  {
     label:"Saxwe Gbe",
     value:"sxw"
  },
  {
     label:"Siang",
     value:"sya"
  },
  {
     label:"Central Subanen",
     value:"syb"
  },
  {
     label:"Seki",
     value:"syi"
  },
  {
     label:"Sukur",
     value:"syk"
  },
  {
     label:"Sylheti",
     value:"syl"
  },
  {
     label:"Maya Samo",
     value:"sym"
  },
  {
     label:"Senaya",
     value:"syn"
  },
  {
     label:"Suoy",
     value:"syo"
  },
  {
     label:"Syriac",
     value:"syr",
     "iso6392B":"syr",
     "iso6392T":"syr"
  },
  {
     label:"Sinyar",
     value:"sys"
  },
  {
     label:"Kagate",
     value:"syw"
  },
  {
     label:"Samay",
     value:"syx"
  },
  {
     label:"Semelai",
     value:"sza"
  },
  {
     label:"Ngalum",
     value:"szb"
  },
  {
     label:"Semaq Beri",
     value:"szc"
  },
  {
     label:"Seze",
     value:"sze"
  },
  {
     label:"Sengele",
     value:"szg"
  },
  {
     label:"Silesian",
     value:"szl"
  },
  {
     label:"Sula",
     value:"szn"
  },
  {
     label:"Suabo",
     value:"szp"
  },
  {
     label:"Isu (Fako Division)",
     value:"szv"
  },
  {
     label:"Sawai",
     value:"szw"
  },
  {
     label:"Sakizaya",
     value:"szy"
  },
  {
     label:"Lower Tanana",
     value:"taa"
  },
  {
     label:"Tabassaran",
     value:"tab"
  },
  {
     label:"Lowland Tarahumara",
     value:"tac"
  },
  {
     label:"Tause",
     value:"tad"
  },
  {
     label:"Tariana",
     value:"tae"
  },
  {
     label:"Tapirap\u00e9",
     value:"taf"
  },
  {
     label:"Tagoi",
     value:"tag"
  },
  {
     label:"Tahitian",
     value:"tah",
     "iso6392B":"tah",
     "iso6392T":"tah",
     "iso6391":"ty"
  },
  {
     label:"Eastern Tamang",
     value:"taj"
  },
  {
     label:"Tala",
     value:"tak"
  },
  {
     label:"Tal",
     value:"tal"
  },
  {
     label:"Tamil",
     value:"tam",
     "iso6392B":"tam",
     "iso6392T":"tam",
     "iso6391":"ta"
  },
  {
     label:"Tangale",
     value:"tan"
  },
  {
     label:"Yami",
     value:"tao"
  },
  {
     label:"Taabwa",
     value:"tap"
  },
  {
     label:"Tamasheq",
     value:"taq"
  },
  {
     label:"Central Tarahumara",
     value:"tar"
  },
  {
     label:"Tatar",
     value:"tat",
     "iso6392B":"tat",
     "iso6392T":"tat",
     "iso6391":"tt"
  },
  {
     label:"Upper Tanana",
     value:"tau"
  },
  {
     label:"Tatuyo",
     value:"tav"
  },
  {
     label:"Tai",
     value:"taw"
  },
  {
     label:"Tamki",
     value:"tax"
  },
  {
     label:"Atayal",
     value:"tay"
  },
  {
     label:"Tocho",
     value:"taz"
  },
  {
     label:"Aikan\u00e3",
     value:"tba"
  },
  {
     label:"Takia",
     value:"tbc"
  },
  {
     label:"Kaki Ae",
     value:"tbd"
  },
  {
     label:"Tanimbili",
     value:"tbe"
  },
  {
     label:"Mandara",
     value:"tbf"
  },
  {
     label:"North Tairora",
     value:"tbg"
  },
  {
     label:"Gaam",
     value:"tbi"
  },
  {
     label:"Tiang",
     value:"tbj"
  },
  {
     label:"Calamian Tagbanwa",
     value:"tbk"
  },
  {
     label:"Tboli",
     value:"tbl"
  },
  {
     label:"Tagbu",
     value:"tbm"
  },
  {
     label:"Barro Negro Tunebo",
     value:"tbn"
  },
  {
     label:"Tawala",
     value:"tbo"
  },
  {
     label:"Taworta",
     value:"tbp"
  },
  {
     label:"Tumtum",
     value:"tbr"
  },
  {
     label:"Tanguat",
     value:"tbs"
  },
  {
     label:"Tembo (Kitembo)",
     value:"tbt"
  },
  {
     label:"Tobo",
     value:"tbv"
  },
  {
     label:"Tagbanwa",
     value:"tbw"
  },
  {
     label:"Kapin",
     value:"tbx"
  },
  {
     label:"Tabaru",
     value:"tby"
  },
  {
     label:"Ditammari",
     value:"tbz"
  },
  {
     label:"Ticuna",
     value:"tca"
  },
  {
     label:"Tanacross",
     value:"tcb"
  },
  {
     label:"Datooga",
     value:"tcc"
  },
  {
     label:"Tafi",
     value:"tcd"
  },
  {
     label:"Southern Tutchone",
     value:"tce"
  },
  {
     label:"Malinaltepec Me'phaa",
     value:"tcf"
  },
  {
     label:"Tamagario",
     value:"tcg"
  },
  {
     label:"Turks And Caicos Creole English",
     value:"tch"
  },
  {
     label:"W\u00e1ra",
     value:"tci"
  },
  {
     label:"Tchitchege",
     value:"tck"
  },
  {
     label:"Tanahmerah",
     value:"tcm"
  },
  {
     label:"Tichurong",
     value:"tcn"
  },
  {
     label:"Taungyo",
     value:"tco"
  },
  {
     label:"Tawr Chin",
     value:"tcp"
  },
  {
     label:"Kaiy",
     value:"tcq"
  },
  {
     label:"Torres Strait Creole",
     value:"tcs"
  },
  {
     label:"T'en",
     value:"tct"
  },
  {
     label:"Southeastern Tarahumara",
     value:"tcu"
  },
  {
     label:"Tecpatl\u00e1n Totonac",
     value:"tcw"
  },
  {
     label:"Toda",
     value:"tcx"
  },
  {
     label:"Tulu",
     value:"tcy"
  },
  {
     label:"Thado Chin",
     value:"tcz"
  },
  {
     label:"Tagdal",
     value:"tda"
  },
  {
     label:"Panchpargania",
     value:"tdb"
  },
  {
     label:"Ember\u00e1-Tad\u00f3",
     value:"tdc"
  },
  {
     label:"Tai N\u00fca",
     value:"tdd"
  },
  {
     label:"Tiranige Diga Dogon",
     value:"tde"
  },
  {
     label:"Talieng",
     value:"tdf"
  },
  {
     label:"Western Tamang",
     value:"tdg"
  },
  {
     label:"Thulung",
     value:"tdh"
  },
  {
     label:"Tomadino",
     value:"tdi"
  },
  {
     label:"Tajio",
     value:"tdj"
  },
  {
     label:"Tambas",
     value:"tdk"
  },
  {
     label:"Sur",
     value:"tdl"
  },
  {
     label:"Taruma",
     value:"tdm"
  },
  {
     label:"Tondano",
     value:"tdn"
  },
  {
     label:"Teme",
     value:"tdo"
  },
  {
     label:"Tita",
     value:"tdq"
  },
  {
     label:"Todrah",
     value:"tdr"
  },
  {
     label:"Doutai",
     value:"tds"
  },
  {
     label:"Tetun Dili",
     value:"tdt"
  },
  {
     label:"Toro",
     value:"tdv"
  },
  {
     label:"Tandroy-Mahafaly Malagasy",
     value:"tdx"
  },
  {
     label:"Tadyawan",
     value:"tdy"
  },
  {
     label:"Temiar",
     value:"tea"
  },
  {
     label:"Terik",
     value:"tec"
  },
  {
     label:"Tepo Krumen",
     value:"ted"
  },
  {
     label:"Huehuetla Tepehua",
     value:"tee"
  },
  {
     label:"Teressa",
     value:"tef"
  },
  {
     label:"Teke-Tege",
     value:"teg"
  },
  {
     label:"Tehuelche",
     value:"teh"
  },
  {
     label:"Torricelli",
     value:"tei"
  },
  {
     label:"Ibali Teke",
     value:"tek"
  },
  {
     label:"Telugu",
     value:"tel",
     "iso6392B":"tel",
     "iso6392T":"tel",
     "iso6391":"te"
  },
  {
     label:"Timne",
     value:"tem",
     "iso6392B":"tem",
     "iso6392T":"tem"
  },
  {
     label:"Teso",
     value:"teo"
  },
  {
     label:"Temein",
     value:"teq"
  },
  {
     label:"Tereno",
     value:"ter",
     "iso6392B":"ter",
     "iso6392T":"ter"
  },
  {
     label:"Tengger",
     value:"tes"
  },
  {
     label:"Tetum",
     value:"tet",
     "iso6392B":"tet",
     "iso6392T":"tet"
  },
  {
     label:"Soo",
     value:"teu"
  },
  {
     label:"Teor",
     value:"tev"
  },
  {
     label:"Tewa (USA)",
     value:"tew"
  },
  {
     label:"Tennet",
     value:"tex"
  },
  {
     label:"Tulishi",
     value:"tey"
  },
  {
     label:"Tetserret",
     value:"tez"
  },
  {
     label:"Tofin Gbe",
     value:"tfi"
  },
  {
     label:"Tanaina",
     value:"tfn"
  },
  {
     label:"Tefaro",
     value:"tfo"
  },
  {
     label:"Teribe",
     value:"tfr"
  },
  {
     label:"Ternate",
     value:"tft"
  },
  {
     label:"Sagalla",
     value:"tga"
  },
  {
     label:"Tobilung",
     value:"tgb"
  },
  {
     label:"Tigak",
     value:"tgc"
  },
  {
     label:"Ciwogai",
     value:"tgd"
  },
  {
     label:"Eastern Gorkha Tamang",
     value:"tge"
  },
  {
     label:"Chalikha",
     value:"tgf"
  },
  {
     label:"Tobagonian Creole English",
     value:"tgh"
  },
  {
     label:"Lawunuia",
     value:"tgi"
  },
  {
     label:"Tagin",
     value:"tgj"
  },
  {
     label:"Tajik",
     value:"tgk",
     "iso6392B":"tgk",
     "iso6392T":"tgk",
     "iso6391":"tg"
  },
  {
     label:"Tagalog",
     value:"tgl",
     "iso6392B":"tgl",
     "iso6392T":"tgl",
     "iso6391":"tl"
  },
  {
     label:"Tandaganon",
     value:"tgn"
  },
  {
     label:"Sudest",
     value:"tgo"
  },
  {
     label:"Tangoa",
     value:"tgp"
  },
  {
     label:"Tring",
     value:"tgq"
  },
  {
     label:"Tareng",
     value:"tgr"
  },
  {
     label:"Nume",
     value:"tgs"
  },
  {
     label:"Central Tagbanwa",
     value:"tgt"
  },
  {
     label:"Tanggu",
     value:"tgu"
  },
  {
     label:"Tagwana Senoufo",
     value:"tgw"
  },
  {
     label:"Tagish",
     value:"tgx"
  },
  {
     label:"Thai",
     value:"tha",
     "iso6392B":"tha",
     "iso6392T":"tha",
     "iso6391":"th"
  },
  {
     label:"Kuuk Thaayorre",
     value:"thd"
  },
  {
     label:"Chitwania Tharu",
     value:"the"
  },
  {
     label:"Thangmi",
     value:"thf"
  },
  {
     label:"Northern Tarahumara",
     value:"thh"
  },
  {
     label:"Tai Long",
     value:"thi"
  },
  {
     label:"Tharaka",
     value:"thk"
  },
  {
     label:"Dangaura Tharu",
     value:"thl"
  },
  {
     label:"Aheu",
     value:"thm"
  },
  {
     label:"Thachanadan",
     value:"thn"
  },
  {
     label:"Thompson",
     value:"thp"
  },
  {
     label:"Kochila Tharu",
     value:"thq"
  },
  {
     label:"Rana Tharu",
     value:"thr"
  },
  {
     label:"Thakali",
     value:"ths"
  },
  {
     label:"Tahltan",
     value:"tht"
  },
  {
     label:"Thuri",
     value:"thu"
  },
  {
     label:"Tahaggart Tamahaq",
     value:"thv"
  },
  {
     label:"Tha",
     value:"thy"
  },
  {
     label:"Tayart Tamajeq",
     value:"thz"
  },
  {
     label:"Tidikelt Tamazight",
     value:"tia"
  },
  {
     label:"Tira",
     value:"tic"
  },
  {
     label:"Tifal",
     value:"tif"
  },
  {
     label:"Tigre",
     value:"tig",
     "iso6392B":"tig",
     "iso6392T":"tig"
  },
  {
     label:"Timugon Murut",
     value:"tih"
  },
  {
     label:"Tiene",
     value:"tii"
  },
  {
     label:"Tilung",
     value:"tij"
  },
  {
     label:"Tikar",
     value:"tik"
  },
  {
     label:"Timbe",
     value:"tim"
  },
  {
     label:"Tindi",
     value:"tin"
  },
  {
     label:"Teop",
     value:"tio"
  },
  {
     label:"Trimuris",
     value:"tip"
  },
  {
     label:"Ti\u00e9fo",
     value:"tiq"
  },
  {
     label:"Tigrinya",
     value:"tir",
     "iso6392B":"tir",
     "iso6392T":"tir",
     "iso6391":"ti"
  },
  {
     label:"Masadiit Itneg",
     value:"tis"
  },
  {
     label:"Tinigua",
     value:"tit"
  },
  {
     label:"Adasen",
     value:"tiu"
  },
  {
     label:"Tiv",
     value:"tiv",
     "iso6392B":"tiv",
     "iso6392T":"tiv"
  },
  {
     label:"Tiwi",
     value:"tiw"
  },
  {
     label:"Southern Tiwa",
     value:"tix"
  },
  {
     label:"Tiruray",
     value:"tiy"
  },
  {
     label:"Tai Hongjin",
     value:"tiz"
  },
  {
     label:"Tajuasohn",
     value:"tja"
  },
  {
     label:"Tunjung",
     value:"tjg"
  },
  {
     label:"Northern Tujia",
     value:"tji"
  },
  {
     label:"Tjungundji",
     value:"tjj"
  },
  {
     label:"Tai Laing",
     value:"tjl"
  },
  {
     label:"Temacine Tamazight",
     value:"tjo"
  },
  {
     label:"Tjupany",
     value:"tjp"
  },
  {
     label:"Southern Tujia",
     value:"tjs"
  },
  {
     label:"Djabwurrung",
     value:"tjw"
  },
  {
     label:"Buksa",
     value:"tkb"
  },
  {
     label:"Tukudede",
     value:"tkd"
  },
  {
     label:"Takwane",
     value:"tke"
  },
  {
     label:"Tesaka Malagasy",
     value:"tkg"
  },
  {
     label:"Tokelau",
     value:"tkl",
     "iso6392B":"tkl",
     "iso6392T":"tkl"
  },
  {
     label:"Toku-No-Shima",
     value:"tkn"
  },
  {
     label:"Tikopia",
     value:"tkp"
  },
  {
     label:"Tee",
     value:"tkq"
  },
  {
     label:"Tsakhur",
     value:"tkr"
  },
  {
     label:"Takestani",
     value:"tks"
  },
  {
     label:"Kathoriya Tharu",
     value:"tkt"
  },
  {
     label:"Upper Necaxa Totonac",
     value:"tku"
  },
  {
     label:"Mur Pano",
     value:"tkv"
  },
  {
     label:"Teanu",
     value:"tkw"
  },
  {
     label:"Tangko",
     value:"tkx"
  },
  {
     label:"Takua",
     value:"tkz"
  },
  {
     label:"Southwestern Tepehuan",
     value:"tla"
  },
  {
     label:"Tobelo",
     value:"tlb"
  },
  {
     label:"Yecuatla Totonac",
     value:"tlc"
  },
  {
     label:"Talaud",
     value:"tld"
  },
  {
     label:"Telefol",
     value:"tlf"
  },
  {
     label:"Tofanma",
     value:"tlg"
  },
  {
     label:"Klingon",
     value:"tlh",
     "iso6392B":"tlh",
     "iso6392T":"tlh"
  },
  {
     label:"Tlingit",
     value:"tli",
     "iso6392B":"tli",
     "iso6392T":"tli"
  },
  {
     label:"Talinga-Bwisi",
     value:"tlj"
  },
  {
     label:"Taloki",
     value:"tlk"
  },
  {
     label:"Tetela",
     value:"tll"
  },
  {
     label:"Tolomako",
     value:"tlm"
  },
  {
     label:"Talondo'",
     value:"tln"
  },
  {
     label:"Talodi",
     value:"tlo"
  },
  {
     label:"Filomena Mata-Coahuitl\u00e1n Totonac",
     value:"tlp"
  },
  {
     label:"Tai Loi",
     value:"tlq"
  },
  {
     label:"Talise",
     value:"tlr"
  },
  {
     label:"Tambotalo",
     value:"tls"
  },
  {
     label:"Sou Nama",
     value:"tlt"
  },
  {
     label:"Tulehu",
     value:"tlu"
  },
  {
     label:"Taliabu",
     value:"tlv"
  },
  {
     label:"Khehek",
     value:"tlx"
  },
  {
     label:"Talysh",
     value:"tly"
  },
  {
     label:"Tama (Chad)",
     value:"tma"
  },
  {
     label:"Katbol",
     value:"tmb"
  },
  {
     label:"Tumak",
     value:"tmc"
  },
  {
     label:"Haruai",
     value:"tmd"
  },
  {
     label:"Toba-Maskoy",
     value:"tmf"
  },
  {
     label:"Tamashek",
     value:"tmh",
     "iso6392B":"tmh",
     "iso6392T":"tmh"
  },
  {
     label:"Tutuba",
     value:"tmi"
  },
  {
     label:"Samarokena",
     value:"tmj"
  },
  {
     label:"Northwestern Tamang",
     value:"tmk"
  },
  {
     label:"Tamnim Citak",
     value:"tml"
  },
  {
     label:"Tai Thanh",
     value:"tmm"
  },
  {
     label:"Taman (Indonesia)",
     value:"tmn"
  },
  {
     label:"Temoq",
     value:"tmo"
  },
  {
     label:"Tumleo",
     value:"tmq"
  },
  {
     label:"Tima",
     value:"tms"
  },
  {
     label:"Tasmate",
     value:"tmt"
  },
  {
     label:"Iau",
     value:"tmu"
  },
  {
     label:"Tembo (Motembo)",
     value:"tmv"
  },
  {
     label:"Temuan",
     value:"tmw"
  },
  {
     label:"Tami",
     value:"tmy"
  },
  {
     label:"Tacana",
     value:"tna"
  },
  {
     label:"Western Tunebo",
     value:"tnb"
  },
  {
     label:"Tanimuca-Retuar\u00e3",
     value:"tnc"
  },
  {
     label:"Angosturas Tunebo",
     value:"tnd"
  },
  {
     label:"Tobanga",
     value:"tng"
  },
  {
     label:"Maiani",
     value:"tnh"
  },
  {
     label:"Tandia",
     value:"tni"
  },
  {
     label:"Kwamera",
     value:"tnk"
  },
  {
     label:"Lenakel",
     value:"tnl"
  },
  {
     label:"Tabla",
     value:"tnm"
  },
  {
     label:"North Tanna",
     value:"tnn"
  },
  {
     label:"Toromono",
     value:"tno"
  },
  {
     label:"Whitesands",
     value:"tnp"
  },
  {
     label:"M\u00e9nik",
     value:"tnr"
  },
  {
     label:"Tenis",
     value:"tns"
  },
  {
     label:"Tontemboan",
     value:"tnt"
  },
  {
     label:"Tay Khang",
     value:"tnu"
  },
  {
     label:"Tangchangya",
     value:"tnv"
  },
  {
     label:"Tonsawang",
     value:"tnw"
  },
  {
     label:"Tanema",
     value:"tnx"
  },
  {
     label:"Tongwe",
     value:"tny"
  },
  {
     label:"Ten'edn",
     value:"tnz"
  },
  {
     label:"Toba",
     value:"tob"
  },
  {
     label:"Coyutla Totonac",
     value:"toc"
  },
  {
     label:"Toma",
     value:"tod"
  },
  {
     label:"Gizrra",
     value:"tof"
  },
  {
     label:"Tonga (Nyasa)",
     value:"tog",
     "iso6392B":"tog",
     "iso6392T":"tog"
  },
  {
     label:"Gitonga",
     value:"toh"
  },
  {
     label:"Tonga (Zambia)",
     value:"toi"
  },
  {
     label:"Tojolabal",
     value:"toj"
  },
  {
     label:"Tombulu",
     value:"tom"
  },
  {
     label:"Tonga (Tonga Islands)",
     value:"ton",
     "iso6392B":"ton",
     "iso6392T":"ton",
     "iso6391":"to"
  },
  {
     label:"Xicotepec De Ju\u00e1rez Totonac",
     value:"too"
  },
  {
     label:"Papantla Totonac",
     value:"top"
  },
  {
     label:"Toposa",
     value:"toq"
  },
  {
     label:"Togbo-Vara Banda",
     value:"tor"
  },
  {
     label:"Highland Totonac",
     value:"tos"
  },
  {
     label:"Tho",
     value:"tou"
  },
  {
     label:"Upper Taromi",
     value:"tov"
  },
  {
     label:"Jemez",
     value:"tow"
  },
  {
     label:"Tobian",
     value:"tox"
  },
  {
     label:"Topoiyo",
     value:"toy"
  },
  {
     label:"To",
     value:"toz"
  },
  {
     label:"Taupota",
     value:"tpa"
  },
  {
     label:"Azoy\u00fa Me'phaa",
     value:"tpc"
  },
  {
     label:"Tippera",
     value:"tpe"
  },
  {
     label:"Tarpia",
     value:"tpf"
  },
  {
     label:"Kula",
     value:"tpg"
  },
  {
     label:"Tok Pisin",
     value:"tpi",
     "iso6392B":"tpi",
     "iso6392T":"tpi"
  },
  {
     label:"Tapiet\u00e9",
     value:"tpj"
  },
  {
     label:"Tlacoapa Me'phaa",
     value:"tpl"
  },
  {
     label:"Tampulma",
     value:"tpm"
  },
  {
     label:"Tai Pao",
     value:"tpo"
  },
  {
     label:"Pisaflores Tepehua",
     value:"tpp"
  },
  {
     label:"Tukpa",
     value:"tpq"
  },
  {
     label:"Tupar\u00ed",
     value:"tpr"
  },
  {
     label:"Tlachichilco Tepehua",
     value:"tpt"
  },
  {
     label:"Tampuan",
     value:"tpu"
  },
  {
     label:"Tanapag",
     value:"tpv"
  },
  {
     label:"Acatepec Me'phaa",
     value:"tpx"
  },
  {
     label:"Trumai",
     value:"tpy"
  },
  {
     label:"Tinputz",
     value:"tpz"
  },
  {
     label:"Temb\u00e9",
     value:"tqb"
  },
  {
     label:"Lehali",
     value:"tql"
  },
  {
     label:"Turumsa",
     value:"tqm"
  },
  {
     label:"Tenino",
     value:"tqn"
  },
  {
     label:"Toaripi",
     value:"tqo"
  },
  {
     label:"Tomoip",
     value:"tqp"
  },
  {
     label:"Tunni",
     value:"tqq"
  },
  {
     label:"Western Totonac",
     value:"tqt"
  },
  {
     label:"Touo",
     value:"tqu"
  },
  {
     label:"Tirahi",
     value:"tra"
  },
  {
     label:"Terebu",
     value:"trb"
  },
  {
     label:"Copala Triqui",
     value:"trc"
  },
  {
     label:"Turi",
     value:"trd"
  },
  {
     label:"East Tarangan",
     value:"tre"
  },
  {
     label:"Trinidadian Creole English",
     value:"trf"
  },
  {
     label:"Lish\u00e1n Did\u00e1n",
     value:"trg"
  },
  {
     label:"Turaka",
     value:"trh"
  },
  {
     label:"Tri\u00f3",
     value:"tri"
  },
  {
     label:"Toram",
     value:"trj"
  },
  {
     label:"Traveller Scottish",
     value:"trl"
  },
  {
     label:"Tregami",
     value:"trm"
  },
  {
     label:"Trinitario",
     value:"trn"
  },
  {
     label:"Tarao Naga",
     value:"tro"
  },
  {
     label:"Kok Borok",
     value:"trp"
  },
  {
     label:"San Mart\u00edn Itunyoso Triqui",
     value:"trq"
  },
  {
     label:"Taushiro",
     value:"trr"
  },
  {
     label:"Chicahuaxtla Triqui",
     value:"trs"
  },
  {
     label:"Tunggare",
     value:"trt"
  },
  {
     label:"Turoyo",
     value:"tru"
  },
  {
     label:"Taroko",
     value:"trv"
  },
  {
     label:"Torwali",
     value:"trw"
  },
  {
     label:"Tringgus-Sembaan Bidayuh",
     value:"trx"
  },
  {
     label:"Tsaangi",
     value:"tsa"
  },
  {
     label:"Tsamai",
     value:"tsb"
  },
  {
     label:"Tswa",
     value:"tsc"
  },
  {
     label:"Tsakonian",
     value:"tsd"
  },
  {
     label:"Tausug",
     value:"tsg"
  },
  {
     label:"Tsuvan",
     value:"tsh"
  },
  {
     label:"Tsimshian",
     value:"tsi",
     "iso6392B":"tsi",
     "iso6392T":"tsi"
  },
  {
     label:"Tshangla",
     value:"tsj"
  },
  {
     label:"Tseku",
     value:"tsk"
  },
  {
     label:"Ts'\u00fcn-Lao",
     value:"tsl"
  },
  {
     label:"Tswana",
     value:"tsn",
     "iso6392B":"tsn",
     "iso6392T":"tsn",
     "iso6391":"tn"
  },
  {
     label:"Tsonga",
     value:"tso",
     "iso6392B":"tso",
     "iso6392T":"tso",
     "iso6391":"ts"
  },
  {
     label:"Northern Toussian",
     value:"tsp"
  },
  {
     label:"Akei",
     value:"tsr"
  },
  {
     label:"Tondi Songway Kiini",
     value:"tst"
  },
  {
     label:"Tsou",
     value:"tsu"
  },
  {
     label:"Tsogo",
     value:"tsv"
  },
  {
     label:"Tsishingini",
     value:"tsw"
  },
  {
     label:"Mubami",
     value:"tsx"
  },
  {
     label:"Purepecha",
     value:"tsz"
  },
  {
     label:"Gaa",
     value:"ttb"
  },
  {
     label:"Tektiteko",
     value:"ttc"
  },
  {
     label:"Tauade",
     value:"ttd"
  },
  {
     label:"Bwanabwana",
     value:"tte"
  },
  {
     label:"Tuotomb",
     value:"ttf"
  },
  {
     label:"Tutong",
     value:"ttg"
  },
  {
     label:"Upper Ta'oih",
     value:"tth"
  },
  {
     label:"Tobati",
     value:"tti"
  },
  {
     label:"Tooro",
     value:"ttj"
  },
  {
     label:"Totoro",
     value:"ttk"
  },
  {
     label:"Totela",
     value:"ttl"
  },
  {
     label:"Northern Tutchone",
     value:"ttm"
  },
  {
     label:"Towei",
     value:"ttn"
  },
  {
     label:"Lower Ta'oih",
     value:"tto"
  },
  {
     label:"Tombelala",
     value:"ttp"
  },
  {
     label:"Tawallammat Tamajaq",
     value:"ttq"
  },
  {
     label:"Tera",
     value:"ttr"
  },
  {
     label:"Northeastern Thai",
     value:"tts"
  },
  {
     label:"Muslim Tat",
     value:"ttt"
  },
  {
     label:"Torau",
     value:"ttu"
  },
  {
     label:"Titan",
     value:"ttv"
  },
  {
     label:"Long Wat",
     value:"ttw"
  },
  {
     label:"Sikaritai",
     value:"tty"
  },
  {
     label:"Tsum",
     value:"ttz"
  },
  {
     label:"Wiarumus",
     value:"tua"
  },
  {
     label:"Mutu",
     value:"tuc"
  },
  {
     label:"Tuyuca",
     value:"tue"
  },
  {
     label:"Central Tunebo",
     value:"tuf"
  },
  {
     label:"Tunia",
     value:"tug"
  },
  {
     label:"Taulil",
     value:"tuh"
  },
  {
     label:"Tupuri",
     value:"tui"
  },
  {
     label:"Tugutil",
     value:"tuj"
  },
  {
     label:"Turkmen",
     value:"tuk",
     "iso6392B":"tuk",
     "iso6392T":"tuk",
     "iso6391":"tk"
  },
  {
     label:"Tula",
     value:"tul"
  },
  {
     label:"Tumbuka",
     value:"tum",
     "iso6392B":"tum",
     "iso6392T":"tum"
  },
  {
     label:"Tunica",
     value:"tun"
  },
  {
     label:"Tucano",
     value:"tuo"
  },
  {
     label:"Tedaga",
     value:"tuq"
  },
  {
     label:"Turkish",
     value:"tur",
     "iso6392B":"tur",
     "iso6392T":"tur",
     "iso6391":"tr"
  },
  {
     label:"Tuscarora",
     value:"tus"
  },
  {
     label:"Tututni",
     value:"tuu"
  },
  {
     label:"Turkana",
     value:"tuv"
  },
  {
     label:"Tugen",
     value:"tuy"
  },
  {
     label:"Turka",
     value:"tuz"
  },
  {
     label:"Vaghua",
     value:"tva"
  },
  {
     label:"Tsuvadi",
     value:"tvd"
  },
  {
     label:"Te'un",
     value:"tve"
  },
  {
     label:"Southeast Ambrym",
     value:"tvk"
  },
  {
     label:"Tuvalu",
     value:"tvl",
     "iso6392B":"tvl",
     "iso6392T":"tvl"
  },
  {
     label:"Tela-Masbuar",
     value:"tvm"
  },
  {
     label:"Tavoyan",
     value:"tvn"
  },
  {
     label:"Tidore",
     value:"tvo"
  },
  {
     label:"Taveta",
     value:"tvs"
  },
  {
     label:"Tutsa Naga",
     value:"tvt"
  },
  {
     label:"Tunen",
     value:"tvu"
  },
  {
     label:"Sedoa",
     value:"tvw"
  },
  {
     label:"Western Tawbuid",
     value:"twb"
  },
  {
     label:"Twents",
     value:"twd"
  },
  {
     label:"Tewa (Indonesia)",
     value:"twe"
  },
  {
     label:"Northern Tiwa",
     value:"twf"
  },
  {
     label:"Tereweng",
     value:"twg"
  },
  {
     label:"Tai D\u00f3n",
     value:"twh"
  },
  {
     label:"Twi",
     value:"twi",
     "iso6392B":"twi",
     "iso6392T":"twi",
     "iso6391":"tw"
  },
  {
     label:"Tawara",
     value:"twl"
  },
  {
     label:"Tawang Monpa",
     value:"twm"
  },
  {
     label:"Twendi",
     value:"twn"
  },
  {
     label:"Tswapong",
     value:"two"
  },
  {
     label:"Ere",
     value:"twp"
  },
  {
     label:"Tasawaq",
     value:"twq"
  },
  {
     label:"Southwestern Tarahumara",
     value:"twr"
  },
  {
     label:"Termanu",
     value:"twu"
  },
  {
     label:"Tuwari",
     value:"tww"
  },
  {
     label:"Tewe",
     value:"twx"
  },
  {
     label:"Tawoyan",
     value:"twy"
  },
  {
     label:"Tombonuo",
     value:"txa"
  },
  {
     label:"Totoli",
     value:"txe"
  },
  {
     label:"Ikpeng",
     value:"txi"
  },
  {
     label:"Tarjumo",
     value:"txj"
  },
  {
     label:"Tomini",
     value:"txm"
  },
  {
     label:"West Tarangan",
     value:"txn"
  },
  {
     label:"Toto",
     value:"txo"
  },
  {
     label:"Tii",
     value:"txq"
  },
  {
     label:"Tonsea",
     value:"txs"
  },
  {
     label:"Citak",
     value:"txt"
  },
  {
     label:"Kayap\u00f3",
     value:"txu"
  },
  {
     label:"Tatana",
     value:"txx"
  },
  {
     label:"Tanosy Malagasy",
     value:"txy"
  },
  {
     label:"Tauya",
     value:"tya"
  },
  {
     label:"Kyanga",
     value:"tye"
  },
  {
     label:"O'du",
     value:"tyh"
  },
  {
     label:"Teke-Tsaayi",
     value:"tyi"
  },
  {
     label:"Tai Do",
     value:"tyj"
  },
  {
     label:"Thu Lao",
     value:"tyl"
  },
  {
     label:"Kombai",
     value:"tyn"
  },
  {
     label:"Tai Daeng",
     value:"tyr"
  },
  {
     label:"T\u00e0y Sa Pa",
     value:"tys"
  },
  {
     label:"T\u00e0y Tac",
     value:"tyt"
  },
  {
     label:"Kua",
     value:"tyu"
  },
  {
     label:"Tuvinian",
     value:"tyv",
     "iso6392B":"tyv",
     "iso6392T":"tyv"
  },
  {
     label:"Teke-Tyee",
     value:"tyx"
  },
  {
     label:"T\u00e0y",
     value:"tyz"
  },
  {
     label:"Tzeltal",
     value:"tzh"
  },
  {
     label:"Tz'utujil",
     value:"tzj"
  },
  {
     label:"Talossan",
     value:"tzl"
  },
  {
     label:"Central Atlas Tamazight",
     value:"tzm"
  },
  {
     label:"Tugun",
     value:"tzn"
  },
  {
     label:"Tzotzil",
     value:"tzo"
  },
  {
     label:"Tabriak",
     value:"tzx"
  },
  {
     label:"Kuan",
     value:"uan"
  },
  {
     label:"Tairuma",
     value:"uar"
  },
  {
     label:"Ubang",
     value:"uba"
  },
  {
     label:"Ubi",
     value:"ubi"
  },
  {
     label:"Buhi'non Bikol",
     value:"ubl"
  },
  {
     label:"Ubir",
     value:"ubr"
  },
  {
     label:"Umbu-Ungu",
     value:"ubu"
  },
  {
     label:"Uda",
     value:"uda"
  },
  {
     label:"Udihe",
     value:"ude"
  },
  {
     label:"Muduga",
     value:"udg"
  },
  {
     label:"Udi",
     value:"udi"
  },
  {
     label:"Ujir",
     value:"udj"
  },
  {
     label:"Wuzlam",
     value:"udl"
  },
  {
     label:"Udmurt",
     value:"udm",
     "iso6392B":"udm",
     "iso6392T":"udm"
  },
  {
     label:"Uduk",
     value:"udu"
  },
  {
     label:"Kioko",
     value:"ues"
  },
  {
     label:"Ufim",
     value:"ufi"
  },
  {
     label:"Ughele",
     value:"uge"
  },
  {
     label:"Ugong",
     value:"ugo"
  },
  {
     label:"Uhami",
     value:"uha"
  },
  {
     label:"Damal",
     value:"uhn"
  },
  {
     label:"Uighur",
     value:"uig",
     "iso6392B":"uig",
     "iso6392T":"uig",
     "iso6391":"ug"
  },
  {
     label:"Uisai",
     value:"uis"
  },
  {
     label:"Iyive",
     value:"uiv"
  },
  {
     label:"Tanjijili",
     value:"uji"
  },
  {
     label:"Kaburi",
     value:"uka"
  },
  {
     label:"Ukuriguma",
     value:"ukg"
  },
  {
     label:"Ukhwejo",
     value:"ukh"
  },
  {
     label:"Kui (India)",
     value:"uki"
  },
  {
     label:"Muak Sa-aak",
     value:"ukk"
  },
  {
     label:"Ukpe-Bayobiri",
     value:"ukp"
  },
  {
     label:"Ukwa",
     value:"ukq"
  },
  {
     label:"Ukrainian",
     value:"ukr",
     "iso6392B":"ukr",
     "iso6392T":"ukr",
     "iso6391":"uk"
  },
  {
     label:"Ukue",
     value:"uku"
  },
  {
     label:"Kuku",
     value:"ukv"
  },
  {
     label:"Ukwuani-Aboh-Ndoni",
     value:"ukw"
  },
  {
     label:"Fungwa",
     value:"ula"
  },
  {
     label:"Ulukwumi",
     value:"ulb"
  },
  {
     label:"Ulch",
     value:"ulc"
  },
  {
     label:"Usku",
     value:"ulf"
  },
  {
     label:"Ulithian",
     value:"uli"
  },
  {
     label:"Meriam Mir",
     value:"ulk"
  },
  {
     label:"Ullatan",
     value:"ull"
  },
  {
     label:"Ulumanda'",
     value:"ulm"
  },
  {
     label:"Unserdeutsch",
     value:"uln"
  },
  {
     label:"Uma' Lung",
     value:"ulu"
  },
  {
     label:"Ulwa",
     value:"ulw"
  },
  {
     label:"Umatilla",
     value:"uma"
  },
  {
     label:"Umbundu",
     value:"umb",
     "iso6392B":"umb",
     "iso6392T":"umb"
  },
  {
     label:"Ukit",
     value:"umi"
  },
  {
     label:"Umon",
     value:"umm"
  },
  {
     label:"Makyan Naga",
     value:"umn"
  },
  {
     label:"Umpila",
     value:"ump"
  },
  {
     label:"Pendau",
     value:"ums"
  },
  {
     label:"Munsee",
     value:"umu"
  },
  {
     label:"North Watut",
     value:"una"
  },
  {
     label:"Undetermined",
     value:"und",
     "iso6392B":"und",
     "iso6392T":"und"
  },
  {
     label:"Uneme",
     value:"une"
  },
  {
     label:"Ngarinyin",
     value:"ung"
  },
  {
     label:"Enawen\u00e9-Naw\u00e9",
     value:"unk"
  },
  {
     label:"Kurnai",
     value:"unn"
  },
  {
     label:"Mundari",
     value:"unr"
  },
  {
     label:"Unubahe",
     value:"unu"
  },
  {
     label:"Munda",
     value:"unx"
  },
  {
     label:"Unde Kaili",
     value:"unz"
  },
  {
     label:"Umeda",
     value:"upi"
  },
  {
     label:"Uripiv-Wala-Rano-Atchin",
     value:"upv"
  },
  {
     label:"Urarina",
     value:"ura"
  },
  {
     label:"Urub\u00fa-Kaapor",
     value:"urb"
  },
  {
     label:"Urdu",
     value:"urd",
     "iso6392B":"urd",
     "iso6392T":"urd",
     "iso6391":"ur"
  },
  {
     label:"Uru",
     value:"ure"
  },
  {
     label:"Urigina",
     value:"urg"
  },
  {
     label:"Urhobo",
     value:"urh"
  },
  {
     label:"Urim",
     value:"uri"
  },
  {
     label:"Urak Lawoi'",
     value:"urk"
  },
  {
     label:"Urali",
     value:"url"
  },
  {
     label:"Urapmin",
     value:"urm"
  },
  {
     label:"Uruangnirin",
     value:"urn"
  },
  {
     label:"Ura (Papua New Guinea)",
     value:"uro"
  },
  {
     label:"Uru-Pa-In",
     value:"urp"
  },
  {
     label:"Lehalurup",
     value:"urr"
  },
  {
     label:"Urat",
     value:"urt"
  },
  {
     label:"Sop",
     value:"urw"
  },
  {
     label:"Urimo",
     value:"urx"
  },
  {
     label:"Orya",
     value:"ury"
  },
  {
     label:"Uru-Eu-Wau-Wau",
     value:"urz"
  },
  {
     label:"Usarufa",
     value:"usa"
  },
  {
     label:"Ushojo",
     value:"ush"
  },
  {
     label:"Usui",
     value:"usi"
  },
  {
     label:"Usaghade",
     value:"usk"
  },
  {
     label:"Uspanteco",
     value:"usp"
  },
  {
     label:"us-Saare",
     value:"uss"
  },
  {
     label:"Uya",
     value:"usu"
  },
  {
     label:"Otank",
     value:"uta"
  },
  {
     label:"Ute-Southern Paiute",
     value:"ute"
  },
  {
     label:"ut-Hun",
     value:"uth"
  },
  {
     label:"Amba (Solomon Islands)",
     value:"utp"
  },
  {
     label:"Etulo",
     value:"utr"
  },
  {
     label:"Utu",
     value:"utu"
  },
  {
     label:"Urum",
     value:"uum"
  },
  {
     label:"Kulon-Pazeh",
     value:"uun"
  },
  {
     label:"Ura (Vanuatu)",
     value:"uur"
  },
  {
     label:"U",
     value:"uuu"
  },
  {
     label:"West Uvean",
     value:"uve"
  },
  {
     label:"Uri",
     value:"uvh"
  },
  {
     label:"Lote",
     value:"uvl"
  },
  {
     label:"Kuku-Uwanh",
     value:"uwa"
  },
  {
     label:"Doko-Uyanga",
     value:"uya"
  },
  {
     label:"Uzbek",
     value:"uzb",
     "iso6392B":"uzb",
     "iso6392T":"uzb",
     "iso6391":"uz"
  },
  {
     label:"Northern Uzbek",
     value:"uzn"
  },
  {
     label:"Southern Uzbek",
     value:"uzs"
  },
  {
     label:"Vaagri Booli",
     value:"vaa"
  },
  {
     label:"Vale",
     value:"vae"
  },
  {
     label:"Vafsi",
     value:"vaf"
  },
  {
     label:"Vagla",
     value:"vag"
  },
  {
     label:"Varhadi-Nagpuri",
     value:"vah"
  },
  {
     label:"Vai",
     value:"vai",
     "iso6392B":"vai",
     "iso6392T":"vai"
  },
  {
     label:"Sekele",
     value:"vaj"
  },
  {
     label:"Vehes",
     value:"val"
  },
  {
     label:"Vanimo",
     value:"vam"
  },
  {
     label:"Valman",
     value:"van"
  },
  {
     label:"Vao",
     value:"vao"
  },
  {
     label:"Vaiphei",
     value:"vap"
  },
  {
     label:"Huarijio",
     value:"var"
  },
  {
     label:"Vasavi",
     value:"vas"
  },
  {
     label:"Vanuma",
     value:"vau"
  },
  {
     label:"Varli",
     value:"vav"
  },
  {
     label:"Wayu",
     value:"vay"
  },
  {
     label:"Southeast Babar",
     value:"vbb"
  },
  {
     label:"Southwestern Bontok",
     value:"vbk"
  },
  {
     label:"Venetian",
     value:"vec"
  },
  {
     label:"Veddah",
     value:"ved"
  },
  {
     label:"Veluws",
     value:"vel"
  },
  {
     label:"Vemgo-Mabas",
     value:"vem"
  },
  {
     label:"Venda",
     value:"ven",
     "iso6392B":"ven",
     "iso6392T":"ven",
     "iso6391":"ve"
  },
  {
     label:"Veps",
     value:"vep"
  },
  {
     label:"Mom Jango",
     value:"ver"
  },
  {
     label:"Vaghri",
     value:"vgr"
  },
  {
     label:"Vlaamse Gebarentaal",
     value:"vgt"
  },
  {
     label:"Virgin Islands Creole English",
     value:"vic"
  },
  {
     label:"Vidunda",
     value:"vid"
  },
  {
     label:"Vietnamese",
     value:"vie",
     "iso6392B":"vie",
     "iso6392T":"vie",
     "iso6391":"vi"
  },
  {
     label:"Vili",
     value:"vif"
  },
  {
     label:"Viemo",
     value:"vig"
  },
  {
     label:"Vilela",
     value:"vil"
  },
  {
     label:"Vinza",
     value:"vin"
  },
  {
     label:"Vishavan",
     value:"vis"
  },
  {
     label:"Viti",
     value:"vit"
  },
  {
     label:"Iduna",
     value:"viv"
  },
  {
     label:"Ija-Zuba",
     value:"vki"
  },
  {
     label:"Kujarge",
     value:"vkj"
  },
  {
     label:"Kaur",
     value:"vkk"
  },
  {
     label:"Kulisusu",
     value:"vkl"
  },
  {
     label:"Kodeoha",
     value:"vko"
  },
  {
     label:"Korlai Creole Portuguese",
     value:"vkp"
  },
  {
     label:"Tenggarong Kutai Malay",
     value:"vkt"
  },
  {
     label:"Kurrama",
     value:"vku"
  },
  {
     label:"Valpei",
     value:"vlp"
  },
  {
     label:"Vlaams",
     value:"vls"
  },
  {
     label:"Martuyhunira",
     value:"vma"
  },
  {
     label:"Juxtlahuaca Mixtec",
     value:"vmc"
  },
  {
     label:"Mudu Koraga",
     value:"vmd"
  },
  {
     label:"East Masela",
     value:"vme"
  },
  {
     label:"Mainfr\u00e4nkisch",
     value:"vmf"
  },
  {
     label:"Lungalunga",
     value:"vmg"
  },
  {
     label:"Maraghei",
     value:"vmh"
  },
  {
     label:"Ixtayutla Mixtec",
     value:"vmj"
  },
  {
     label:"Makhuwa-Shirima",
     value:"vmk"
  },
  {
     label:"Mitlatongo Mixtec",
     value:"vmm"
  },
  {
     label:"Soyaltepec Mazatec",
     value:"vmp"
  },
  {
     label:"Soyaltepec Mixtec",
     value:"vmq"
  },
  {
     label:"Marenje",
     value:"vmr"
  },
  {
     label:"Makhuwa",
     value:"vmw"
  },
  {
     label:"Tamazola Mixtec",
     value:"vmx"
  },
  {
     label:"Ayautla Mazatec",
     value:"vmy"
  },
  {
     label:"Mazatl\u00e1n Mazatec",
     value:"vmz"
  },
  {
     label:"Vano",
     value:"vnk"
  },
  {
     label:"Vinmavis",
     value:"vnm"
  },
  {
     label:"Vunapu",
     value:"vnp"
  },
  {
     label:"Volap\u00fck",
     value:"vol",
     "iso6392B":"vol",
     "iso6392T":"vol",
     "iso6391":"vo"
  },
  {
     label:"Voro",
     value:"vor"
  },
  {
     label:"Votic",
     value:"vot",
     "iso6392B":"vot",
     "iso6392T":"vot"
  },
  {
     label:"Vera'a",
     value:"vra"
  },
  {
     label:"V\u00f5ro",
     value:"vro"
  },
  {
     label:"Varisi",
     value:"vrs"
  },
  {
     label:"Burmbar",
     value:"vrt"
  },
  {
     label:"Vitou",
     value:"vto"
  },
  {
     label:"Vumbu",
     value:"vum"
  },
  {
     label:"Vunjo",
     value:"vun"
  },
  {
     label:"Vute",
     value:"vut"
  },
  {
     label:"Awa (China)",
     value:"vwa"
  },
  {
     label:"Walla Walla",
     value:"waa"
  },
  {
     label:"Wab",
     value:"wab"
  },
  {
     label:"Wandamen",
     value:"wad"
  },
  {
     label:"Walser",
     value:"wae"
  },
  {
     label:"Wa'ema",
     value:"wag"
  },
  {
     label:"Watubela",
     value:"wah"
  },
  {
     label:"Wares",
     value:"wai"
  },
  {
     label:"Waffa",
     value:"waj"
  },
  {
     label:"Wolaytta",
     value:"wal",
     "iso6392B":"wal",
     "iso6392T":"wal"
  },
  {
     label:"Wan",
     value:"wan"
  },
  {
     label:"Wapishana",
     value:"wap"
  },
  {
     label:"Wagiman",
     value:"waq"
  },
  {
     label:"Waray (Philippines)",
     value:"war",
     "iso6392B":"war",
     "iso6392T":"war"
  },
  {
     label:"Washo",
     value:"was",
     "iso6392B":"was",
     "iso6392T":"was"
  },
  {
     label:"Kaninuwa",
     value:"wat"
  },
  {
     label:"Waur\u00e1",
     value:"wau"
  },
  {
     label:"Waka",
     value:"wav"
  },
  {
     label:"Waiwai",
     value:"waw"
  },
  {
     label:"Watam",
     value:"wax"
  },
  {
     label:"Wayana",
     value:"way"
  },
  {
     label:"Wampur",
     value:"waz"
  },
  {
     label:"Warao",
     value:"wba"
  },
  {
     label:"Wabo",
     value:"wbb"
  },
  {
     label:"Waritai",
     value:"wbe"
  },
  {
     label:"Wara",
     value:"wbf"
  },
  {
     label:"Wanda",
     value:"wbh"
  },
  {
     label:"Vwanji",
     value:"wbi"
  },
  {
     label:"Alagwa",
     value:"wbj"
  },
  {
     label:"Waigali",
     value:"wbk"
  },
  {
     label:"Wakhi",
     value:"wbl"
  },
  {
     label:"Wa",
     value:"wbm"
  },
  {
     label:"Warlpiri",
     value:"wbp"
  },
  {
     label:"Waddar",
     value:"wbq"
  },
  {
     label:"Wagdi",
     value:"wbr"
  },
  {
     label:"Warnman",
     value:"wbt"
  },
  {
     label:"Wajarri",
     value:"wbv"
  },
  {
     label:"Woi",
     value:"wbw"
  },
  {
     label:"Yanom\u00e1mi",
     value:"wca"
  },
  {
     label:"Waci Gbe",
     value:"wci"
  },
  {
     label:"Wandji",
     value:"wdd"
  },
  {
     label:"Wadaginam",
     value:"wdg"
  },
  {
     label:"Wadjiginy",
     value:"wdj"
  },
  {
     label:"W\u00e8 Western",
     value:"wec"
  },
  {
     label:"Wedau",
     value:"wed"
  },
  {
     label:"Wergaia",
     value:"weg"
  },
  {
     label:"Weh",
     value:"weh"
  },
  {
     label:"Kiunum",
     value:"wei"
  },
  {
     label:"Weme Gbe",
     value:"wem"
  },
  {
     label:"Wemale",
     value:"weo"
  },
  {
     label:"Westphalien",
     value:"wep"
  },
  {
     label:"Weri",
     value:"wer"
  },
  {
     label:"Cameroon Pidgin",
     value:"wes"
  },
  {
     label:"Perai",
     value:"wet"
  },
  {
     label:"Rawngtu Chin",
     value:"weu"
  },
  {
     label:"Wejewa",
     value:"wew"
  },
  {
     label:"Yafi",
     value:"wfg"
  },
  {
     label:"Wagawaga",
     value:"wgb"
  },
  {
     label:"Wahgi",
     value:"wgi"
  },
  {
     label:"Waigeo",
     value:"wgo"
  },
  {
     label:"Warrgamay",
     value:"wgy"
  },
  {
     label:"Sou Upaa",
     value:"wha"
  },
  {
     label:"North Wahgi",
     value:"whg"
  },
  {
     label:"Wahau Kenyah",
     value:"whk"
  },
  {
     label:"Wahau Kayan",
     value:"whu"
  },
  {
     label:"Southern Toussian",
     value:"wib"
  },
  {
     label:"Wik Ngathan",
     value:"wig"
  },
  {
     label:"Wik-Me'anha",
     value:"wih"
  },
  {
     label:"Minidien",
     value:"wii"
  },
  {
     label:"Wik-Iiyanh",
     value:"wij"
  },
  {
     label:"Wikalkan",
     value:"wik"
  },
  {
     label:"Wik-Mungkan",
     value:"wim"
  },
  {
     label:"Ho-Chunk",
     value:"win"
  },
  {
     label:"Wiru",
     value:"wiu"
  },
  {
     label:"Vitu",
     value:"wiv"
  },
  {
     label:"Waja",
     value:"wja"
  },
  {
     label:"Warji",
     value:"wji"
  },
  {
     label:"Kumbaran",
     value:"wkb"
  },
  {
     label:"Wakde",
     value:"wkd"
  },
  {
     label:"Kalanadi",
     value:"wkl"
  },
  {
     label:"Keerray-Woorroong",
     value:"wkr"
  },
  {
     label:"Kunduvadi",
     value:"wku"
  },
  {
     label:"Walio",
     value:"wla"
  },
  {
     label:"Mwali Comorian",
     value:"wlc"
  },
  {
     label:"Wolane",
     value:"wle"
  },
  {
     label:"Kunbarlang",
     value:"wlg"
  },
  {
     label:"Welaun",
     value:"wlh"
  },
  {
     label:"Waioli",
     value:"wli"
  },
  {
     label:"Wali (Sudan)",
     value:"wll"
  },
  {
     label:"Walloon",
     value:"wln",
     "iso6392B":"wln",
     "iso6392T":"wln",
     "iso6391":"wa"
  },
  {
     label:"Wolio",
     value:"wlo"
  },
  {
     label:"Wailapa",
     value:"wlr"
  },
  {
     label:"Wallisian",
     value:"wls"
  },
  {
     label:"Wich\u00ed Lhamt\u00e9s Vejoz",
     value:"wlv"
  },
  {
     label:"Walak",
     value:"wlw"
  },
  {
     label:"Wali (Ghana)",
     value:"wlx"
  },
  {
     label:"Wambaya",
     value:"wmb"
  },
  {
     label:"Wamas",
     value:"wmc"
  },
  {
     label:"Mamaind\u00e9",
     value:"wmd"
  },
  {
     label:"Wambule",
     value:"wme"
  },
  {
     label:"Waima'a",
     value:"wmh"
  },
  {
     label:"Maiwa (Indonesia)",
     value:"wmm"
  },
  {
     label:"Wom (Papua New Guinea)",
     value:"wmo"
  },
  {
     label:"Wambon",
     value:"wms"
  },
  {
     label:"Walmajarri",
     value:"wmt"
  },
  {
     label:"Mwani",
     value:"wmw"
  },
  {
     label:"Womo",
     value:"wmx"
  },
  {
     label:"Wanambre",
     value:"wnb"
  },
  {
     label:"Wantoat",
     value:"wnc"
  },
  {
     label:"Waneci",
     value:"wne"
  },
  {
     label:"Wanggom",
     value:"wng"
  },
  {
     label:"Ndzwani Comorian",
     value:"wni"
  },
  {
     label:"Wanukaka",
     value:"wnk"
  },
  {
     label:"Wano",
     value:"wno"
  },
  {
     label:"Wanap",
     value:"wnp"
  },
  {
     label:"Usan",
     value:"wnu"
  },
  {
     label:"Wintu",
     value:"wnw"
  },
  {
     label:"Wanyi",
     value:"wny"
  },
  {
     label:"Kuwema",
     value:"woa"
  },
  {
     label:"W\u00e8 Northern",
     value:"wob"
  },
  {
     label:"Wogeo",
     value:"woc"
  },
  {
     label:"Wolani",
     value:"wod"
  },
  {
     label:"Woleaian",
     value:"woe"
  },
  {
     label:"Gambian Wolof",
     value:"wof"
  },
  {
     label:"Wogamusin",
     value:"wog"
  },
  {
     label:"Kamang",
     value:"woi"
  },
  {
     label:"Longto",
     value:"wok"
  },
  {
     label:"Wolof",
     value:"wol",
     "iso6392B":"wol",
     "iso6392T":"wol",
     "iso6391":"wo"
  },
  {
     label:"Wom (Nigeria)",
     value:"wom"
  },
  {
     label:"Wongo",
     value:"won"
  },
  {
     label:"Manombai",
     value:"woo"
  },
  {
     label:"Woria",
     value:"wor"
  },
  {
     label:"Hanga Hundi",
     value:"wos"
  },
  {
     label:"Wawonii",
     value:"wow"
  },
  {
     label:"Maco",
     value:"wpc"
  },
  {
     label:"Warapu",
     value:"wra"
  },
  {
     label:"Warduji",
     value:"wrd"
  },
  {
     label:"Garrwa",
     value:"wrk"
  },
  {
     label:"Warlmanpa",
     value:"wrl"
  },
  {
     label:"Warumungu",
     value:"wrm"
  },
  {
     label:"Warnang",
     value:"wrn"
  },
  {
     label:"Waropen",
     value:"wrp"
  },
  {
     label:"Wardaman",
     value:"wrr"
  },
  {
     label:"Waris",
     value:"wrs"
  },
  {
     label:"Waru",
     value:"wru"
  },
  {
     label:"Waruna",
     value:"wrv"
  },
  {
     label:"Wae Rana",
     value:"wrx"
  },
  {
     label:"Merwari",
     value:"wry"
  },
  {
     label:"Warembori",
     value:"wsa"
  },
  {
     label:"Adilabad Gondi",
     value:"wsg"
  },
  {
     label:"Wusi",
     value:"wsi"
  },
  {
     label:"Waskia",
     value:"wsk"
  },
  {
     label:"Owenia",
     value:"wsr"
  },
  {
     label:"Wasa",
     value:"wss"
  },
  {
     label:"Watiwa",
     value:"wtf"
  },
  {
     label:"Berta",
     value:"wti"
  },
  {
     label:"Watakataui",
     value:"wtk"
  },
  {
     label:"Mewati",
     value:"wtm"
  },
  {
     label:"Wotu",
     value:"wtw"
  },
  {
     label:"Wikngenchera",
     value:"wua"
  },
  {
     label:"Wunambal",
     value:"wub"
  },
  {
     label:"Wudu",
     value:"wud"
  },
  {
     label:"Wutunhua",
     value:"wuh"
  },
  {
     label:"Silimo",
     value:"wul"
  },
  {
     label:"Wumbvu",
     value:"wum"
  },
  {
     label:"Bungu",
     value:"wun"
  },
  {
     label:"Wutung",
     value:"wut"
  },
  {
     label:"Wu Chinese",
     value:"wuu"
  },
  {
     label:"Wuvulu-Aua",
     value:"wuv"
  },
  {
     label:"Wulna",
     value:"wux"
  },
  {
     label:"Wauyai",
     value:"wuy"
  },
  {
     label:"Waama",
     value:"wwa"
  },
  {
     label:"Wetamut",
     value:"wwo"
  },
  {
     label:"Wawa",
     value:"www"
  },
  {
     label:"Waxianghua",
     value:"wxa"
  },
  {
     label:"Wyandot",
     value:"wya"
  },
  {
     label:"Wangaaybuwan-Ngiyambaa",
     value:"wyb"
  },
  {
     label:"Wymysorys",
     value:"wym"
  },
  {
     label:"Wayor\u00f3",
     value:"wyr"
  },
  {
     label:"Western Fijian",
     value:"wyy"
  },
  {
     label:"Sambe",
     value:"xab"
  },
  {
     label:"Kachari",
     value:"xac"
  },
  {
     label:"Kalmyk",
     value:"xal",
     "iso6392B":"xal",
     "iso6392T":"xal"
  },
  {
     label:"Xamtanga",
     value:"xan"
  },
  {
     label:"Khao",
     value:"xao"
  },
  {
     label:"Katawixi",
     value:"xat"
  },
  {
     label:"Kauwera",
     value:"xau"
  },
  {
     label:"Xav\u00e1nte",
     value:"xav"
  },
  {
     label:"Kawaiisu",
     value:"xaw"
  },
  {
     label:"Kayan Mahakam",
     value:"xay"
  },
  {
     label:"Kombio",
     value:"xbi"
  },
  {
     label:"Kambera",
     value:"xbr"
  },
  {
     label:"Batjala",
     value:"xby"
  },
  {
     label:"Darkinyung",
     value:"xda"
  },
  {
     label:"Kwandu",
     value:"xdo"
  },
  {
     label:"Malayic Dayak",
     value:"xdy"
  },
  {
     label:"Hdi",
     value:"xed"
  },
  {
     label:"Kelo",
     value:"xel"
  },
  {
     label:"Kembayan",
     value:"xem"
  },
  {
     label:"Xer\u00e9nte",
     value:"xer"
  },
  {
     label:"Kesawai",
     value:"xes"
  },
  {
     label:"Xet\u00e1",
     value:"xet"
  },
  {
     label:"Keoru-Ahia",
     value:"xeu"
  },
  {
     label:"Unggumi",
     value:"xgu"
  },
  {
     label:"Khetrani",
     value:"xhe"
  },
  {
     label:"Xhosa",
     value:"xho",
     "iso6392B":"xho",
     "iso6392T":"xho",
     "iso6391":"xh"
  },
  {
     label:"Khua",
     value:"xhv"
  },
  {
     label:"Xiri",
     value:"xii"
  },
  {
     label:"Kisan",
     value:"xis"
  },
  {
     label:"Xipaya",
     value:"xiy"
  },
  {
     label:"Kalkoti",
     value:"xka"
  },
  {
     label:"Northern Nago",
     value:"xkb"
  },
  {
     label:"Kho'ini",
     value:"xkc"
  },
  {
     label:"Mendalam Kayan",
     value:"xkd"
  },
  {
     label:"Kereho",
     value:"xke"
  },
  {
     label:"Khengkha",
     value:"xkf"
  },
  {
     label:"Kagoro",
     value:"xkg"
  },
  {
     label:"Kajali",
     value:"xkj"
  },
  {
     label:"Kaco'",
     value:"xkk"
  },
  {
     label:"Mainstream Kenyah",
     value:"xkl"
  },
  {
     label:"Kayan River Kayan",
     value:"xkn"
  },
  {
     label:"Kiorr",
     value:"xko"
  },
  {
     label:"Kabatei",
     value:"xkp"
  },
  {
     label:"Koroni",
     value:"xkq"
  },
  {
     label:"Kumbewaha",
     value:"xks"
  },
  {
     label:"Kantosi",
     value:"xkt"
  },
  {
     label:"Kaamba",
     value:"xku"
  },
  {
     label:"Kgalagadi",
     value:"xkv"
  },
  {
     label:"Kembra",
     value:"xkw"
  },
  {
     label:"Karore",
     value:"xkx"
  },
  {
     label:"Uma' Lasan",
     value:"xky"
  },
  {
     label:"Kurtokha",
     value:"xkz"
  },
  {
     label:"Kamula",
     value:"xla"
  },
  {
     label:"Mushungulu",
     value:"xma"
  },
  {
     label:"Mbonga",
     value:"xmb"
  },
  {
     label:"Makhuwa-Marrevone",
     value:"xmc"
  },
  {
     label:"Mbudum",
     value:"xmd"
  },
  {
     label:"Mingrelian",
     value:"xmf"
  },
  {
     label:"Mengaka",
     value:"xmg"
  },
  {
     label:"Kugu-Muminh",
     value:"xmh"
  },
  {
     label:"Majera",
     value:"xmj"
  },
  {
     label:"Manado Malay",
     value:"xmm"
  },
  {
     label:"Morerebi",
     value:"xmo"
  },
  {
     label:"Matbat",
     value:"xmt"
  },
  {
     label:"Antankarana Malagasy",
     value:"xmv"
  },
  {
     label:"Tsimihety Malagasy",
     value:"xmw"
  },
  {
     label:"Maden",
     value:"xmx"
  },
  {
     label:"Mayaguduna",
     value:"xmy"
  },
  {
     label:"Mori Bawah",
     value:"xmz"
  },
  {
     label:"Kanakanabu",
     value:"xnb"
  },
  {
     label:"Kuanhua",
     value:"xnh"
  },
  {
     label:"Northern Kankanay",
     value:"xnn"
  },
  {
     label:"Kangri",
     value:"xnr"
  },
  {
     label:"Kanashi",
     value:"xns"
  },
  {
     label:"Nyiyaparli",
     value:"xny"
  },
  {
     label:"Kenzi",
     value:"xnz"
  },
  {
     label:"Kokoda",
     value:"xod"
  },
  {
     label:"Soga",
     value:"xog"
  },
  {
     label:"Kominimung",
     value:"xoi"
  },
  {
     label:"Xokleng",
     value:"xok"
  },
  {
     label:"Komo (Sudan)",
     value:"xom"
  },
  {
     label:"Konkomba",
     value:"xon"
  },
  {
     label:"Kopar",
     value:"xop"
  },
  {
     label:"Korubo",
     value:"xor"
  },
  {
     label:"Kowaki",
     value:"xow"
  },
  {
     label:"Liberia Kpelle",
     value:"xpe"
  },
  {
     label:"Kulina Pano",
     value:"xpk"
  },
  {
     label:"Krah\u00f4",
     value:"xra"
  },
  {
     label:"Eastern Karaboro",
     value:"xrb"
  },
  {
     label:"Kreye",
     value:"xre"
  },
  {
     label:"Krikati-Timbira",
     value:"xri"
  },
  {
     label:"Marriammu",
     value:"xru"
  },
  {
     label:"Karawa",
     value:"xrw"
  },
  {
     label:"Sambal",
     value:"xsb"
  },
  {
     label:"Sempan",
     value:"xse"
  },
  {
     label:"Shamang",
     value:"xsh"
  },
  {
     label:"Sio",
     value:"xsi"
  },
  {
     label:"Subi",
     value:"xsj"
  },
  {
     label:"South Slavey",
     value:"xsl"
  },
  {
     label:"Kasem",
     value:"xsm"
  },
  {
     label:"Sanga (Nigeria)",
     value:"xsn"
  },
  {
     label:"Silopi",
     value:"xsp"
  },
  {
     label:"Makhuwa-Saka",
     value:"xsq"
  },
  {
     label:"Sherpa",
     value:"xsr"
  },
  {
     label:"Sanum\u00e1",
     value:"xsu"
  },
  {
     label:"Saisiyat",
     value:"xsy"
  },
  {
     label:"Alcozauca Mixtec",
     value:"xta"
  },
  {
     label:"Chazumba Mixtec",
     value:"xtb"
  },
  {
     label:"Katcha-Kadugli-Miri",
     value:"xtc"
  },
  {
     label:"Diuxi-Tilantongo Mixtec",
     value:"xtd"
  },
  {
     label:"Ketengban",
     value:"xte"
  },
  {
     label:"Sinicahua Mixtec",
     value:"xti"
  },
  {
     label:"San Juan Teita Mixtec",
     value:"xtj"
  },
  {
     label:"Tijaltepec Mixtec",
     value:"xtl"
  },
  {
     label:"Magdalena Pe\u00f1asco Mixtec",
     value:"xtm"
  },
  {
     label:"Northern Tlaxiaco Mixtec",
     value:"xtn"
  },
  {
     label:"San Miguel Piedras Mixtec",
     value:"xtp"
  },
  {
     label:"Sindihui Mixtec",
     value:"xts"
  },
  {
     label:"Tacahua Mixtec",
     value:"xtt"
  },
  {
     label:"Cuyamecalco Mixtec",
     value:"xtu"
  },
  {
     label:"Tawand\u00ea",
     value:"xtw"
  },
  {
     label:"Yoloxochitl Mixtec",
     value:"xty"
  },
  {
     label:"Alu Kurumba",
     value:"xua"
  },
  {
     label:"Betta Kurumba",
     value:"xub"
  },
  {
     label:"Kunigami",
     value:"xug"
  },
  {
     label:"Jennu Kurumba",
     value:"xuj"
  },
  {
     label:"Kuo",
     value:"xuo"
  },
  {
     label:"Kxoe",
     value:"xuu"
  },
  {
     label:"Kamviri",
     value:"xvi"
  },
  {
     label:"Kwaza",
     value:"xwa"
  },
  {
     label:"Xwela Gbe",
     value:"xwe"
  },
  {
     label:"Kwegu",
     value:"xwg"
  },
  {
     label:"Western Xwla Gbe",
     value:"xwl"
  },
  {
     label:"Kwerba Mamberamo",
     value:"xwr"
  },
  {
     label:"Ke'o",
     value:"xxk"
  },
  {
     label:"Yorta Yorta",
     value:"xyy"
  },
  {
     label:"Yaminahua",
     value:"yaa"
  },
  {
     label:"Yuhup",
     value:"yab"
  },
  {
     label:"Pass Valley Yali",
     value:"yac"
  },
  {
     label:"Yagua",
     value:"yad"
  },
  {
     label:"Pum\u00e9",
     value:"yae"
  },
  {
     label:"Yaka (Democratic Republic of Congo)",
     value:"yaf"
  },
  {
     label:"Y\u00e1mana",
     value:"yag"
  },
  {
     label:"Yazgulyam",
     value:"yah"
  },
  {
     label:"Yagnobi",
     value:"yai"
  },
  {
     label:"Banda-Yangere",
     value:"yaj"
  },
  {
     label:"Yakama",
     value:"yak"
  },
  {
     label:"Yalunka",
     value:"yal"
  },
  {
     label:"Yamba",
     value:"yam"
  },
  {
     label:"Mayangna",
     value:"yan"
  },
  {
     label:"Yao",
     value:"yao",
     "iso6392B":"yao",
     "iso6392T":"yao"
  },
  {
     label:"Yapese",
     value:"yap",
     "iso6392B":"yap",
     "iso6392T":"yap"
  },
  {
     label:"Yaqui",
     value:"yaq"
  },
  {
     label:"Yabarana",
     value:"yar"
  },
  {
     label:"Nugunu (Cameroon)",
     value:"yas"
  },
  {
     label:"Yambeta",
     value:"yat"
  },
  {
     label:"Yuwana",
     value:"yau"
  },
  {
     label:"Yangben",
     value:"yav"
  },
  {
     label:"Yawalapit\u00ed",
     value:"yaw"
  },
  {
     label:"Yauma",
     value:"yax"
  },
  {
     label:"Agwagwune",
     value:"yay"
  },
  {
     label:"Lokaa",
     value:"yaz"
  },
  {
     label:"Yala",
     value:"yba"
  },
  {
     label:"Yemba",
     value:"ybb"
  },
  {
     label:"West Yugur",
     value:"ybe"
  },
  {
     label:"Yakha",
     value:"ybh"
  },
  {
     label:"Yamphu",
     value:"ybi"
  },
  {
     label:"Hasha",
     value:"ybj"
  },
  {
     label:"Bokha",
     value:"ybk"
  },
  {
     label:"Yukuben",
     value:"ybl"
  },
  {
     label:"Yaben",
     value:"ybm"
  },
  {
     label:"Yabong",
     value:"ybo"
  },
  {
     label:"Yawiyo",
     value:"ybx"
  },
  {
     label:"Yaweyuha",
     value:"yby"
  },
  {
     label:"Chesu",
     value:"ych"
  },
  {
     label:"Lolopo",
     value:"ycl"
  },
  {
     label:"Yucuna",
     value:"ycn"
  },
  {
     label:"Chepya",
     value:"ycp"
  },
  {
     label:"Eastern Yiddish",
     value:"ydd"
  },
  {
     label:"Yangum Dey",
     value:"yde"
  },
  {
     label:"Yidgha",
     value:"ydg"
  },
  {
     label:"Yoidik",
     value:"ydk"
  },
  {
     label:"Ravula",
     value:"yea"
  },
  {
     label:"Yeniche",
     value:"yec"
  },
  {
     label:"Yimas",
     value:"yee"
  },
  {
     label:"Yevanic",
     value:"yej"
  },
  {
     label:"Yela",
     value:"yel"
  },
  {
     label:"Tarok",
     value:"yer"
  },
  {
     label:"Nyankpa",
     value:"yes"
  },
  {
     label:"Yetfa",
     value:"yet"
  },
  {
     label:"Yerukula",
     value:"yeu"
  },
  {
     label:"Yapunda",
     value:"yev"
  },
  {
     label:"Yeyi",
     value:"yey"
  },
  {
     label:"Yangum Gel",
     value:"ygl"
  },
  {
     label:"Yagomi",
     value:"ygm"
  },
  {
     label:"Gepo",
     value:"ygp"
  },
  {
     label:"Yagaria",
     value:"ygr"
  },
  {
     label:"Yugul",
     value:"ygu"
  },
  {
     label:"Yagwoia",
     value:"ygw"
  },
  {
     label:"Baha Buyang",
     value:"yha"
  },
  {
     label:"Judeo-Iraqi Arabic",
     value:"yhd"
  },
  {
     label:"Hlepho Phowa",
     value:"yhl"
  },
  {
     label:"Yinggarda",
     value:"yia"
  },
  {
     label:"Yiddish",
     value:"yid",
     "iso6392B":"yid",
     "iso6392T":"yid",
     "iso6391":"yi"
  },
  {
     label:"Ache",
     value:"yif"
  },
  {
     label:"Wusa Nasu",
     value:"yig"
  },
  {
     label:"Western Yiddish",
     value:"yih"
  },
  {
     label:"Yidiny",
     value:"yii"
  },
  {
     label:"Yindjibarndi",
     value:"yij"
  },
  {
     label:"Dongshanba Lalo",
     value:"yik"
  },
  {
     label:"Yimchungru Naga",
     value:"yim"
  },
  {
     label:"Riang Lai",
     value:"yin"
  },
  {
     label:"Pholo",
     value:"yip"
  },
  {
     label:"Miqie",
     value:"yiq"
  },
  {
     label:"North Awyu",
     value:"yir"
  },
  {
     label:"Yis",
     value:"yis"
  },
  {
     label:"Eastern Lalu",
     value:"yit"
  },
  {
     label:"Awu",
     value:"yiu"
  },
  {
     label:"Northern Nisu",
     value:"yiv"
  },
  {
     label:"Axi Yi",
     value:"yix"
  },
  {
     label:"Azhe",
     value:"yiz"
  },
  {
     label:"Yakan",
     value:"yka"
  },
  {
     label:"Northern Yukaghir",
     value:"ykg"
  },
  {
     label:"Yoke",
     value:"yki"
  },
  {
     label:"Yakaikeke",
     value:"ykk"
  },
  {
     label:"Khlula",
     value:"ykl"
  },
  {
     label:"Kap",
     value:"ykm"
  },
  {
     label:"Kua-nsi",
     value:"ykn"
  },
  {
     label:"Yasa",
     value:"yko"
  },
  {
     label:"Yekora",
     value:"ykr"
  },
  {
     label:"Kathu",
     value:"ykt"
  },
  {
     label:"Kuamasi",
     value:"yku"
  },
  {
     label:"Yakoma",
     value:"yky"
  },
  {
     label:"Yaul",
     value:"yla"
  },
  {
     label:"Yaleba",
     value:"ylb"
  },
  {
     label:"Yele",
     value:"yle"
  },
  {
     label:"Yelogu",
     value:"ylg"
  },
  {
     label:"Angguruk Yali",
     value:"yli"
  },
  {
     label:"Yil",
     value:"yll"
  },
  {
     label:"Limi",
     value:"ylm"
  },
  {
     label:"Langnian Buyang",
     value:"yln"
  },
  {
     label:"Naluo Yi",
     value:"ylo"
  },
  {
     label:"Aribwaung",
     value:"ylu"
  },
  {
     label:"Ny\u00e2layu",
     value:"yly"
  },
  {
     label:"Yambes",
     value:"ymb"
  },
  {
     label:"Southern Muji",
     value:"ymc"
  },
  {
     label:"Muda",
     value:"ymd"
  },
  {
     label:"Yamongeri",
     value:"ymg"
  },
  {
     label:"Mili",
     value:"ymh"
  },
  {
     label:"Moji",
     value:"ymi"
  },
  {
     label:"Makwe",
     value:"ymk"
  },
  {
     label:"Iamalele",
     value:"yml"
  },
  {
     label:"Maay",
     value:"ymm"
  },
  {
     label:"Yamna",
     value:"ymn"
  },
  {
     label:"Yangum Mon",
     value:"ymo"
  },
  {
     label:"Yamap",
     value:"ymp"
  },
  {
     label:"Qila Muji",
     value:"ymq"
  },
  {
     label:"Malasar",
     value:"ymr"
  },
  {
     label:"Northern Muji",
     value:"ymx"
  },
  {
     label:"Muzi",
     value:"ymz"
  },
  {
     label:"Aluo",
     value:"yna"
  },
  {
     label:"Lang'e",
     value:"yne"
  },
  {
     label:"Yango",
     value:"yng"
  },
  {
     label:"Naukan Yupik",
     value:"ynk"
  },
  {
     label:"Yangulam",
     value:"ynl"
  },
  {
     label:"Yong",
     value:"yno"
  },
  {
     label:"Yendang",
     value:"ynq"
  },
  {
     label:"Yansi",
     value:"yns"
  },
  {
     label:"Yogad",
     value:"yog"
  },
  {
     label:"Yonaguni",
     value:"yoi"
  },
  {
     label:"Yokuts",
     value:"yok"
  },
  {
     label:"Yombe",
     value:"yom"
  },
  {
     label:"Yongkom",
     value:"yon"
  },
  {
     label:"Yoruba",
     value:"yor",
     "iso6392B":"yor",
     "iso6392T":"yor",
     "iso6391":"yo"
  },
  {
     label:"Yotti",
     value:"yot"
  },
  {
     label:"Yoron",
     value:"yox"
  },
  {
     label:"Yoy",
     value:"yoy"
  },
  {
     label:"Phala",
     value:"ypa"
  },
  {
     label:"Labo Phowa",
     value:"ypb"
  },
  {
     label:"Phola",
     value:"ypg"
  },
  {
     label:"Phupha",
     value:"yph"
  },
  {
     label:"Phuma",
     value:"ypm"
  },
  {
     label:"Ani Phowa",
     value:"ypn"
  },
  {
     label:"Alo Phola",
     value:"ypo"
  },
  {
     label:"Phupa",
     value:"ypp"
  },
  {
     label:"Phuza",
     value:"ypz"
  },
  {
     label:"Yerakai",
     value:"yra"
  },
  {
     label:"Yareba",
     value:"yrb"
  },
  {
     label:"Yaour\u00e9",
     value:"yre"
  },
  {
     label:"Nenets",
     value:"yrk"
  },
  {
     label:"Nhengatu",
     value:"yrl"
  },
  {
     label:"Yirrk-Mel",
     value:"yrm"
  },
  {
     label:"Yerong",
     value:"yrn"
  },
  {
     label:"Yaroam\u00eb",
     value:"yro"
  },
  {
     label:"Yarsun",
     value:"yrs"
  },
  {
     label:"Yarawata",
     value:"yrw"
  },
  {
     label:"Yarluyandi",
     value:"yry"
  },
  {
     label:"Samatao",
     value:"ysd"
  },
  {
     label:"Sonaga",
     value:"ysg"
  },
  {
     label:"Sani",
     value:"ysn"
  },
  {
     label:"Nisi (China)",
     value:"yso"
  },
  {
     label:"Southern Lolopo",
     value:"ysp"
  },
  {
     label:"Yessan-Mayo",
     value:"yss"
  },
  {
     label:"Sanie",
     value:"ysy"
  },
  {
     label:"Talu",
     value:"yta"
  },
  {
     label:"Tanglang",
     value:"ytl"
  },
  {
     label:"Thopho",
     value:"ytp"
  },
  {
     label:"Yout Wam",
     value:"ytw"
  },
  {
     label:"Yucateco",
     value:"yua"
  },
  {
     label:"Yuchi",
     value:"yuc"
  },
  {
     label:"Judeo-Tripolitanian Arabic",
     value:"yud"
  },
  {
     label:"Yue Chinese",
     value:"yue"
  },
  {
     label:"Havasupai-Walapai-Yavapai",
     value:"yuf"
  },
  {
     label:"Yurut\u00ed",
     value:"yui"
  },
  {
     label:"Karkar-Yuri",
     value:"yuj"
  },
  {
     label:"Yulu",
     value:"yul"
  },
  {
     label:"Quechan",
     value:"yum"
  },
  {
     label:"Bena (Nigeria)",
     value:"yun"
  },
  {
     label:"Yukpa",
     value:"yup"
  },
  {
     label:"Yuqui",
     value:"yuq"
  },
  {
     label:"Yopno",
     value:"yut"
  },
  {
     label:"Yau (Morobe Province)",
     value:"yuw"
  },
  {
     label:"Southern Yukaghir",
     value:"yux"
  },
  {
     label:"East Yugur",
     value:"yuy"
  },
  {
     label:"Yuracare",
     value:"yuz"
  },
  {
     label:"Yawa",
     value:"yva"
  },
  {
     label:"Kalou",
     value:"ywa"
  },
  {
     label:"Yinhawangka",
     value:"ywg"
  },
  {
     label:"Western Lalu",
     value:"ywl"
  },
  {
     label:"Yawanawa",
     value:"ywn"
  },
  {
     label:"Wuding-Luquan Yi",
     value:"ywq"
  },
  {
     label:"Yawuru",
     value:"ywr"
  },
  {
     label:"Xishanba Lalo",
     value:"ywt"
  },
  {
     label:"Wumeng Nasu",
     value:"ywu"
  },
  {
     label:"Yau (Sandaun Province)",
     value:"yyu"
  },
  {
     label:"Ayizi",
     value:"yyz"
  },
  {
     label:"E'ma Buyang",
     value:"yzg"
  },
  {
     label:"Zokhuo",
     value:"yzk"
  },
  {
     label:"Sierra de Ju\u00e1rez Zapotec",
     value:"zaa"
  },
  {
     label:"Western Tlacolula Valley Zapotec",
     value:"zab"
  },
  {
     label:"Ocotl\u00e1n Zapotec",
     value:"zac"
  },
  {
     label:"Cajonos Zapotec",
     value:"zad"
  },
  {
     label:"Yareni Zapotec",
     value:"zae"
  },
  {
     label:"Ayoquesco Zapotec",
     value:"zaf"
  },
  {
     label:"Zaghawa",
     value:"zag"
  },
  {
     label:"Zangwal",
     value:"zah"
  },
  {
     label:"Isthmus Zapotec",
     value:"zai"
  },
  {
     label:"Zaramo",
     value:"zaj"
  },
  {
     label:"Zanaki",
     value:"zak"
  },
  {
     label:"Zauzou",
     value:"zal"
  },
  {
     label:"Miahuatl\u00e1n Zapotec",
     value:"zam"
  },
  {
     label:"Ozolotepec Zapotec",
     value:"zao"
  },
  {
     label:"Zapotec",
     value:"zap",
     "iso6392B":"zap",
     "iso6392T":"zap"
  },
  {
     label:"Alo\u00e1pam Zapotec",
     value:"zaq"
  },
  {
     label:"Rinc\u00f3n Zapotec",
     value:"zar"
  },
  {
     label:"Santo Domingo Albarradas Zapotec",
     value:"zas"
  },
  {
     label:"Tabaa Zapotec",
     value:"zat"
  },
  {
     label:"Zangskari",
     value:"zau"
  },
  {
     label:"Yatzachi Zapotec",
     value:"zav"
  },
  {
     label:"Mitla Zapotec",
     value:"zaw"
  },
  {
     label:"Xadani Zapotec",
     value:"zax"
  },
  {
     label:"Zayse-Zergulla",
     value:"zay"
  },
  {
     label:"Zari",
     value:"zaz"
  },
  {
     label:"Balaibalan",
     value:"zba"
  },
  {
     label:"Central Berawan",
     value:"zbc"
  },
  {
     label:"East Berawan",
     value:"zbe"
  },
  {
     label:"Blissymbols",
     value:"zbl",
     "iso6392B":"zbl",
     "iso6392T":"zbl"
  },
  {
     label:"Batui",
     value:"zbt"
  },
  {
     label:"West Berawan",
     value:"zbw"
  },
  {
     label:"Coatecas Altas Zapotec",
     value:"zca"
  },
  {
     label:"Central Hongshuihe Zhuang",
     value:"zch"
  },
  {
     label:"Ngazidja Comorian",
     value:"zdj"
  },
  {
     label:"Zeeuws",
     value:"zea"
  },
  {
     label:"Zenag",
     value:"zeg"
  },
  {
     label:"Eastern Hongshuihe Zhuang",
     value:"zeh"
  },
  {
     label:"Zenaga",
     value:"zen",
     "iso6392B":"zen",
     "iso6392T":"zen"
  },
  {
     label:"Kinga",
     value:"zga"
  },
  {
     label:"Guibei Zhuang",
     value:"zgb"
  },
  {
     label:"Standard Moroccan Tamazight",
     value:"zgh",
     "iso6392B":"zgh",
     "iso6392T":"zgh"
  },
  {
     label:"Minz Zhuang",
     value:"zgm"
  },
  {
     label:"Guibian Zhuang",
     value:"zgn"
  },
  {
     label:"Magori",
     value:"zgr"
  },
  {
     label:"Zhuang",
     value:"zha",
     "iso6392B":"zha",
     "iso6392T":"zha",
     "iso6391":"za"
  },
  {
     label:"Zhaba",
     value:"zhb"
  },
  {
     label:"Dai Zhuang",
     value:"zhd"
  },
  {
     label:"Zhire",
     value:"zhi"
  },
  {
     label:"Nong Zhuang",
     value:"zhn"
  },
  {
     label:"Chinese",
     value:"zho",
     "iso6392B":"chi",
     "iso6392T":"zho",
     "iso6391":"zh"
  },
  {
     label:"Zhoa",
     value:"zhw"
  },
  {
     label:"Zia",
     value:"zia"
  },
  {
     label:"Zimakani",
     value:"zik"
  },
  {
     label:"Zialo",
     value:"zil"
  },
  {
     label:"Mesme",
     value:"zim"
  },
  {
     label:"Zinza",
     value:"zin"
  },
  {
     label:"Zigula",
     value:"ziw"
  },
  {
     label:"Zizilivakan",
     value:"ziz"
  },
  {
     label:"Kaimbulawa",
     value:"zka"
  },
  {
     label:"Kadu",
     value:"zkd"
  },
  {
     label:"Kanan",
     value:"zkn"
  },
  {
     label:"Zakhring",
     value:"zkr"
  },
  {
     label:"Kaurna",
     value:"zku"
  },
  {
     label:"Liujiang Zhuang",
     value:"zlj"
  },
  {
     label:"Malay (individual language)",
     value:"zlm"
  },
  {
     label:"Lianshan Zhuang",
     value:"zln"
  },
  {
     label:"Liuqian Zhuang",
     value:"zlq"
  },
  {
     label:"Manda (Australia)",
     value:"zma"
  },
  {
     label:"Zimba",
     value:"zmb"
  },
  {
     label:"Maridan",
     value:"zmd"
  },
  {
     label:"Mfinu",
     value:"zmf"
  },
  {
     label:"Marti Ke",
     value:"zmg"
  },
  {
     label:"Negeri Sembilan Malay",
     value:"zmi"
  },
  {
     label:"Maridjabin",
     value:"zmj"
  },
  {
     label:"Marimanindji",
     value:"zmm"
  },
  {
     label:"Mbangwe",
     value:"zmn"
  },
  {
     label:"Molo",
     value:"zmo"
  },
  {
     label:"Mpuono",
     value:"zmp"
  },
  {
     label:"Mituku",
     value:"zmq"
  },
  {
     label:"Maranunggu",
     value:"zmr"
  },
  {
     label:"Mbesa",
     value:"zms"
  },
  {
     label:"Maringarr",
     value:"zmt"
  },
  {
     label:"Mbo (Democratic Republic of Congo)",
     value:"zmw"
  },
  {
     label:"Bomitaba",
     value:"zmx"
  },
  {
     label:"Mariyedi",
     value:"zmy"
  },
  {
     label:"Mbandja",
     value:"zmz"
  },
  {
     label:"Zan Gula",
     value:"zna"
  },
  {
     label:"Zande (individual language)",
     value:"zne"
  },
  {
     label:"Mang",
     value:"zng"
  },
  {
     label:"Mangas",
     value:"zns"
  },
  {
     label:"Copainal\u00e1 Zoque",
     value:"zoc"
  },
  {
     label:"Chimalapa Zoque",
     value:"zoh"
  },
  {
     label:"Zou",
     value:"zom"
  },
  {
     label:"Asunci\u00f3n Mixtepec Zapotec",
     value:"zoo"
  },
  {
     label:"Tabasco Zoque",
     value:"zoq"
  },
  {
     label:"Ray\u00f3n Zoque",
     value:"zor"
  },
  {
     label:"Francisco Le\u00f3n Zoque",
     value:"zos"
  },
  {
     label:"Lachiguiri Zapotec",
     value:"zpa"
  },
  {
     label:"Yautepec Zapotec",
     value:"zpb"
  },
  {
     label:"Choapan Zapotec",
     value:"zpc"
  },
  {
     label:"Southeastern Ixtl\u00e1n Zapotec",
     value:"zpd"
  },
  {
     label:"Petapa Zapotec",
     value:"zpe"
  },
  {
     label:"San Pedro Quiatoni Zapotec",
     value:"zpf"
  },
  {
     label:"Guevea De Humboldt Zapotec",
     value:"zpg"
  },
  {
     label:"Totomachapan Zapotec",
     value:"zph"
  },
  {
     label:"Santa Mar\u00eda Quiegolani Zapotec",
     value:"zpi"
  },
  {
     label:"Quiavicuzas Zapotec",
     value:"zpj"
  },
  {
     label:"Tlacolulita Zapotec",
     value:"zpk"
  },
  {
     label:"Lachix\u00edo Zapotec",
     value:"zpl"
  },
  {
     label:"Mixtepec Zapotec",
     value:"zpm"
  },
  {
     label:"Santa In\u00e9s Yatzechi Zapotec",
     value:"zpn"
  },
  {
     label:"Amatl\u00e1n Zapotec",
     value:"zpo"
  },
  {
     label:"El Alto Zapotec",
     value:"zpp"
  },
  {
     label:"Zoogocho Zapotec",
     value:"zpq"
  },
  {
     label:"Santiago Xanica Zapotec",
     value:"zpr"
  },
  {
     label:"Coatl\u00e1n Zapotec",
     value:"zps"
  },
  {
     label:"San Vicente Coatl\u00e1n Zapotec",
     value:"zpt"
  },
  {
     label:"Yal\u00e1lag Zapotec",
     value:"zpu"
  },
  {
     label:"Chichicapan Zapotec",
     value:"zpv"
  },
  {
     label:"Zaniza Zapotec",
     value:"zpw"
  },
  {
     label:"San Baltazar Loxicha Zapotec",
     value:"zpx"
  },
  {
     label:"Mazaltepec Zapotec",
     value:"zpy"
  },
  {
     label:"Texmelucan Zapotec",
     value:"zpz"
  },
  {
     label:"Qiubei Zhuang",
     value:"zqe"
  },
  {
     label:"Mirgan",
     value:"zrg"
  },
  {
     label:"Zerenkel",
     value:"zrn"
  },
  {
     label:"Z\u00e1paro",
     value:"zro"
  },
  {
     label:"Mairasi",
     value:"zrs"
  },
  {
     label:"Sarasira",
     value:"zsa"
  },
  {
     label:"Standard Malay",
     value:"zsm"
  },
  {
     label:"Southern Rincon Zapotec",
     value:"zsr"
  },
  {
     label:"Sukurum",
     value:"zsu"
  },
  {
     label:"Elotepec Zapotec",
     value:"zte"
  },
  {
     label:"Xanagu\u00eda Zapotec",
     value:"ztg"
  },
  {
     label:"Lapagu\u00eda-Guivini Zapotec",
     value:"ztl"
  },
  {
     label:"San Agust\u00edn Mixtepec Zapotec",
     value:"ztm"
  },
  {
     label:"Santa Catarina Albarradas Zapotec",
     value:"ztn"
  },
  {
     label:"Loxicha Zapotec",
     value:"ztp"
  },
  {
     label:"Quioquitani-Quier\u00ed Zapotec",
     value:"ztq"
  },
  {
     label:"Tilquiapan Zapotec",
     value:"zts"
  },
  {
     label:"Tejalapan Zapotec",
     value:"ztt"
  },
  {
     label:"G\u00fcil\u00e1 Zapotec",
     value:"ztu"
  },
  {
     label:"Zaachila Zapotec",
     value:"ztx"
  },
  {
     label:"Yatee Zapotec",
     value:"zty"
  },
  {
     label:"Zeem",
     value:"zua"
  },
  {
     label:"Tokano",
     value:"zuh"
  },
  {
     label:"Zulu",
     value:"zul",
     "iso6392B":"zul",
     "iso6392T":"zul",
     "iso6391":"zu"
  },
  {
     label:"Kumzari",
     value:"zum"
  },
  {
     label:"Zuni",
     value:"zun",
     "iso6392B":"zun",
     "iso6392T":"zun"
  },
  {
     label:"Zumaya",
     value:"zuy"
  },
  {
     label:"Zay",
     value:"zwa"
  },
  {
     label:"No linguistic content",
     value:"zxx",
     "iso6392B":"zxx",
     "iso6392T":"zxx"
  },
  {
     label:"Yongbei Zhuang",
     value:"zyb"
  },
  {
     label:"Yang Zhuang",
     value:"zyg"
  },
  {
     label:"Youjiang Zhuang",
     value:"zyj"
  },
  {
     label:"Yongnan Zhuang",
     value:"zyn"
  },
  {
     label:"Zyphe Chin",
     value:"zyp"
  },
  {
     label:"Zaza",
     value:"zza",
     "iso6392B":"zza",
     "iso6392T":"zza"
  },
  {
     label:"Zuojiang Zhuang",
     value:"zzj"
  }
 ]